
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref70d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref70d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lgFxF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("22OtE"));

});
parcelRegister("22OtE", function(module, exports) {

$parcel$export(module.exports, "Children", () => $17d2ec6ad0953795$export$dca3b0875bd9a954, (v) => $17d2ec6ad0953795$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $17d2ec6ad0953795$export$16fa2f45be04daa8, (v) => $17d2ec6ad0953795$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $17d2ec6ad0953795$export$ffb0004e005737fa, (v) => $17d2ec6ad0953795$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $17d2ec6ad0953795$export$e2c29f18771995cb, (v) => $17d2ec6ad0953795$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $17d2ec6ad0953795$export$221d75b3f55bb0bd, (v) => $17d2ec6ad0953795$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $17d2ec6ad0953795$export$5f8d39834fd61797, (v) => $17d2ec6ad0953795$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $17d2ec6ad0953795$export$74bf444e3cd11ea5, (v) => $17d2ec6ad0953795$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17d2ec6ad0953795$export$ae55be85d98224ed, (v) => $17d2ec6ad0953795$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $17d2ec6ad0953795$export$e530037191fcd5d7, (v) => $17d2ec6ad0953795$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $17d2ec6ad0953795$export$fd42f52fd3ae1109, (v) => $17d2ec6ad0953795$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $17d2ec6ad0953795$export$c8a8987d4410bf2d, (v) => $17d2ec6ad0953795$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $17d2ec6ad0953795$export$d38cd72104c1f0e9, (v) => $17d2ec6ad0953795$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $17d2ec6ad0953795$export$7d1e3a5e95ceca43, (v) => $17d2ec6ad0953795$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $17d2ec6ad0953795$export$257a8862b851cb5b, (v) => $17d2ec6ad0953795$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $17d2ec6ad0953795$export$a8257692ac88316c, (v) => $17d2ec6ad0953795$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $17d2ec6ad0953795$export$488013bae63b21da, (v) => $17d2ec6ad0953795$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $17d2ec6ad0953795$export$7c73462e0d25e514, (v) => $17d2ec6ad0953795$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $17d2ec6ad0953795$export$35808ee640e87ca7, (v) => $17d2ec6ad0953795$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $17d2ec6ad0953795$export$fae74005e78b1a27, (v) => $17d2ec6ad0953795$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $17d2ec6ad0953795$export$dc8fbce3eb94dc1e, (v) => $17d2ec6ad0953795$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $17d2ec6ad0953795$export$6d9c69b0de29b591, (v) => $17d2ec6ad0953795$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $17d2ec6ad0953795$export$d5a552a76deda3c2, (v) => $17d2ec6ad0953795$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $17d2ec6ad0953795$export$e5c5a5f917a5871c, (v) => $17d2ec6ad0953795$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $17d2ec6ad0953795$export$1538c33de8887b59, (v) => $17d2ec6ad0953795$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $17d2ec6ad0953795$export$13e3392192263954, (v) => $17d2ec6ad0953795$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $17d2ec6ad0953795$export$b8f5890fc79d6aca, (v) => $17d2ec6ad0953795$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $17d2ec6ad0953795$export$60241385465d0a34, (v) => $17d2ec6ad0953795$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $17d2ec6ad0953795$export$83d89fbfd8236492, (v) => $17d2ec6ad0953795$export$83d89fbfd8236492 = v);
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $17d2ec6ad0953795$export$dca3b0875bd9a954;
var $17d2ec6ad0953795$export$16fa2f45be04daa8;
var $17d2ec6ad0953795$export$ffb0004e005737fa;
var $17d2ec6ad0953795$export$e2c29f18771995cb;
var $17d2ec6ad0953795$export$221d75b3f55bb0bd;
var $17d2ec6ad0953795$export$5f8d39834fd61797;
var $17d2ec6ad0953795$export$74bf444e3cd11ea5;
var $17d2ec6ad0953795$export$ae55be85d98224ed;
var $17d2ec6ad0953795$export$e530037191fcd5d7;
var $17d2ec6ad0953795$export$fd42f52fd3ae1109;
var $17d2ec6ad0953795$export$c8a8987d4410bf2d;
var $17d2ec6ad0953795$export$d38cd72104c1f0e9;
var $17d2ec6ad0953795$export$7d1e3a5e95ceca43;
var $17d2ec6ad0953795$export$257a8862b851cb5b;
var $17d2ec6ad0953795$export$a8257692ac88316c;
var $17d2ec6ad0953795$export$488013bae63b21da;
var $17d2ec6ad0953795$export$7c73462e0d25e514;
var $17d2ec6ad0953795$export$35808ee640e87ca7;
var $17d2ec6ad0953795$export$fae74005e78b1a27;
var $17d2ec6ad0953795$export$dc8fbce3eb94dc1e;
var $17d2ec6ad0953795$export$6d9c69b0de29b591;
var $17d2ec6ad0953795$export$d5a552a76deda3c2;
var $17d2ec6ad0953795$export$e5c5a5f917a5871c;
var $17d2ec6ad0953795$export$1538c33de8887b59;
var $17d2ec6ad0953795$export$13e3392192263954;
var $17d2ec6ad0953795$export$b8f5890fc79d6aca;
var $17d2ec6ad0953795$export$60241385465d0a34;
var $17d2ec6ad0953795$export$83d89fbfd8236492;
'use strict';

var $lk4ro = parcelRequire("lk4ro");
var $17d2ec6ad0953795$var$n = "function" === typeof Symbol && Symbol.for, $17d2ec6ad0953795$var$p = $17d2ec6ad0953795$var$n ? Symbol.for("react.element") : 60103, $17d2ec6ad0953795$var$q = $17d2ec6ad0953795$var$n ? Symbol.for("react.portal") : 60106, $17d2ec6ad0953795$var$r = $17d2ec6ad0953795$var$n ? Symbol.for("react.fragment") : 60107, $17d2ec6ad0953795$var$t = $17d2ec6ad0953795$var$n ? Symbol.for("react.strict_mode") : 60108, $17d2ec6ad0953795$var$u = $17d2ec6ad0953795$var$n ? Symbol.for("react.profiler") : 60114, $17d2ec6ad0953795$var$v = $17d2ec6ad0953795$var$n ? Symbol.for("react.provider") : 60109, $17d2ec6ad0953795$var$w = $17d2ec6ad0953795$var$n ? Symbol.for("react.context") : 60110, $17d2ec6ad0953795$var$x = $17d2ec6ad0953795$var$n ? Symbol.for("react.forward_ref") : 60112, $17d2ec6ad0953795$var$y = $17d2ec6ad0953795$var$n ? Symbol.for("react.suspense") : 60113, $17d2ec6ad0953795$var$z = $17d2ec6ad0953795$var$n ? Symbol.for("react.memo") : 60115, $17d2ec6ad0953795$var$A = $17d2ec6ad0953795$var$n ? Symbol.for("react.lazy") : 60116, $17d2ec6ad0953795$var$B = "function" === typeof Symbol && Symbol.iterator;
function $17d2ec6ad0953795$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17d2ec6ad0953795$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $17d2ec6ad0953795$var$E = {};
function $17d2ec6ad0953795$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $17d2ec6ad0953795$var$E;
    this.updater = c || $17d2ec6ad0953795$var$D;
}
$17d2ec6ad0953795$var$F.prototype.isReactComponent = {};
$17d2ec6ad0953795$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($17d2ec6ad0953795$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$17d2ec6ad0953795$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $17d2ec6ad0953795$var$G() {}
$17d2ec6ad0953795$var$G.prototype = $17d2ec6ad0953795$var$F.prototype;
function $17d2ec6ad0953795$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $17d2ec6ad0953795$var$E;
    this.updater = c || $17d2ec6ad0953795$var$D;
}
var $17d2ec6ad0953795$var$I = $17d2ec6ad0953795$var$H.prototype = new $17d2ec6ad0953795$var$G;
$17d2ec6ad0953795$var$I.constructor = $17d2ec6ad0953795$var$H;
$lk4ro($17d2ec6ad0953795$var$I, $17d2ec6ad0953795$var$F.prototype);
$17d2ec6ad0953795$var$I.isPureReactComponent = !0;
var $17d2ec6ad0953795$var$J = {
    current: null
}, $17d2ec6ad0953795$var$K = Object.prototype.hasOwnProperty, $17d2ec6ad0953795$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $17d2ec6ad0953795$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$17d2ec6ad0953795$var$K.call(b, e) && !$17d2ec6ad0953795$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $17d2ec6ad0953795$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $17d2ec6ad0953795$var$J.current
    };
}
function $17d2ec6ad0953795$var$N(a, b) {
    return {
        $$typeof: $17d2ec6ad0953795$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $17d2ec6ad0953795$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $17d2ec6ad0953795$var$p;
}
function $17d2ec6ad0953795$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $17d2ec6ad0953795$var$P = /\/+/g, $17d2ec6ad0953795$var$Q = [];
function $17d2ec6ad0953795$var$R(a, b, c, e) {
    if ($17d2ec6ad0953795$var$Q.length) {
        var d = $17d2ec6ad0953795$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $17d2ec6ad0953795$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $17d2ec6ad0953795$var$Q.length && $17d2ec6ad0953795$var$Q.push(a);
}
function $17d2ec6ad0953795$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $17d2ec6ad0953795$var$p:
                case $17d2ec6ad0953795$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $17d2ec6ad0953795$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $17d2ec6ad0953795$var$U(d, k);
        g += $17d2ec6ad0953795$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $17d2ec6ad0953795$var$B && a[$17d2ec6ad0953795$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $17d2ec6ad0953795$var$U(d, k++), g += $17d2ec6ad0953795$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($17d2ec6ad0953795$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $17d2ec6ad0953795$var$V(a, b, c) {
    return null == a ? 0 : $17d2ec6ad0953795$var$T(a, "", b, c);
}
function $17d2ec6ad0953795$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $17d2ec6ad0953795$var$escape(a.key) : b.toString(36);
}
function $17d2ec6ad0953795$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $17d2ec6ad0953795$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $17d2ec6ad0953795$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($17d2ec6ad0953795$var$O(a) && (a = $17d2ec6ad0953795$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($17d2ec6ad0953795$var$P, "$&/") + "/") + c)), e.push(a));
}
function $17d2ec6ad0953795$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($17d2ec6ad0953795$var$P, "$&/") + "/");
    b = $17d2ec6ad0953795$var$R(b, g, e, d);
    $17d2ec6ad0953795$var$V(a, $17d2ec6ad0953795$var$aa, b);
    $17d2ec6ad0953795$var$S(b);
}
var $17d2ec6ad0953795$var$Y = {
    current: null
};
function $17d2ec6ad0953795$var$Z() {
    var a = $17d2ec6ad0953795$var$Y.current;
    if (null === a) throw Error($17d2ec6ad0953795$var$C(321));
    return a;
}
var $17d2ec6ad0953795$var$ba = {
    ReactCurrentDispatcher: $17d2ec6ad0953795$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $17d2ec6ad0953795$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $lk4ro
};
$17d2ec6ad0953795$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $17d2ec6ad0953795$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $17d2ec6ad0953795$var$R(null, null, b, c);
        $17d2ec6ad0953795$var$V(a, $17d2ec6ad0953795$var$W, b);
        $17d2ec6ad0953795$var$S(b);
    },
    count: function(a) {
        return $17d2ec6ad0953795$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $17d2ec6ad0953795$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$17d2ec6ad0953795$var$O(a)) throw Error($17d2ec6ad0953795$var$C(143));
        return a;
    }
};
$17d2ec6ad0953795$export$16fa2f45be04daa8 = $17d2ec6ad0953795$var$F;
$17d2ec6ad0953795$export$ffb0004e005737fa = $17d2ec6ad0953795$var$r;
$17d2ec6ad0953795$export$e2c29f18771995cb = $17d2ec6ad0953795$var$u;
$17d2ec6ad0953795$export$221d75b3f55bb0bd = $17d2ec6ad0953795$var$H;
$17d2ec6ad0953795$export$5f8d39834fd61797 = $17d2ec6ad0953795$var$t;
$17d2ec6ad0953795$export$74bf444e3cd11ea5 = $17d2ec6ad0953795$var$y;
$17d2ec6ad0953795$export$ae55be85d98224ed = $17d2ec6ad0953795$var$ba;
$17d2ec6ad0953795$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($17d2ec6ad0953795$var$C(267, a));
    var e = $lk4ro({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $17d2ec6ad0953795$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$17d2ec6ad0953795$var$K.call(b, h) && !$17d2ec6ad0953795$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $17d2ec6ad0953795$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$17d2ec6ad0953795$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $17d2ec6ad0953795$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $17d2ec6ad0953795$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$17d2ec6ad0953795$export$c8a8987d4410bf2d = $17d2ec6ad0953795$var$M;
$17d2ec6ad0953795$export$d38cd72104c1f0e9 = function(a) {
    var b = $17d2ec6ad0953795$var$M.bind(null, a);
    b.type = a;
    return b;
};
$17d2ec6ad0953795$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$17d2ec6ad0953795$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $17d2ec6ad0953795$var$x,
        render: a
    };
};
$17d2ec6ad0953795$export$a8257692ac88316c = $17d2ec6ad0953795$var$O;
$17d2ec6ad0953795$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $17d2ec6ad0953795$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$17d2ec6ad0953795$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $17d2ec6ad0953795$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$17d2ec6ad0953795$export$35808ee640e87ca7 = function(a, b) {
    return $17d2ec6ad0953795$var$Z().useCallback(a, b);
};
$17d2ec6ad0953795$export$fae74005e78b1a27 = function(a, b) {
    return $17d2ec6ad0953795$var$Z().useContext(a, b);
};
$17d2ec6ad0953795$export$dc8fbce3eb94dc1e = function() {};
$17d2ec6ad0953795$export$6d9c69b0de29b591 = function(a, b) {
    return $17d2ec6ad0953795$var$Z().useEffect(a, b);
};
$17d2ec6ad0953795$export$d5a552a76deda3c2 = function(a, b, c) {
    return $17d2ec6ad0953795$var$Z().useImperativeHandle(a, b, c);
};
$17d2ec6ad0953795$export$e5c5a5f917a5871c = function(a, b) {
    return $17d2ec6ad0953795$var$Z().useLayoutEffect(a, b);
};
$17d2ec6ad0953795$export$1538c33de8887b59 = function(a, b) {
    return $17d2ec6ad0953795$var$Z().useMemo(a, b);
};
$17d2ec6ad0953795$export$13e3392192263954 = function(a, b, c) {
    return $17d2ec6ad0953795$var$Z().useReducer(a, b, c);
};
$17d2ec6ad0953795$export$b8f5890fc79d6aca = function(a) {
    return $17d2ec6ad0953795$var$Z().useRef(a);
};
$17d2ec6ad0953795$export$60241385465d0a34 = function(a) {
    return $17d2ec6ad0953795$var$Z().useState(a);
};
$17d2ec6ad0953795$export$83d89fbfd8236492 = "16.13.1";

});
parcelRegister("lk4ro", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $f85ee90fccfdc63d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f85ee90fccfdc63d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f85ee90fccfdc63d$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $f85ee90fccfdc63d$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $f85ee90fccfdc63d$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $f85ee90fccfdc63d$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $f85ee90fccfdc63d$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($f85ee90fccfdc63d$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($f85ee90fccfdc63d$var$getOwnPropertySymbols) {
            symbols = $f85ee90fccfdc63d$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($f85ee90fccfdc63d$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("aBztI", function(module, exports) {
'use strict';
function $7b88e15745b6d10e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7b88e15745b6d10e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7b88e15745b6d10e$var$checkDCE();

module.exports = (parcelRequire("amAMB"));

});
parcelRegister("amAMB", function(module, exports) {
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $lgFxF = parcelRequire("lgFxF");

var $lk4ro = parcelRequire("lk4ro");

var $5hOxT = parcelRequire("5hOxT");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$lgFxF) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $lgFxF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $lk4ro({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $lgFxF.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $lk4ro({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $lk4ro({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $5hOxT.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $5hOxT.unstable_scheduleCallback($5hOxT.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $5hOxT.unstable_UserBlockingPriority, ed = $5hOxT.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $lk4ro({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$lk4ro(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $lk4ro(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $lk4ro({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $lk4ro({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $5hOxT.unstable_runWithPriority, Jf = $5hOxT.unstable_scheduleCallback, Kf = $5hOxT.unstable_cancelCallback, Lf = $5hOxT.unstable_requestPaint, Mf = $5hOxT.unstable_now, Nf = $5hOxT.unstable_getCurrentPriorityLevel, Of = $5hOxT.unstable_ImmediatePriority, Pf = $5hOxT.unstable_UserBlockingPriority, Qf = $5hOxT.unstable_NormalPriority, Rf = $5hOxT.unstable_LowPriority, Sf = $5hOxT.unstable_IdlePriority, Tf = {}, Uf = $5hOxT.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $lk4ro({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $lk4ro({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $lgFxF.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $lk4ro({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $lk4ro({}, f, {
                    value: void 0
                });
                d = $lk4ro({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $lk4ro({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($lk4ro({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.13.1",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.13.1";

});
parcelRegister("5hOxT", function(module, exports) {
'use strict';

module.exports = (parcelRequire("96V4K"));

});
parcelRegister("96V4K", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $6a20f2a3c12833d3$export$c4744153514ff05d, (v) => $6a20f2a3c12833d3$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $6a20f2a3c12833d3$export$d66a1c1c77bd778b, (v) => $6a20f2a3c12833d3$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $6a20f2a3c12833d3$export$3e506c1ccc9cc1a7, (v) => $6a20f2a3c12833d3$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $6a20f2a3c12833d3$export$e26fe2ed2fa76875, (v) => $6a20f2a3c12833d3$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $6a20f2a3c12833d3$export$502329bbf4b505b1, (v) => $6a20f2a3c12833d3$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $6a20f2a3c12833d3$export$6e3807111c4874c4, (v) => $6a20f2a3c12833d3$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $6a20f2a3c12833d3$export$c27134553091fb3a, (v) => $6a20f2a3c12833d3$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $6a20f2a3c12833d3$export$33ee1acdc04fd2a2, (v) => $6a20f2a3c12833d3$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $6a20f2a3c12833d3$export$b00a404bbd5edef2, (v) => $6a20f2a3c12833d3$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $6a20f2a3c12833d3$export$8352ce38b91d0c62, (v) => $6a20f2a3c12833d3$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $6a20f2a3c12833d3$export$d3dfb8e4810cb555, (v) => $6a20f2a3c12833d3$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $6a20f2a3c12833d3$export$839f9183b0465a69, (v) => $6a20f2a3c12833d3$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $6a20f2a3c12833d3$export$72fdf0e06517287b, (v) => $6a20f2a3c12833d3$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $6a20f2a3c12833d3$export$4b844e58a3e414b4, (v) => $6a20f2a3c12833d3$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $6a20f2a3c12833d3$export$816d2913ae6b83b1, (v) => $6a20f2a3c12833d3$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $6a20f2a3c12833d3$export$61bcfe829111a1d0, (v) => $6a20f2a3c12833d3$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $6a20f2a3c12833d3$export$7ee8c9beb337bc3f, (v) => $6a20f2a3c12833d3$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $6a20f2a3c12833d3$export$b5836b71941fa3ed, (v) => $6a20f2a3c12833d3$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $6a20f2a3c12833d3$export$cf845f2c119da08a, (v) => $6a20f2a3c12833d3$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6a20f2a3c12833d3$export$c4744153514ff05d;
var $6a20f2a3c12833d3$export$d66a1c1c77bd778b;
var $6a20f2a3c12833d3$export$3e506c1ccc9cc1a7;
var $6a20f2a3c12833d3$export$e26fe2ed2fa76875;
var $6a20f2a3c12833d3$export$502329bbf4b505b1;
var $6a20f2a3c12833d3$export$6e3807111c4874c4;
var $6a20f2a3c12833d3$export$c27134553091fb3a;
var $6a20f2a3c12833d3$export$33ee1acdc04fd2a2;
var $6a20f2a3c12833d3$export$b00a404bbd5edef2;
var $6a20f2a3c12833d3$export$8352ce38b91d0c62;
var $6a20f2a3c12833d3$export$d3dfb8e4810cb555;
var $6a20f2a3c12833d3$export$839f9183b0465a69;
var $6a20f2a3c12833d3$export$72fdf0e06517287b;
var $6a20f2a3c12833d3$export$4b844e58a3e414b4;
var $6a20f2a3c12833d3$export$816d2913ae6b83b1;
var $6a20f2a3c12833d3$export$61bcfe829111a1d0;
var $6a20f2a3c12833d3$export$7ee8c9beb337bc3f;
var $6a20f2a3c12833d3$export$b5836b71941fa3ed;
var $6a20f2a3c12833d3$export$cf845f2c119da08a;
'use strict';
var $6a20f2a3c12833d3$var$f, $6a20f2a3c12833d3$var$g, $6a20f2a3c12833d3$var$h, $6a20f2a3c12833d3$var$k, $6a20f2a3c12833d3$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $6a20f2a3c12833d3$var$p = null, $6a20f2a3c12833d3$var$q = null, $6a20f2a3c12833d3$var$t = function() {
        if (null !== $6a20f2a3c12833d3$var$p) try {
            var a = $6a20f2a3c12833d3$export$c4744153514ff05d();
            $6a20f2a3c12833d3$var$p(!0, a);
            $6a20f2a3c12833d3$var$p = null;
        } catch (b) {
            throw setTimeout($6a20f2a3c12833d3$var$t, 0), b;
        }
    }, $6a20f2a3c12833d3$var$u = Date.now();
    $6a20f2a3c12833d3$export$c4744153514ff05d = function() {
        return Date.now() - $6a20f2a3c12833d3$var$u;
    };
    $6a20f2a3c12833d3$var$f = function(a) {
        null !== $6a20f2a3c12833d3$var$p ? setTimeout($6a20f2a3c12833d3$var$f, 0, a) : ($6a20f2a3c12833d3$var$p = a, setTimeout($6a20f2a3c12833d3$var$t, 0));
    };
    $6a20f2a3c12833d3$var$g = function(a, b) {
        $6a20f2a3c12833d3$var$q = setTimeout(a, b);
    };
    $6a20f2a3c12833d3$var$h = function() {
        clearTimeout($6a20f2a3c12833d3$var$q);
    };
    $6a20f2a3c12833d3$var$k = function() {
        return !1;
    };
    $6a20f2a3c12833d3$var$l = $6a20f2a3c12833d3$export$d66a1c1c77bd778b = function() {};
} else {
    var $6a20f2a3c12833d3$var$w = window.performance, $6a20f2a3c12833d3$var$x = window.Date, $6a20f2a3c12833d3$var$y = window.setTimeout, $6a20f2a3c12833d3$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $6a20f2a3c12833d3$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $6a20f2a3c12833d3$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $6a20f2a3c12833d3$var$w && "function" === typeof $6a20f2a3c12833d3$var$w.now) $6a20f2a3c12833d3$export$c4744153514ff05d = function() {
        return $6a20f2a3c12833d3$var$w.now();
    };
    else {
        var $6a20f2a3c12833d3$var$B = $6a20f2a3c12833d3$var$x.now();
        $6a20f2a3c12833d3$export$c4744153514ff05d = function() {
            return $6a20f2a3c12833d3$var$x.now() - $6a20f2a3c12833d3$var$B;
        };
    }
    var $6a20f2a3c12833d3$var$C = !1, $6a20f2a3c12833d3$var$D = null, $6a20f2a3c12833d3$var$E = -1, $6a20f2a3c12833d3$var$F = 5, $6a20f2a3c12833d3$var$G = 0;
    $6a20f2a3c12833d3$var$k = function() {
        return $6a20f2a3c12833d3$export$c4744153514ff05d() >= $6a20f2a3c12833d3$var$G;
    };
    $6a20f2a3c12833d3$var$l = function() {};
    $6a20f2a3c12833d3$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $6a20f2a3c12833d3$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $6a20f2a3c12833d3$var$H = new MessageChannel, $6a20f2a3c12833d3$var$I = $6a20f2a3c12833d3$var$H.port2;
    $6a20f2a3c12833d3$var$H.port1.onmessage = function() {
        if (null !== $6a20f2a3c12833d3$var$D) {
            var a = $6a20f2a3c12833d3$export$c4744153514ff05d();
            $6a20f2a3c12833d3$var$G = a + $6a20f2a3c12833d3$var$F;
            try {
                $6a20f2a3c12833d3$var$D(!0, a) ? $6a20f2a3c12833d3$var$I.postMessage(null) : ($6a20f2a3c12833d3$var$C = !1, $6a20f2a3c12833d3$var$D = null);
            } catch (b) {
                throw $6a20f2a3c12833d3$var$I.postMessage(null), b;
            }
        } else $6a20f2a3c12833d3$var$C = !1;
    };
    $6a20f2a3c12833d3$var$f = function(a) {
        $6a20f2a3c12833d3$var$D = a;
        $6a20f2a3c12833d3$var$C || ($6a20f2a3c12833d3$var$C = !0, $6a20f2a3c12833d3$var$I.postMessage(null));
    };
    $6a20f2a3c12833d3$var$g = function(a, b) {
        $6a20f2a3c12833d3$var$E = $6a20f2a3c12833d3$var$y(function() {
            a($6a20f2a3c12833d3$export$c4744153514ff05d());
        }, b);
    };
    $6a20f2a3c12833d3$var$h = function() {
        $6a20f2a3c12833d3$var$z($6a20f2a3c12833d3$var$E);
        $6a20f2a3c12833d3$var$E = -1;
    };
}
function $6a20f2a3c12833d3$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $6a20f2a3c12833d3$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6a20f2a3c12833d3$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $6a20f2a3c12833d3$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $6a20f2a3c12833d3$var$K(n, c)) void 0 !== r && 0 > $6a20f2a3c12833d3$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $6a20f2a3c12833d3$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $6a20f2a3c12833d3$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $6a20f2a3c12833d3$var$N = [], $6a20f2a3c12833d3$var$O = [], $6a20f2a3c12833d3$var$P = 1, $6a20f2a3c12833d3$var$Q = null, $6a20f2a3c12833d3$var$R = 3, $6a20f2a3c12833d3$var$S = !1, $6a20f2a3c12833d3$var$T = !1, $6a20f2a3c12833d3$var$U = !1;
function $6a20f2a3c12833d3$var$V(a) {
    for(var b = $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$O); null !== b;){
        if (null === b.callback) $6a20f2a3c12833d3$var$M($6a20f2a3c12833d3$var$O);
        else if (b.startTime <= a) $6a20f2a3c12833d3$var$M($6a20f2a3c12833d3$var$O), b.sortIndex = b.expirationTime, $6a20f2a3c12833d3$var$J($6a20f2a3c12833d3$var$N, b);
        else break;
        b = $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$O);
    }
}
function $6a20f2a3c12833d3$var$W(a) {
    $6a20f2a3c12833d3$var$U = !1;
    $6a20f2a3c12833d3$var$V(a);
    if (!$6a20f2a3c12833d3$var$T) {
        if (null !== $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$N)) $6a20f2a3c12833d3$var$T = !0, $6a20f2a3c12833d3$var$f($6a20f2a3c12833d3$var$X);
        else {
            var b = $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$O);
            null !== b && $6a20f2a3c12833d3$var$g($6a20f2a3c12833d3$var$W, b.startTime - a);
        }
    }
}
function $6a20f2a3c12833d3$var$X(a, b) {
    $6a20f2a3c12833d3$var$T = !1;
    $6a20f2a3c12833d3$var$U && ($6a20f2a3c12833d3$var$U = !1, $6a20f2a3c12833d3$var$h());
    $6a20f2a3c12833d3$var$S = !0;
    var c = $6a20f2a3c12833d3$var$R;
    try {
        $6a20f2a3c12833d3$var$V(b);
        for($6a20f2a3c12833d3$var$Q = $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$N); null !== $6a20f2a3c12833d3$var$Q && (!($6a20f2a3c12833d3$var$Q.expirationTime > b) || a && !$6a20f2a3c12833d3$var$k());){
            var d = $6a20f2a3c12833d3$var$Q.callback;
            if (null !== d) {
                $6a20f2a3c12833d3$var$Q.callback = null;
                $6a20f2a3c12833d3$var$R = $6a20f2a3c12833d3$var$Q.priorityLevel;
                var e = d($6a20f2a3c12833d3$var$Q.expirationTime <= b);
                b = $6a20f2a3c12833d3$export$c4744153514ff05d();
                "function" === typeof e ? $6a20f2a3c12833d3$var$Q.callback = e : $6a20f2a3c12833d3$var$Q === $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$N) && $6a20f2a3c12833d3$var$M($6a20f2a3c12833d3$var$N);
                $6a20f2a3c12833d3$var$V(b);
            } else $6a20f2a3c12833d3$var$M($6a20f2a3c12833d3$var$N);
            $6a20f2a3c12833d3$var$Q = $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$N);
        }
        if (null !== $6a20f2a3c12833d3$var$Q) var m = !0;
        else {
            var n = $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$O);
            null !== n && $6a20f2a3c12833d3$var$g($6a20f2a3c12833d3$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $6a20f2a3c12833d3$var$Q = null, $6a20f2a3c12833d3$var$R = c, $6a20f2a3c12833d3$var$S = !1;
    }
}
function $6a20f2a3c12833d3$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $6a20f2a3c12833d3$var$Z = $6a20f2a3c12833d3$var$l;
$6a20f2a3c12833d3$export$3e506c1ccc9cc1a7 = 5;
$6a20f2a3c12833d3$export$e26fe2ed2fa76875 = 1;
$6a20f2a3c12833d3$export$502329bbf4b505b1 = 4;
$6a20f2a3c12833d3$export$6e3807111c4874c4 = 3;
$6a20f2a3c12833d3$export$c27134553091fb3a = null;
$6a20f2a3c12833d3$export$33ee1acdc04fd2a2 = 2;
$6a20f2a3c12833d3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6a20f2a3c12833d3$export$8352ce38b91d0c62 = function() {
    $6a20f2a3c12833d3$var$T || $6a20f2a3c12833d3$var$S || ($6a20f2a3c12833d3$var$T = !0, $6a20f2a3c12833d3$var$f($6a20f2a3c12833d3$var$X));
};
$6a20f2a3c12833d3$export$d3dfb8e4810cb555 = function() {
    return $6a20f2a3c12833d3$var$R;
};
$6a20f2a3c12833d3$export$839f9183b0465a69 = function() {
    return $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$N);
};
$6a20f2a3c12833d3$export$72fdf0e06517287b = function(a) {
    switch($6a20f2a3c12833d3$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6a20f2a3c12833d3$var$R;
    }
    var c = $6a20f2a3c12833d3$var$R;
    $6a20f2a3c12833d3$var$R = b;
    try {
        return a();
    } finally{
        $6a20f2a3c12833d3$var$R = c;
    }
};
$6a20f2a3c12833d3$export$4b844e58a3e414b4 = function() {};
$6a20f2a3c12833d3$export$816d2913ae6b83b1 = $6a20f2a3c12833d3$var$Z;
$6a20f2a3c12833d3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6a20f2a3c12833d3$var$R;
    $6a20f2a3c12833d3$var$R = a;
    try {
        return b();
    } finally{
        $6a20f2a3c12833d3$var$R = c;
    }
};
$6a20f2a3c12833d3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6a20f2a3c12833d3$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $6a20f2a3c12833d3$var$Y(a);
    } else c = $6a20f2a3c12833d3$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $6a20f2a3c12833d3$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $6a20f2a3c12833d3$var$J($6a20f2a3c12833d3$var$O, a), null === $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$N) && a === $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$O) && ($6a20f2a3c12833d3$var$U ? $6a20f2a3c12833d3$var$h() : $6a20f2a3c12833d3$var$U = !0, $6a20f2a3c12833d3$var$g($6a20f2a3c12833d3$var$W, e - d))) : (a.sortIndex = c, $6a20f2a3c12833d3$var$J($6a20f2a3c12833d3$var$N, a), $6a20f2a3c12833d3$var$T || $6a20f2a3c12833d3$var$S || ($6a20f2a3c12833d3$var$T = !0, $6a20f2a3c12833d3$var$f($6a20f2a3c12833d3$var$X)));
    return a;
};
$6a20f2a3c12833d3$export$b5836b71941fa3ed = function() {
    var a = $6a20f2a3c12833d3$export$c4744153514ff05d();
    $6a20f2a3c12833d3$var$V(a);
    var b = $6a20f2a3c12833d3$var$L($6a20f2a3c12833d3$var$N);
    return b !== $6a20f2a3c12833d3$var$Q && null !== $6a20f2a3c12833d3$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $6a20f2a3c12833d3$var$Q.expirationTime || $6a20f2a3c12833d3$var$k();
};
$6a20f2a3c12833d3$export$cf845f2c119da08a = function(a) {
    var b = $6a20f2a3c12833d3$var$R;
    return function() {
        var c = $6a20f2a3c12833d3$var$R;
        $6a20f2a3c12833d3$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6a20f2a3c12833d3$var$R = c;
        }
    };
};

});




parcelRegister("9d9Fx", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");

var $lwbau = parcelRequire("lwbau");

var $eCrWh = parcelRequire("eCrWh");

var $kSe7Y = parcelRequire("kSe7Y");

var $2Y4F5 = parcelRequire("2Y4F5");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $6b4cd404abfd0ec8$var$createInstance(defaultConfig) {
    var context = new $eCrWh(defaultConfig);
    var instance = $lwbau($eCrWh.prototype.request, context);
    // Copy axios.prototype to instance
    $i4ijA.extend(instance, $eCrWh.prototype, context);
    // Copy context to instance
    $i4ijA.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $6b4cd404abfd0ec8$var$axios = $6b4cd404abfd0ec8$var$createInstance($2Y4F5);
// Expose Axios class to allow class inheritance
$6b4cd404abfd0ec8$var$axios.Axios = $eCrWh;
// Factory for creating new instances
$6b4cd404abfd0ec8$var$axios.create = function create(instanceConfig) {
    return $6b4cd404abfd0ec8$var$createInstance($kSe7Y($6b4cd404abfd0ec8$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$6b4cd404abfd0ec8$var$axios.Cancel = (parcelRequire("kKSgw"));

$6b4cd404abfd0ec8$var$axios.CancelToken = (parcelRequire("9GGcx"));

$6b4cd404abfd0ec8$var$axios.isCancel = (parcelRequire("5SIUr"));
// Expose all/spread
$6b4cd404abfd0ec8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$6b4cd404abfd0ec8$var$axios.spread = (parcelRequire("4rx4g"));
module.exports = $6b4cd404abfd0ec8$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $6b4cd404abfd0ec8$var$axios;

});
parcelRegister("i4ijA", function(module, exports) {
'use strict';

var $lwbau = parcelRequire("lwbau");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $d276ceaf10d97c14$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $d276ceaf10d97c14$var$isArray(val) {
    return $d276ceaf10d97c14$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $d276ceaf10d97c14$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $d276ceaf10d97c14$var$isBuffer(val) {
    return val !== null && !$d276ceaf10d97c14$var$isUndefined(val) && val.constructor !== null && !$d276ceaf10d97c14$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $d276ceaf10d97c14$var$isArrayBuffer(val) {
    return $d276ceaf10d97c14$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $d276ceaf10d97c14$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $d276ceaf10d97c14$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $d276ceaf10d97c14$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $d276ceaf10d97c14$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $d276ceaf10d97c14$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $d276ceaf10d97c14$var$isPlainObject(val) {
    if ($d276ceaf10d97c14$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $d276ceaf10d97c14$var$isDate(val) {
    return $d276ceaf10d97c14$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $d276ceaf10d97c14$var$isFile(val) {
    return $d276ceaf10d97c14$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $d276ceaf10d97c14$var$isBlob(val) {
    return $d276ceaf10d97c14$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $d276ceaf10d97c14$var$isFunction(val) {
    return $d276ceaf10d97c14$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $d276ceaf10d97c14$var$isStream(val) {
    return $d276ceaf10d97c14$var$isObject(val) && $d276ceaf10d97c14$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $d276ceaf10d97c14$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $d276ceaf10d97c14$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $d276ceaf10d97c14$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $d276ceaf10d97c14$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($d276ceaf10d97c14$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $d276ceaf10d97c14$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($d276ceaf10d97c14$var$isPlainObject(result[key]) && $d276ceaf10d97c14$var$isPlainObject(val)) result[key] = $d276ceaf10d97c14$var$merge(result[key], val);
        else if ($d276ceaf10d97c14$var$isPlainObject(val)) result[key] = $d276ceaf10d97c14$var$merge({}, val);
        else if ($d276ceaf10d97c14$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$d276ceaf10d97c14$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $d276ceaf10d97c14$var$extend(a, b, thisArg) {
    $d276ceaf10d97c14$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $lwbau(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $d276ceaf10d97c14$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $d276ceaf10d97c14$var$isArray,
    isArrayBuffer: $d276ceaf10d97c14$var$isArrayBuffer,
    isBuffer: $d276ceaf10d97c14$var$isBuffer,
    isFormData: $d276ceaf10d97c14$var$isFormData,
    isArrayBufferView: $d276ceaf10d97c14$var$isArrayBufferView,
    isString: $d276ceaf10d97c14$var$isString,
    isNumber: $d276ceaf10d97c14$var$isNumber,
    isObject: $d276ceaf10d97c14$var$isObject,
    isPlainObject: $d276ceaf10d97c14$var$isPlainObject,
    isUndefined: $d276ceaf10d97c14$var$isUndefined,
    isDate: $d276ceaf10d97c14$var$isDate,
    isFile: $d276ceaf10d97c14$var$isFile,
    isBlob: $d276ceaf10d97c14$var$isBlob,
    isFunction: $d276ceaf10d97c14$var$isFunction,
    isStream: $d276ceaf10d97c14$var$isStream,
    isURLSearchParams: $d276ceaf10d97c14$var$isURLSearchParams,
    isStandardBrowserEnv: $d276ceaf10d97c14$var$isStandardBrowserEnv,
    forEach: $d276ceaf10d97c14$var$forEach,
    merge: $d276ceaf10d97c14$var$merge,
    extend: $d276ceaf10d97c14$var$extend,
    trim: $d276ceaf10d97c14$var$trim,
    stripBOM: $d276ceaf10d97c14$var$stripBOM
};

});
parcelRegister("lwbau", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("eCrWh", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");

var $h9Lf1 = parcelRequire("h9Lf1");

var $itbxz = parcelRequire("itbxz");

var $2u9Ce = parcelRequire("2u9Ce");

var $kSe7Y = parcelRequire("kSe7Y");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $aa4a4968ac7003a8$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $itbxz(),
        response: new $itbxz()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $aa4a4968ac7003a8$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $kSe7Y(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    // Hook up interceptors middleware
    var chain = [
        $2u9Ce,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$aa4a4968ac7003a8$var$Axios.prototype.getUri = function getUri(config) {
    config = $kSe7Y(this.defaults, config);
    return $h9Lf1(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$i4ijA.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $aa4a4968ac7003a8$var$Axios.prototype[method] = function(url, config) {
        return this.request($kSe7Y(config || {}, {
            method: method,
            url: url
        }));
    };
});
$i4ijA.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $aa4a4968ac7003a8$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($kSe7Y(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $aa4a4968ac7003a8$var$Axios;

});
parcelRegister("h9Lf1", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");
function $c7d7ec0d2502b763$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($i4ijA.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $i4ijA.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($i4ijA.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $i4ijA.forEach(val, function parseValue(v) {
                if ($i4ijA.isDate(v)) v = v.toISOString();
                else if ($i4ijA.isObject(v)) v = JSON.stringify(v);
                parts.push($c7d7ec0d2502b763$var$encode(key) + '=' + $c7d7ec0d2502b763$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("itbxz", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");
function $d723e3221e1c4ee2$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $d723e3221e1c4ee2$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $d723e3221e1c4ee2$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $d723e3221e1c4ee2$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $i4ijA.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $d723e3221e1c4ee2$var$InterceptorManager;

});

parcelRegister("2u9Ce", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");

var $iQhXV = parcelRequire("iQhXV");

var $5SIUr = parcelRequire("5SIUr");

var $2Y4F5 = parcelRequire("2Y4F5");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $1cf5d79166687f5c$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $1cf5d79166687f5c$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $iQhXV(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $i4ijA.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $i4ijA.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $2Y4F5.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $1cf5d79166687f5c$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $iQhXV(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$5SIUr(reason)) {
            $1cf5d79166687f5c$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $iQhXV(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("iQhXV", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $i4ijA.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("5SIUr", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("2Y4F5", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");

var $fwPMl = parcelRequire("fwPMl");
var $2294cd1427668d43$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $2294cd1427668d43$var$setContentTypeIfUnset(headers, value) {
    if (!$i4ijA.isUndefined(headers) && $i4ijA.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $2294cd1427668d43$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("2kdvM"));
    return adapter;
}
var $2294cd1427668d43$var$defaults = {
    adapter: $2294cd1427668d43$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $fwPMl(headers, 'Accept');
            $fwPMl(headers, 'Content-Type');
            if ($i4ijA.isFormData(data) || $i4ijA.isArrayBuffer(data) || $i4ijA.isBuffer(data) || $i4ijA.isStream(data) || $i4ijA.isFile(data) || $i4ijA.isBlob(data)) return data;
            if ($i4ijA.isArrayBufferView(data)) return data.buffer;
            if ($i4ijA.isURLSearchParams(data)) {
                $2294cd1427668d43$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($i4ijA.isObject(data)) {
                $2294cd1427668d43$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$2294cd1427668d43$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$i4ijA.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $2294cd1427668d43$var$defaults.headers[method] = {};
});
$i4ijA.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $2294cd1427668d43$var$defaults.headers[method] = $i4ijA.merge($2294cd1427668d43$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $2294cd1427668d43$var$defaults;

});
parcelRegister("fwPMl", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $i4ijA.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("2kdvM", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");

var $4Bh8W = parcelRequire("4Bh8W");

var $j9ifV = parcelRequire("j9ifV");

var $h9Lf1 = parcelRequire("h9Lf1");

var $kHvG3 = parcelRequire("kHvG3");

var $gwcWo = parcelRequire("gwcWo");

var $kgVUb = parcelRequire("kgVUb");

var $6EBa4 = parcelRequire("6EBa4");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($i4ijA.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        if (($i4ijA.isBlob(requestData) || $i4ijA.isFile(requestData)) && requestData.type) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = unescape(encodeURIComponent(config.auth.password)) || '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $kHvG3(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $h9Lf1(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $gwcWo(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $4Bh8W(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($6EBa4('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($6EBa4('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($6EBa4(timeoutErrorMessage, config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($i4ijA.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $kgVUb(fullPath)) && config.xsrfCookieName ? $j9ifV.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $i4ijA.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$i4ijA.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("4Bh8W", function(module, exports) {
'use strict';

var $6EBa4 = parcelRequire("6EBa4");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($6EBa4('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("6EBa4", function(module, exports) {
'use strict';

var $FzJVl = parcelRequire("FzJVl");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $FzJVl(error, config, code, request, response);
};

});
parcelRegister("FzJVl", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("j9ifV", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");
module.exports = $i4ijA.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($i4ijA.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($i4ijA.isString(path)) cookie.push('path=' + path);
            if ($i4ijA.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("kHvG3", function(module, exports) {
'use strict';

var $2IQpt = parcelRequire("2IQpt");

var $bb7xE = parcelRequire("bb7xE");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$2IQpt(requestedURL)) return $bb7xE(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("2IQpt", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("bb7xE", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("gwcWo", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $c069ac43578f2ab0$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $i4ijA.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $i4ijA.trim(line.substr(0, i)).toLowerCase();
        val = $i4ijA.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $c069ac43578f2ab0$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("kgVUb", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");
module.exports = $i4ijA.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $i4ijA.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("kSe7Y", function(module, exports) {
'use strict';

var $i4ijA = parcelRequire("i4ijA");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($i4ijA.isPlainObject(target) && $i4ijA.isPlainObject(source)) return $i4ijA.merge(target, source);
        else if ($i4ijA.isPlainObject(source)) return $i4ijA.merge({}, source);
        else if ($i4ijA.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$i4ijA.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$i4ijA.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $i4ijA.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$i4ijA.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $i4ijA.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $i4ijA.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$i4ijA.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$i4ijA.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $i4ijA.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $i4ijA.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});


parcelRegister("kKSgw", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $f1c23285181b86c7$var$Cancel(message) {
    this.message = message;
}
$f1c23285181b86c7$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$f1c23285181b86c7$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $f1c23285181b86c7$var$Cancel;

});

parcelRegister("9GGcx", function(module, exports) {
'use strict';

var $kKSgw = parcelRequire("kKSgw");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $70d8c5980303e5f5$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $kKSgw(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $70d8c5980303e5f5$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $70d8c5980303e5f5$var$CancelToken.source = function source() {
    var cancel;
    var token = new $70d8c5980303e5f5$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $70d8c5980303e5f5$var$CancelToken;

});

parcelRegister("4rx4g", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});


parcelRegister("aHLOA", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.20';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g, reTrimStart = /^\s+/, reTrimEnd = /\s+$/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = value.replace(reTrim, '');
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrim, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimEnd, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("ae8en", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $772198ad8eb79c5e$var$isArray = Array.isArray;
module.exports = $772198ad8eb79c5e$var$isArray;

});

parcelRegister("8Nda1", function(module, exports) {

var $8hDRs = parcelRequire("8hDRs");

var $24Rur = parcelRequire("24Rur");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8hDRs.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $24Rur;
module.exports = isBuffer;

});
parcelRegister("8hDRs", function(module, exports) {

var $jc27j = parcelRequire("jc27j");
/** Detect free variable `self`. */ var $607ed4d8f2e85ef3$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $607ed4d8f2e85ef3$var$root = $jc27j || $607ed4d8f2e85ef3$var$freeSelf || Function('return this')();
module.exports = $607ed4d8f2e85ef3$var$root;

});
parcelRegister("jc27j", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $df90c7af3baf8377$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $df90c7af3baf8377$var$freeGlobal;

});


parcelRegister("24Rur", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $1835728287f9d4f5$var$stubFalse() {
    return false;
}
module.exports = $1835728287f9d4f5$var$stubFalse;

});


parcelRegister("eR4B6", function(module, exports) {

var $jc27j = parcelRequire("jc27j");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $jc27j.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("bHMyM", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $885960d5b1728b84$var$identity(value) {
    return value;
}
module.exports = $885960d5b1728b84$var$identity;

});

parcelRegister("6ZVPo", function(module, exports) {
module.exports = import("4HS37").then(()=>parcelRequire('jGAly'));

});

parcelRegister("iJ0c1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iTcbh = parcelRequire("iTcbh");
function $da1c9442ee37b7f0$var$emptyFunction() {}
function $da1c9442ee37b7f0$var$emptyFunctionWithReset() {}
$da1c9442ee37b7f0$var$emptyFunctionWithReset.resetWarningCache = $da1c9442ee37b7f0$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iTcbh) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $da1c9442ee37b7f0$var$emptyFunctionWithReset,
        resetWarningCache: $da1c9442ee37b7f0$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iTcbh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $dc06cff46834b7c7$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $dc06cff46834b7c7$var$ReactPropTypesSecret;

});


parcelRegister("bilGQ", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $8392335a7c1d6a23$export$2b8d127b894957b9, (v) => $8392335a7c1d6a23$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $8392335a7c1d6a23$export$cea3a54a6425200c, (v) => $8392335a7c1d6a23$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $8392335a7c1d6a23$export$a7c73072b1a182ae, (v) => $8392335a7c1d6a23$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8392335a7c1d6a23$export$9f27bc3417b4524d, (v) => $8392335a7c1d6a23$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8392335a7c1d6a23$export$db77ccec0bb4ccac, (v) => $8392335a7c1d6a23$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8392335a7c1d6a23$export$8392c0c9d3dcbd35, (v) => $8392335a7c1d6a23$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8392335a7c1d6a23$export$ffb0004e005737fa, (v) => $8392335a7c1d6a23$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8392335a7c1d6a23$export$b624eff549462981, (v) => $8392335a7c1d6a23$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8392335a7c1d6a23$export$7897aa7841a5380c, (v) => $8392335a7c1d6a23$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8392335a7c1d6a23$export$602eac185826482c, (v) => $8392335a7c1d6a23$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8392335a7c1d6a23$export$e2c29f18771995cb, (v) => $8392335a7c1d6a23$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8392335a7c1d6a23$export$5f8d39834fd61797, (v) => $8392335a7c1d6a23$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8392335a7c1d6a23$export$74bf444e3cd11ea5, (v) => $8392335a7c1d6a23$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8392335a7c1d6a23$export$92387174baf9b227, (v) => $8392335a7c1d6a23$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8392335a7c1d6a23$export$ec112efeb987d9c6, (v) => $8392335a7c1d6a23$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8392335a7c1d6a23$export$b706b080d889d2c9, (v) => $8392335a7c1d6a23$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8392335a7c1d6a23$export$5be5a87408f70ddc, (v) => $8392335a7c1d6a23$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8392335a7c1d6a23$export$45a5e7f76e0caa8d, (v) => $8392335a7c1d6a23$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8392335a7c1d6a23$export$455c2e768291efa6, (v) => $8392335a7c1d6a23$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8392335a7c1d6a23$export$9522e17588c12572, (v) => $8392335a7c1d6a23$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8392335a7c1d6a23$export$2110ac352bb060b9, (v) => $8392335a7c1d6a23$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8392335a7c1d6a23$export$56885ab8b9c456ab, (v) => $8392335a7c1d6a23$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8392335a7c1d6a23$export$d927fcb6adf8f9de, (v) => $8392335a7c1d6a23$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8392335a7c1d6a23$export$b82d16f27459e05a, (v) => $8392335a7c1d6a23$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8392335a7c1d6a23$export$522c17b4f5e123e8, (v) => $8392335a7c1d6a23$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8392335a7c1d6a23$export$1aabd8a0274ecfd6, (v) => $8392335a7c1d6a23$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $8392335a7c1d6a23$export$9b621391a187a31a, (v) => $8392335a7c1d6a23$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8392335a7c1d6a23$export$f5bbd400c2f4426f, (v) => $8392335a7c1d6a23$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8392335a7c1d6a23$export$2b8d127b894957b9;
var $8392335a7c1d6a23$export$cea3a54a6425200c;
var $8392335a7c1d6a23$export$a7c73072b1a182ae;
var $8392335a7c1d6a23$export$9f27bc3417b4524d;
var $8392335a7c1d6a23$export$db77ccec0bb4ccac;
var $8392335a7c1d6a23$export$8392c0c9d3dcbd35;
var $8392335a7c1d6a23$export$ffb0004e005737fa;
var $8392335a7c1d6a23$export$b624eff549462981;
var $8392335a7c1d6a23$export$7897aa7841a5380c;
var $8392335a7c1d6a23$export$602eac185826482c;
var $8392335a7c1d6a23$export$e2c29f18771995cb;
var $8392335a7c1d6a23$export$5f8d39834fd61797;
var $8392335a7c1d6a23$export$74bf444e3cd11ea5;
var $8392335a7c1d6a23$export$92387174baf9b227;
var $8392335a7c1d6a23$export$ec112efeb987d9c6;
var $8392335a7c1d6a23$export$b706b080d889d2c9;
var $8392335a7c1d6a23$export$5be5a87408f70ddc;
var $8392335a7c1d6a23$export$45a5e7f76e0caa8d;
var $8392335a7c1d6a23$export$455c2e768291efa6;
var $8392335a7c1d6a23$export$9522e17588c12572;
var $8392335a7c1d6a23$export$2110ac352bb060b9;
var $8392335a7c1d6a23$export$56885ab8b9c456ab;
var $8392335a7c1d6a23$export$d927fcb6adf8f9de;
var $8392335a7c1d6a23$export$b82d16f27459e05a;
var $8392335a7c1d6a23$export$522c17b4f5e123e8;
var $8392335a7c1d6a23$export$1aabd8a0274ecfd6;
var $8392335a7c1d6a23$export$9b621391a187a31a;
var $8392335a7c1d6a23$export$f5bbd400c2f4426f;
'use strict';
var $8392335a7c1d6a23$var$b = "function" === typeof Symbol && Symbol.for, $8392335a7c1d6a23$var$c = $8392335a7c1d6a23$var$b ? Symbol.for("react.element") : 60103, $8392335a7c1d6a23$var$d = $8392335a7c1d6a23$var$b ? Symbol.for("react.portal") : 60106, $8392335a7c1d6a23$var$e = $8392335a7c1d6a23$var$b ? Symbol.for("react.fragment") : 60107, $8392335a7c1d6a23$var$f = $8392335a7c1d6a23$var$b ? Symbol.for("react.strict_mode") : 60108, $8392335a7c1d6a23$var$g = $8392335a7c1d6a23$var$b ? Symbol.for("react.profiler") : 60114, $8392335a7c1d6a23$var$h = $8392335a7c1d6a23$var$b ? Symbol.for("react.provider") : 60109, $8392335a7c1d6a23$var$k = $8392335a7c1d6a23$var$b ? Symbol.for("react.context") : 60110, $8392335a7c1d6a23$var$l = $8392335a7c1d6a23$var$b ? Symbol.for("react.async_mode") : 60111, $8392335a7c1d6a23$var$m = $8392335a7c1d6a23$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8392335a7c1d6a23$var$n = $8392335a7c1d6a23$var$b ? Symbol.for("react.forward_ref") : 60112, $8392335a7c1d6a23$var$p = $8392335a7c1d6a23$var$b ? Symbol.for("react.suspense") : 60113, $8392335a7c1d6a23$var$q = $8392335a7c1d6a23$var$b ? Symbol.for("react.suspense_list") : 60120, $8392335a7c1d6a23$var$r = $8392335a7c1d6a23$var$b ? Symbol.for("react.memo") : 60115, $8392335a7c1d6a23$var$t = $8392335a7c1d6a23$var$b ? Symbol.for("react.lazy") : 60116, $8392335a7c1d6a23$var$v = $8392335a7c1d6a23$var$b ? Symbol.for("react.block") : 60121, $8392335a7c1d6a23$var$w = $8392335a7c1d6a23$var$b ? Symbol.for("react.fundamental") : 60117, $8392335a7c1d6a23$var$x = $8392335a7c1d6a23$var$b ? Symbol.for("react.responder") : 60118, $8392335a7c1d6a23$var$y = $8392335a7c1d6a23$var$b ? Symbol.for("react.scope") : 60119;
function $8392335a7c1d6a23$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8392335a7c1d6a23$var$c:
                switch(a = a.type, a){
                    case $8392335a7c1d6a23$var$l:
                    case $8392335a7c1d6a23$var$m:
                    case $8392335a7c1d6a23$var$e:
                    case $8392335a7c1d6a23$var$g:
                    case $8392335a7c1d6a23$var$f:
                    case $8392335a7c1d6a23$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8392335a7c1d6a23$var$k:
                            case $8392335a7c1d6a23$var$n:
                            case $8392335a7c1d6a23$var$t:
                            case $8392335a7c1d6a23$var$r:
                            case $8392335a7c1d6a23$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8392335a7c1d6a23$var$d:
                return u;
        }
    }
}
function $8392335a7c1d6a23$var$A(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$m;
}
$8392335a7c1d6a23$export$2b8d127b894957b9 = $8392335a7c1d6a23$var$l;
$8392335a7c1d6a23$export$cea3a54a6425200c = $8392335a7c1d6a23$var$m;
$8392335a7c1d6a23$export$a7c73072b1a182ae = $8392335a7c1d6a23$var$k;
$8392335a7c1d6a23$export$9f27bc3417b4524d = $8392335a7c1d6a23$var$h;
$8392335a7c1d6a23$export$db77ccec0bb4ccac = $8392335a7c1d6a23$var$c;
$8392335a7c1d6a23$export$8392c0c9d3dcbd35 = $8392335a7c1d6a23$var$n;
$8392335a7c1d6a23$export$ffb0004e005737fa = $8392335a7c1d6a23$var$e;
$8392335a7c1d6a23$export$b624eff549462981 = $8392335a7c1d6a23$var$t;
$8392335a7c1d6a23$export$7897aa7841a5380c = $8392335a7c1d6a23$var$r;
$8392335a7c1d6a23$export$602eac185826482c = $8392335a7c1d6a23$var$d;
$8392335a7c1d6a23$export$e2c29f18771995cb = $8392335a7c1d6a23$var$g;
$8392335a7c1d6a23$export$5f8d39834fd61797 = $8392335a7c1d6a23$var$f;
$8392335a7c1d6a23$export$74bf444e3cd11ea5 = $8392335a7c1d6a23$var$p;
$8392335a7c1d6a23$export$92387174baf9b227 = function(a) {
    return $8392335a7c1d6a23$var$A(a) || $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$l;
};
$8392335a7c1d6a23$export$ec112efeb987d9c6 = $8392335a7c1d6a23$var$A;
$8392335a7c1d6a23$export$b706b080d889d2c9 = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$k;
};
$8392335a7c1d6a23$export$5be5a87408f70ddc = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$h;
};
$8392335a7c1d6a23$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8392335a7c1d6a23$var$c;
};
$8392335a7c1d6a23$export$455c2e768291efa6 = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$n;
};
$8392335a7c1d6a23$export$9522e17588c12572 = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$e;
};
$8392335a7c1d6a23$export$2110ac352bb060b9 = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$t;
};
$8392335a7c1d6a23$export$56885ab8b9c456ab = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$r;
};
$8392335a7c1d6a23$export$d927fcb6adf8f9de = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$d;
};
$8392335a7c1d6a23$export$b82d16f27459e05a = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$g;
};
$8392335a7c1d6a23$export$522c17b4f5e123e8 = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$f;
};
$8392335a7c1d6a23$export$1aabd8a0274ecfd6 = function(a) {
    return $8392335a7c1d6a23$var$z(a) === $8392335a7c1d6a23$var$p;
};
$8392335a7c1d6a23$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8392335a7c1d6a23$var$e || a === $8392335a7c1d6a23$var$m || a === $8392335a7c1d6a23$var$g || a === $8392335a7c1d6a23$var$f || a === $8392335a7c1d6a23$var$p || a === $8392335a7c1d6a23$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8392335a7c1d6a23$var$t || a.$$typeof === $8392335a7c1d6a23$var$r || a.$$typeof === $8392335a7c1d6a23$var$h || a.$$typeof === $8392335a7c1d6a23$var$k || a.$$typeof === $8392335a7c1d6a23$var$n || a.$$typeof === $8392335a7c1d6a23$var$w || a.$$typeof === $8392335a7c1d6a23$var$x || a.$$typeof === $8392335a7c1d6a23$var$y || a.$$typeof === $8392335a7c1d6a23$var$v);
};
$8392335a7c1d6a23$export$f5bbd400c2f4426f = $8392335a7c1d6a23$var$z;

});

parcelRegister("3ThkG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2d53f409f12f98b8$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $2d53f409f12f98b8$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $2d53f409f12f98b8$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($2d53f409f12f98b8$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $2d53f409f12f98b8$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $2d53f409f12f98b8$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $2d53f409f12f98b8$var$timeoutDuration);
        }
    };
}
var $2d53f409f12f98b8$var$supportsMicroTasks = $2d53f409f12f98b8$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $2d53f409f12f98b8$var$debounce = $2d53f409f12f98b8$var$supportsMicroTasks ? $2d53f409f12f98b8$var$microtaskDebounce : $2d53f409f12f98b8$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $2d53f409f12f98b8$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $2d53f409f12f98b8$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $2d53f409f12f98b8$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $2d53f409f12f98b8$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $2d53f409f12f98b8$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $2d53f409f12f98b8$var$getScrollParent($2d53f409f12f98b8$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $2d53f409f12f98b8$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $2d53f409f12f98b8$var$isIE11 = $2d53f409f12f98b8$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $2d53f409f12f98b8$var$isIE10 = $2d53f409f12f98b8$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $2d53f409f12f98b8$var$isIE(version) {
    if (version === 11) return $2d53f409f12f98b8$var$isIE11;
    if (version === 10) return $2d53f409f12f98b8$var$isIE10;
    return $2d53f409f12f98b8$var$isIE11 || $2d53f409f12f98b8$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $2d53f409f12f98b8$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $2d53f409f12f98b8$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $2d53f409f12f98b8$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $2d53f409f12f98b8$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $2d53f409f12f98b8$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $2d53f409f12f98b8$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $2d53f409f12f98b8$var$getRoot(node) {
    if (node.parentNode !== null) return $2d53f409f12f98b8$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $2d53f409f12f98b8$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($2d53f409f12f98b8$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $2d53f409f12f98b8$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $2d53f409f12f98b8$var$getRoot(element1);
    if (element1root.host) return $2d53f409f12f98b8$var$findCommonOffsetParent(element1root.host, element2);
    else return $2d53f409f12f98b8$var$findCommonOffsetParent(element1, $2d53f409f12f98b8$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $2d53f409f12f98b8$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $2d53f409f12f98b8$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $2d53f409f12f98b8$var$getScroll(element, 'top');
    var scrollLeft = $2d53f409f12f98b8$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $2d53f409f12f98b8$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $2d53f409f12f98b8$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $2d53f409f12f98b8$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $2d53f409f12f98b8$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $2d53f409f12f98b8$var$isIE(10) && getComputedStyle(html);
    return {
        height: $2d53f409f12f98b8$var$getSize('Height', body, html, computedStyle),
        width: $2d53f409f12f98b8$var$getSize('Width', body, html, computedStyle)
    };
}
var $2d53f409f12f98b8$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $2d53f409f12f98b8$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $2d53f409f12f98b8$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $2d53f409f12f98b8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $2d53f409f12f98b8$var$getClientRect(offsets) {
    return $2d53f409f12f98b8$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $2d53f409f12f98b8$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($2d53f409f12f98b8$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $2d53f409f12f98b8$var$getScroll(element, 'top');
            var scrollLeft = $2d53f409f12f98b8$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $2d53f409f12f98b8$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $2d53f409f12f98b8$var$getStyleComputedProperty(element);
        horizScrollbar -= $2d53f409f12f98b8$var$getBordersSize(styles, 'x');
        vertScrollbar -= $2d53f409f12f98b8$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $2d53f409f12f98b8$var$getClientRect(result);
}
function $2d53f409f12f98b8$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $2d53f409f12f98b8$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $2d53f409f12f98b8$var$getBoundingClientRect(children);
    var parentRect = $2d53f409f12f98b8$var$getBoundingClientRect(parent);
    var scrollParent = $2d53f409f12f98b8$var$getScrollParent(children);
    var styles = $2d53f409f12f98b8$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $2d53f409f12f98b8$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $2d53f409f12f98b8$var$includeScroll(offsets, parent);
    return offsets;
}
function $2d53f409f12f98b8$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $2d53f409f12f98b8$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $2d53f409f12f98b8$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $2d53f409f12f98b8$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $2d53f409f12f98b8$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $2d53f409f12f98b8$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($2d53f409f12f98b8$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $2d53f409f12f98b8$var$getParentNode(element);
    if (!parentNode) return false;
    return $2d53f409f12f98b8$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $2d53f409f12f98b8$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $2d53f409f12f98b8$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $2d53f409f12f98b8$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $2d53f409f12f98b8$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $2d53f409f12f98b8$var$getFixedPositionOffsetParent(popper) : $2d53f409f12f98b8$var$findCommonOffsetParent(popper, $2d53f409f12f98b8$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $2d53f409f12f98b8$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $2d53f409f12f98b8$var$getScrollParent($2d53f409f12f98b8$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $2d53f409f12f98b8$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$2d53f409f12f98b8$var$isFixed(offsetParent)) {
            var _getWindowSizes = $2d53f409f12f98b8$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $2d53f409f12f98b8$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $2d53f409f12f98b8$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $2d53f409f12f98b8$var$_extends({
            key: key
        }, rects[key], {
            area: $2d53f409f12f98b8$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $2d53f409f12f98b8$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $2d53f409f12f98b8$var$getFixedPositionOffsetParent(popper) : $2d53f409f12f98b8$var$findCommonOffsetParent(popper, $2d53f409f12f98b8$var$getReferenceNode(reference));
    return $2d53f409f12f98b8$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $2d53f409f12f98b8$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $2d53f409f12f98b8$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $2d53f409f12f98b8$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $2d53f409f12f98b8$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$2d53f409f12f98b8$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $2d53f409f12f98b8$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $2d53f409f12f98b8$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $2d53f409f12f98b8$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $2d53f409f12f98b8$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $2d53f409f12f98b8$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $2d53f409f12f98b8$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $2d53f409f12f98b8$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $2d53f409f12f98b8$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $2d53f409f12f98b8$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $2d53f409f12f98b8$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $2d53f409f12f98b8$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $2d53f409f12f98b8$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $2d53f409f12f98b8$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $2d53f409f12f98b8$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $2d53f409f12f98b8$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $2d53f409f12f98b8$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($2d53f409f12f98b8$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$2d53f409f12f98b8$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $2d53f409f12f98b8$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $2d53f409f12f98b8$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $2d53f409f12f98b8$var$attachToScrollParents($2d53f409f12f98b8$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $2d53f409f12f98b8$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $2d53f409f12f98b8$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $2d53f409f12f98b8$var$getScrollParent(reference);
    $2d53f409f12f98b8$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $2d53f409f12f98b8$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $2d53f409f12f98b8$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $2d53f409f12f98b8$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $2d53f409f12f98b8$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $2d53f409f12f98b8$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $2d53f409f12f98b8$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $2d53f409f12f98b8$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $2d53f409f12f98b8$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $2d53f409f12f98b8$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $2d53f409f12f98b8$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $2d53f409f12f98b8$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $2d53f409f12f98b8$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $2d53f409f12f98b8$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $2d53f409f12f98b8$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $2d53f409f12f98b8$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $2d53f409f12f98b8$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $2d53f409f12f98b8$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $2d53f409f12f98b8$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $2d53f409f12f98b8$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $2d53f409f12f98b8$var$isFirefox = $2d53f409f12f98b8$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $2d53f409f12f98b8$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $2d53f409f12f98b8$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $2d53f409f12f98b8$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $2d53f409f12f98b8$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$2d53f409f12f98b8$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $2d53f409f12f98b8$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $2d53f409f12f98b8$var$_extends({}, attributes, data.attributes);
    data.styles = $2d53f409f12f98b8$var$_extends({}, styles, data.styles);
    data.arrowStyles = $2d53f409f12f98b8$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $2d53f409f12f98b8$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $2d53f409f12f98b8$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$2d53f409f12f98b8$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $2d53f409f12f98b8$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $2d53f409f12f98b8$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $2d53f409f12f98b8$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $2d53f409f12f98b8$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $2d53f409f12f98b8$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $2d53f409f12f98b8$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $2d53f409f12f98b8$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $2d53f409f12f98b8$var$validPlacements = $2d53f409f12f98b8$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $2d53f409f12f98b8$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $2d53f409f12f98b8$var$validPlacements.indexOf(placement);
    var arr = $2d53f409f12f98b8$var$validPlacements.slice(index + 1).concat($2d53f409f12f98b8$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $2d53f409f12f98b8$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($2d53f409f12f98b8$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $2d53f409f12f98b8$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $2d53f409f12f98b8$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $2d53f409f12f98b8$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $2d53f409f12f98b8$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $2d53f409f12f98b8$var$clockwise(placement);
            break;
        case $2d53f409f12f98b8$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $2d53f409f12f98b8$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $2d53f409f12f98b8$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $2d53f409f12f98b8$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $2d53f409f12f98b8$var$_extends({}, data.offsets.popper, $2d53f409f12f98b8$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $2d53f409f12f98b8$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $2d53f409f12f98b8$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $2d53f409f12f98b8$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $2d53f409f12f98b8$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($2d53f409f12f98b8$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $2d53f409f12f98b8$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($2d53f409f12f98b8$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($2d53f409f12f98b8$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $2d53f409f12f98b8$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $2d53f409f12f98b8$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $2d53f409f12f98b8$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $2d53f409f12f98b8$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $2d53f409f12f98b8$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $2d53f409f12f98b8$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $2d53f409f12f98b8$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $2d53f409f12f98b8$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $2d53f409f12f98b8$var$defineProperty({}, side, reference[side]),
            end: $2d53f409f12f98b8$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $2d53f409f12f98b8$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$hide(data) {
    if (!$2d53f409f12f98b8$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $2d53f409f12f98b8$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2d53f409f12f98b8$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $2d53f409f12f98b8$var$getOppositePlacement(placement);
    data.offsets.popper = $2d53f409f12f98b8$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $2d53f409f12f98b8$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2d53f409f12f98b8$var$applyStyle,
        /** @prop {Function} */ onLoad: $2d53f409f12f98b8$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $2d53f409f12f98b8$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $2d53f409f12f98b8$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $2d53f409f12f98b8$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $2d53f409f12f98b8$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $2d53f409f12f98b8$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $2d53f409f12f98b8$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($2d53f409f12f98b8$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $2d53f409f12f98b8$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $2d53f409f12f98b8$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $2d53f409f12f98b8$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $2d53f409f12f98b8$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $2d53f409f12f98b8$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $2d53f409f12f98b8$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $2d53f409f12f98b8$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $2d53f409f12f98b8$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $2d53f409f12f98b8$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$2d53f409f12f98b8$var$Popper.placements = $2d53f409f12f98b8$var$placements;
$2d53f409f12f98b8$var$Popper.Defaults = $2d53f409f12f98b8$var$Defaults;
var $2d53f409f12f98b8$export$2e2bcd8739ae039 = $2d53f409f12f98b8$var$Popper;

});

parcelRegister("gLKmg", function(module, exports) {
//! moment.js
//! version : 2.28.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i;
        for(i = 0; i < arr.length; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentProperties.length > 0) for(i = 0; i < momentProperties.length; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key;
                for(i = 0; i < arguments.length; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i;
            for(i = 0; i < prioritized.length; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        for(i = 0; i < token.length; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias('month', 'M');
    // PRIORITY
    addUnitPriority('month', 8);
    // PARSING
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // ALIASES
    addUnitAlias('year', 'y');
    // PRIORITIES
    addUnitPriority('year', 1);
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // ALIASES
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    // PRIORITIES
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    // PARSING
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // ALIASES
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // ALIASES
    addUnitAlias('hour', 'h');
    // PRIORITY
    addUnitPriority('hour', 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDates.length; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimes.length; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false;
        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < config._f.length; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < ordering.length; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    // PRIORITY
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // ALIASES
    addUnitAlias('quarter', 'Q');
    // PRIORITY
    addUnitPriority('quarter', 7);
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // ALIASES
    addUnitAlias('date', 'D');
    // PRIORITY
    addUnitPriority('date', 9);
    // PARSING
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // ALIASES
    addUnitAlias('dayOfYear', 'DDD');
    // PRIORITY
    addUnitPriority('dayOfYear', 4);
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // ALIASES
    addUnitAlias('minute', 'm');
    // PRIORITY
    addUnitPriority('minute', 14);
    // PARSING
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // ALIASES
    addUnitAlias('second', 's');
    // PRIORITY
    addUnitPriority('second', 15);
    // PARSING
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias('millisecond', 'ms');
    // PRIORITY
    addUnitPriority('millisecond', 16);
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y');
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.28.0';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("ipmjT", function(module, exports) {

var $dDGfm = parcelRequire("dDGfm");

var $eJm1z = parcelRequire("eJm1z");
function $d66be0113a37b492$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $dDGfm)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $eJm1z(rnds);
}
module.exports = $d66be0113a37b492$var$v4;

});
parcelRegister("dDGfm", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $9edfb037a8038687$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($9edfb037a8038687$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $9edfb037a8038687$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $9edfb037a8038687$var$getRandomValues($9edfb037a8038687$var$rnds8);
        return $9edfb037a8038687$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $9edfb037a8038687$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $9edfb037a8038687$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $9edfb037a8038687$var$rnds;
    };
}

});

parcelRegister("eJm1z", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $ab965a371ea68634$var$byteToHex = [];
for(var $ab965a371ea68634$var$i = 0; $ab965a371ea68634$var$i < 256; ++$ab965a371ea68634$var$i)$ab965a371ea68634$var$byteToHex[$ab965a371ea68634$var$i] = ($ab965a371ea68634$var$i + 0x100).toString(16).substr(1);
function $ab965a371ea68634$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $ab965a371ea68634$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $ab965a371ea68634$var$bytesToUuid;

});


parcelRegister("1Garp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $1391d00cd5de2227$var$buildEvent;

var $1391d00cd5de2227$var$_pickBy = $1391d00cd5de2227$var$_interopRequireDefault((parcelRequire("8hOm9")));

var $1391d00cd5de2227$var$_identity = $1391d00cd5de2227$var$_interopRequireDefault((parcelRequire("bHMyM")));

var $1391d00cd5de2227$var$_defaults = $1391d00cd5de2227$var$_interopRequireDefault((parcelRequire("hfkbF")));
function $1391d00cd5de2227$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1391d00cd5de2227$var$buildEvent() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var title = attributes.title, productId = attributes.productId, method = attributes.method, uid = attributes.uid, sequence = attributes.sequence, start = attributes.start, startType = attributes.startType, duration = attributes.duration, end = attributes.end, description = attributes.description, url = attributes.url, geo = attributes.geo, location = attributes.location, status = attributes.status, categories = attributes.categories, organizer = attributes.organizer, attendees = attributes.attendees, alarms = attributes.alarms, recurrenceRule = attributes.recurrenceRule, created = attributes.created, lastModified = attributes.lastModified, calName = attributes.calName; // fill in default values where necessary
    var output = Object.assign({}, $1391d00cd5de2227$var$_defaults["default"], attributes); // remove falsey values
    var cleanOutput = (0, $1391d00cd5de2227$var$_pickBy["default"])(output, $1391d00cd5de2227$var$_identity["default"]);
    return cleanOutput;
}

});
parcelRegister("8hOm9", function(module, exports) {

var $g7GeS = parcelRequire("g7GeS");

var $2oilF = parcelRequire("2oilF");

var $jQrXv = parcelRequire("jQrXv");

var $h95GP = parcelRequire("h95GP");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $6086f8fb5bec5487$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $g7GeS($h95GP(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $2oilF(predicate);
    return $jQrXv(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = $6086f8fb5bec5487$var$pickBy;

});
parcelRegister("g7GeS", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $bbce10953c902d93$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $bbce10953c902d93$var$arrayMap;

});

parcelRegister("2oilF", function(module, exports) {

var $cu0ya = parcelRequire("cu0ya");

var $2pOu8 = parcelRequire("2pOu8");

var $bHMyM = parcelRequire("bHMyM");

var $ae8en = parcelRequire("ae8en");

var $8oWHw = parcelRequire("8oWHw");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $1bdc0e4d9d528d14$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $bHMyM;
    if (typeof value == 'object') return $ae8en(value) ? $2pOu8(value[0], value[1]) : $cu0ya(value);
    return $8oWHw(value);
}
module.exports = $1bdc0e4d9d528d14$var$baseIteratee;

});
parcelRegister("cu0ya", function(module, exports) {

var $8ON14 = parcelRequire("8ON14");

var $dOP7B = parcelRequire("dOP7B");

var $kV0W5 = parcelRequire("kV0W5");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $9168b6966ced6a70$var$baseMatches(source) {
    var matchData = $dOP7B(source);
    if (matchData.length == 1 && matchData[0][2]) return $kV0W5(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $8ON14(object, source, matchData);
    };
}
module.exports = $9168b6966ced6a70$var$baseMatches;

});
parcelRegister("8ON14", function(module, exports) {

var $clBMc = parcelRequire("clBMc");

var $ivT4I = parcelRequire("ivT4I");
/** Used to compose bitmasks for value comparisons. */ var $66b903d864bd2211$var$COMPARE_PARTIAL_FLAG = 1, $66b903d864bd2211$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $66b903d864bd2211$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $clBMc;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $ivT4I(srcValue, objValue, $66b903d864bd2211$var$COMPARE_PARTIAL_FLAG | $66b903d864bd2211$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $66b903d864bd2211$var$baseIsMatch;

});
parcelRegister("clBMc", function(module, exports) {

var $8awmE = parcelRequire("8awmE");

var $lsevN = parcelRequire("lsevN");

var $c5pET = parcelRequire("c5pET");

var $gFcJO = parcelRequire("gFcJO");

var $lGp0v = parcelRequire("lGp0v");

var $6BeSQ = parcelRequire("6BeSQ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8fd4bfd143c5ac2e$var$Stack(entries) {
    var data = this.__data__ = new $8awmE(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$8fd4bfd143c5ac2e$var$Stack.prototype.clear = $lsevN;
$8fd4bfd143c5ac2e$var$Stack.prototype['delete'] = $c5pET;
$8fd4bfd143c5ac2e$var$Stack.prototype.get = $gFcJO;
$8fd4bfd143c5ac2e$var$Stack.prototype.has = $lGp0v;
$8fd4bfd143c5ac2e$var$Stack.prototype.set = $6BeSQ;
module.exports = $8fd4bfd143c5ac2e$var$Stack;

});
parcelRegister("8awmE", function(module, exports) {

var $iVbYB = parcelRequire("iVbYB");

var $7YVID = parcelRequire("7YVID");

var $ab21b = parcelRequire("ab21b");

var $3dnrv = parcelRequire("3dnrv");

var $9BGvb = parcelRequire("9BGvb");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5f285ccb59f87ac8$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$5f285ccb59f87ac8$var$ListCache.prototype.clear = $iVbYB;
$5f285ccb59f87ac8$var$ListCache.prototype['delete'] = $7YVID;
$5f285ccb59f87ac8$var$ListCache.prototype.get = $ab21b;
$5f285ccb59f87ac8$var$ListCache.prototype.has = $3dnrv;
$5f285ccb59f87ac8$var$ListCache.prototype.set = $9BGvb;
module.exports = $5f285ccb59f87ac8$var$ListCache;

});
parcelRegister("iVbYB", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $dc66d71eeddc98ec$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $dc66d71eeddc98ec$var$listCacheClear;

});

parcelRegister("7YVID", function(module, exports) {

var $23Tz6 = parcelRequire("23Tz6");
/** Used for built-in method references. */ var $5cfae8c3be3bacfd$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $5cfae8c3be3bacfd$var$splice = $5cfae8c3be3bacfd$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5cfae8c3be3bacfd$var$listCacheDelete(key) {
    var data = this.__data__, index = $23Tz6(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $5cfae8c3be3bacfd$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $5cfae8c3be3bacfd$var$listCacheDelete;

});
parcelRegister("23Tz6", function(module, exports) {

var $h2kXj = parcelRequire("h2kXj");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $1806f6a552b198c2$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($h2kXj(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $1806f6a552b198c2$var$assocIndexOf;

});
parcelRegister("h2kXj", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $c672e0ede83b6d5a$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $c672e0ede83b6d5a$var$eq;

});



parcelRegister("ab21b", function(module, exports) {

var $23Tz6 = parcelRequire("23Tz6");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $768c7f3c397245f2$var$listCacheGet(key) {
    var data = this.__data__, index = $23Tz6(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $768c7f3c397245f2$var$listCacheGet;

});

parcelRegister("3dnrv", function(module, exports) {

var $23Tz6 = parcelRequire("23Tz6");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2574c53cb6e13180$var$listCacheHas(key) {
    return $23Tz6(this.__data__, key) > -1;
}
module.exports = $2574c53cb6e13180$var$listCacheHas;

});

parcelRegister("9BGvb", function(module, exports) {

var $23Tz6 = parcelRequire("23Tz6");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $6fe889c3a253a5c6$var$listCacheSet(key, value) {
    var data = this.__data__, index = $23Tz6(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $6fe889c3a253a5c6$var$listCacheSet;

});


parcelRegister("lsevN", function(module, exports) {

var $8awmE = parcelRequire("8awmE");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $f9e778390372274c$var$stackClear() {
    this.__data__ = new $8awmE;
    this.size = 0;
}
module.exports = $f9e778390372274c$var$stackClear;

});

parcelRegister("c5pET", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8cc9daeeee153d6b$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $8cc9daeeee153d6b$var$stackDelete;

});

parcelRegister("gFcJO", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c21a5b2f32e11837$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $c21a5b2f32e11837$var$stackGet;

});

parcelRegister("lGp0v", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fc90eb23049cac08$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $fc90eb23049cac08$var$stackHas;

});

parcelRegister("6BeSQ", function(module, exports) {

var $8awmE = parcelRequire("8awmE");

var $kCR6l = parcelRequire("kCR6l");

var $drHYq = parcelRequire("drHYq");
/** Used as the size to enable large array optimizations. */ var $4ce1be5df4afa269$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $4ce1be5df4afa269$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $8awmE) {
        var pairs = data.__data__;
        if (!$kCR6l || pairs.length < $4ce1be5df4afa269$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $drHYq(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $4ce1be5df4afa269$var$stackSet;

});
parcelRegister("kCR6l", function(module, exports) {

var $dAfD8 = parcelRequire("dAfD8");

var $8hDRs = parcelRequire("8hDRs");
/* Built-in method references that are verified to be native. */ var $f0408c109a962ddf$var$Map = $dAfD8($8hDRs, 'Map');
module.exports = $f0408c109a962ddf$var$Map;

});
parcelRegister("dAfD8", function(module, exports) {

var $5QaJG = parcelRequire("5QaJG");

var $lBXa8 = parcelRequire("lBXa8");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $9e3ac2feb57a155b$var$getNative(object, key) {
    var value = $lBXa8(object, key);
    return $5QaJG(value) ? value : undefined;
}
module.exports = $9e3ac2feb57a155b$var$getNative;

});
parcelRegister("5QaJG", function(module, exports) {

var $e3IvZ = parcelRequire("e3IvZ");

var $c4cnD = parcelRequire("c4cnD");

var $e9Eyz = parcelRequire("e9Eyz");

var $djZgM = parcelRequire("djZgM");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $440a22fa4edac47e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $440a22fa4edac47e$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $440a22fa4edac47e$var$funcProto = Function.prototype, $440a22fa4edac47e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $440a22fa4edac47e$var$funcToString = $440a22fa4edac47e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $440a22fa4edac47e$var$hasOwnProperty = $440a22fa4edac47e$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $440a22fa4edac47e$var$reIsNative = RegExp('^' + $440a22fa4edac47e$var$funcToString.call($440a22fa4edac47e$var$hasOwnProperty).replace($440a22fa4edac47e$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $440a22fa4edac47e$var$baseIsNative(value) {
    if (!$e9Eyz(value) || $c4cnD(value)) return false;
    var pattern = $e3IvZ(value) ? $440a22fa4edac47e$var$reIsNative : $440a22fa4edac47e$var$reIsHostCtor;
    return pattern.test($djZgM(value));
}
module.exports = $440a22fa4edac47e$var$baseIsNative;

});
parcelRegister("e3IvZ", function(module, exports) {

var $iQRu3 = parcelRequire("iQRu3");

var $e9Eyz = parcelRequire("e9Eyz");
/** `Object#toString` result references. */ var $a3c3e03f3911d2b7$var$asyncTag = '[object AsyncFunction]', $a3c3e03f3911d2b7$var$funcTag = '[object Function]', $a3c3e03f3911d2b7$var$genTag = '[object GeneratorFunction]', $a3c3e03f3911d2b7$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $a3c3e03f3911d2b7$var$isFunction(value) {
    if (!$e9Eyz(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $iQRu3(value);
    return tag == $a3c3e03f3911d2b7$var$funcTag || tag == $a3c3e03f3911d2b7$var$genTag || tag == $a3c3e03f3911d2b7$var$asyncTag || tag == $a3c3e03f3911d2b7$var$proxyTag;
}
module.exports = $a3c3e03f3911d2b7$var$isFunction;

});
parcelRegister("iQRu3", function(module, exports) {

var $bpT63 = parcelRequire("bpT63");

var $6tEGU = parcelRequire("6tEGU");

var $aqTTO = parcelRequire("aqTTO");
/** `Object#toString` result references. */ var $db96921a978a0194$var$nullTag = '[object Null]', $db96921a978a0194$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $db96921a978a0194$var$symToStringTag = $bpT63 ? $bpT63.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $db96921a978a0194$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $db96921a978a0194$var$undefinedTag : $db96921a978a0194$var$nullTag;
    return $db96921a978a0194$var$symToStringTag && $db96921a978a0194$var$symToStringTag in Object(value) ? $6tEGU(value) : $aqTTO(value);
}
module.exports = $db96921a978a0194$var$baseGetTag;

});
parcelRegister("bpT63", function(module, exports) {

var $8hDRs = parcelRequire("8hDRs");
/** Built-in value references. */ var $84fcc49377fe3f23$var$Symbol = $8hDRs.Symbol;
module.exports = $84fcc49377fe3f23$var$Symbol;

});

parcelRegister("6tEGU", function(module, exports) {

var $bpT63 = parcelRequire("bpT63");
/** Used for built-in method references. */ var $4b7503ee9a310b5e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4b7503ee9a310b5e$var$hasOwnProperty = $4b7503ee9a310b5e$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4b7503ee9a310b5e$var$nativeObjectToString = $4b7503ee9a310b5e$var$objectProto.toString;
/** Built-in value references. */ var $4b7503ee9a310b5e$var$symToStringTag = $bpT63 ? $bpT63.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4b7503ee9a310b5e$var$getRawTag(value) {
    var isOwn = $4b7503ee9a310b5e$var$hasOwnProperty.call(value, $4b7503ee9a310b5e$var$symToStringTag), tag = value[$4b7503ee9a310b5e$var$symToStringTag];
    try {
        value[$4b7503ee9a310b5e$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4b7503ee9a310b5e$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4b7503ee9a310b5e$var$symToStringTag] = tag;
        else delete value[$4b7503ee9a310b5e$var$symToStringTag];
    }
    return result;
}
module.exports = $4b7503ee9a310b5e$var$getRawTag;

});

parcelRegister("aqTTO", function(module, exports) {
/** Used for built-in method references. */ var $7987b17fc6bbaf8d$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7987b17fc6bbaf8d$var$nativeObjectToString = $7987b17fc6bbaf8d$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $7987b17fc6bbaf8d$var$objectToString(value) {
    return $7987b17fc6bbaf8d$var$nativeObjectToString.call(value);
}
module.exports = $7987b17fc6bbaf8d$var$objectToString;

});


parcelRegister("e9Eyz", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a4e15da6acf0a3e0$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $a4e15da6acf0a3e0$var$isObject;

});


parcelRegister("c4cnD", function(module, exports) {

var $6EaVc = parcelRequire("6EaVc");
/** Used to detect methods masquerading as native. */ var $8c8f76389531b51d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($6EaVc && $6EaVc.keys && $6EaVc.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8c8f76389531b51d$var$isMasked(func) {
    return !!$8c8f76389531b51d$var$maskSrcKey && $8c8f76389531b51d$var$maskSrcKey in func;
}
module.exports = $8c8f76389531b51d$var$isMasked;

});
parcelRegister("6EaVc", function(module, exports) {

var $8hDRs = parcelRequire("8hDRs");
/** Used to detect overreaching core-js shims. */ var $4d6ef34e39e63522$var$coreJsData = $8hDRs["__core-js_shared__"];
module.exports = $4d6ef34e39e63522$var$coreJsData;

});


parcelRegister("djZgM", function(module, exports) {
/** Used for built-in method references. */ var $9b2c9393bb4553e0$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9b2c9393bb4553e0$var$funcToString = $9b2c9393bb4553e0$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9b2c9393bb4553e0$var$toSource(func) {
    if (func != null) {
        try {
            return $9b2c9393bb4553e0$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $9b2c9393bb4553e0$var$toSource;

});


parcelRegister("lBXa8", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $fbbaf22072956faa$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $fbbaf22072956faa$var$getValue;

});



parcelRegister("drHYq", function(module, exports) {

var $1NZHS = parcelRequire("1NZHS");

var $2HvSU = parcelRequire("2HvSU");

var $dQU5d = parcelRequire("dQU5d");

var $fxo5z = parcelRequire("fxo5z");

var $16hAZ = parcelRequire("16hAZ");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9c9fe83a93bd0fe1$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$9c9fe83a93bd0fe1$var$MapCache.prototype.clear = $1NZHS;
$9c9fe83a93bd0fe1$var$MapCache.prototype['delete'] = $2HvSU;
$9c9fe83a93bd0fe1$var$MapCache.prototype.get = $dQU5d;
$9c9fe83a93bd0fe1$var$MapCache.prototype.has = $fxo5z;
$9c9fe83a93bd0fe1$var$MapCache.prototype.set = $16hAZ;
module.exports = $9c9fe83a93bd0fe1$var$MapCache;

});
parcelRegister("1NZHS", function(module, exports) {

var $8urXd = parcelRequire("8urXd");

var $8awmE = parcelRequire("8awmE");

var $kCR6l = parcelRequire("kCR6l");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $150a3bb2cb54d757$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $8urXd,
        'map': new ($kCR6l || $8awmE),
        'string': new $8urXd
    };
}
module.exports = $150a3bb2cb54d757$var$mapCacheClear;

});
parcelRegister("8urXd", function(module, exports) {

var $52yLY = parcelRequire("52yLY");

var $drDSe = parcelRequire("drDSe");

var $7PIbZ = parcelRequire("7PIbZ");

var $iRhaj = parcelRequire("iRhaj");

var $ljHDF = parcelRequire("ljHDF");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $62e6cf26048d37b3$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$62e6cf26048d37b3$var$Hash.prototype.clear = $52yLY;
$62e6cf26048d37b3$var$Hash.prototype['delete'] = $drDSe;
$62e6cf26048d37b3$var$Hash.prototype.get = $7PIbZ;
$62e6cf26048d37b3$var$Hash.prototype.has = $iRhaj;
$62e6cf26048d37b3$var$Hash.prototype.set = $ljHDF;
module.exports = $62e6cf26048d37b3$var$Hash;

});
parcelRegister("52yLY", function(module, exports) {

var $8Mw46 = parcelRequire("8Mw46");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $3ab81cc8eca13deb$var$hashClear() {
    this.__data__ = $8Mw46 ? $8Mw46(null) : {};
    this.size = 0;
}
module.exports = $3ab81cc8eca13deb$var$hashClear;

});
parcelRegister("8Mw46", function(module, exports) {

var $dAfD8 = parcelRequire("dAfD8");
/* Built-in method references that are verified to be native. */ var $664bade98c51f065$var$nativeCreate = $dAfD8(Object, 'create');
module.exports = $664bade98c51f065$var$nativeCreate;

});


parcelRegister("drDSe", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9c9cba111f175d54$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9c9cba111f175d54$var$hashDelete;

});

parcelRegister("7PIbZ", function(module, exports) {

var $8Mw46 = parcelRequire("8Mw46");
/** Used to stand-in for `undefined` hash values. */ var $5b3f938229b7f787$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $5b3f938229b7f787$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5b3f938229b7f787$var$hasOwnProperty = $5b3f938229b7f787$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5b3f938229b7f787$var$hashGet(key) {
    var data = this.__data__;
    if ($8Mw46) {
        var result = data[key];
        return result === $5b3f938229b7f787$var$HASH_UNDEFINED ? undefined : result;
    }
    return $5b3f938229b7f787$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $5b3f938229b7f787$var$hashGet;

});

parcelRegister("iRhaj", function(module, exports) {

var $8Mw46 = parcelRequire("8Mw46");
/** Used for built-in method references. */ var $dbaa7de74fb9ab56$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dbaa7de74fb9ab56$var$hasOwnProperty = $dbaa7de74fb9ab56$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dbaa7de74fb9ab56$var$hashHas(key) {
    var data = this.__data__;
    return $8Mw46 ? data[key] !== undefined : $dbaa7de74fb9ab56$var$hasOwnProperty.call(data, key);
}
module.exports = $dbaa7de74fb9ab56$var$hashHas;

});

parcelRegister("ljHDF", function(module, exports) {

var $8Mw46 = parcelRequire("8Mw46");
/** Used to stand-in for `undefined` hash values. */ var $f84d39104865c712$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $f84d39104865c712$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $8Mw46 && value === undefined ? $f84d39104865c712$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $f84d39104865c712$var$hashSet;

});



parcelRegister("2HvSU", function(module, exports) {

var $k1cqu = parcelRequire("k1cqu");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1f78548d793b53c1$var$mapCacheDelete(key) {
    var result = $k1cqu(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $1f78548d793b53c1$var$mapCacheDelete;

});
parcelRegister("k1cqu", function(module, exports) {

var $4m7Iv = parcelRequire("4m7Iv");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e92d8a36ecabf1c6$var$getMapData(map, key) {
    var data = map.__data__;
    return $4m7Iv(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $e92d8a36ecabf1c6$var$getMapData;

});
parcelRegister("4m7Iv", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $32bf33e9e493fcbe$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $32bf33e9e493fcbe$var$isKeyable;

});



parcelRegister("dQU5d", function(module, exports) {

var $k1cqu = parcelRequire("k1cqu");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a15ba2a35e6b580e$var$mapCacheGet(key) {
    return $k1cqu(this, key).get(key);
}
module.exports = $a15ba2a35e6b580e$var$mapCacheGet;

});

parcelRegister("fxo5z", function(module, exports) {

var $k1cqu = parcelRequire("k1cqu");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b4fc9f9ed053247e$var$mapCacheHas(key) {
    return $k1cqu(this, key).has(key);
}
module.exports = $b4fc9f9ed053247e$var$mapCacheHas;

});

parcelRegister("16hAZ", function(module, exports) {

var $k1cqu = parcelRequire("k1cqu");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $0cd40020ab212d30$var$mapCacheSet(key, value) {
    var data = $k1cqu(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $0cd40020ab212d30$var$mapCacheSet;

});




parcelRegister("ivT4I", function(module, exports) {

var $3SWiq = parcelRequire("3SWiq");

var $7S6hp = parcelRequire("7S6hp");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $d7a5d7fdc675f6e2$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$7S6hp(value) && !$7S6hp(other)) return value !== value && other !== other;
    return $3SWiq(value, other, bitmask, customizer, $d7a5d7fdc675f6e2$var$baseIsEqual, stack);
}
module.exports = $d7a5d7fdc675f6e2$var$baseIsEqual;

});
parcelRegister("3SWiq", function(module, exports) {

var $clBMc = parcelRequire("clBMc");

var $cvUTr = parcelRequire("cvUTr");

var $8hjLY = parcelRequire("8hjLY");

var $kA30j = parcelRequire("kA30j");

var $kLPXq = parcelRequire("kLPXq");

var $ae8en = parcelRequire("ae8en");

var $8Nda1 = parcelRequire("8Nda1");

var $9askA = parcelRequire("9askA");
/** Used to compose bitmasks for value comparisons. */ var $2d43a2abbccdda10$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $2d43a2abbccdda10$var$argsTag = '[object Arguments]', $2d43a2abbccdda10$var$arrayTag = '[object Array]', $2d43a2abbccdda10$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $2d43a2abbccdda10$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2d43a2abbccdda10$var$hasOwnProperty = $2d43a2abbccdda10$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2d43a2abbccdda10$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $ae8en(object), othIsArr = $ae8en(other), objTag = objIsArr ? $2d43a2abbccdda10$var$arrayTag : $kLPXq(object), othTag = othIsArr ? $2d43a2abbccdda10$var$arrayTag : $kLPXq(other);
    objTag = objTag == $2d43a2abbccdda10$var$argsTag ? $2d43a2abbccdda10$var$objectTag : objTag;
    othTag = othTag == $2d43a2abbccdda10$var$argsTag ? $2d43a2abbccdda10$var$objectTag : othTag;
    var objIsObj = objTag == $2d43a2abbccdda10$var$objectTag, othIsObj = othTag == $2d43a2abbccdda10$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $8Nda1(object)) {
        if (!$8Nda1(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $clBMc);
        return objIsArr || $9askA(object) ? $cvUTr(object, other, bitmask, customizer, equalFunc, stack) : $8hjLY(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $2d43a2abbccdda10$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $2d43a2abbccdda10$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $2d43a2abbccdda10$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $clBMc);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $clBMc);
    return $kA30j(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $2d43a2abbccdda10$var$baseIsEqualDeep;

});
parcelRegister("cvUTr", function(module, exports) {

var $kcaEB = parcelRequire("kcaEB");

var $kpV1i = parcelRequire("kpV1i");

var $dwbsX = parcelRequire("dwbsX");
/** Used to compose bitmasks for value comparisons. */ var $91c4831473abcaf6$var$COMPARE_PARTIAL_FLAG = 1, $91c4831473abcaf6$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $91c4831473abcaf6$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $91c4831473abcaf6$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $91c4831473abcaf6$var$COMPARE_UNORDERED_FLAG ? new $kcaEB : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$kpV1i(other, function(othValue, othIndex) {
                if (!$dwbsX(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $91c4831473abcaf6$var$equalArrays;

});
parcelRegister("kcaEB", function(module, exports) {

var $drHYq = parcelRequire("drHYq");

var $lFoJi = parcelRequire("lFoJi");

var $kUwFf = parcelRequire("kUwFf");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $eb3d3149d777d5a0$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $drHYq;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$eb3d3149d777d5a0$var$SetCache.prototype.add = $eb3d3149d777d5a0$var$SetCache.prototype.push = $lFoJi;
$eb3d3149d777d5a0$var$SetCache.prototype.has = $kUwFf;
module.exports = $eb3d3149d777d5a0$var$SetCache;

});
parcelRegister("lFoJi", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $fc609c134605120b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $fc609c134605120b$var$setCacheAdd(value) {
    this.__data__.set(value, $fc609c134605120b$var$HASH_UNDEFINED);
    return this;
}
module.exports = $fc609c134605120b$var$setCacheAdd;

});

parcelRegister("kUwFf", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f392600b3ba8f689$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $f392600b3ba8f689$var$setCacheHas;

});


parcelRegister("kpV1i", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $edd25f6d840a8092$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $edd25f6d840a8092$var$arraySome;

});

parcelRegister("dwbsX", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9d77287585e7bfd3$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $9d77287585e7bfd3$var$cacheHas;

});


parcelRegister("8hjLY", function(module, exports) {

var $bpT63 = parcelRequire("bpT63");

var $2dNmt = parcelRequire("2dNmt");

var $h2kXj = parcelRequire("h2kXj");

var $cvUTr = parcelRequire("cvUTr");

var $6uLkA = parcelRequire("6uLkA");

var $ee80J = parcelRequire("ee80J");
/** Used to compose bitmasks for value comparisons. */ var $606f3fb23a1f0c39$var$COMPARE_PARTIAL_FLAG = 1, $606f3fb23a1f0c39$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $606f3fb23a1f0c39$var$boolTag = '[object Boolean]', $606f3fb23a1f0c39$var$dateTag = '[object Date]', $606f3fb23a1f0c39$var$errorTag = '[object Error]', $606f3fb23a1f0c39$var$mapTag = '[object Map]', $606f3fb23a1f0c39$var$numberTag = '[object Number]', $606f3fb23a1f0c39$var$regexpTag = '[object RegExp]', $606f3fb23a1f0c39$var$setTag = '[object Set]', $606f3fb23a1f0c39$var$stringTag = '[object String]', $606f3fb23a1f0c39$var$symbolTag = '[object Symbol]';
var $606f3fb23a1f0c39$var$arrayBufferTag = '[object ArrayBuffer]', $606f3fb23a1f0c39$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $606f3fb23a1f0c39$var$symbolProto = $bpT63 ? $bpT63.prototype : undefined, $606f3fb23a1f0c39$var$symbolValueOf = $606f3fb23a1f0c39$var$symbolProto ? $606f3fb23a1f0c39$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $606f3fb23a1f0c39$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $606f3fb23a1f0c39$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $606f3fb23a1f0c39$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $2dNmt(object), new $2dNmt(other))) return false;
            return true;
        case $606f3fb23a1f0c39$var$boolTag:
        case $606f3fb23a1f0c39$var$dateTag:
        case $606f3fb23a1f0c39$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $h2kXj(+object, +other);
        case $606f3fb23a1f0c39$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $606f3fb23a1f0c39$var$regexpTag:
        case $606f3fb23a1f0c39$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $606f3fb23a1f0c39$var$mapTag:
            var convert = $6uLkA;
        case $606f3fb23a1f0c39$var$setTag:
            var isPartial = bitmask & $606f3fb23a1f0c39$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $ee80J);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $606f3fb23a1f0c39$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $cvUTr(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $606f3fb23a1f0c39$var$symbolTag:
            if ($606f3fb23a1f0c39$var$symbolValueOf) return $606f3fb23a1f0c39$var$symbolValueOf.call(object) == $606f3fb23a1f0c39$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $606f3fb23a1f0c39$var$equalByTag;

});
parcelRegister("2dNmt", function(module, exports) {

var $8hDRs = parcelRequire("8hDRs");
/** Built-in value references. */ var $19e315d95f5a8b19$var$Uint8Array = $8hDRs.Uint8Array;
module.exports = $19e315d95f5a8b19$var$Uint8Array;

});

parcelRegister("6uLkA", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $4baa426343fc52ae$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $4baa426343fc52ae$var$mapToArray;

});

parcelRegister("ee80J", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $a5b896402ed1e581$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $a5b896402ed1e581$var$setToArray;

});


parcelRegister("kA30j", function(module, exports) {

var $2guDa = parcelRequire("2guDa");
/** Used to compose bitmasks for value comparisons. */ var $efb980000d26e6c8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $efb980000d26e6c8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $efb980000d26e6c8$var$hasOwnProperty = $efb980000d26e6c8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $efb980000d26e6c8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $efb980000d26e6c8$var$COMPARE_PARTIAL_FLAG, objProps = $2guDa(object), objLength = objProps.length, othProps = $2guDa(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $efb980000d26e6c8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $efb980000d26e6c8$var$equalObjects;

});
parcelRegister("2guDa", function(module, exports) {

var $ashyr = parcelRequire("ashyr");

var $j44BY = parcelRequire("j44BY");

var $gRgFA = parcelRequire("gRgFA");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $1a64d60b59c95561$var$getAllKeys(object) {
    return $ashyr(object, $gRgFA, $j44BY);
}
module.exports = $1a64d60b59c95561$var$getAllKeys;

});
parcelRegister("ashyr", function(module, exports) {

var $836c9 = parcelRequire("836c9");

var $ae8en = parcelRequire("ae8en");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $79ca22dc160a8181$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $ae8en(object) ? result : $836c9(result, symbolsFunc(object));
}
module.exports = $79ca22dc160a8181$var$baseGetAllKeys;

});
parcelRegister("836c9", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $5dc368c19b34bc39$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $5dc368c19b34bc39$var$arrayPush;

});


parcelRegister("j44BY", function(module, exports) {

var $kfKby = parcelRequire("kfKby");

var $hfqvJ = parcelRequire("hfqvJ");
/** Used for built-in method references. */ var $de11f7cc14dc8b08$var$objectProto = Object.prototype;
/** Built-in value references. */ var $de11f7cc14dc8b08$var$propertyIsEnumerable = $de11f7cc14dc8b08$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $de11f7cc14dc8b08$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $de11f7cc14dc8b08$var$getSymbols = !$de11f7cc14dc8b08$var$nativeGetSymbols ? $hfqvJ : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $kfKby($de11f7cc14dc8b08$var$nativeGetSymbols(object), function(symbol) {
        return $de11f7cc14dc8b08$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $de11f7cc14dc8b08$var$getSymbols;

});
parcelRegister("kfKby", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ebe908d3262ff899$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $ebe908d3262ff899$var$arrayFilter;

});

parcelRegister("hfqvJ", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $c8e866e20e6b4411$var$stubArray() {
    return [];
}
module.exports = $c8e866e20e6b4411$var$stubArray;

});


parcelRegister("gRgFA", function(module, exports) {

var $jHUqE = parcelRequire("jHUqE");

var $136ff = parcelRequire("136ff");

var $50iuD = parcelRequire("50iuD");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $c45e86d54fb9c3c1$var$keys(object) {
    return $50iuD(object) ? $jHUqE(object) : $136ff(object);
}
module.exports = $c45e86d54fb9c3c1$var$keys;

});
parcelRegister("jHUqE", function(module, exports) {

var $1toKv = parcelRequire("1toKv");

var $jmUZP = parcelRequire("jmUZP");

var $ae8en = parcelRequire("ae8en");

var $8Nda1 = parcelRequire("8Nda1");

var $iVSLT = parcelRequire("iVSLT");

var $9askA = parcelRequire("9askA");
/** Used for built-in method references. */ var $e58dce131ac48c75$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e58dce131ac48c75$var$hasOwnProperty = $e58dce131ac48c75$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $e58dce131ac48c75$var$arrayLikeKeys(value, inherited) {
    var isArr = $ae8en(value), isArg = !isArr && $jmUZP(value), isBuff = !isArr && !isArg && $8Nda1(value), isType = !isArr && !isArg && !isBuff && $9askA(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $1toKv(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $e58dce131ac48c75$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $iVSLT(key, length)))) result.push(key);
    return result;
}
module.exports = $e58dce131ac48c75$var$arrayLikeKeys;

});
parcelRegister("1toKv", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $112bb283733d09bd$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $112bb283733d09bd$var$baseTimes;

});

parcelRegister("jmUZP", function(module, exports) {

var $g7nVU = parcelRequire("g7nVU");

var $7S6hp = parcelRequire("7S6hp");
/** Used for built-in method references. */ var $e19c48ab090155ec$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e19c48ab090155ec$var$hasOwnProperty = $e19c48ab090155ec$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $e19c48ab090155ec$var$propertyIsEnumerable = $e19c48ab090155ec$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $e19c48ab090155ec$var$isArguments = $g7nVU(function() {
    return arguments;
}()) ? $g7nVU : function(value) {
    return $7S6hp(value) && $e19c48ab090155ec$var$hasOwnProperty.call(value, 'callee') && !$e19c48ab090155ec$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $e19c48ab090155ec$var$isArguments;

});
parcelRegister("g7nVU", function(module, exports) {

var $iQRu3 = parcelRequire("iQRu3");

var $7S6hp = parcelRequire("7S6hp");
/** `Object#toString` result references. */ var $bbbfdd5d2ae9f35f$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $bbbfdd5d2ae9f35f$var$baseIsArguments(value) {
    return $7S6hp(value) && $iQRu3(value) == $bbbfdd5d2ae9f35f$var$argsTag;
}
module.exports = $bbbfdd5d2ae9f35f$var$baseIsArguments;

});
parcelRegister("7S6hp", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5bb27290c24e737b$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $5bb27290c24e737b$var$isObjectLike;

});



parcelRegister("iVSLT", function(module, exports) {
/** Used as references for various `Number` constants. */ var $dc88095b48a73595$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $dc88095b48a73595$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $dc88095b48a73595$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $dc88095b48a73595$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $dc88095b48a73595$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $dc88095b48a73595$var$isIndex;

});

parcelRegister("9askA", function(module, exports) {

var $cRJ84 = parcelRequire("cRJ84");

var $3B3Jp = parcelRequire("3B3Jp");

var $eR4B6 = parcelRequire("eR4B6");
/* Node.js helper references. */ var $6acb06291b650136$var$nodeIsTypedArray = $eR4B6 && $eR4B6.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $6acb06291b650136$var$isTypedArray = $6acb06291b650136$var$nodeIsTypedArray ? $3B3Jp($6acb06291b650136$var$nodeIsTypedArray) : $cRJ84;
module.exports = $6acb06291b650136$var$isTypedArray;

});
parcelRegister("cRJ84", function(module, exports) {

var $iQRu3 = parcelRequire("iQRu3");

var $9SSrs = parcelRequire("9SSrs");

var $7S6hp = parcelRequire("7S6hp");
/** `Object#toString` result references. */ var $95dd7102673f16d2$var$argsTag = '[object Arguments]', $95dd7102673f16d2$var$arrayTag = '[object Array]', $95dd7102673f16d2$var$boolTag = '[object Boolean]', $95dd7102673f16d2$var$dateTag = '[object Date]', $95dd7102673f16d2$var$errorTag = '[object Error]', $95dd7102673f16d2$var$funcTag = '[object Function]', $95dd7102673f16d2$var$mapTag = '[object Map]', $95dd7102673f16d2$var$numberTag = '[object Number]', $95dd7102673f16d2$var$objectTag = '[object Object]', $95dd7102673f16d2$var$regexpTag = '[object RegExp]', $95dd7102673f16d2$var$setTag = '[object Set]', $95dd7102673f16d2$var$stringTag = '[object String]', $95dd7102673f16d2$var$weakMapTag = '[object WeakMap]';
var $95dd7102673f16d2$var$arrayBufferTag = '[object ArrayBuffer]', $95dd7102673f16d2$var$dataViewTag = '[object DataView]', $95dd7102673f16d2$var$float32Tag = '[object Float32Array]', $95dd7102673f16d2$var$float64Tag = '[object Float64Array]', $95dd7102673f16d2$var$int8Tag = '[object Int8Array]', $95dd7102673f16d2$var$int16Tag = '[object Int16Array]', $95dd7102673f16d2$var$int32Tag = '[object Int32Array]', $95dd7102673f16d2$var$uint8Tag = '[object Uint8Array]', $95dd7102673f16d2$var$uint8ClampedTag = '[object Uint8ClampedArray]', $95dd7102673f16d2$var$uint16Tag = '[object Uint16Array]', $95dd7102673f16d2$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $95dd7102673f16d2$var$typedArrayTags = {};
$95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$float32Tag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$float64Tag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$int8Tag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$int16Tag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$int32Tag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$uint8Tag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$uint8ClampedTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$uint16Tag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$uint32Tag] = true;
$95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$argsTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$arrayTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$arrayBufferTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$boolTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$dataViewTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$dateTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$errorTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$funcTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$mapTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$numberTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$objectTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$regexpTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$setTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$stringTag] = $95dd7102673f16d2$var$typedArrayTags[$95dd7102673f16d2$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $95dd7102673f16d2$var$baseIsTypedArray(value) {
    return $7S6hp(value) && $9SSrs(value.length) && !!$95dd7102673f16d2$var$typedArrayTags[$iQRu3(value)];
}
module.exports = $95dd7102673f16d2$var$baseIsTypedArray;

});
parcelRegister("9SSrs", function(module, exports) {
/** Used as references for various `Number` constants. */ var $7323633f59d2da26$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $7323633f59d2da26$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $7323633f59d2da26$var$MAX_SAFE_INTEGER;
}
module.exports = $7323633f59d2da26$var$isLength;

});


parcelRegister("3B3Jp", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $29e7b8c4ef921960$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $29e7b8c4ef921960$var$baseUnary;

});



parcelRegister("136ff", function(module, exports) {

var $vFm6J = parcelRequire("vFm6J");

var $iulHN = parcelRequire("iulHN");
/** Used for built-in method references. */ var $0c3aea593bf9e15b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0c3aea593bf9e15b$var$hasOwnProperty = $0c3aea593bf9e15b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0c3aea593bf9e15b$var$baseKeys(object) {
    if (!$vFm6J(object)) return $iulHN(object);
    var result = [];
    for(var key in Object(object))if ($0c3aea593bf9e15b$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $0c3aea593bf9e15b$var$baseKeys;

});
parcelRegister("vFm6J", function(module, exports) {
/** Used for built-in method references. */ var $05f2f9b8628ce935$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $05f2f9b8628ce935$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $05f2f9b8628ce935$var$objectProto;
    return value === proto;
}
module.exports = $05f2f9b8628ce935$var$isPrototype;

});

parcelRegister("iulHN", function(module, exports) {

var $jC9zE = parcelRequire("jC9zE");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d75bdd9198d87b00$var$nativeKeys = $jC9zE(Object.keys, Object);
module.exports = $d75bdd9198d87b00$var$nativeKeys;

});
parcelRegister("jC9zE", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e478fe221b23723b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $e478fe221b23723b$var$overArg;

});



parcelRegister("50iuD", function(module, exports) {

var $e3IvZ = parcelRequire("e3IvZ");

var $9SSrs = parcelRequire("9SSrs");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $3a4b4c2d27784477$var$isArrayLike(value) {
    return value != null && $9SSrs(value.length) && !$e3IvZ(value);
}
module.exports = $3a4b4c2d27784477$var$isArrayLike;

});




parcelRegister("kLPXq", function(module, exports) {

var $5GBWC = parcelRequire("5GBWC");

var $kCR6l = parcelRequire("kCR6l");

var $am0BX = parcelRequire("am0BX");

var $kCCHN = parcelRequire("kCCHN");

var $cMjCn = parcelRequire("cMjCn");

var $iQRu3 = parcelRequire("iQRu3");

var $djZgM = parcelRequire("djZgM");
/** `Object#toString` result references. */ var $f1f0801cad32340e$var$mapTag = '[object Map]', $f1f0801cad32340e$var$objectTag = '[object Object]', $f1f0801cad32340e$var$promiseTag = '[object Promise]', $f1f0801cad32340e$var$setTag = '[object Set]', $f1f0801cad32340e$var$weakMapTag = '[object WeakMap]';
var $f1f0801cad32340e$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $f1f0801cad32340e$var$dataViewCtorString = $djZgM($5GBWC), $f1f0801cad32340e$var$mapCtorString = $djZgM($kCR6l), $f1f0801cad32340e$var$promiseCtorString = $djZgM($am0BX), $f1f0801cad32340e$var$setCtorString = $djZgM($kCCHN), $f1f0801cad32340e$var$weakMapCtorString = $djZgM($cMjCn);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $f1f0801cad32340e$var$getTag = $iQRu3;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5GBWC && $f1f0801cad32340e$var$getTag(new $5GBWC(new ArrayBuffer(1))) != $f1f0801cad32340e$var$dataViewTag || $kCR6l && $f1f0801cad32340e$var$getTag(new $kCR6l) != $f1f0801cad32340e$var$mapTag || $am0BX && $f1f0801cad32340e$var$getTag($am0BX.resolve()) != $f1f0801cad32340e$var$promiseTag || $kCCHN && $f1f0801cad32340e$var$getTag(new $kCCHN) != $f1f0801cad32340e$var$setTag || $cMjCn && $f1f0801cad32340e$var$getTag(new $cMjCn) != $f1f0801cad32340e$var$weakMapTag) $f1f0801cad32340e$var$getTag = function(value) {
    var result = $iQRu3(value), Ctor = result == $f1f0801cad32340e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $djZgM(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $f1f0801cad32340e$var$dataViewCtorString:
            return $f1f0801cad32340e$var$dataViewTag;
        case $f1f0801cad32340e$var$mapCtorString:
            return $f1f0801cad32340e$var$mapTag;
        case $f1f0801cad32340e$var$promiseCtorString:
            return $f1f0801cad32340e$var$promiseTag;
        case $f1f0801cad32340e$var$setCtorString:
            return $f1f0801cad32340e$var$setTag;
        case $f1f0801cad32340e$var$weakMapCtorString:
            return $f1f0801cad32340e$var$weakMapTag;
    }
    return result;
};
module.exports = $f1f0801cad32340e$var$getTag;

});
parcelRegister("5GBWC", function(module, exports) {

var $dAfD8 = parcelRequire("dAfD8");

var $8hDRs = parcelRequire("8hDRs");
/* Built-in method references that are verified to be native. */ var $423e4ef90a9467c7$var$DataView = $dAfD8($8hDRs, 'DataView');
module.exports = $423e4ef90a9467c7$var$DataView;

});

parcelRegister("am0BX", function(module, exports) {

var $dAfD8 = parcelRequire("dAfD8");

var $8hDRs = parcelRequire("8hDRs");
/* Built-in method references that are verified to be native. */ var $789c6ed96c890bcf$var$Promise = $dAfD8($8hDRs, 'Promise');
module.exports = $789c6ed96c890bcf$var$Promise;

});

parcelRegister("kCCHN", function(module, exports) {

var $dAfD8 = parcelRequire("dAfD8");

var $8hDRs = parcelRequire("8hDRs");
/* Built-in method references that are verified to be native. */ var $f035615209518541$var$Set = $dAfD8($8hDRs, 'Set');
module.exports = $f035615209518541$var$Set;

});

parcelRegister("cMjCn", function(module, exports) {

var $dAfD8 = parcelRequire("dAfD8");

var $8hDRs = parcelRequire("8hDRs");
/* Built-in method references that are verified to be native. */ var $94d92f73d31eaa33$var$WeakMap = $dAfD8($8hDRs, 'WeakMap');
module.exports = $94d92f73d31eaa33$var$WeakMap;

});





parcelRegister("dOP7B", function(module, exports) {

var $dahTY = parcelRequire("dahTY");

var $gRgFA = parcelRequire("gRgFA");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $a0f79995770cdb4d$var$getMatchData(object) {
    var result = $gRgFA(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $dahTY(value)
        ];
    }
    return result;
}
module.exports = $a0f79995770cdb4d$var$getMatchData;

});
parcelRegister("dahTY", function(module, exports) {

var $e9Eyz = parcelRequire("e9Eyz");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $995a187a0332677d$var$isStrictComparable(value) {
    return value === value && !$e9Eyz(value);
}
module.exports = $995a187a0332677d$var$isStrictComparable;

});


parcelRegister("kV0W5", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f3a9db57745cbb4a$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $f3a9db57745cbb4a$var$matchesStrictComparable;

});


parcelRegister("2pOu8", function(module, exports) {

var $ivT4I = parcelRequire("ivT4I");

var $6Uq4s = parcelRequire("6Uq4s");

var $i4sGm = parcelRequire("i4sGm");

var $dkiUG = parcelRequire("dkiUG");

var $dahTY = parcelRequire("dahTY");

var $kV0W5 = parcelRequire("kV0W5");

var $2kfDE = parcelRequire("2kfDE");
/** Used to compose bitmasks for value comparisons. */ var $1c2513de2610bf8c$var$COMPARE_PARTIAL_FLAG = 1, $1c2513de2610bf8c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1c2513de2610bf8c$var$baseMatchesProperty(path, srcValue) {
    if ($dkiUG(path) && $dahTY(srcValue)) return $kV0W5($2kfDE(path), srcValue);
    return function(object) {
        var objValue = $6Uq4s(object, path);
        return objValue === undefined && objValue === srcValue ? $i4sGm(object, path) : $ivT4I(srcValue, objValue, $1c2513de2610bf8c$var$COMPARE_PARTIAL_FLAG | $1c2513de2610bf8c$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $1c2513de2610bf8c$var$baseMatchesProperty;

});
parcelRegister("6Uq4s", function(module, exports) {

var $eI84R = parcelRequire("eI84R");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $507c3226ad5a3f7c$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $eI84R(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $507c3226ad5a3f7c$var$get;

});
parcelRegister("eI84R", function(module, exports) {

var $89Pye = parcelRequire("89Pye");

var $2kfDE = parcelRequire("2kfDE");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ab5b70c0452e75c6$var$baseGet(object, path) {
    path = $89Pye(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$2kfDE(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $ab5b70c0452e75c6$var$baseGet;

});
parcelRegister("89Pye", function(module, exports) {

var $ae8en = parcelRequire("ae8en");

var $dkiUG = parcelRequire("dkiUG");

var $7rfqQ = parcelRequire("7rfqQ");

var $8ZfbE = parcelRequire("8ZfbE");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $5f0726f3ceacc5d5$var$castPath(value, object) {
    if ($ae8en(value)) return value;
    return $dkiUG(value, object) ? [
        value
    ] : $7rfqQ($8ZfbE(value));
}
module.exports = $5f0726f3ceacc5d5$var$castPath;

});
parcelRegister("dkiUG", function(module, exports) {

var $ae8en = parcelRequire("ae8en");

var $tMqsp = parcelRequire("tMqsp");
/** Used to match property names within property paths. */ var $9b3bd069f4ad1d5f$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $9b3bd069f4ad1d5f$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $9b3bd069f4ad1d5f$var$isKey(value, object) {
    if ($ae8en(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $tMqsp(value)) return true;
    return $9b3bd069f4ad1d5f$var$reIsPlainProp.test(value) || !$9b3bd069f4ad1d5f$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $9b3bd069f4ad1d5f$var$isKey;

});
parcelRegister("tMqsp", function(module, exports) {

var $iQRu3 = parcelRequire("iQRu3");

var $7S6hp = parcelRequire("7S6hp");
/** `Object#toString` result references. */ var $059845e3a52d04e6$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $059845e3a52d04e6$var$isSymbol(value) {
    return typeof value == 'symbol' || $7S6hp(value) && $iQRu3(value) == $059845e3a52d04e6$var$symbolTag;
}
module.exports = $059845e3a52d04e6$var$isSymbol;

});


parcelRegister("7rfqQ", function(module, exports) {

var $fvIS4 = parcelRequire("fvIS4");
/** Used to match property names within property paths. */ var $56a7067ea996b4d9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $56a7067ea996b4d9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $56a7067ea996b4d9$var$stringToPath = $fvIS4(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($56a7067ea996b4d9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($56a7067ea996b4d9$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $56a7067ea996b4d9$var$stringToPath;

});
parcelRegister("fvIS4", function(module, exports) {

var $1NTzT = parcelRequire("1NTzT");
/** Used as the maximum memoize cache size. */ var $b4ac8eb85fa3bd7a$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b4ac8eb85fa3bd7a$var$memoizeCapped(func) {
    var result = $1NTzT(func, function(key) {
        if (cache.size === $b4ac8eb85fa3bd7a$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $b4ac8eb85fa3bd7a$var$memoizeCapped;

});
parcelRegister("1NTzT", function(module, exports) {

var $drHYq = parcelRequire("drHYq");
/** Error message constants. */ var $15057aaf8d24b88f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $15057aaf8d24b88f$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($15057aaf8d24b88f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($15057aaf8d24b88f$var$memoize.Cache || $drHYq);
    return memoized;
}
// Expose `MapCache`.
$15057aaf8d24b88f$var$memoize.Cache = $drHYq;
module.exports = $15057aaf8d24b88f$var$memoize;

});



parcelRegister("8ZfbE", function(module, exports) {

var $28Fuk = parcelRequire("28Fuk");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $68afcd043835d67d$var$toString(value) {
    return value == null ? '' : $28Fuk(value);
}
module.exports = $68afcd043835d67d$var$toString;

});
parcelRegister("28Fuk", function(module, exports) {

var $bpT63 = parcelRequire("bpT63");

var $g7GeS = parcelRequire("g7GeS");

var $ae8en = parcelRequire("ae8en");

var $tMqsp = parcelRequire("tMqsp");
/** Used as references for various `Number` constants. */ var $18ec82cc23f3cf13$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $18ec82cc23f3cf13$var$symbolProto = $bpT63 ? $bpT63.prototype : undefined, $18ec82cc23f3cf13$var$symbolToString = $18ec82cc23f3cf13$var$symbolProto ? $18ec82cc23f3cf13$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $18ec82cc23f3cf13$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($ae8en(value)) // Recursively convert values (susceptible to call stack limits).
    return $g7GeS(value, $18ec82cc23f3cf13$var$baseToString) + '';
    if ($tMqsp(value)) return $18ec82cc23f3cf13$var$symbolToString ? $18ec82cc23f3cf13$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$18ec82cc23f3cf13$var$INFINITY ? '-0' : result;
}
module.exports = $18ec82cc23f3cf13$var$baseToString;

});



parcelRegister("2kfDE", function(module, exports) {

var $tMqsp = parcelRequire("tMqsp");
/** Used as references for various `Number` constants. */ var $1b19947f8a150593$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $1b19947f8a150593$var$toKey(value) {
    if (typeof value == 'string' || $tMqsp(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$1b19947f8a150593$var$INFINITY ? '-0' : result;
}
module.exports = $1b19947f8a150593$var$toKey;

});



parcelRegister("i4sGm", function(module, exports) {

var $63Al0 = parcelRequire("63Al0");

var $2mpmW = parcelRequire("2mpmW");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $d27ed96be1081ae1$var$hasIn(object, path) {
    return object != null && $2mpmW(object, path, $63Al0);
}
module.exports = $d27ed96be1081ae1$var$hasIn;

});
parcelRegister("63Al0", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $468f35d5b3b087a8$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $468f35d5b3b087a8$var$baseHasIn;

});

parcelRegister("2mpmW", function(module, exports) {

var $89Pye = parcelRequire("89Pye");

var $jmUZP = parcelRequire("jmUZP");

var $ae8en = parcelRequire("ae8en");

var $iVSLT = parcelRequire("iVSLT");

var $9SSrs = parcelRequire("9SSrs");

var $2kfDE = parcelRequire("2kfDE");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $1b81509e0ee6201e$var$hasPath(object, path, hasFunc) {
    path = $89Pye(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $2kfDE(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $9SSrs(length) && $iVSLT(key, length) && ($ae8en(object) || $jmUZP(object));
}
module.exports = $1b81509e0ee6201e$var$hasPath;

});



parcelRegister("8oWHw", function(module, exports) {

var $52A5X = parcelRequire("52A5X");

var $hg8sV = parcelRequire("hg8sV");

var $dkiUG = parcelRequire("dkiUG");

var $2kfDE = parcelRequire("2kfDE");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $61de196590f61fb0$var$property(path) {
    return $dkiUG(path) ? $52A5X($2kfDE(path)) : $hg8sV(path);
}
module.exports = $61de196590f61fb0$var$property;

});
parcelRegister("52A5X", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $3ab92368f4f7e5e6$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $3ab92368f4f7e5e6$var$baseProperty;

});

parcelRegister("hg8sV", function(module, exports) {

var $eI84R = parcelRequire("eI84R");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c90a7f5fa322c64d$var$basePropertyDeep(path) {
    return function(object) {
        return $eI84R(object, path);
    };
}
module.exports = $c90a7f5fa322c64d$var$basePropertyDeep;

});



parcelRegister("jQrXv", function(module, exports) {

var $eI84R = parcelRequire("eI84R");

var $dL3zg = parcelRequire("dL3zg");

var $89Pye = parcelRequire("89Pye");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $e7288fa80019ba45$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $eI84R(object, path);
        if (predicate(value, path)) $dL3zg(result, $89Pye(path, object), value);
    }
    return result;
}
module.exports = $e7288fa80019ba45$var$basePickBy;

});
parcelRegister("dL3zg", function(module, exports) {

var $dIHln = parcelRequire("dIHln");

var $89Pye = parcelRequire("89Pye");

var $iVSLT = parcelRequire("iVSLT");

var $e9Eyz = parcelRequire("e9Eyz");

var $2kfDE = parcelRequire("2kfDE");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $0295b77628fdfa69$var$baseSet(object, path, value, customizer) {
    if (!$e9Eyz(object)) return object;
    path = $89Pye(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $2kfDE(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $e9Eyz(objValue) ? objValue : $iVSLT(path[index + 1]) ? [] : {};
        }
        $dIHln(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $0295b77628fdfa69$var$baseSet;

});
parcelRegister("dIHln", function(module, exports) {

var $6Gx3I = parcelRequire("6Gx3I");

var $h2kXj = parcelRequire("h2kXj");
/** Used for built-in method references. */ var $9fd1019b97acbee5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9fd1019b97acbee5$var$hasOwnProperty = $9fd1019b97acbee5$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $9fd1019b97acbee5$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($9fd1019b97acbee5$var$hasOwnProperty.call(object, key) && $h2kXj(objValue, value)) || value === undefined && !(key in object)) $6Gx3I(object, key, value);
}
module.exports = $9fd1019b97acbee5$var$assignValue;

});
parcelRegister("6Gx3I", function(module, exports) {

var $2WeUr = parcelRequire("2WeUr");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $4de04f2896db1445$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $2WeUr) $2WeUr(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $4de04f2896db1445$var$baseAssignValue;

});
parcelRegister("2WeUr", function(module, exports) {

var $dAfD8 = parcelRequire("dAfD8");
var $223c904013311c66$var$defineProperty = function() {
    try {
        var func = $dAfD8(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $223c904013311c66$var$defineProperty;

});





parcelRegister("h95GP", function(module, exports) {

var $ashyr = parcelRequire("ashyr");

var $cZ9h2 = parcelRequire("cZ9h2");

var $iYGby = parcelRequire("iYGby");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c7b7b0cdb88b5e16$var$getAllKeysIn(object) {
    return $ashyr(object, $iYGby, $cZ9h2);
}
module.exports = $c7b7b0cdb88b5e16$var$getAllKeysIn;

});
parcelRegister("cZ9h2", function(module, exports) {

var $836c9 = parcelRequire("836c9");

var $lCEWq = parcelRequire("lCEWq");

var $j44BY = parcelRequire("j44BY");

var $hfqvJ = parcelRequire("hfqvJ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $97426025686ad412$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $97426025686ad412$var$getSymbolsIn = !$97426025686ad412$var$nativeGetSymbols ? $hfqvJ : function(object) {
    var result = [];
    while(object){
        $836c9(result, $j44BY(object));
        object = $lCEWq(object);
    }
    return result;
};
module.exports = $97426025686ad412$var$getSymbolsIn;

});
parcelRegister("lCEWq", function(module, exports) {

var $jC9zE = parcelRequire("jC9zE");
/** Built-in value references. */ var $fbdce7ac153d99a0$var$getPrototype = $jC9zE(Object.getPrototypeOf, Object);
module.exports = $fbdce7ac153d99a0$var$getPrototype;

});


parcelRegister("iYGby", function(module, exports) {

var $jHUqE = parcelRequire("jHUqE");

var $4i5We = parcelRequire("4i5We");

var $50iuD = parcelRequire("50iuD");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $dd0e8dbfe5fcbf97$var$keysIn(object) {
    return $50iuD(object) ? $jHUqE(object, true) : $4i5We(object);
}
module.exports = $dd0e8dbfe5fcbf97$var$keysIn;

});
parcelRegister("4i5We", function(module, exports) {

var $e9Eyz = parcelRequire("e9Eyz");

var $vFm6J = parcelRequire("vFm6J");

var $19Fww = parcelRequire("19Fww");
/** Used for built-in method references. */ var $31fd730d207725f3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $31fd730d207725f3$var$hasOwnProperty = $31fd730d207725f3$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $31fd730d207725f3$var$baseKeysIn(object) {
    if (!$e9Eyz(object)) return $19Fww(object);
    var isProto = $vFm6J(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$31fd730d207725f3$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $31fd730d207725f3$var$baseKeysIn;

});
parcelRegister("19Fww", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0d76d76ddc3f664f$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $0d76d76ddc3f664f$var$nativeKeysIn;

});





parcelRegister("hfkbF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c8e37f237af17330$var$_v = $c8e37f237af17330$var$_interopRequireDefault((parcelRequire("c3tr9")));

var $c8e37f237af17330$var$_dayjs = $c8e37f237af17330$var$_interopRequireDefault((parcelRequire("cRL5r")));

var $c8e37f237af17330$var$_utc = $c8e37f237af17330$var$_interopRequireDefault((parcelRequire("e7R0U")));

var $7yynp = parcelRequire("7yynp");
function $c8e37f237af17330$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$c8e37f237af17330$var$_dayjs["default"].extend($c8e37f237af17330$var$_utc["default"]);
var $c8e37f237af17330$var$now = (0, $c8e37f237af17330$var$_dayjs["default"])().utc();
var $c8e37f237af17330$var$defaults = {
    title: 'Untitled event',
    productId: 'adamgibbons/ics',
    method: 'PUBLISH',
    uid: (0, $c8e37f237af17330$var$_v["default"])(),
    timestamp: (0, $7yynp.formatUTCDateAsUTC)([
        $c8e37f237af17330$var$now.get('year'),
        $c8e37f237af17330$var$now.get('month') + 1,
        $c8e37f237af17330$var$now.get('date'),
        $c8e37f237af17330$var$now.get('hours'),
        $c8e37f237af17330$var$now.get('minutes'),
        $c8e37f237af17330$var$now.get('seconds')
    ]),
    start: (0, $7yynp.formatUTCDateAsUTC)()
};
var $c8e37f237af17330$var$_default = $c8e37f237af17330$var$defaults;
module.exports["default"] = $c8e37f237af17330$var$_default;

});
parcelRegister("c3tr9", function(module, exports) {

var $dDGfm = parcelRequire("dDGfm");

var $eJm1z = parcelRequire("eJm1z");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $8c6c9969a1fc5e4a$var$_nodeId;
var $8c6c9969a1fc5e4a$var$_clockseq;
// Previous uuid creation time
var $8c6c9969a1fc5e4a$var$_lastMSecs = 0;
var $8c6c9969a1fc5e4a$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $8c6c9969a1fc5e4a$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $8c6c9969a1fc5e4a$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $8c6c9969a1fc5e4a$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $dDGfm();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $8c6c9969a1fc5e4a$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $8c6c9969a1fc5e4a$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $8c6c9969a1fc5e4a$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $8c6c9969a1fc5e4a$var$_lastMSecs + (nsecs - $8c6c9969a1fc5e4a$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $8c6c9969a1fc5e4a$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $8c6c9969a1fc5e4a$var$_lastMSecs = msecs;
    $8c6c9969a1fc5e4a$var$_lastNSecs = nsecs;
    $8c6c9969a1fc5e4a$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $eJm1z(b);
}
module.exports = $8c6c9969a1fc5e4a$var$v1;

});

parcelRegister("cRL5r", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = "millisecond", e = "second", n = "minute", r = "hour", i = "day", s = "week", u = "month", a = "quarter", o = "year", f = "date", h = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d+)?$/, c = /\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, d = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, $ = {
        s: d,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + d(r, 2, "0") + ":" + d(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, u), s = n - i < 0, a = e.clone().add(r + (s ? -1 : 1), u);
            return +(-(r + (n - i) / (s ? i - a : a - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(h) {
            return ({
                M: u,
                y: o,
                w: s,
                d: i,
                D: f,
                h: r,
                m: n,
                s: e,
                ms: t,
                Q: a
            })[h] || String(h || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, l = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
    }, y = "en", M = {};
    M[y] = l;
    var m = function(t) {
        return t instanceof S;
    }, D = function(t, e, n) {
        var r;
        if (!t) return y;
        if ("string" == typeof t) M[t] && (r = t), e && (M[t] = e, r = t);
        else {
            var i = t.name;
            M[i] = t, r = i;
        }
        return !n && r && (y = r), r || !n && y;
    }, v = function(t, e) {
        if (m(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new S(n);
    }, g = $;
    g.l = D, g.i = m, g.w = function(t, e) {
        return v(t, {
            locale: e.$L,
            utc: e.$u,
            $offset: e.$offset
        });
    };
    var S = function() {
        function d(t) {
            this.$L = this.$L || D(t.locale, null, !0), this.parse(t);
        }
        var $ = d.prototype;
        return $.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (g.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match(h);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, $.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, $.$utils = function() {
            return g;
        }, $.isValid = function() {
            return !("Invalid Date" === this.$d.toString());
        }, $.isSame = function(t, e) {
            var n = v(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, $.isAfter = function(t, e) {
            return v(t) < this.startOf(e);
        }, $.isBefore = function(t, e) {
            return this.endOf(e) < v(t);
        }, $.$g = function(t, e, n) {
            return g.u(t) ? this[e] : this.set(n, t);
        }, $.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, $.valueOf = function() {
            return this.$d.getTime();
        }, $.startOf = function(t, a) {
            var h = this, c = !!g.u(a) || a, d = g.p(t), $ = function(t, e) {
                var n = g.w(h.$u ? Date.UTC(h.$y, e, t) : new Date(h.$y, e, t), h);
                return c ? n : n.endOf(i);
            }, l = function(t, e) {
                return g.w(h.toDate()[t].apply(h.toDate("s"), (c ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), h);
            }, y = this.$W, M = this.$M, m = this.$D, D = "set" + (this.$u ? "UTC" : "");
            switch(d){
                case o:
                    return c ? $(1, 0) : $(31, 11);
                case u:
                    return c ? $(1, M) : $(0, M + 1);
                case s:
                    var v = this.$locale().weekStart || 0, S = (y < v ? y + 7 : y) - v;
                    return $(c ? m - S : m + (6 - S), M);
                case i:
                case f:
                    return l(D + "Hours", 0);
                case r:
                    return l(D + "Minutes", 1);
                case n:
                    return l(D + "Seconds", 2);
                case e:
                    return l(D + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, $.endOf = function(t) {
            return this.startOf(t, !1);
        }, $.$set = function(s, a) {
            var h, c = g.p(s), d = "set" + (this.$u ? "UTC" : ""), $ = (h = {}, h[i] = d + "Date", h[f] = d + "Date", h[u] = d + "Month", h[o] = d + "FullYear", h[r] = d + "Hours", h[n] = d + "Minutes", h[e] = d + "Seconds", h[t] = d + "Milliseconds", h)[c], l = c === i ? this.$D + (a - this.$W) : a;
            if (c === u || c === o) {
                var y = this.clone().set(f, 1);
                y.$d[$](l), y.init(), this.$d = y.set(f, Math.min(this.$D, y.daysInMonth())).$d;
            } else $ && this.$d[$](l);
            return this.init(), this;
        }, $.set = function(t, e) {
            return this.clone().$set(t, e);
        }, $.get = function(t) {
            return this[g.p(t)]();
        }, $.add = function(t, a) {
            var f, h = this;
            t = Number(t);
            var c = g.p(a), d = function(e) {
                var n = v(h);
                return g.w(n.date(n.date() + Math.round(e * t)), h);
            };
            if (c === u) return this.set(u, this.$M + t);
            if (c === o) return this.set(o, this.$y + t);
            if (c === i) return d(1);
            if (c === s) return d(7);
            var $ = (f = {}, f[n] = 6e4, f[r] = 36e5, f[e] = 1e3, f)[c] || 1, l = this.$d.getTime() + t * $;
            return g.w(l, this);
        }, $.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, $.format = function(t) {
            var e = this;
            if (!this.isValid()) return "Invalid Date";
            var n = t || "YYYY-MM-DDTHH:mm:ssZ", r = g.z(this), i = this.$locale(), s = this.$H, u = this.$m, a = this.$M, o = i.weekdays, f = i.months, h = function(t, r, i, s) {
                return t && (t[r] || t(e, n)) || i[r].substr(0, s);
            }, d = function(t) {
                return g.s(s % 12 || 12, t, "0");
            }, $ = i.meridiem || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            }, l = {
                YY: String(this.$y).slice(-2),
                YYYY: this.$y,
                M: a + 1,
                MM: g.s(a + 1, 2, "0"),
                MMM: h(i.monthsShort, a, f, 3),
                MMMM: h(f, a),
                D: this.$D,
                DD: g.s(this.$D, 2, "0"),
                d: String(this.$W),
                dd: h(i.weekdaysMin, this.$W, o, 2),
                ddd: h(i.weekdaysShort, this.$W, o, 3),
                dddd: o[this.$W],
                H: String(s),
                HH: g.s(s, 2, "0"),
                h: d(1),
                hh: d(2),
                a: $(s, u, !0),
                A: $(s, u, !1),
                m: String(u),
                mm: g.s(u, 2, "0"),
                s: String(this.$s),
                ss: g.s(this.$s, 2, "0"),
                SSS: g.s(this.$ms, 3, "0"),
                Z: r
            };
            return n.replace(c, function(t, e) {
                return e || l[t] || r.replace(":", "");
            });
        }, $.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, $.diff = function(t, f, h) {
            var c, d = g.p(f), $ = v(t), l = 6e4 * ($.utcOffset() - this.utcOffset()), y = this - $, M = g.m(this, $);
            return M = (c = {}, c[o] = M / 12, c[u] = M, c[a] = M / 3, c[s] = (y - l) / 6048e5, c[i] = (y - l) / 864e5, c[r] = y / 36e5, c[n] = y / 6e4, c[e] = y / 1e3, c)[d] || y, h ? M : g.a(M);
        }, $.daysInMonth = function() {
            return this.endOf(u).$D;
        }, $.$locale = function() {
            return M[this.$L];
        }, $.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = D(t, e, !0);
            return r && (n.$L = r), n;
        }, $.clone = function() {
            return g.w(this.$d, this);
        }, $.toDate = function() {
            return new Date(this.valueOf());
        }, $.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, $.toISOString = function() {
            return this.$d.toISOString();
        }, $.toString = function() {
            return this.$d.toUTCString();
        }, d;
    }(), p = S.prototype;
    return v.prototype = p, [
        [
            "$ms",
            t
        ],
        [
            "$s",
            e
        ],
        [
            "$m",
            n
        ],
        [
            "$H",
            r
        ],
        [
            "$W",
            i
        ],
        [
            "$M",
            u
        ],
        [
            "$y",
            o
        ],
        [
            "$D",
            f
        ]
    ].forEach(function(t) {
        p[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), v.extend = function(t, e) {
        return t(e, S, v), v;
    }, v.locale = D, v.isDayjs = m, v.unix = function(t) {
        return v(1e3 * t);
    }, v.en = M[y], v.Ls = M, v;
});

});

parcelRegister("e7R0U", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    return function(t, i, e) {
        var s = (new Date).getTimezoneOffset(), n = i.prototype;
        e.utc = function(t) {
            return new i({
                date: t,
                utc: !0,
                args: arguments
            });
        }, n.utc = function() {
            return e(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
        }, n.local = function() {
            return e(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var u = n.parse;
        n.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), u.call(this, t);
        };
        var o = n.init;
        n.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else o.call(this);
        };
        var f = n.utcOffset;
        n.utcOffset = function(t, i) {
            var e = this.$utils().u;
            if (e(t)) return this.$u ? 0 : e(this.$offset) ? f.call(this) : this.$offset;
            var n = Math.abs(t) <= 16 ? 60 * t : t, u = this;
            return i ? (u.$offset = n, u.$u = 0 === t, u) : (0 !== t ? (u = this.local().add(n + s, "minute")).$offset = n : u = this.utc(), u);
        };
        var r = n.format;
        n.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return r.call(this, i);
        }, n.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + s;
            return this.$d.valueOf() - 6e4 * t;
        }, n.isUTC = function() {
            return !!this.$u;
        }, n.toISOString = function() {
            return this.toDate().toISOString();
        }, n.toString = function() {
            return this.toDate().toUTCString();
        };
        var a = n.toDate;
        n.toDate = function(t) {
            return "s" === t && this.$offset ? e(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : a.call(this);
        };
        var c = n.diff;
        n.diff = function(t, i, s) {
            var n = this.local(), u = e(t).local();
            return c.call(n, u, i, s);
        };
    };
});

});

parcelRegister("7yynp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "formatDate", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_formatDate["default"];
    }
});
Object.defineProperty(module.exports, "formatLocalDateAsUTC", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_formatLocalDateAsUtc["default"];
    }
});
Object.defineProperty(module.exports, "formatLocalDateAsLocal", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_formatLocalDateAsLocal["default"];
    }
});
Object.defineProperty(module.exports, "formatUTCDateAsUTC", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_formatUtcDateAsUtc["default"];
    }
});
Object.defineProperty(module.exports, "formatUTCDateAsLocal", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_formatUtcDateAsLocal["default"];
    }
});
Object.defineProperty(module.exports, "setGeolocation", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_setGeolocation["default"];
    }
});
Object.defineProperty(module.exports, "setContact", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_setContact["default"];
    }
});
Object.defineProperty(module.exports, "setOrganizer", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_setOrganizer["default"];
    }
});
Object.defineProperty(module.exports, "setAlarm", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_setAlarm["default"];
    }
});
Object.defineProperty(module.exports, "setDescription", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_setDescription["default"];
    }
});
Object.defineProperty(module.exports, "setSummary", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_setSummary["default"];
    }
});
Object.defineProperty(module.exports, "formatDuration", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_formatDuration["default"];
    }
});
Object.defineProperty(module.exports, "foldLine", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_foldLine["default"];
    }
});
Object.defineProperty(module.exports, "setLocation", {
    enumerable: true,
    get: function get() {
        return $58065fde386e5c8b$var$_setLocation["default"];
    }
});

var $58065fde386e5c8b$var$_formatDate = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("k7Hc8")));

var $58065fde386e5c8b$var$_formatLocalDateAsUtc = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("ioOOD")));

var $58065fde386e5c8b$var$_formatLocalDateAsLocal = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("fHafS")));

var $58065fde386e5c8b$var$_formatUtcDateAsUtc = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("8m67O")));

var $58065fde386e5c8b$var$_formatUtcDateAsLocal = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("icOCI")));

var $58065fde386e5c8b$var$_setGeolocation = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("lLh9Z")));

var $58065fde386e5c8b$var$_setContact = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("6wFdi")));

var $58065fde386e5c8b$var$_setOrganizer = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("kl3Mf")));

var $58065fde386e5c8b$var$_setAlarm = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("dxR8V")));

var $58065fde386e5c8b$var$_setDescription = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("jhT8u")));

var $58065fde386e5c8b$var$_setSummary = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("cNqWh")));

var $58065fde386e5c8b$var$_formatDuration = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("kPA3V")));

var $58065fde386e5c8b$var$_foldLine = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("6KXLt")));

var $58065fde386e5c8b$var$_setLocation = $58065fde386e5c8b$var$_interopRequireDefault((parcelRequire("khPV2")));
function $58065fde386e5c8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("k7Hc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ea65f7ad33e4a7e4$var$formatDate;

var $ea65f7ad33e4a7e4$var$_dayjs = $ea65f7ad33e4a7e4$var$_interopRequireDefault((parcelRequire("cRL5r")));

var $7yynp = parcelRequire("7yynp");
function $ea65f7ad33e4a7e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ea65f7ad33e4a7e4$var$_slicedToArray(arr, i) {
    return $ea65f7ad33e4a7e4$var$_arrayWithHoles(arr) || $ea65f7ad33e4a7e4$var$_iterableToArrayLimit(arr, i) || $ea65f7ad33e4a7e4$var$_unsupportedIterableToArray(arr, i) || $ea65f7ad33e4a7e4$var$_nonIterableRest();
}
function $ea65f7ad33e4a7e4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ea65f7ad33e4a7e4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ea65f7ad33e4a7e4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ea65f7ad33e4a7e4$var$_arrayLikeToArray(o, minLen);
}
function $ea65f7ad33e4a7e4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ea65f7ad33e4a7e4$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ea65f7ad33e4a7e4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ea65f7ad33e4a7e4$var$formatLocalDate() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var outputType = arguments.length > 1 ? arguments[1] : undefined;
    if (outputType == 'utc') return (0, $7yynp.formatLocalDateAsUTC)(args, outputType);
    return (0, $7yynp.formatLocalDateAsLocal)(args, outputType);
}
function $ea65f7ad33e4a7e4$var$formatUTCDate() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var outputType = arguments.length > 1 ? arguments[1] : undefined;
    if (outputType == 'utc') return (0, $7yynp.formatUTCDateAsUTC)(args, outputType);
    return (0, $7yynp.formatUTCDateAsLocal)(args, outputType);
}
function $ea65f7ad33e4a7e4$var$formatDate() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var outputType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utc';
    var inputType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'local';
    var _args = $ea65f7ad33e4a7e4$var$_slicedToArray(args, 6), year = _args[0], month = _args[1], date = _args[2], hours = _args[3], minutes = _args[4], seconds = _args[5];
    if (args.length === 3) return (0, $ea65f7ad33e4a7e4$var$_dayjs["default"])(new Date(year, month - 1, date)).format('YYYYMMDD');
    if (inputType === 'local') return $ea65f7ad33e4a7e4$var$formatLocalDate([
        year,
        month,
        date,
        hours,
        minutes,
        seconds || 0
    ], outputType);
     // type === 'utc'
    return $ea65f7ad33e4a7e4$var$formatUTCDate([
        year,
        month,
        date,
        hours,
        minutes,
        seconds || 0
    ], outputType);
}

});

parcelRegister("ioOOD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d651e2cf848a9237$var$formatLocalDateAsUTC;

var $d651e2cf848a9237$var$_dayjs = $d651e2cf848a9237$var$_interopRequireDefault((parcelRequire("cRL5r")));

var $d651e2cf848a9237$var$_utc = $d651e2cf848a9237$var$_interopRequireDefault((parcelRequire("e7R0U")));
function $d651e2cf848a9237$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d651e2cf848a9237$var$_slicedToArray(arr, i) {
    return $d651e2cf848a9237$var$_arrayWithHoles(arr) || $d651e2cf848a9237$var$_iterableToArrayLimit(arr, i) || $d651e2cf848a9237$var$_unsupportedIterableToArray(arr, i) || $d651e2cf848a9237$var$_nonIterableRest();
}
function $d651e2cf848a9237$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d651e2cf848a9237$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d651e2cf848a9237$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d651e2cf848a9237$var$_arrayLikeToArray(o, minLen);
}
function $d651e2cf848a9237$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d651e2cf848a9237$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d651e2cf848a9237$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$d651e2cf848a9237$var$_dayjs["default"].extend($d651e2cf848a9237$var$_utc["default"]);
function $d651e2cf848a9237$var$formatLocalDateAsUTC() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (args.length > 0) {
        var _args = $d651e2cf848a9237$var$_slicedToArray(args, 6), year = _args[0], month = _args[1], date = _args[2], _args$ = _args[3], hours = _args$ === void 0 ? 0 : _args$, _args$2 = _args[4], minutes = _args$2 === void 0 ? 0 : _args$2, _args$3 = _args[5], seconds = _args$3 === void 0 ? 0 : _args$3;
        var formattedDate = (0, $d651e2cf848a9237$var$_dayjs["default"])(new Date(year, month - 1, date, hours, minutes, seconds)).utc().format('YYYYMMDDTHHmmss') + 'Z';
        return formattedDate;
    }
    return $d651e2cf848a9237$var$_dayjs["default"].utc().format('YYYYMMDDTHHmmss') + 'Z';
}

});

parcelRegister("fHafS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b6d2d3a0a18e709b$var$formatLocalDateAsLocal;

var $b6d2d3a0a18e709b$var$_dayjs = $b6d2d3a0a18e709b$var$_interopRequireDefault((parcelRequire("cRL5r")));
function $b6d2d3a0a18e709b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b6d2d3a0a18e709b$var$_slicedToArray(arr, i) {
    return $b6d2d3a0a18e709b$var$_arrayWithHoles(arr) || $b6d2d3a0a18e709b$var$_iterableToArrayLimit(arr, i) || $b6d2d3a0a18e709b$var$_unsupportedIterableToArray(arr, i) || $b6d2d3a0a18e709b$var$_nonIterableRest();
}
function $b6d2d3a0a18e709b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b6d2d3a0a18e709b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b6d2d3a0a18e709b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b6d2d3a0a18e709b$var$_arrayLikeToArray(o, minLen);
}
function $b6d2d3a0a18e709b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b6d2d3a0a18e709b$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b6d2d3a0a18e709b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b6d2d3a0a18e709b$var$formatLocalDateAsLocal() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (args.length > 0) {
        var _args = $b6d2d3a0a18e709b$var$_slicedToArray(args, 6), year = _args[0], month = _args[1], date = _args[2], _args$ = _args[3], hours = _args$ === void 0 ? 0 : _args$, _args$2 = _args[4], minutes = _args$2 === void 0 ? 0 : _args$2, _args$3 = _args[5], seconds = _args$3 === void 0 ? 0 : _args$3;
        var formattedDate = (0, $b6d2d3a0a18e709b$var$_dayjs["default"])(new Date(year, month - 1, date, hours, minutes, seconds)).format('YYYYMMDDTHHmmss');
        return formattedDate;
    }
    return (0, $b6d2d3a0a18e709b$var$_dayjs["default"])().format('YYYYMMDDTHHmmss');
}

});

parcelRegister("8m67O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6155211c6f8c1ffa$var$formatUTCDateAsUTC;

var $6155211c6f8c1ffa$var$_dayjs = $6155211c6f8c1ffa$var$_interopRequireDefault((parcelRequire("cRL5r")));

var $6155211c6f8c1ffa$var$_utc = $6155211c6f8c1ffa$var$_interopRequireDefault((parcelRequire("e7R0U")));
function $6155211c6f8c1ffa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6155211c6f8c1ffa$var$_slicedToArray(arr, i) {
    return $6155211c6f8c1ffa$var$_arrayWithHoles(arr) || $6155211c6f8c1ffa$var$_iterableToArrayLimit(arr, i) || $6155211c6f8c1ffa$var$_unsupportedIterableToArray(arr, i) || $6155211c6f8c1ffa$var$_nonIterableRest();
}
function $6155211c6f8c1ffa$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6155211c6f8c1ffa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6155211c6f8c1ffa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6155211c6f8c1ffa$var$_arrayLikeToArray(o, minLen);
}
function $6155211c6f8c1ffa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6155211c6f8c1ffa$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6155211c6f8c1ffa$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$6155211c6f8c1ffa$var$_dayjs["default"].extend($6155211c6f8c1ffa$var$_utc["default"]);
function $6155211c6f8c1ffa$var$formatUTCDateAsUTC() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (args.length > 0) {
        var _args = $6155211c6f8c1ffa$var$_slicedToArray(args, 6), year = _args[0], month = _args[1], date = _args[2], _args$ = _args[3], hours = _args$ === void 0 ? 0 : _args$, _args$2 = _args[4], minutes = _args$2 === void 0 ? 0 : _args$2, _args$3 = _args[5], seconds = _args$3 === void 0 ? 0 : _args$3;
        var formattedDate = $6155211c6f8c1ffa$var$_dayjs["default"].utc(Date.UTC(year, month - 1, date, hours, minutes, seconds)).format('YYYYMMDDTHHmmss') + 'Z';
        return formattedDate;
    }
    return $6155211c6f8c1ffa$var$_dayjs["default"].utc().format('YYYYMMDDTHHmm00') + 'Z';
}

});

parcelRegister("icOCI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d4109db9a22fafb9$var$formatLocalDateAsLocal;

var $d4109db9a22fafb9$var$_dayjs = $d4109db9a22fafb9$var$_interopRequireDefault((parcelRequire("cRL5r")));

var $d4109db9a22fafb9$var$_utc = $d4109db9a22fafb9$var$_interopRequireDefault((parcelRequire("e7R0U")));
function $d4109db9a22fafb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d4109db9a22fafb9$var$_slicedToArray(arr, i) {
    return $d4109db9a22fafb9$var$_arrayWithHoles(arr) || $d4109db9a22fafb9$var$_iterableToArrayLimit(arr, i) || $d4109db9a22fafb9$var$_unsupportedIterableToArray(arr, i) || $d4109db9a22fafb9$var$_nonIterableRest();
}
function $d4109db9a22fafb9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d4109db9a22fafb9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d4109db9a22fafb9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d4109db9a22fafb9$var$_arrayLikeToArray(o, minLen);
}
function $d4109db9a22fafb9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d4109db9a22fafb9$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d4109db9a22fafb9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$d4109db9a22fafb9$var$_dayjs["default"].extend($d4109db9a22fafb9$var$_utc["default"]);
function $d4109db9a22fafb9$var$formatLocalDateAsLocal() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (args.length > 0) {
        var _args = $d4109db9a22fafb9$var$_slicedToArray(args, 6), year = _args[0], month = _args[1], date = _args[2], _args$ = _args[3], hours = _args$ === void 0 ? 0 : _args$, _args$2 = _args[4], minutes = _args$2 === void 0 ? 0 : _args$2, _args$3 = _args[5], seconds = _args$3 === void 0 ? 0 : _args$3;
        var formattedDate = $d4109db9a22fafb9$var$_dayjs["default"].utc(Date.UTC(year, month - 1, date, hours, minutes, seconds)).format('YYYYMMDDTHHmmss');
        return formattedDate;
    }
    return (0, $d4109db9a22fafb9$var$_dayjs["default"])().utc().format('YYYYMMDDTHHmmss');
}

});

parcelRegister("lLh9Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $fd7b4c6101016646$var$setGeolocation;
function $fd7b4c6101016646$var$setGeolocation(_ref) {
    var lat = _ref.lat, lon = _ref.lon;
    return "".concat(lat, ";").concat(lon);
}

});

parcelRegister("6wFdi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4c05b361517cd6eb$var$setContact;
function $4c05b361517cd6eb$var$setContact(_ref) {
    var name = _ref.name, email = _ref.email, rsvp = _ref.rsvp, dir = _ref.dir, partstat = _ref.partstat, role = _ref.role;
    var formattedAttendee = '';
    formattedAttendee += rsvp ? 'RSVP=TRUE;' : 'RSVP=FALSE;';
    formattedAttendee += role ? "ROLE=".concat(role, ";") : '';
    formattedAttendee += partstat ? "PARTSTAT=".concat(partstat, ";") : '';
    formattedAttendee += dir ? "DIR=".concat(dir, ";") : '';
    formattedAttendee += 'CN=';
    formattedAttendee += name || 'Unnamed attendee';
    formattedAttendee += email ? ":mailto:".concat(email) : '';
    return formattedAttendee;
}

});

parcelRegister("kl3Mf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ece8b2e2c5aa8385$var$setOrganizer;
function $ece8b2e2c5aa8385$var$setOrganizer(_ref) {
    var name = _ref.name, email = _ref.email, dir = _ref.dir;
    var formattedOrganizer = '';
    formattedOrganizer += dir ? "DIR=".concat(dir, ";") : '';
    formattedOrganizer += 'CN=';
    formattedOrganizer += name || 'Organizer';
    formattedOrganizer += email ? ":mailto:".concat(email) : '';
    return formattedOrganizer;
}

});

parcelRegister("dxR8V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9dc79487d909e2de$var$setAlarm;

var $9dc79487d909e2de$var$_formatDate = $9dc79487d909e2de$var$_interopRequireDefault((parcelRequire("k7Hc8")));

var $9dc79487d909e2de$var$_foldLine = $9dc79487d909e2de$var$_interopRequireDefault((parcelRequire("6KXLt")));

var $9dc79487d909e2de$var$_isArray = $9dc79487d909e2de$var$_interopRequireDefault((parcelRequire("ae8en")));
function $9dc79487d909e2de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9dc79487d909e2de$var$setDuration(_ref) {
    var weeks = _ref.weeks, days = _ref.days, hours = _ref.hours, minutes = _ref.minutes, seconds = _ref.seconds;
    var formattedString = 'P';
    formattedString += weeks ? "".concat(weeks, "W") : '';
    formattedString += days ? "".concat(days, "D") : '';
    formattedString += 'T';
    formattedString += hours ? "".concat(hours, "H") : '';
    formattedString += minutes ? "".concat(minutes, "M") : '';
    formattedString += seconds ? "".concat(seconds, "S") : '';
    return formattedString;
}
function $9dc79487d909e2de$var$setTrigger(trigger) {
    var formattedString = '';
    if ((0, $9dc79487d909e2de$var$_isArray["default"])(trigger)) formattedString = "TRIGGER;VALUE=DATE-TIME:".concat((0, $9dc79487d909e2de$var$_formatDate["default"])(trigger), "\r\n");
    else {
        var alert = trigger.before ? '-' : '';
        formattedString = "TRIGGER:".concat(alert + $9dc79487d909e2de$var$setDuration(trigger), "\r\n");
    }
    return formattedString;
}
function $9dc79487d909e2de$var$setAction(action) {
    return action.toUpperCase();
}
function $9dc79487d909e2de$var$setAlarm() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = attributes.action, repeat = attributes.repeat, description = attributes.description, duration = attributes.duration, attach = attributes.attach, attachType = attributes.attachType, trigger = attributes.trigger, summary = attributes.summary;
    var formattedString = 'BEGIN:VALARM\r\n';
    formattedString += (0, $9dc79487d909e2de$var$_foldLine["default"])("ACTION:".concat($9dc79487d909e2de$var$setAction(action))) + '\r\n';
    formattedString += repeat ? (0, $9dc79487d909e2de$var$_foldLine["default"])("REPEAT:".concat(repeat)) + '\r\n' : '';
    formattedString += description ? (0, $9dc79487d909e2de$var$_foldLine["default"])("DESCRIPTION:".concat(description)) + '\r\n' : '';
    formattedString += duration ? (0, $9dc79487d909e2de$var$_foldLine["default"])("DURATION:".concat($9dc79487d909e2de$var$setDuration(duration))) + '\r\n' : '';
    var attachInfo = attachType ? attachType : 'FMTTYPE=audio/basic';
    formattedString += attach ? (0, $9dc79487d909e2de$var$_foldLine["default"])("ATTACH;".concat(attachInfo, ":").concat(attach)) + '\r\n' : '';
    formattedString += trigger ? $9dc79487d909e2de$var$setTrigger(trigger) : '';
    formattedString += summary ? (0, $9dc79487d909e2de$var$_foldLine["default"])("SUMMARY:".concat(summary)) + '\r\n' : '';
    formattedString += 'END:VALARM\r\n';
    return formattedString;
} // Example:  A duration of 15 days, 5 hours, and 20 seconds would be:
 // P15DT5H0M20S
 // A duration of 7 weeks would be:
 // P7W

});
parcelRegister("6KXLt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4eb565fdacd4dec0$var$foldLine;
function $4eb565fdacd4dec0$var$foldLine(line) {
    var parts = [];
    var length = 75;
    while(line.length > length){
        parts.push(line.slice(0, length));
        line = line.slice(length);
        length = 74;
    }
    parts.push(line);
    return parts.join('\r\n\t');
}

});


parcelRegister("jhT8u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e0aa5fad39eb0741$var$setDescription;

var $e0aa5fad39eb0741$var$_formatText = $e0aa5fad39eb0741$var$_interopRequireDefault((parcelRequire("7kxE8")));
function $e0aa5fad39eb0741$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e0aa5fad39eb0741$var$setDescription(description) {
    return (0, $e0aa5fad39eb0741$var$_formatText["default"])(description);
}

});
parcelRegister("7kxE8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5564801eabf7efbd$var$formatText;
function $5564801eabf7efbd$var$formatText(text) {
    return text.replace(/\\/gm, "\\\\").replace(/\r?\n/gm, "\\n").replace(/;/gm, "\\;").replace(/,/gm, "\\,");
}

});


parcelRegister("cNqWh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $950ef52a23a7c92a$var$setSummary;

var $950ef52a23a7c92a$var$_formatText = $950ef52a23a7c92a$var$_interopRequireDefault((parcelRequire("7kxE8")));
function $950ef52a23a7c92a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $950ef52a23a7c92a$var$setSummary(summary) {
    return (0, $950ef52a23a7c92a$var$_formatText["default"])(summary);
}

});

parcelRegister("kPA3V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f2a48b4bf5a38418$var$formatDuration;
function $f2a48b4bf5a38418$var$formatDuration() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var weeks = attributes.weeks, days = attributes.days, hours = attributes.hours, minutes = attributes.minutes, seconds = attributes.seconds;
    var formattedDuration = 'P';
    formattedDuration += weeks ? "".concat(weeks, "W") : '';
    formattedDuration += days ? "".concat(days, "D") : '';
    formattedDuration += 'T';
    formattedDuration += hours ? "".concat(hours, "H") : '';
    formattedDuration += minutes ? "".concat(minutes, "M") : '';
    formattedDuration += seconds ? "".concat(seconds, "S") : '';
    return formattedDuration;
}

});

parcelRegister("khPV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ec4dab3655604259$var$setLocation;

var $ec4dab3655604259$var$_formatText = $ec4dab3655604259$var$_interopRequireDefault((parcelRequire("7kxE8")));
function $ec4dab3655604259$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ec4dab3655604259$var$setLocation(location) {
    return (0, $ec4dab3655604259$var$_formatText["default"])(location);
}

});




parcelRegister("ifLNJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d49eb4fe494fdea4$var$formatEvent;

var $7yynp = parcelRequire("7yynp");

var $d49eb4fe494fdea4$var$_isEqual = $d49eb4fe494fdea4$var$_interopRequireDefault((parcelRequire("6jrEe")));
function $d49eb4fe494fdea4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d49eb4fe494fdea4$var$formatEvent() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var title = attributes.title, productId = attributes.productId, method = attributes.method, uid = attributes.uid, sequence = attributes.sequence, timestamp = attributes.timestamp, start = attributes.start, startType = attributes.startType, startInputType = attributes.startInputType, startOutputType = attributes.startOutputType, duration = attributes.duration, end = attributes.end, endInputType = attributes.endInputType, endOutputType = attributes.endOutputType, description = attributes.description, url = attributes.url, geo = attributes.geo, location = attributes.location, status = attributes.status, categories = attributes.categories, organizer = attributes.organizer, attendees = attributes.attendees, alarms = attributes.alarms, recurrenceRule = attributes.recurrenceRule, busyStatus = attributes.busyStatus, created = attributes.created, lastModified = attributes.lastModified, calName = attributes.calName;
    var icsFormat = '';
    icsFormat += 'BEGIN:VCALENDAR\r\n';
    icsFormat += 'VERSION:2.0\r\n';
    icsFormat += 'CALSCALE:GREGORIAN\r\n';
    icsFormat += (0, $7yynp.foldLine)("PRODID:".concat(productId)) + '\r\n';
    icsFormat += (0, $7yynp.foldLine)("METHOD:".concat(method)) + '\r\n';
    icsFormat += calName ? (0, $7yynp.foldLine)("X-WR-CALNAME:".concat(calName)) + '\r\n' : '';
    icsFormat += "X-PUBLISHED-TTL:PT1H\r\n";
    icsFormat += 'BEGIN:VEVENT\r\n';
    icsFormat += "UID:".concat(uid, "\r\n");
    icsFormat += (0, $7yynp.foldLine)("SUMMARY:".concat(title ? (0, $7yynp.setSummary)(title) : title)) + '\r\n';
    icsFormat += "DTSTAMP:".concat(timestamp, "\r\n"); // All day events like anniversaries must be specified as VALUE type DATE
    icsFormat += "DTSTART".concat(start && start.length == 3 ? ";VALUE=DATE" : "", ":").concat((0, $7yynp.formatDate)(start, startOutputType || startType, startInputType), "\r\n"); // End is not required for all day events on single days (like anniversaries)
    if (!((0, $d49eb4fe494fdea4$var$_isEqual["default"])(start, end) && end && end.length == 3)) {
        if (end) icsFormat += "DTEND".concat(end.length == 3 ? ";VALUE=DATE" : "", ":").concat((0, $7yynp.formatDate)(end, endOutputType || startOutputType || startType, endInputType || startInputType), "\r\n");
    }
    icsFormat += sequence ? "SEQUENCE:".concat(sequence, "\r\n") : '';
    icsFormat += description ? (0, $7yynp.foldLine)("DESCRIPTION:".concat((0, $7yynp.setDescription)(description))) + '\r\n' : '';
    icsFormat += url ? (0, $7yynp.foldLine)("URL:".concat(url)) + '\r\n' : '';
    icsFormat += geo ? (0, $7yynp.foldLine)("GEO:".concat((0, $7yynp.setGeolocation)(geo))) + '\r\n' : '';
    icsFormat += location ? (0, $7yynp.foldLine)("LOCATION:".concat((0, $7yynp.setLocation)(location))) + '\r\n' : '';
    icsFormat += status ? (0, $7yynp.foldLine)("STATUS:".concat(status)) + '\r\n' : '';
    icsFormat += categories ? (0, $7yynp.foldLine)("CATEGORIES:".concat(categories)) + '\r\n' : '';
    icsFormat += organizer ? (0, $7yynp.foldLine)("ORGANIZER;".concat((0, $7yynp.setOrganizer)(organizer))) + '\r\n' : '';
    icsFormat += busyStatus ? (0, $7yynp.foldLine)("X-MICROSOFT-CDO-BUSYSTATUS:".concat(busyStatus)) + '\r\n' : '';
    icsFormat += created ? 'CREATED:' + (0, $7yynp.formatDate)(created) + '\r\n' : '';
    icsFormat += lastModified ? 'LAST-MODIFIED:' + (0, $7yynp.formatDate)(lastModified) + '\r\n' : '';
    if (attendees) attendees.map(function(attendee) {
        icsFormat += (0, $7yynp.foldLine)("ATTENDEE;".concat((0, $7yynp.setContact)(attendee))) + '\r\n';
    });
    if (alarms) alarms.map(function(alarm) {
        icsFormat += (0, $7yynp.setAlarm)(alarm);
    });
    icsFormat += recurrenceRule ? "RRULE:".concat(recurrenceRule, "\r\n") : '';
    icsFormat += duration ? "DURATION:".concat((0, $7yynp.formatDuration)(duration), "\r\n") : '';
    icsFormat += "END:VEVENT\r\n";
    icsFormat += "END:VCALENDAR\r\n";
    return icsFormat;
}

});
parcelRegister("6jrEe", function(module, exports) {

var $ivT4I = parcelRequire("ivT4I");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $4989f6b981406173$var$isEqual(value, other) {
    return $ivT4I(value, other);
}
module.exports = $4989f6b981406173$var$isEqual;

});


parcelRegister("aWC6d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7f7cdfdd92a0c33c$var$_schema = $7f7cdfdd92a0c33c$var$_interopRequireDefault((parcelRequire("hhLks")));
function $7f7cdfdd92a0c33c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $7f7cdfdd92a0c33c$var$_default = $7f7cdfdd92a0c33c$var$_schema["default"];
module.exports["default"] = $7f7cdfdd92a0c33c$var$_default;

});
parcelRegister("hhLks", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c958bcbc4f0da77e$var$validateEvent;

var $c958bcbc4f0da77e$var$_joi = $c958bcbc4f0da77e$var$_interopRequireDefault((parcelRequire("5Eekv")));
function $c958bcbc4f0da77e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $c958bcbc4f0da77e$var$dateTimeSchema = $c958bcbc4f0da77e$var$_joi["default"].array().min(3).max(7).ordered($c958bcbc4f0da77e$var$_joi["default"].number().integer(), $c958bcbc4f0da77e$var$_joi["default"].number().integer().min(1).max(12), $c958bcbc4f0da77e$var$_joi["default"].number().integer().min(1).max(31), $c958bcbc4f0da77e$var$_joi["default"].number().integer().min(0).max(23), $c958bcbc4f0da77e$var$_joi["default"].number().integer().min(0).max(60), $c958bcbc4f0da77e$var$_joi["default"].number().integer().min(0).max(60));
var $c958bcbc4f0da77e$var$durationSchema = $c958bcbc4f0da77e$var$_joi["default"].object().keys({
    before: $c958bcbc4f0da77e$var$_joi["default"]["boolean"](),
    //option to set before alaram
    weeks: $c958bcbc4f0da77e$var$_joi["default"].number(),
    days: $c958bcbc4f0da77e$var$_joi["default"].number(),
    hours: $c958bcbc4f0da77e$var$_joi["default"].number(),
    minutes: $c958bcbc4f0da77e$var$_joi["default"].number(),
    seconds: $c958bcbc4f0da77e$var$_joi["default"].number()
});
var $c958bcbc4f0da77e$var$contactSchema = $c958bcbc4f0da77e$var$_joi["default"].object().keys({
    name: $c958bcbc4f0da77e$var$_joi["default"].string(),
    email: $c958bcbc4f0da77e$var$_joi["default"].string().email({
        tlds: {
            allow: false
        }
    }),
    rsvp: $c958bcbc4f0da77e$var$_joi["default"]["boolean"](),
    dir: $c958bcbc4f0da77e$var$_joi["default"].string().uri(),
    partstat: $c958bcbc4f0da77e$var$_joi["default"].string(),
    role: $c958bcbc4f0da77e$var$_joi["default"].string()
});
var $c958bcbc4f0da77e$var$organizerSchema = $c958bcbc4f0da77e$var$_joi["default"].object().keys({
    name: $c958bcbc4f0da77e$var$_joi["default"].string(),
    email: $c958bcbc4f0da77e$var$_joi["default"].string().email({
        tlds: {
            allow: false
        }
    })
});
var $c958bcbc4f0da77e$var$alarmSchema = $c958bcbc4f0da77e$var$_joi["default"].object().keys({
    action: $c958bcbc4f0da77e$var$_joi["default"].string().regex(/audio|display|email/).required(),
    trigger: $c958bcbc4f0da77e$var$_joi["default"].any().required(),
    description: $c958bcbc4f0da77e$var$_joi["default"].string(),
    duration: $c958bcbc4f0da77e$var$durationSchema,
    repeat: $c958bcbc4f0da77e$var$_joi["default"].number(),
    attach: $c958bcbc4f0da77e$var$_joi["default"].string(),
    attachType: $c958bcbc4f0da77e$var$_joi["default"].string(),
    summary: $c958bcbc4f0da77e$var$_joi["default"].string(),
    attendee: $c958bcbc4f0da77e$var$contactSchema,
    'x-prop': $c958bcbc4f0da77e$var$_joi["default"].any(),
    'iana-prop': $c958bcbc4f0da77e$var$_joi["default"].any()
});
var $c958bcbc4f0da77e$var$schema = $c958bcbc4f0da77e$var$_joi["default"].object().keys({
    summary: $c958bcbc4f0da77e$var$_joi["default"].string(),
    timestamp: $c958bcbc4f0da77e$var$_joi["default"].any(),
    title: $c958bcbc4f0da77e$var$_joi["default"].string(),
    productId: $c958bcbc4f0da77e$var$_joi["default"].string(),
    method: $c958bcbc4f0da77e$var$_joi["default"].string(),
    uid: $c958bcbc4f0da77e$var$_joi["default"].string().required(),
    sequence: $c958bcbc4f0da77e$var$_joi["default"].number(),
    start: $c958bcbc4f0da77e$var$dateTimeSchema.required(),
    duration: $c958bcbc4f0da77e$var$durationSchema,
    startType: $c958bcbc4f0da77e$var$_joi["default"].string().regex(/utc|local/),
    startInputType: $c958bcbc4f0da77e$var$_joi["default"].string().regex(/utc|local/),
    startOutputType: $c958bcbc4f0da77e$var$_joi["default"].string().regex(/utc|local/),
    end: $c958bcbc4f0da77e$var$dateTimeSchema,
    endInputType: $c958bcbc4f0da77e$var$_joi["default"].string().regex(/utc|local/),
    endOutputType: $c958bcbc4f0da77e$var$_joi["default"].string().regex(/utc|local/),
    description: $c958bcbc4f0da77e$var$_joi["default"].string(),
    url: $c958bcbc4f0da77e$var$_joi["default"].string().uri(),
    geo: $c958bcbc4f0da77e$var$_joi["default"].object().keys({
        lat: $c958bcbc4f0da77e$var$_joi["default"].number(),
        lon: $c958bcbc4f0da77e$var$_joi["default"].number()
    }),
    location: $c958bcbc4f0da77e$var$_joi["default"].string(),
    status: $c958bcbc4f0da77e$var$_joi["default"].string().regex(/TENTATIVE|CANCELLED|CONFIRMED/),
    categories: $c958bcbc4f0da77e$var$_joi["default"].array().items($c958bcbc4f0da77e$var$_joi["default"].string()),
    organizer: $c958bcbc4f0da77e$var$organizerSchema,
    attendees: $c958bcbc4f0da77e$var$_joi["default"].array().items($c958bcbc4f0da77e$var$contactSchema),
    alarms: $c958bcbc4f0da77e$var$_joi["default"].array().items($c958bcbc4f0da77e$var$alarmSchema),
    recurrenceRule: $c958bcbc4f0da77e$var$_joi["default"].string(),
    busyStatus: $c958bcbc4f0da77e$var$_joi["default"].string().regex(/TENTATIVE|FREE|BUSY|OOF/),
    created: $c958bcbc4f0da77e$var$dateTimeSchema,
    lastModified: $c958bcbc4f0da77e$var$dateTimeSchema,
    calName: $c958bcbc4f0da77e$var$_joi["default"].string()
}).xor('end', 'duration');
function $c958bcbc4f0da77e$var$validateEvent(candidate) {
    var _schema$validate = $c958bcbc4f0da77e$var$schema.validate(candidate), _schema$validate$erro = _schema$validate.error, error = _schema$validate$erro === void 0 ? null : _schema$validate$erro, value = _schema$validate.value;
    return {
        error: error,
        value: value
    };
}

});
parcelRegister("5Eekv", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(window, function() {
    return function(e) {
        var t = {};
        function r(s) {
            if (t[s]) return t[s].exports;
            var n = t[s] = {
                i: s,
                l: !1,
                exports: {}
            };
            return e[s].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, s) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: s
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var s = Object.create(null);
            if (r.r(s), Object.defineProperty(s, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var n in e)r.d(s, n, (function(t) {
                return e[t];
            }).bind(null, n));
            return s;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 11);
    }([
        function(e, t, r) {
            "use strict";
            const s = r(12);
            e.exports = function(e, ...t) {
                if (!e) {
                    if (1 === t.length && t[0] instanceof Error) throw t[0];
                    throw new s(t);
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(12), o = r(29);
            let a, i;
            const l = {
                isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/
            };
            t.version = o.version, t.defaults = {
                abortEarly: !0,
                allowUnknown: !1,
                cache: !0,
                context: null,
                convert: !0,
                dateFormat: "iso",
                errors: {
                    escapeHtml: !1,
                    label: "path",
                    language: null,
                    render: !0,
                    stack: !1,
                    wrap: {
                        label: '"',
                        array: "[]"
                    }
                },
                externals: !0,
                messages: {},
                nonEnumerables: !1,
                noDefaults: !1,
                presence: "optional",
                skipFunctions: !1,
                stripUnknown: !1,
                warnings: !1
            }, t.symbols = {
                any: Symbol.for("@hapi/joi/schema"),
                arraySingle: Symbol("arraySingle"),
                deepDefault: Symbol("deepDefault"),
                literal: Symbol("literal"),
                override: Symbol("override"),
                prefs: Symbol("prefs"),
                ref: Symbol("ref"),
                values: Symbol("values"),
                template: Symbol("template")
            }, t.assertOptions = function(e, t, r = "Options") {
                s(e && "object" == typeof e && !Array.isArray(e), "Options must be of type object");
                const n = Object.keys(e).filter((e)=>!t.includes(e));
                s(0 === n.length, "".concat(r, " contain unknown keys: ").concat(n));
            }, t.checkPreferences = function(e) {
                i = i || r(16);
                const t = i.preferences.validate(e);
                if (t.error) throw new n([
                    t.error.details[0].message
                ]);
            }, t.compare = function(e, t, r) {
                switch(r){
                    case "=":
                        return e === t;
                    case ">":
                        return e > t;
                    case "<":
                        return e < t;
                    case ">=":
                        return e >= t;
                    case "<=":
                        return e <= t;
                }
            }, t.default = function(e, t) {
                return void 0 === e ? t : e;
            }, t.isIsoDate = function(e) {
                return l.isoDate.test(e);
            }, t.isNumber = function(e) {
                return "number" == typeof e && !isNaN(e);
            }, t.isResolvable = function(e) {
                return !!e && (e[t.symbols.ref] || e[t.symbols.template]);
            }, t.isSchema = function(e, r = {}) {
                const n = e && e[t.symbols.any];
                return !!n && (s(r.legacy || n.version === t.version, "Cannot mix different versions of joi schemas"), !0);
            }, t.isValues = function(e) {
                return e[t.symbols.values];
            }, t.limit = function(e) {
                return Number.isSafeInteger(e) && e >= 0;
            }, t.preferences = function(e, s) {
                a = a || r(9), e = e || {}, s = s || {};
                const n = Object.assign({}, e, s);
                return s.errors && e.errors && (n.errors = Object.assign({}, e.errors, s.errors), n.errors.wrap = Object.assign({}, e.errors.wrap, s.errors.wrap)), s.messages && (n.messages = a.compile(s.messages, e.messages)), delete n[t.symbols.prefs], n;
            }, t.tryWithPath = function(e, t, r = {}) {
                try {
                    return e();
                } catch (e) {
                    throw void 0 !== e.path ? e.path = t + "." + e.path : e.path = t, r.append && (e.message = "".concat(e.message, " (").concat(e.path, ")")), e;
                }
            }, t.validateArg = function(e, r, { assert: s, message: n }) {
                if (t.isSchema(s)) {
                    const t = s.validate(e);
                    if (!t.error) return;
                    return t.error.message;
                }
                if (!s(e)) return r ? "".concat(r, " ").concat(n) : n;
            }, t.verifyFlat = function(e, t) {
                for (const r of e)s(!Array.isArray(r), "Method no longer accepts array arguments:", t);
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(6), n = r(13), o = r(14), a = {
                needsProtoHack: new Set([
                    n.set,
                    n.map,
                    n.weakSet,
                    n.weakMap
                ])
            };
            e.exports = a.clone = function(e, t = {}, r = null) {
                if ("object" != typeof e || null === e) return e;
                let s = a.clone, i = r;
                if (t.shallow) {
                    if (!0 !== t.shallow) return a.cloneWithShallow(e, t);
                    s = (e)=>e;
                } else if (i) {
                    const t = i.get(e);
                    if (t) return t;
                } else i = new Map;
                const l = n.getInternalProto(e);
                if (l === n.buffer) return !1;
                if (l === n.date) return new Date(e.getTime());
                if (l === n.regex) return new RegExp(e);
                const c = a.base(e, l, t);
                if (c === e) return e;
                if (i && i.set(e, c), l === n.set) for (const r of e)c.add(s(r, t, i));
                else if (l === n.map) for (const [r, n] of e)c.set(r, s(n, t, i));
                const u = o.keys(e, t);
                for (const r of u){
                    if ("__proto__" === r) continue;
                    if (l === n.array && "length" === r) {
                        c.length = e.length;
                        continue;
                    }
                    const o = Object.getOwnPropertyDescriptor(e, r);
                    o ? o.get || o.set ? Object.defineProperty(c, r, o) : o.enumerable ? c[r] = s(e[r], t, i) : Object.defineProperty(c, r, {
                        enumerable: !1,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, i)
                    }) : Object.defineProperty(c, r, {
                        enumerable: !0,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, i)
                    });
                }
                return c;
            }, a.cloneWithShallow = function(e, t) {
                const r = t.shallow;
                (t = Object.assign({}, t)).shallow = !1;
                const n = new Map;
                for (const t of r){
                    const r = s(e, t);
                    "object" != typeof r && "function" != typeof r || n.set(r, r);
                }
                return a.clone(e, t, n);
            }, a.base = function(e, t, r) {
                if (!1 === r.prototype) return a.needsProtoHack.has(t) ? new t.constructor : t === n.array ? [] : {};
                const s = Object.getPrototypeOf(e);
                if (s && s.isImmutable) return e;
                if (t === n.array) {
                    const e = [];
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                if (a.needsProtoHack.has(t)) {
                    const e = new s.constructor;
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                return Object.create(s);
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(34), o = r(1), a = r(9);
            e.exports = n.extend({
                type: "any",
                flags: {
                    only: {
                        default: !1
                    }
                },
                terms: {
                    alterations: {
                        init: null
                    },
                    examples: {
                        init: null
                    },
                    externals: {
                        init: null
                    },
                    metas: {
                        init: []
                    },
                    notes: {
                        init: []
                    },
                    shared: {
                        init: null
                    },
                    tags: {
                        init: []
                    },
                    whens: {
                        init: null
                    }
                },
                rules: {
                    custom: {
                        method (e, t) {
                            return s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this.$_addRule({
                                name: "custom",
                                args: {
                                    method: e,
                                    description: t
                                }
                            });
                        },
                        validate (e, t, { method: r }) {
                            try {
                                return r(e, t);
                            } catch (e) {
                                return t.error("any.custom", {
                                    error: e
                                });
                            }
                        },
                        args: [
                            "method",
                            "description"
                        ],
                        multi: !0
                    },
                    messages: {
                        method (e) {
                            return this.prefs({
                                messages: e
                            });
                        }
                    },
                    shared: {
                        method (e) {
                            s(o.isSchema(e) && e._flags.id, "Schema must be a schema with an id");
                            const t = this.clone();
                            return t.$_terms.shared = t.$_terms.shared || [], t.$_terms.shared.push(e), t.$_mutateRegister(e), t;
                        }
                    },
                    warning: {
                        method (e, t) {
                            return s(e && "string" == typeof e, "Invalid warning code"), this.$_addRule({
                                name: "warning",
                                args: {
                                    code: e,
                                    local: t
                                },
                                warn: !0
                            });
                        },
                        validate: (e, t, { code: r, local: s })=>t.error(r, s),
                        args: [
                            "code",
                            "local"
                        ],
                        multi: !0
                    }
                },
                modifiers: {
                    keep (e, t = !0) {
                        e.keep = t;
                    },
                    message (e, t) {
                        e.message = a.compile(t);
                    },
                    warn (e, t = !0) {
                        e.warn = t;
                    }
                },
                manifest: {
                    build (e, t) {
                        for(const r in t){
                            const s = t[r];
                            if ([
                                "examples",
                                "externals",
                                "metas",
                                "notes",
                                "tags"
                            ].includes(r)) for (const t of s)e = e[r.slice(0, -1)](t);
                            else if ("alterations" !== r) {
                                if ("whens" !== r) {
                                    if ("shared" === r) for (const t of s)e = e.shared(t);
                                } else for (const t of s){
                                    const { ref: r, is: s, not: n, then: o, otherwise: a, concat: i } = t;
                                    e = i ? e.concat(i) : r ? e.when(r, {
                                        is: s,
                                        not: n,
                                        then: o,
                                        otherwise: a,
                                        switch: t.switch,
                                        break: t.break
                                    }) : e.when(s, {
                                        then: o,
                                        otherwise: a,
                                        break: t.break
                                    });
                                }
                            } else {
                                const t = {};
                                for (const { target: e, adjuster: r } of s)t[e] = r;
                                e = e.alter(t);
                            }
                        }
                        return e;
                    }
                },
                messages: {
                    "any.custom": "{{#label}} failed custom validation because {{#error.message}}",
                    "any.default": "{{#label}} threw an error when running default method",
                    "any.failover": "{{#label}} threw an error when running failover method",
                    "any.invalid": "{{#label}} contains an invalid value",
                    "any.only": '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
                    "any.ref": '{{#label}} {{#arg}} references "{{#ref}}" which {{#reason}}',
                    "any.required": "{{#label}} is required",
                    "any.unknown": "{{#label}} is not allowed"
                }
            });
        },
        function(e, t, r) {
            "use strict";
            const s = r(32), n = r(1), o = r(7);
            t.Report = class {
                constructor(e, r, s, n, o, a, i){
                    if (this.code = e, this.flags = n, this.messages = o, this.path = a.path, this.prefs = i, this.state = a, this.value = r, this.message = null, this.template = null, this.local = s || {}, this.local.label = t.label(this.flags, this.state, this.prefs, this.messages), void 0 === this.value || this.local.hasOwnProperty("value") || (this.local.value = this.value), this.path.length) {
                        const e = this.path[this.path.length - 1];
                        "object" != typeof e && (this.local.key = e);
                    }
                }
                _setTemplate(e) {
                    if (this.template = e, !this.flags.label && 0 === this.path.length) {
                        const e = this._template(this.template, "root");
                        e && (this.local.label = e);
                    }
                }
                toString() {
                    if (this.message) return this.message;
                    const e = this.code;
                    if (!this.prefs.errors.render) return this.code;
                    const t = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);
                    return void 0 === t ? 'Error code "'.concat(e, '" is not defined, your custom type is missing the correct messages definition') : (this.message = t.render(this.value, this.state, this.prefs, this.local, {
                        errors: this.prefs.errors,
                        messages: [
                            this.prefs.messages,
                            this.messages
                        ]
                    }), this.prefs.errors.label || (this.message = this.message.replace(/^"" /, "").trim()), this.message);
                }
                _template(e, r) {
                    return t.template(this.value, e, r || this.code, this.state, this.prefs);
                }
            }, t.path = function(e) {
                let t = "";
                for (const r of e)"object" != typeof r && ("string" == typeof r ? (t && (t += "."), t += r) : t += "[".concat(r, "]"));
                return t;
            }, t.template = function(e, t, r, s, a) {
                if (!t) return;
                if (o.isTemplate(t)) return "root" !== r ? t : null;
                let i = a.errors.language;
                return n.isResolvable(i) && (i = i.resolve(e, s, a)), i && t[i] && void 0 !== t[i][r] ? t[i][r] : t[r];
            }, t.label = function(e, r, s, n) {
                if (e.label) return e.label;
                if (!s.errors.label) return "";
                let o = r.path;
                "key" === s.errors.label && r.path.length > 1 && (o = r.path.slice(-1));
                const a = t.path(o);
                return a || t.template(null, s.messages, "root", r, s) || n && t.template(null, n, "root", r, s) || "value";
            }, t.process = function(e, r, s) {
                if (!e) return null;
                const { override: n, message: o, details: a } = t.details(e);
                if (n) return n;
                if (s.errors.stack) return new t.ValidationError(o, a, r);
                const i = Error.stackTraceLimit;
                Error.stackTraceLimit = 0;
                const l = new t.ValidationError(o, a, r);
                return Error.stackTraceLimit = i, l;
            }, t.details = function(e, t = {}) {
                let r = [];
                const s = [];
                for (const n of e){
                    if (n instanceof Error) {
                        if (!1 !== t.override) return {
                            override: n
                        };
                        const e = n.toString();
                        r.push(e), s.push({
                            message: e,
                            type: "override",
                            context: {
                                error: n
                            }
                        });
                        continue;
                    }
                    const e = n.toString();
                    r.push(e), s.push({
                        message: e,
                        path: n.path.filter((e)=>"object" != typeof e),
                        type: n.code,
                        context: n.local
                    });
                }
                return r.length > 1 && (r = [
                    ...new Set(r)
                ]), {
                    message: r.join(". "),
                    details: s
                };
            }, t.ValidationError = class extends Error {
                constructor(e, t, r){
                    super(e), this._original = r, this.details = t;
                }
                static isError(e) {
                    return e instanceof t.ValidationError;
                }
            }, t.ValidationError.prototype.isJoi = !0, t.ValidationError.prototype.name = "ValidationError", t.ValidationError.prototype.annotate = s.error;
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(6), a = r(1);
            let i;
            const l = {
                symbol: Symbol("ref"),
                defaults: {
                    adjust: null,
                    in: !1,
                    iterables: null,
                    map: null,
                    separator: ".",
                    type: "value"
                }
            };
            t.create = function(e, t = {}) {
                s("string" == typeof e, "Invalid reference key:", e), a.assertOptions(t, [
                    "adjust",
                    "ancestor",
                    "in",
                    "iterables",
                    "map",
                    "prefix",
                    "separator"
                ]), s(!t.prefix || "object" == typeof t.prefix, "options.prefix must be of type object");
                const r = Object.assign({}, l.defaults, t);
                delete r.prefix;
                const n = r.separator, o = l.context(e, n, t.prefix);
                if (r.type = o.type, e = o.key, "value" === r.type) {
                    if (o.root && (s(!n || e[0] !== n, "Cannot specify relative path with root prefix"), r.ancestor = "root", e || (e = null)), n && n === e) e = null, r.ancestor = 0;
                    else if (void 0 !== r.ancestor) s(!n || !e || e[0] !== n, "Cannot combine prefix with ancestor option");
                    else {
                        const [t, s] = l.ancestor(e, n);
                        s && "" === (e = e.slice(s)) && (e = null), r.ancestor = t;
                    }
                }
                return r.path = n ? null === e ? [] : e.split(n) : [
                    e
                ], new l.Ref(r);
            }, t.in = function(e, r = {}) {
                return t.create(e, Object.assign({}, r, {
                    in: !0
                }));
            }, t.isRef = function(e) {
                return !!e && !!e[a.symbols.ref];
            }, l.Ref = class {
                constructor(e){
                    s("object" == typeof e, "Invalid reference construction"), a.assertOptions(e, [
                        "adjust",
                        "ancestor",
                        "in",
                        "iterables",
                        "map",
                        "path",
                        "separator",
                        "type",
                        "depth",
                        "key",
                        "root",
                        "display"
                    ]), s([
                        !1,
                        void 0
                    ].includes(e.separator) || "string" == typeof e.separator && 1 === e.separator.length, "Invalid separator"), s(!e.adjust || "function" == typeof e.adjust, "options.adjust must be a function"), s(!e.map || Array.isArray(e.map), "options.map must be an array"), s(!e.map || !e.adjust, "Cannot set both map and adjust options"), Object.assign(this, l.defaults, e), s("value" === this.type || void 0 === this.ancestor, "Non-value references cannot reference ancestors"), Array.isArray(this.map) && (this.map = new Map(this.map)), this.depth = this.path.length, this.key = this.path.length ? this.path.join(this.separator) : null, this.root = this.path[0], this.updateDisplay();
                }
                resolve(e, t, r, n, o = {}) {
                    return s(!this.in || o.in, "Invalid in() reference usage"), "global" === this.type ? this._resolve(r.context, t, o) : "local" === this.type ? this._resolve(n, t, o) : this.ancestor ? "root" === this.ancestor ? this._resolve(t.ancestors[t.ancestors.length - 1], t, o) : (s(this.ancestor <= t.ancestors.length, "Invalid reference exceeds the schema root:", this.display), this._resolve(t.ancestors[this.ancestor - 1], t, o)) : this._resolve(e, t, o);
                }
                _resolve(e, t, r) {
                    let s;
                    if ("value" === this.type && t.mainstay.shadow && !1 !== r.shadow && (s = t.mainstay.shadow.get(this.absolute(t))), void 0 === s && (s = o(e, this.path, {
                        iterables: this.iterables,
                        functions: !0
                    })), this.adjust && (s = this.adjust(s)), this.map) {
                        const e = this.map.get(s);
                        void 0 !== e && (s = e);
                    }
                    return t.mainstay && t.mainstay.tracer.resolve(t, this, s), s;
                }
                toString() {
                    return this.display;
                }
                absolute(e) {
                    return [
                        ...e.path.slice(0, -this.ancestor),
                        ...this.path
                    ];
                }
                clone() {
                    return new l.Ref(this);
                }
                describe() {
                    const e = {
                        path: this.path
                    };
                    "value" !== this.type && (e.type = this.type), "." !== this.separator && (e.separator = this.separator), "value" === this.type && 1 !== this.ancestor && (e.ancestor = this.ancestor), this.map && (e.map = [
                        ...this.map
                    ]);
                    for (const t of [
                        "adjust",
                        "iterables"
                    ])null !== this[t] && (e[t] = this[t]);
                    return !1 !== this.in && (e.in = !0), {
                        ref: e
                    };
                }
                updateDisplay() {
                    const e = null !== this.key ? this.key : "";
                    if ("value" !== this.type) return void (this.display = "ref:".concat(this.type, ":").concat(e));
                    if (!this.separator) return void (this.display = "ref:".concat(e));
                    if (!this.ancestor) return void (this.display = "ref:".concat(this.separator).concat(e));
                    if ("root" === this.ancestor) return void (this.display = "ref:root:".concat(e));
                    if (1 === this.ancestor) return void (this.display = "ref:".concat(e || ".."));
                    const t = new Array(this.ancestor + 1).fill(this.separator).join("");
                    this.display = "ref:".concat(t).concat(e || "");
                }
            }, l.Ref.prototype[a.symbols.ref] = !0, t.build = function(e) {
                return "value" === (e = Object.assign({}, l.defaults, e)).type && void 0 === e.ancestor && (e.ancestor = 1), new l.Ref(e);
            }, l.context = function(e, t, r = {}) {
                if (e = e.trim(), r) {
                    const s = void 0 === r.global ? "$" : r.global;
                    if (s !== t && e.startsWith(s)) return {
                        key: e.slice(s.length),
                        type: "global"
                    };
                    const n = void 0 === r.local ? "#" : r.local;
                    if (n !== t && e.startsWith(n)) return {
                        key: e.slice(n.length),
                        type: "local"
                    };
                    const o = void 0 === r.root ? "/" : r.root;
                    if (o !== t && e.startsWith(o)) return {
                        key: e.slice(o.length),
                        type: "value",
                        root: !0
                    };
                }
                return {
                    key: e,
                    type: "value"
                };
            }, l.ancestor = function(e, t) {
                if (!t) return [
                    1,
                    0
                ];
                if (e[0] !== t) return [
                    1,
                    0
                ];
                if (e[1] !== t) return [
                    0,
                    1
                ];
                let r = 2;
                for(; e[r] === t;)++r;
                return [
                    r - 1,
                    r
                ];
            }, t.toSibling = 0, t.toParent = 1, t.Manager = class {
                constructor(){
                    this.refs = [];
                }
                register(e, s) {
                    if (e) {
                        if (s = void 0 === s ? t.toParent : s, Array.isArray(e)) for (const t of e)this.register(t, s);
                        else if (a.isSchema(e)) for (const t of e._refs.refs)t.ancestor - s >= 0 && this.refs.push({
                            ancestor: t.ancestor - s,
                            root: t.root
                        });
                        else t.isRef(e) && "value" === e.type && e.ancestor - s >= 0 && this.refs.push({
                            ancestor: e.ancestor - s,
                            root: e.root
                        }), i = i || r(7), i.isTemplate(e) && this.register(e.refs(), s);
                    }
                }
                get length() {
                    return this.refs.length;
                }
                clone() {
                    const e = new t.Manager;
                    return e.refs = n(this.refs), e;
                }
                reset() {
                    this.refs = [];
                }
                roots() {
                    return this.refs.filter((e)=>!e.ancestor).map((e)=>e.root);
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = {};
            e.exports = function(e, t, r) {
                if (!1 === t || null == t) return e;
                "string" == typeof (r = r || {}) && (r = {
                    separator: r
                });
                const o = Array.isArray(t);
                s(!o || !r.separator, "Separator option no valid for array-based chain");
                const a = o ? t : t.split(r.separator || ".");
                let i = e;
                for(let e = 0; e < a.length; ++e){
                    let o = a[e];
                    const l = r.iterables && n.iterables(i);
                    if (Array.isArray(i) || "set" === l) {
                        const e = Number(o);
                        Number.isInteger(e) && (o = e < 0 ? i.length + e : e);
                    }
                    if (!i || "function" == typeof i && !1 === r.functions || !l && void 0 === i[o]) {
                        s(!r.strict || e + 1 === a.length, "Missing segment", o, "in reach path ", t), s("object" == typeof i || !0 === r.functions || "function" != typeof i, "Invalid segment", o, "in reach path ", t), i = r.default;
                        break;
                    }
                    i = l ? "set" === l ? [
                        ...i
                    ][o] : i.get(o) : i[o];
                }
                return i;
            }, n.iterables = function(e) {
                return e instanceof Set ? "set" : e instanceof Map ? "map" : void 0;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(30), a = r(31), i = r(1), l = r(4), c = r(5), u = {
                symbol: Symbol("template"),
                opens: new Array(1e3).join("\0"),
                closes: new Array(1e3).join(""),
                dateFormat: {
                    date: Date.prototype.toDateString,
                    iso: Date.prototype.toISOString,
                    string: Date.prototype.toString,
                    time: Date.prototype.toTimeString,
                    utc: Date.prototype.toUTCString
                }
            };
            e.exports = u.Template = class {
                constructor(e, t){
                    s("string" == typeof e, "Template source must be a string"), s(!e.includes("\0") && !e.includes(""), "Template source cannot contain reserved control characters"), this.source = e, this.rendered = e, this._template = null, this._settings = n(t), this._parse();
                }
                _parse() {
                    if (!this.source.includes("{")) return;
                    const e = u.encode(this.source), t = u.split(e);
                    let r = !1;
                    const s = [], n = t.shift();
                    n && s.push(n);
                    for (const e of t){
                        const t = "{" !== e[0], n = t ? "}" : "}}", o = e.indexOf(n);
                        if (-1 === o || "{" === e[1]) {
                            s.push("{".concat(u.decode(e)));
                            continue;
                        }
                        const a = e.slice(t ? 0 : 1, o), i = this._ref(u.decode(a), t);
                        s.push(i), "string" != typeof i && (r = !0);
                        const l = e.slice(o + n.length);
                        l && s.push(u.decode(l));
                    }
                    r ? this._template = s : this.rendered = s.join("");
                }
                static date(e, t) {
                    return u.dateFormat[t.dateFormat].call(e);
                }
                describe(e = {}) {
                    if (!this._settings && e.compact) return this.source;
                    const t = {
                        template: this.source
                    };
                    return this._settings && (t.options = this._settings), t;
                }
                static build(e) {
                    return new u.Template(e.template, e.options);
                }
                isDynamic() {
                    return !!this._template;
                }
                static isTemplate(e) {
                    return !!e && !!e[i.symbols.template];
                }
                refs() {
                    if (!this._template) return;
                    const e = [];
                    for (const t of this._template)"string" != typeof t && e.push(...t.refs);
                    return e;
                }
                resolve(e, t, r, s) {
                    return this._template && 1 === this._template.length ? this._part(this._template[0], e, t, r, s, {}) : this.render(e, t, r, s);
                }
                _part(e, ...t) {
                    return e.ref ? e.ref.resolve(...t) : e.formula.evaluate(t);
                }
                render(e, t, r, s, n = {}) {
                    if (!this.isDynamic()) return this.rendered;
                    const a = [];
                    for (const i of this._template)if ("string" == typeof i) a.push(i);
                    else {
                        const l = this._part(i, e, t, r, s, n), c = u.stringify(l, r, n.errors);
                        if (void 0 !== c) {
                            const e = i.raw || !1 === (n.errors && n.errors.escapeHtml) ? c : o(c), t = i.ref && "local" === i.ref.type && "label" === i.ref.key && r.errors.wrap.label;
                            a.push(u.wrap(e, t));
                        }
                    }
                    return a.join("");
                }
                _ref(e, t) {
                    const r = [], s = (e)=>{
                        const t = c.create(e, this._settings);
                        return r.push(t), (e)=>t.resolve(...e);
                    };
                    try {
                        var n = new a.Parser(e, {
                            reference: s,
                            functions: u.functions,
                            constants: u.constants
                        });
                    } catch (t) {
                        throw t.message = 'Invalid template variable "'.concat(e, '" fails due to: ').concat(t.message), t;
                    }
                    return n.single ? "reference" === n.single.type ? {
                        ref: r[0],
                        raw: t,
                        refs: r
                    } : u.stringify(n.single.value) : {
                        formula: n,
                        raw: t,
                        refs: r
                    };
                }
                toString() {
                    return this.source;
                }
            }, u.Template.prototype[i.symbols.template] = !0, u.Template.prototype.isImmutable = !0, u.encode = function(e) {
                return e.replace(/\\(\{+)/g, (e, t)=>u.opens.slice(0, t.length)).replace(/\\(\}+)/g, (e, t)=>u.closes.slice(0, t.length));
            }, u.decode = function(e) {
                return e.replace(/\u0000/g, "{").replace(/\u0001/g, "}");
            }, u.split = function(e) {
                const t = [];
                let r = "";
                for(let s = 0; s < e.length; ++s){
                    const n = e[s];
                    if ("{" === n) {
                        let n = "";
                        for(; s + 1 < e.length && "{" === e[s + 1];)n += "{", ++s;
                        t.push(r), r = n;
                    } else r += n;
                }
                return t.push(r), t;
            }, u.wrap = function(e, t) {
                return t ? 1 === t.length ? "".concat(t).concat(e).concat(t) : "".concat(t[0]).concat(e).concat(t[1]) : e;
            }, u.stringify = function(e, t, r) {
                const s = typeof e;
                if (null === e) return "null";
                if ("string" === s) return e;
                if ("number" === s || "function" === s || "symbol" === s) return e.toString();
                if ("object" !== s) return JSON.stringify(e);
                if (e instanceof Date) return u.Template.date(e, t);
                if (e instanceof Map) {
                    const t = [];
                    for (const [r, s] of e.entries())t.push("".concat(r.toString(), " -> ").concat(s.toString()));
                    e = t;
                }
                if (!Array.isArray(e)) return e.toString();
                let n = "";
                for (const s of e)n = n + (n.length ? ", " : "") + u.stringify(s, t, r);
                return u.wrap(n, t.errors.wrap.array);
            }, u.constants = {
                true: !0,
                false: !1,
                null: null,
                second: 1e3,
                minute: 6e4,
                hour: 36e5,
                day: 864e5
            }, u.functions = {
                if: (e, t, r)=>e ? t : r,
                msg (e) {
                    const [t, r, s, n, o] = this, a = o.messages;
                    if (!a) return "";
                    const i = l.template(t, a[0], e, r, s) || l.template(t, a[1], e, r, s);
                    return i ? i.render(t, r, s, n, o) : "";
                },
                number: (e)=>"number" == typeof e ? e : "string" == typeof e ? parseFloat(e) : "boolean" == typeof e ? e ? 1 : 0 : e instanceof Date ? e.getTime() : null
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(1), o = r(5), a = {};
            t.schema = function(e, t, r = {}) {
                n.assertOptions(r, [
                    "appendPath",
                    "override"
                ]);
                try {
                    return a.schema(e, t, r);
                } catch (e) {
                    throw r.appendPath && void 0 !== e.path && (e.message = "".concat(e.message, " (").concat(e.path, ")")), e;
                }
            }, a.schema = function(e, t, r) {
                s(void 0 !== t, "Invalid undefined schema"), Array.isArray(t) && (s(t.length, "Invalid empty array schema"), 1 === t.length && (t = t[0]));
                const o = (t, ...s)=>!1 !== r.override ? t.valid(e.override, ...s) : t.valid(...s);
                if (a.simple(t)) return o(e, t);
                if ("function" == typeof t) return e.custom(t);
                if (s("object" == typeof t, "Invalid schema content:", typeof t), n.isResolvable(t)) return o(e, t);
                if (n.isSchema(t)) return t;
                if (Array.isArray(t)) {
                    for (const r of t)if (!a.simple(r)) return e.alternatives().try(...t);
                    return o(e, ...t);
                }
                return t instanceof RegExp ? e.string().regex(t) : t instanceof Date ? o(e.date(), t) : (s(Object.getPrototypeOf(t) === Object.getPrototypeOf({}), "Schema can only contain plain objects"), e.object().keys(t));
            }, t.ref = function(e, t) {
                return o.isRef(e) ? e : o.create(e, t);
            }, t.compile = function(e, r, o = {}) {
                n.assertOptions(o, [
                    "legacy"
                ]);
                const i = r && r[n.symbols.any];
                if (i) return s(o.legacy || i.version === n.version, "Cannot mix different versions of joi schemas:", i.version, n.version), r;
                if ("object" != typeof r || !o.legacy) return t.schema(e, r, {
                    appendPath: !0
                });
                const l = a.walk(r);
                return l ? l.compile(l.root, r) : t.schema(e, r, {
                    appendPath: !0
                });
            }, a.walk = function(e) {
                if ("object" != typeof e) return null;
                if (Array.isArray(e)) {
                    for (const t of e){
                        const e = a.walk(t);
                        if (e) return e;
                    }
                    return null;
                }
                const t = e[n.symbols.any];
                if (t) return {
                    root: e[t.root],
                    compile: t.compile
                };
                s(Object.getPrototypeOf(e) === Object.getPrototypeOf({}), "Schema can only contain plain objects");
                for(const t in e){
                    const r = a.walk(e[t]);
                    if (r) return r;
                }
                return null;
            }, a.simple = function(e) {
                return null === e || [
                    "boolean",
                    "string",
                    "number"
                ].includes(typeof e);
            }, t.when = function(e, r, i) {
                if (void 0 === i && (s(r && "object" == typeof r, "Missing options"), i = r, r = o.create(".")), Array.isArray(i) && (i = {
                    switch: i
                }), n.assertOptions(i, [
                    "is",
                    "not",
                    "then",
                    "otherwise",
                    "switch",
                    "break"
                ]), n.isSchema(r)) return s(void 0 === i.is, '"is" can not be used with a schema condition'), s(void 0 === i.not, '"not" can not be used with a schema condition'), s(void 0 === i.switch, '"switch" can not be used with a schema condition'), a.condition(e, {
                    is: r,
                    then: i.then,
                    otherwise: i.otherwise,
                    break: i.break
                });
                if (s(o.isRef(r) || "string" == typeof r, "Invalid condition:", r), s(void 0 === i.not || void 0 === i.is, 'Cannot combine "is" with "not"'), void 0 === i.switch) {
                    let l = i;
                    void 0 !== i.not && (l = {
                        is: i.not,
                        then: i.otherwise,
                        otherwise: i.then,
                        break: i.break
                    });
                    let c = void 0 !== l.is ? e.$_compile(l.is) : e.$_root.invalid(null, !1, 0, "").required();
                    return s(void 0 !== l.then || void 0 !== l.otherwise, 'options must have at least one of "then", "otherwise", or "switch"'), s(void 0 === l.break || void 0 === l.then || void 0 === l.otherwise, "Cannot specify then, otherwise, and break all together"), void 0 === i.is || o.isRef(i.is) || n.isSchema(i.is) || (c = c.required()), a.condition(e, {
                        ref: t.ref(r),
                        is: c,
                        then: l.then,
                        otherwise: l.otherwise,
                        break: l.break
                    });
                }
                s(Array.isArray(i.switch), '"switch" must be an array'), s(void 0 === i.is, 'Cannot combine "switch" with "is"'), s(void 0 === i.not, 'Cannot combine "switch" with "not"'), s(void 0 === i.then, 'Cannot combine "switch" with "then"');
                const l = {
                    ref: t.ref(r),
                    switch: [],
                    break: i.break
                };
                for(let t = 0; t < i.switch.length; ++t){
                    const r = i.switch[t], a = t === i.switch.length - 1;
                    n.assertOptions(r, a ? [
                        "is",
                        "then",
                        "otherwise"
                    ] : [
                        "is",
                        "then"
                    ]), s(void 0 !== r.is, 'Switch statement missing "is"'), s(void 0 !== r.then, 'Switch statement missing "then"');
                    const c = {
                        is: e.$_compile(r.is),
                        then: e.$_compile(r.then)
                    };
                    if (o.isRef(r.is) || n.isSchema(r.is) || (c.is = c.is.required()), a) {
                        s(void 0 === i.otherwise || void 0 === r.otherwise, 'Cannot specify "otherwise" inside and outside a "switch"');
                        const t = void 0 !== i.otherwise ? i.otherwise : r.otherwise;
                        void 0 !== t && (s(void 0 === l.break, "Cannot specify both otherwise and break"), c.otherwise = e.$_compile(t));
                    }
                    l.switch.push(c);
                }
                return l;
            }, a.condition = function(e, t) {
                for (const r of [
                    "then",
                    "otherwise"
                ])void 0 === t[r] ? delete t[r] : t[r] = e.$_compile(t[r]);
                return t;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(7);
            t.compile = function(e, t) {
                if ("string" == typeof e) return s(!t, "Cannot set single message string"), new o(e);
                if (o.isTemplate(e)) return s(!t, "Cannot set single message template"), e;
                s("object" == typeof e && !Array.isArray(e), "Invalid message options"), t = t ? n(t) : {};
                for(let r in e){
                    const n = e[r];
                    if ("root" === r || o.isTemplate(n)) {
                        t[r] = n;
                        continue;
                    }
                    if ("string" == typeof n) {
                        t[r] = new o(n);
                        continue;
                    }
                    s("object" == typeof n && !Array.isArray(n), "Invalid message for", r);
                    const a = r;
                    for(r in t[a] = t[a] || {}, n){
                        const e = n[r];
                        "root" === r || o.isTemplate(e) ? t[a][r] = e : (s("string" == typeof e, "Invalid message for", r, "in", a), t[a][r] = new o(e));
                    }
                }
                return t;
            }, t.decompile = function(e) {
                const t = {};
                for(let r in e){
                    const s = e[r];
                    if ("root" === r) {
                        t[r] = s;
                        continue;
                    }
                    if (o.isTemplate(s)) {
                        t[r] = s.describe({
                            compact: !0
                        });
                        continue;
                    }
                    const n = r;
                    for(r in t[n] = {}, s){
                        const e = s[r];
                        "root" !== r ? t[n][r] = e.describe({
                            compact: !0
                        }) : t[n][r] = e;
                    }
                }
                return t;
            }, t.merge = function(e, r) {
                if (!e) return t.compile(r);
                if (!r) return e;
                if ("string" == typeof r) return new o(r);
                if (o.isTemplate(r)) return r;
                const a = n(e);
                for(let e in r){
                    const t = r[e];
                    if ("root" === e || o.isTemplate(t)) {
                        a[e] = t;
                        continue;
                    }
                    if ("string" == typeof t) {
                        a[e] = new o(t);
                        continue;
                    }
                    s("object" == typeof t && !Array.isArray(t), "Invalid message for", e);
                    const n = e;
                    for(e in a[n] = a[n] || {}, t){
                        const r = t[e];
                        "root" === e || o.isTemplate(r) ? a[n][e] = r : (s("string" == typeof r, "Invalid message for", e, "in", n), a[n][e] = new o(r));
                    }
                }
                return a;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(13), n = {
                mismatched: null
            };
            e.exports = function(e, t, r) {
                return r = Object.assign({
                    prototype: !0
                }, r), !!n.isDeepEqual(e, t, r, []);
            }, n.isDeepEqual = function(e, t, r, o) {
                if (e === t) return 0 !== e || 1 / e == 1 / t;
                const a = typeof e;
                if (a !== typeof t) return !1;
                if (null === e || null === t) return !1;
                if ("function" === a) {
                    if (!r.deepFunction || e.toString() !== t.toString()) return !1;
                } else if ("object" !== a) return e != e && t != t;
                const i = n.getSharedType(e, t, !!r.prototype);
                switch(i){
                    case s.buffer:
                        return !1;
                    case s.promise:
                        return e === t;
                    case s.regex:
                        return e.toString() === t.toString();
                    case n.mismatched:
                        return !1;
                }
                for(let r = o.length - 1; r >= 0; --r)if (o[r].isSame(e, t)) return !0;
                o.push(new n.SeenEntry(e, t));
                try {
                    return !!n.isDeepEqualObj(i, e, t, r, o);
                } finally{
                    o.pop();
                }
            }, n.getSharedType = function(e, t, r) {
                if (r) return Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? n.mismatched : s.getInternalProto(e);
                const o = s.getInternalProto(e);
                return o !== s.getInternalProto(t) ? n.mismatched : o;
            }, n.valueOf = function(e) {
                const t = e.valueOf;
                if (void 0 === t) return e;
                try {
                    return t.call(e);
                } catch (e) {
                    return e;
                }
            }, n.hasOwnEnumerableProperty = function(e, t) {
                return Object.prototype.propertyIsEnumerable.call(e, t);
            }, n.isSetSimpleEqual = function(e, t) {
                for (const r of e)if (!t.has(r)) return !1;
                return !0;
            }, n.isDeepEqualObj = function(e, t, r, o, a) {
                const { isDeepEqual: i, valueOf: l, hasOwnEnumerableProperty: c } = n, { keys: u, getOwnPropertySymbols: f } = Object;
                if (e === s.array) {
                    if (!o.part) {
                        if (t.length !== r.length) return !1;
                        for(let e = 0; e < t.length; ++e)if (!i(t[e], r[e], o, a)) return !1;
                        return !0;
                    }
                    for (const e of t)for (const t of r)if (i(e, t, o, a)) return !0;
                } else if (e === s.set) {
                    if (t.size !== r.size) return !1;
                    if (!n.isSetSimpleEqual(t, r)) {
                        const e = new Set(r);
                        for (const r of t){
                            if (e.delete(r)) continue;
                            let t = !1;
                            for (const s of e)if (i(r, s, o, a)) {
                                e.delete(s), t = !0;
                                break;
                            }
                            if (!t) return !1;
                        }
                    }
                } else if (e === s.map) {
                    if (t.size !== r.size) return !1;
                    for (const [e, s] of t){
                        if (void 0 === s && !r.has(e)) return !1;
                        if (!i(s, r.get(e), o, a)) return !1;
                    }
                } else if (e === s.error && (t.name !== r.name || t.message !== r.message)) return !1;
                const m = l(t), h = l(r);
                if ((t !== m || r !== h) && !i(m, h, o, a)) return !1;
                const d = u(t);
                if (!o.part && d.length !== u(r).length && !o.skip) return !1;
                let p = 0;
                for (const e of d)if (o.skip && o.skip.includes(e)) void 0 === r[e] && ++p;
                else {
                    if (!c(r, e)) return !1;
                    if (!i(t[e], r[e], o, a)) return !1;
                }
                if (!o.part && d.length - p !== u(r).length) return !1;
                if (!1 !== o.symbols) {
                    const e = f(t), s = new Set(f(r));
                    for (const n of e){
                        if (!o.skip || !o.skip.includes(n)) {
                            if (c(t, n)) {
                                if (!c(r, n)) return !1;
                                if (!i(t[n], r[n], o, a)) return !1;
                            } else if (c(r, n)) return !1;
                        }
                        s.delete(n);
                    }
                    for (const e of s)if (c(r, e)) return !1;
                }
                return !0;
            }, n.SeenEntry = class {
                constructor(e, t){
                    this.obj = e, this.ref = t;
                }
                isSame(e, t) {
                    return this.obj === e && this.ref === t;
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(15), a = r(1), i = r(8), l = r(4), c = r(17), u = r(18), f = r(5), m = r(7), h = r(19);
            let d;
            const p = {
                types: {
                    alternatives: r(33),
                    any: r(3),
                    array: r(39),
                    boolean: r(40),
                    date: r(41),
                    function: r(42),
                    link: r(45),
                    number: r(46),
                    object: r(47),
                    string: r(48),
                    symbol: r(52)
                },
                aliases: {
                    alt: "alternatives",
                    bool: "boolean",
                    func: "function"
                }
            };
            p.root = function() {
                const e = {
                    _types: new Set(Object.keys(p.types))
                };
                for (const t of e._types)e[t] = function(...e) {
                    return s(!e.length || [
                        "alternatives",
                        "link",
                        "object"
                    ].includes(t), "The", t, "type does not allow arguments"), p.generate(this, p.types[t], e);
                };
                for (const t of [
                    "allow",
                    "custom",
                    "disallow",
                    "equal",
                    "exist",
                    "forbidden",
                    "invalid",
                    "not",
                    "only",
                    "optional",
                    "options",
                    "prefs",
                    "preferences",
                    "required",
                    "strip",
                    "valid",
                    "when"
                ])e[t] = function(...e) {
                    return this.any()[t](...e);
                };
                Object.assign(e, p.methods);
                for(const t in p.aliases){
                    const r = p.aliases[t];
                    e[t] = e[r];
                }
                return e.x = e.expression, h.setup && h.setup(e), e;
            }, p.methods = {
                ValidationError: l.ValidationError,
                version: a.version,
                cache: o.provider,
                assert (e, t, ...r) {
                    p.assert(e, t, !0, r);
                },
                attempt: (e, t, ...r)=>p.assert(e, t, !1, r),
                build (e) {
                    return s("function" == typeof u.build, "Manifest functionality disabled"), u.build(this, e);
                },
                checkPreferences (e) {
                    a.checkPreferences(e);
                },
                compile (e, t) {
                    return i.compile(this, e, t);
                },
                defaults (e) {
                    s("function" == typeof e, "modifier must be a function");
                    const t = Object.assign({}, this);
                    for (const r of t._types){
                        const n = e(t[r]());
                        s(a.isSchema(n), "modifier must return a valid schema object"), t[r] = function(...e) {
                            return p.generate(this, n, e);
                        };
                    }
                    return t;
                },
                expression: (...e)=>new m(...e),
                extend (...e) {
                    a.verifyFlat(e, "extend"), d = d || r(16), s(e.length, "You need to provide at least one extension"), this.assert(e, d.extensions);
                    const t = Object.assign({}, this);
                    t._types = new Set(t._types);
                    for (let r of e){
                        "function" == typeof r && (r = r(t)), this.assert(r, d.extension);
                        const e = p.expandExtension(r, t);
                        for (const r of e){
                            s(void 0 === t[r.type] || t._types.has(r.type), "Cannot override name", r.type);
                            const e = r.base || this.any(), n = c.type(e, r);
                            t._types.add(r.type), t[r.type] = function(...e) {
                                return p.generate(this, n, e);
                            };
                        }
                    }
                    return t;
                },
                isError: l.ValidationError.isError,
                isExpression: m.isTemplate,
                isRef: f.isRef,
                isSchema: a.isSchema,
                in: (...e)=>f.in(...e),
                override: a.symbols.override,
                ref: (...e)=>f.create(...e),
                types () {
                    const e = {};
                    for (const t of this._types)e[t] = this[t]();
                    for(const t in p.aliases)e[t] = this[t]();
                    return e;
                }
            }, p.assert = function(e, t, r, s) {
                const o = s[0] instanceof Error || "string" == typeof s[0] ? s[0] : null, i = o ? s[1] : s[0], c = t.validate(e, a.preferences({
                    errors: {
                        stack: !0
                    }
                }, i || {}));
                let u = c.error;
                if (!u) return c.value;
                if (o instanceof Error) throw o;
                const f = r && "function" == typeof u.annotate ? u.annotate() : u.message;
                throw u instanceof l.ValidationError == !1 && (u = n(u)), u.message = o ? "".concat(o, " ").concat(f) : f, u;
            }, p.generate = function(e, t, r) {
                return s(e, "Must be invoked on a Joi instance."), t.$_root = e, t._definition.args && r.length ? t._definition.args(t, ...r) : t;
            }, p.expandExtension = function(e, t) {
                if ("string" == typeof e.type) return [
                    e
                ];
                const r = [];
                for (const s of t._types)if (e.type.test(s)) {
                    const n = Object.assign({}, e);
                    n.type = s, n.base = t[s](), r.push(n);
                }
                return r;
            }, e.exports = p.root();
        },
        function(e, t, r) {
            "use strict";
            const s = r(28);
            e.exports = class extends Error {
                constructor(e){
                    super(e.filter((e)=>"" !== e).map((e)=>"string" == typeof e ? e : e instanceof Error ? e.message : s(e)).join(" ") || "Unknown error"), "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, t.assert);
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = {};
            t = e.exports = {
                array: Array.prototype,
                buffer: !1,
                date: Date.prototype,
                error: Error.prototype,
                generic: Object.prototype,
                map: Map.prototype,
                promise: Promise.prototype,
                regex: RegExp.prototype,
                set: Set.prototype,
                weakMap: WeakMap.prototype,
                weakSet: WeakSet.prototype
            }, s.typeMap = new Map([
                [
                    "[object Error]",
                    t.error
                ],
                [
                    "[object Map]",
                    t.map
                ],
                [
                    "[object Promise]",
                    t.promise
                ],
                [
                    "[object Set]",
                    t.set
                ],
                [
                    "[object WeakMap]",
                    t.weakMap
                ],
                [
                    "[object WeakSet]",
                    t.weakSet
                ]
            ]), t.getInternalProto = function(e) {
                if (Array.isArray(e)) return t.array;
                if (e instanceof Date) return t.date;
                if (e instanceof RegExp) return t.regex;
                if (e instanceof Error) return t.error;
                const r = Object.prototype.toString.call(e);
                return s.typeMap.get(r) || t.generic;
            };
        },
        function(e, t, r) {
            "use strict";
            t.keys = function(e, t = {}) {
                return !1 !== t.symbols ? Reflect.ownKeys(e) : Object.getOwnPropertyNames(e);
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(1), a = {
                max: 1e3,
                supported: new Set([
                    "undefined",
                    "boolean",
                    "number",
                    "string"
                ])
            };
            t.provider = {
                provision: (e)=>new a.Cache(e)
            }, a.Cache = class {
                constructor(e = {}){
                    o.assertOptions(e, [
                        "max"
                    ]), s(void 0 === e.max || e.max && e.max > 0 && isFinite(e.max), "Invalid max cache size"), this._max = e.max || a.max, this._map = new Map, this._list = new a.List;
                }
                get length() {
                    return this._map.size;
                }
                set(e, t) {
                    if (null !== e && !a.supported.has(typeof e)) return;
                    let r = this._map.get(e);
                    if (r) return r.value = t, void this._list.first(r);
                    r = this._list.unshift({
                        key: e,
                        value: t
                    }), this._map.set(e, r), this._compact();
                }
                get(e) {
                    const t = this._map.get(e);
                    if (t) return this._list.first(t), n(t.value);
                }
                _compact() {
                    if (this._map.size > this._max) {
                        const e = this._list.pop();
                        this._map.delete(e.key);
                    }
                }
            }, a.List = class {
                constructor(){
                    this.tail = null, this.head = null;
                }
                unshift(e) {
                    return e.next = null, e.prev = this.head, this.head && (this.head.next = e), this.head = e, this.tail || (this.tail = e), e;
                }
                first(e) {
                    e !== this.head && (this._remove(e), this.unshift(e));
                }
                pop() {
                    return this._remove(this.tail);
                }
                _remove(e) {
                    const { next: t, prev: r } = e;
                    return t.prev = r, r && (r.next = t), e === this.tail && (this.tail = t), e.prev = null, e.next = null, e;
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(11), n = {};
            n.wrap = s.string().min(1).max(2).allow(!1), t.preferences = s.object({
                allowUnknown: s.boolean(),
                abortEarly: s.boolean(),
                cache: s.boolean(),
                context: s.object(),
                convert: s.boolean(),
                dateFormat: s.valid("date", "iso", "string", "time", "utc"),
                debug: s.boolean(),
                errors: {
                    escapeHtml: s.boolean(),
                    label: s.valid("path", "key", !1),
                    language: [
                        s.string(),
                        s.object().ref()
                    ],
                    render: s.boolean(),
                    stack: s.boolean(),
                    wrap: {
                        label: n.wrap,
                        array: n.wrap
                    }
                },
                externals: s.boolean(),
                messages: s.object(),
                noDefaults: s.boolean(),
                nonEnumerables: s.boolean(),
                presence: s.valid("required", "optional", "forbidden"),
                skipFunctions: s.boolean(),
                stripUnknown: s.object({
                    arrays: s.boolean(),
                    objects: s.boolean()
                }).or("arrays", "objects").allow(!0, !1),
                warnings: s.boolean()
            }).strict(), n.nameRx = /^[a-zA-Z0-9]\w*$/, n.rule = s.object({
                alias: s.array().items(s.string().pattern(n.nameRx)).single(),
                args: s.array().items(s.string(), s.object({
                    name: s.string().pattern(n.nameRx).required(),
                    ref: s.boolean(),
                    assert: s.alternatives([
                        s.function(),
                        s.object().schema()
                    ]).conditional("ref", {
                        is: !0,
                        then: s.required()
                    }),
                    normalize: s.function(),
                    message: s.string().when("assert", {
                        is: s.function(),
                        then: s.required()
                    })
                })),
                convert: s.boolean(),
                manifest: s.boolean(),
                method: s.function().allow(!1),
                multi: s.boolean(),
                validate: s.function()
            }), t.extension = s.object({
                type: s.alternatives([
                    s.string(),
                    s.object().regex()
                ]).required(),
                args: s.function(),
                base: s.object().schema().when("type", {
                    is: s.object().regex(),
                    then: s.forbidden()
                }),
                coerce: [
                    s.function().maxArity(3),
                    s.object({
                        method: s.function().maxArity(3).required(),
                        from: s.array().items(s.string()).single()
                    })
                ],
                flags: s.object().pattern(n.nameRx, s.object({
                    setter: s.string(),
                    default: s.any()
                })),
                manifest: {
                    build: s.function().arity(2)
                },
                messages: [
                    s.object(),
                    s.string()
                ],
                modifiers: s.object().pattern(n.nameRx, s.function().minArity(1).maxArity(2)),
                overrides: s.object().pattern(n.nameRx, s.function()),
                prepare: s.function().maxArity(3),
                rebuild: s.function().arity(1),
                rules: s.object().pattern(n.nameRx, n.rule),
                terms: s.object().pattern(n.nameRx, s.object({
                    init: s.array().allow(null).required(),
                    manifest: s.object().pattern(/.+/, [
                        s.valid("schema", "single"),
                        s.object({
                            mapped: s.object({
                                from: s.string().required(),
                                to: s.string().required()
                            }).required()
                        })
                    ])
                })),
                validate: s.function().maxArity(3)
            }).strict(), t.extensions = s.array().items(s.object(), s.function().arity(1)).strict(), n.desc = {
                buffer: s.object({
                    buffer: s.string()
                }),
                func: s.object({
                    function: s.function().required(),
                    options: {
                        literal: !0
                    }
                }),
                override: s.object({
                    override: !0
                }),
                ref: s.object({
                    ref: s.object({
                        type: s.valid("value", "global", "local"),
                        path: s.array().required(),
                        separator: s.string().length(1).allow(!1),
                        ancestor: s.number().min(0).integer().allow("root"),
                        map: s.array().items(s.array().length(2)).min(1),
                        adjust: s.function(),
                        iterables: s.boolean(),
                        in: s.boolean()
                    }).required()
                }),
                regex: s.object({
                    regex: s.string().min(3)
                }),
                special: s.object({
                    special: s.valid("deep").required()
                }),
                template: s.object({
                    template: s.string().required(),
                    options: s.object()
                }),
                value: s.object({
                    value: s.alternatives([
                        s.object(),
                        s.array()
                    ]).required()
                })
            }, n.desc.entity = s.alternatives([
                s.array().items(s.link("...")),
                s.boolean(),
                s.function(),
                s.number(),
                s.string(),
                n.desc.buffer,
                n.desc.func,
                n.desc.ref,
                n.desc.regex,
                n.desc.special,
                n.desc.template,
                n.desc.value,
                s.link("/")
            ]), n.desc.values = s.array().items(null, s.boolean(), s.function(), s.number().allow(1 / 0, -1 / 0), s.string().allow(""), s.symbol(), n.desc.buffer, n.desc.func, n.desc.override, n.desc.ref, n.desc.regex, n.desc.template, n.desc.value), n.desc.messages = s.object().pattern(/.+/, [
                s.string(),
                n.desc.template,
                s.object().pattern(/.+/, [
                    s.string(),
                    n.desc.template
                ])
            ]), t.description = s.object({
                type: s.string().required(),
                flags: s.object({
                    cast: s.string(),
                    default: s.any(),
                    description: s.string(),
                    empty: s.link("/"),
                    failover: n.desc.entity,
                    id: s.string(),
                    label: s.string(),
                    only: !0,
                    presence: [
                        "optional",
                        "required",
                        "forbidden"
                    ],
                    result: [
                        "raw",
                        "strip"
                    ],
                    strip: s.boolean(),
                    unit: s.string()
                }).unknown(),
                preferences: {
                    allowUnknown: s.boolean(),
                    abortEarly: s.boolean(),
                    cache: s.boolean(),
                    convert: s.boolean(),
                    dateFormat: [
                        "date",
                        "iso",
                        "string",
                        "time",
                        "utc"
                    ],
                    errors: {
                        escapeHtml: s.boolean(),
                        label: [
                            "path",
                            "key"
                        ],
                        language: [
                            s.string(),
                            n.desc.ref
                        ],
                        wrap: {
                            label: n.wrap,
                            array: n.wrap
                        }
                    },
                    externals: s.boolean(),
                    messages: n.desc.messages,
                    noDefaults: s.boolean(),
                    nonEnumerables: s.boolean(),
                    presence: [
                        "required",
                        "optional",
                        "forbidden"
                    ],
                    skipFunctions: s.boolean(),
                    stripUnknown: s.object({
                        arrays: s.boolean(),
                        objects: s.boolean()
                    }).or("arrays", "objects").allow(!0, !1),
                    warnings: s.boolean()
                },
                allow: n.desc.values,
                invalid: n.desc.values,
                rules: s.array().min(1).items({
                    name: s.string().required(),
                    args: s.object().min(1),
                    keep: s.boolean(),
                    message: [
                        s.string(),
                        n.desc.messages
                    ],
                    warn: s.boolean()
                }),
                keys: s.object().pattern(/.*/, s.link("/")),
                link: n.desc.ref
            }).pattern(/^[a-z]\w*$/, s.any());
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(1), a = r(9), i = {};
            t.type = function(e, t) {
                const r = Object.getPrototypeOf(e), l = n(r), c = e._assign(Object.create(l)), u = Object.assign({}, t);
                delete u.base, l._definition = u;
                const f = r._definition || {};
                u.messages = a.merge(f.messages, u.messages), u.properties = Object.assign({}, f.properties, u.properties), c.type = u.type, u.flags = Object.assign({}, f.flags, u.flags);
                const m = Object.assign({}, f.terms);
                if (u.terms) for(const e in u.terms){
                    const t = u.terms[e];
                    s(void 0 === c.$_terms[e], "Invalid term override for", u.type, e), c.$_terms[e] = t.init, m[e] = t;
                }
                u.terms = m, u.args || (u.args = f.args), u.prepare = i.prepare(u.prepare, f.prepare), u.coerce && ("function" == typeof u.coerce && (u.coerce = {
                    method: u.coerce
                }), u.coerce.from && !Array.isArray(u.coerce.from) && (u.coerce = {
                    method: u.coerce.method,
                    from: [].concat(u.coerce.from)
                })), u.coerce = i.coerce(u.coerce, f.coerce), u.validate = i.validate(u.validate, f.validate);
                const h = Object.assign({}, f.rules);
                if (u.rules) for(const e in u.rules){
                    const t = u.rules[e];
                    s("object" == typeof t, "Invalid rule definition for", u.type, e);
                    let r = t.method;
                    if (void 0 === r && (r = function() {
                        return this.$_addRule(e);
                    }), r && (s(!l[e], "Rule conflict in", u.type, e), l[e] = r), s(!h[e], "Rule conflict in", u.type, e), h[e] = t, t.alias) {
                        const e = [].concat(t.alias);
                        for (const r of e)l[r] = t.method;
                    }
                    t.args && (t.argsByName = new Map, t.args = t.args.map((e)=>("string" == typeof e && (e = {
                            name: e
                        }), s(!t.argsByName.has(e.name), "Duplicated argument name", e.name), o.isSchema(e.assert) && (e.assert = e.assert.strict().label(e.name)), t.argsByName.set(e.name, e), e)));
                }
                u.rules = h;
                const d = Object.assign({}, f.modifiers);
                if (u.modifiers) for(const e in u.modifiers){
                    s(!l[e], "Rule conflict in", u.type, e);
                    const t = u.modifiers[e];
                    s("function" == typeof t, "Invalid modifier definition for", u.type, e);
                    const r = function(t) {
                        return this.rule({
                            [e]: t
                        });
                    };
                    l[e] = r, d[e] = t;
                }
                if (u.modifiers = d, u.overrides) {
                    l._super = r, c.$_super = {};
                    for(const e in u.overrides)s(r[e], "Cannot override missing", e), c.$_super[e] = r[e].bind(c);
                    Object.assign(l, u.overrides);
                }
                u.cast = Object.assign({}, f.cast, u.cast);
                const p = Object.assign({}, f.manifest, u.manifest);
                return p.build = i.build(u.manifest && u.manifest.build, f.manifest && f.manifest.build), u.manifest = p, u.rebuild = i.rebuild(u.rebuild, f.rebuild), c;
            }, i.build = function(e, t) {
                return e && t ? function(r, s) {
                    return t(e(r, s), s);
                } : e || t;
            }, i.coerce = function(e, t) {
                return e && t ? {
                    from: e.from && t.from ? [
                        ...new Set([
                            ...e.from,
                            ...t.from
                        ])
                    ] : null,
                    method (r, s) {
                        let n;
                        if ((!t.from || t.from.includes(typeof r)) && (n = t.method(r, s), n)) {
                            if (n.errors || void 0 === n.value) return n;
                            r = n.value;
                        }
                        if (!e.from || e.from.includes(typeof r)) {
                            const t = e.method(r, s);
                            if (t) return t;
                        }
                        return n;
                    }
                } : e || t;
            }, i.prepare = function(e, t) {
                return e && t ? function(r, s) {
                    const n = e(r, s);
                    if (n) {
                        if (n.errors || void 0 === n.value) return n;
                        r = n.value;
                    }
                    return t(r, s) || n;
                } : e || t;
            }, i.rebuild = function(e, t) {
                return e && t ? function(r) {
                    t(r), e(r);
                } : e || t;
            }, i.validate = function(e, t) {
                return e && t ? function(r, s) {
                    const n = t(r, s);
                    if (n) {
                        if (n.errors && (!Array.isArray(n.errors) || n.errors.length)) return n;
                        r = n.value;
                    }
                    return e(r, s) || n;
                } : e || t;
            };
        },
        function(e, t) {},
        function(e, t) {},
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(14), a = {};
            e.exports = a.merge = function(e, t, r) {
                if (s(e && "object" == typeof e, "Invalid target value: must be an object"), s(null == t || "object" == typeof t, "Invalid source value: must be null, undefined, or an object"), !t) return e;
                if (r = Object.assign({
                    nullOverride: !0,
                    mergeArrays: !0
                }, r), Array.isArray(t)) {
                    s(Array.isArray(e), "Cannot merge array onto an object"), r.mergeArrays || (e.length = 0);
                    for(let s = 0; s < t.length; ++s)e.push(n(t[s], {
                        symbols: r.symbols
                    }));
                    return e;
                }
                const i = o.keys(t, r);
                for(let s = 0; s < i.length; ++s){
                    const o = i[s];
                    if ("__proto__" === o || !Object.prototype.propertyIsEnumerable.call(t, o)) continue;
                    const l = t[o];
                    if (l && "object" == typeof l) {
                        if (e[o] === l) continue;
                        !e[o] || "object" != typeof e[o] || Array.isArray(e[o]) !== Array.isArray(l) || l instanceof Date || l instanceof RegExp ? e[o] = n(l, {
                            symbols: r.symbols
                        }) : a.merge(e[o], l, r);
                    } else null != l ? e[o] = l : r.nullOverride && (e[o] = l);
                }
                return e;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(10), o = r(1), a = {};
            e.exports = a.Values = class {
                constructor(e, t){
                    this._values = new Set(e), this._refs = new Set(t), this._lowercase = a.lowercases(e), this._override = !1;
                }
                get length() {
                    return this._values.size + this._refs.size;
                }
                add(e, t) {
                    o.isResolvable(e) ? this._refs.has(e) || (this._refs.add(e), t && t.register(e)) : this.has(e, null, null, !1) || (this._values.add(e), "string" == typeof e && this._lowercase.set(e.toLowerCase(), e));
                }
                static merge(e, t, r) {
                    if (e = e || new a.Values, t) {
                        if (t._override) return t.clone();
                        for (const r of [
                            ...t._values,
                            ...t._refs
                        ])e.add(r);
                    }
                    if (r) for (const t of [
                        ...r._values,
                        ...r._refs
                    ])e.remove(t);
                    return e.length ? e : null;
                }
                remove(e) {
                    o.isResolvable(e) ? this._refs.delete(e) : (this._values.delete(e), "string" == typeof e && this._lowercase.delete(e.toLowerCase()));
                }
                has(e, t, r, s) {
                    return !!this.get(e, t, r, s);
                }
                get(e, t, r, s) {
                    if (!this.length) return !1;
                    if (this._values.has(e)) return {
                        value: e
                    };
                    if ("string" == typeof e && e && s) {
                        const t = this._lowercase.get(e.toLowerCase());
                        if (t) return {
                            value: t
                        };
                    }
                    if (!this._refs.size && "object" != typeof e) return !1;
                    if ("object" == typeof e) {
                        for (const t of this._values)if (n(t, e)) return {
                            value: t
                        };
                    }
                    if (t) for (const o of this._refs){
                        const a = o.resolve(e, t, r, null, {
                            in: !0
                        });
                        if (void 0 === a) continue;
                        const i = o.in && "object" == typeof a ? Array.isArray(a) ? a : Object.keys(a) : [
                            a
                        ];
                        for (const t of i)if (typeof t == typeof e) {
                            if (s && e && "string" == typeof e) {
                                if (t.toLowerCase() === e.toLowerCase()) return {
                                    value: t,
                                    ref: o
                                };
                            } else if (n(t, e)) return {
                                value: t,
                                ref: o
                            };
                        }
                    }
                    return !1;
                }
                override() {
                    this._override = !0;
                }
                values(e) {
                    if (e && e.display) {
                        const e = [];
                        for (const t of [
                            ...this._values,
                            ...this._refs
                        ])void 0 !== t && e.push(t);
                        return e;
                    }
                    return Array.from([
                        ...this._values,
                        ...this._refs
                    ]);
                }
                clone() {
                    const e = new a.Values(this._values, this._refs);
                    return e._override = this._override, e;
                }
                concat(e) {
                    s(!e._override, "Cannot concat override set of values");
                    const t = new a.Values([
                        ...this._values,
                        ...e._values
                    ], [
                        ...this._refs,
                        ...e._refs
                    ]);
                    return t._override = this._override, t;
                }
                describe() {
                    const e = [];
                    this._override && e.push({
                        override: !0
                    });
                    for (const t of this._values.values())e.push(t && "object" == typeof t ? {
                        value: t
                    } : t);
                    for (const t of this._refs.values())e.push(t.describe());
                    return e;
                }
            }, a.Values.prototype[o.symbols.values] = !0, a.Values.prototype.slice = a.Values.prototype.clone, a.lowercases = function(e) {
                const t = new Map;
                if (e) for (const r of e)"string" == typeof r && t.set(r.toLowerCase(), r);
                return t;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(43), n = r(0), o = r(2), a = r(44), i = r(3), l = r(1), c = r(8), u = r(4), f = r(5), m = r(7), h = {
                renameDefaults: {
                    alias: !1,
                    multiple: !1,
                    override: !1
                }
            };
            e.exports = i.extend({
                type: "_keys",
                properties: {
                    typeof: "object"
                },
                flags: {
                    unknown: {
                        default: !1
                    }
                },
                terms: {
                    dependencies: {
                        init: null
                    },
                    keys: {
                        init: null,
                        manifest: {
                            mapped: {
                                from: "schema",
                                to: "key"
                            }
                        }
                    },
                    patterns: {
                        init: null
                    },
                    renames: {
                        init: null
                    }
                },
                args: (e, t)=>e.keys(t),
                validate (e, { schema: t, error: r, state: s, prefs: n }) {
                    if (!e || typeof e !== t.$_property("typeof") || Array.isArray(e)) return {
                        value: e,
                        errors: r("object.base", {
                            type: t.$_property("typeof")
                        })
                    };
                    if (!(t.$_terms.renames || t.$_terms.dependencies || t.$_terms.keys || t.$_terms.patterns || t.$_terms.externals)) return;
                    e = h.clone(e, n);
                    const o = [];
                    if (t.$_terms.renames && !h.rename(t, e, s, n, o)) return {
                        value: e,
                        errors: o
                    };
                    if (!t.$_terms.keys && !t.$_terms.patterns && !t.$_terms.dependencies) return {
                        value: e,
                        errors: o
                    };
                    const a = new Set(Object.keys(e));
                    if (t.$_terms.keys) {
                        const r = [
                            e,
                            ...s.ancestors
                        ];
                        for (const i of t.$_terms.keys){
                            const t = i.key, l = e[t];
                            a.delete(t);
                            const c = s.localize([
                                ...s.path,
                                t
                            ], r, i), u = i.schema.$_validate(l, c, n);
                            if (u.errors) {
                                if (n.abortEarly) return {
                                    value: e,
                                    errors: u.errors
                                };
                                o.push(...u.errors);
                            } else "strip" === i.schema._flags.result || void 0 === u.value && void 0 !== l ? delete e[t] : void 0 !== u.value && (e[t] = u.value);
                        }
                    }
                    if (a.size || t._flags._hasPatternMatch) {
                        const r = h.unknown(t, e, a, o, s, n);
                        if (r) return r;
                    }
                    if (t.$_terms.dependencies) for (const r of t.$_terms.dependencies){
                        if (r.key && void 0 === r.key.resolve(e, s, n, null, {
                            shadow: !1
                        })) continue;
                        const a = h.dependencies[r.rel](t, r, e, s, n);
                        if (a) {
                            const r = t.$_createError(a.code, e, a.context, s, n);
                            if (n.abortEarly) return {
                                value: e,
                                errors: r
                            };
                            o.push(r);
                        }
                    }
                    return {
                        value: e,
                        errors: o
                    };
                },
                rules: {
                    and: {
                        method (...e) {
                            return l.verifyFlat(e, "and"), h.dependency(this, "and", null, e);
                        }
                    },
                    append: {
                        method (e) {
                            return null == e || 0 === Object.keys(e).length ? this : this.keys(e);
                        }
                    },
                    assert: {
                        method (e, t, r) {
                            m.isTemplate(e) || (e = c.ref(e)), n(void 0 === r || "string" == typeof r, "Message must be a string"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const s = this.$_addRule({
                                name: "assert",
                                args: {
                                    subject: e,
                                    schema: t,
                                    message: r
                                }
                            });
                            return s.$_mutateRegister(e), s.$_mutateRegister(t), s;
                        },
                        validate (e, { error: t, prefs: r, state: s }, { subject: n, schema: o, message: a }) {
                            const i = n.resolve(e, s, r), l = f.isRef(n) ? n.absolute(s) : [];
                            return o.$_match(i, s.localize(l, [
                                e,
                                ...s.ancestors
                            ], o), r) ? e : t("object.assert", {
                                subject: n,
                                message: a
                            });
                        },
                        args: [
                            "subject",
                            "schema",
                            "message"
                        ],
                        multi: !0
                    },
                    instance: {
                        method (e, t) {
                            return n("function" == typeof e, "constructor must be a function"), t = t || e.name, this.$_addRule({
                                name: "instance",
                                args: {
                                    constructor: e,
                                    name: t
                                }
                            });
                        },
                        validate: (e, t, { constructor: r, name: s })=>e instanceof r ? e : t.error("object.instance", {
                                type: s,
                                value: e
                            }),
                        args: [
                            "constructor",
                            "name"
                        ]
                    },
                    keys: {
                        method (e) {
                            n(void 0 === e || "object" == typeof e, "Object schema must be a valid object"), n(!l.isSchema(e), "Object schema cannot be a joi schema");
                            const t = this.clone();
                            if (e) {
                                if (Object.keys(e).length) {
                                    t.$_terms.keys = t.$_terms.keys ? t.$_terms.keys.filter((t)=>!e.hasOwnProperty(t.key)) : new h.Keys;
                                    for(const r in e)l.tryWithPath(()=>t.$_terms.keys.push({
                                            key: r,
                                            schema: this.$_compile(e[r])
                                        }), r);
                                } else t.$_terms.keys = new h.Keys;
                            } else t.$_terms.keys = null;
                            return t.$_mutateRebuild();
                        }
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate: (e, t, { limit: r }, { name: s, operator: n, args: o })=>l.compare(Object.keys(e).length, r, n) ? e : t.error("object." + s, {
                                limit: o.limit,
                                value: e
                            }),
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: l.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    nand: {
                        method (...e) {
                            return l.verifyFlat(e, "nand"), h.dependency(this, "nand", null, e);
                        }
                    },
                    or: {
                        method (...e) {
                            return l.verifyFlat(e, "or"), h.dependency(this, "or", null, e);
                        }
                    },
                    oxor: {
                        method (...e) {
                            return h.dependency(this, "oxor", null, e);
                        }
                    },
                    pattern: {
                        method (e, t, r = {}) {
                            const s = e instanceof RegExp;
                            s || (e = this.$_compile(e, {
                                appendPath: !0
                            })), n(void 0 !== t, "Invalid rule"), l.assertOptions(r, [
                                "fallthrough",
                                "matches"
                            ]), s && n(!e.flags.includes("g") && !e.flags.includes("y"), "pattern should not use global or sticky mode"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const o = this.clone();
                            o.$_terms.patterns = o.$_terms.patterns || [];
                            const a = {
                                [s ? "regex" : "schema"]: e,
                                rule: t
                            };
                            return r.matches && (a.matches = this.$_compile(r.matches), "array" !== a.matches.type && (a.matches = a.matches.$_root.array().items(a.matches)), o.$_mutateRegister(a.matches), o.$_setFlag("_hasPatternMatch", !0, {
                                clone: !1
                            })), r.fallthrough && (a.fallthrough = !0), o.$_terms.patterns.push(a), o.$_mutateRegister(t), o;
                        }
                    },
                    ref: {
                        method () {
                            return this.$_addRule("ref");
                        },
                        validate: (e, t)=>f.isRef(e) ? e : t.error("object.refType", {
                                value: e
                            })
                    },
                    regex: {
                        method () {
                            return this.$_addRule("regex");
                        },
                        validate: (e, t)=>e instanceof RegExp ? e : t.error("object.regex", {
                                value: e
                            })
                    },
                    rename: {
                        method (e, t, r = {}) {
                            n("string" == typeof e || e instanceof RegExp, "Rename missing the from argument"), n("string" == typeof t || t instanceof m, "Invalid rename to argument"), n(t !== e, "Cannot rename key to same name:", e), l.assertOptions(r, [
                                "alias",
                                "ignoreUndefined",
                                "override",
                                "multiple"
                            ]);
                            const o = this.clone();
                            o.$_terms.renames = o.$_terms.renames || [];
                            for (const t of o.$_terms.renames)n(t.from !== e, "Cannot rename the same key multiple times");
                            return t instanceof m && o.$_mutateRegister(t), o.$_terms.renames.push({
                                from: e,
                                to: t,
                                options: s(h.renameDefaults, r)
                            }), o;
                        }
                    },
                    schema: {
                        method (e = "any") {
                            return this.$_addRule({
                                name: "schema",
                                args: {
                                    type: e
                                }
                            });
                        },
                        validate: (e, t, { type: r })=>!l.isSchema(e) || "any" !== r && e.type !== r ? t.error("object.schema", {
                                type: r
                            }) : e
                    },
                    unknown: {
                        method (e) {
                            return this.$_setFlag("unknown", !1 !== e);
                        }
                    },
                    with: {
                        method (e, t, r = {}) {
                            return h.dependency(this, "with", e, t, r);
                        }
                    },
                    without: {
                        method (e, t, r = {}) {
                            return h.dependency(this, "without", e, t, r);
                        }
                    },
                    xor: {
                        method (...e) {
                            return l.verifyFlat(e, "xor"), h.dependency(this, "xor", null, e);
                        }
                    }
                },
                overrides: {
                    default (e, t) {
                        return void 0 === e && (e = l.symbols.deepDefault), this.$_super.default(e, t);
                    }
                },
                rebuild (e) {
                    if (e.$_terms.keys) {
                        const t = new a.Sorter;
                        for (const r of e.$_terms.keys)l.tryWithPath(()=>t.add(r, {
                                after: r.schema.$_rootReferences(),
                                group: r.key
                            }), r.key);
                        e.$_terms.keys = new h.Keys(...t.nodes);
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.keys && (e = e.keys(t.keys)), t.dependencies) for (const { rel: r, key: s = null, peers: n, options: o } of t.dependencies)e = h.dependency(e, r, s, n, o);
                        if (t.patterns) for (const { regex: r, schema: s, rule: n, fallthrough: o, matches: a } of t.patterns)e = e.pattern(r || s, n, {
                            fallthrough: o,
                            matches: a
                        });
                        if (t.renames) for (const { from: r, to: s, options: n } of t.renames)e = e.rename(r, s, n);
                        return e;
                    }
                },
                messages: {
                    "object.and": "{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}",
                    "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}',
                    "object.base": "{{#label}} must be of type {{#type}}",
                    "object.instance": '{{#label}} must be an instance of "{{#type}}"',
                    "object.length": '{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.max": '{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.min": '{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.missing": "{{#label}} must contain at least one of {{#peersWithLabels}}",
                    "object.nand": '"{{#mainWithLabel}}" must not exist simultaneously with {{#peersWithLabels}}',
                    "object.oxor": "{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}",
                    "object.pattern.match": "{{#label}} keys failed to match pattern requirements",
                    "object.refType": "{{#label}} must be a Joi reference",
                    "object.regex": "{{#label}} must be a RegExp object",
                    "object.rename.multiple": '{{#label}} cannot rename "{{#from}}" because multiple renames are disabled and another key was already renamed to "{{#to}}"',
                    "object.rename.override": '{{#label}} cannot rename "{{#from}}" because override is disabled and target "{{#to}}" exists',
                    "object.schema": "{{#label}} must be a Joi schema of {{#type}} type",
                    "object.unknown": "{{#label}} is not allowed",
                    "object.with": '"{{#mainWithLabel}}" missing required peer "{{#peerWithLabel}}"',
                    "object.without": '"{{#mainWithLabel}}" conflict with forbidden peer "{{#peerWithLabel}}"',
                    "object.xor": "{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}"
                }
            }), h.clone = function(e, t) {
                if ("object" == typeof e) {
                    if (t.nonEnumerables) return o(e, {
                        shallow: !0
                    });
                    const r = Object.create(Object.getPrototypeOf(e));
                    return Object.assign(r, e), r;
                }
                const r = function(...t) {
                    return e.apply(this, t);
                };
                return r.prototype = o(e.prototype), Object.defineProperty(r, "name", {
                    value: e.name,
                    writable: !1
                }), Object.defineProperty(r, "length", {
                    value: e.length,
                    writable: !1
                }), Object.assign(r, e), r;
            }, h.dependency = function(e, t, r, s, o) {
                n(null === r || "string" == typeof r, t, "key must be a strings"), o || (o = s.length > 1 && "object" == typeof s[s.length - 1] ? s.pop() : {}), l.assertOptions(o, [
                    "separator"
                ]), s = [].concat(s);
                const a = l.default(o.separator, "."), i = [];
                for (const e of s)n("string" == typeof e, t, "peers must be a string or a reference"), i.push(c.ref(e, {
                    separator: a,
                    ancestor: 0,
                    prefix: !1
                }));
                null !== r && (r = c.ref(r, {
                    separator: a,
                    ancestor: 0,
                    prefix: !1
                }));
                const u = e.clone();
                return u.$_terms.dependencies = u.$_terms.dependencies || [], u.$_terms.dependencies.push(new h.Dependency(t, r, i, s)), u;
            }, h.dependencies = {
                and (e, t, r, s, n) {
                    const o = [], a = [], i = t.peers.length;
                    for (const e of t.peers)void 0 === e.resolve(r, s, n, null, {
                        shadow: !1
                    }) ? o.push(e.key) : a.push(e.key);
                    if (o.length !== i && a.length !== i) return {
                        code: "object.and",
                        context: {
                            present: a,
                            presentWithLabels: h.keysToLabels(e, a),
                            missing: o,
                            missingWithLabels: h.keysToLabels(e, o)
                        }
                    };
                },
                nand (e, t, r, s, n) {
                    const o = [];
                    for (const e of t.peers)void 0 !== e.resolve(r, s, n, null, {
                        shadow: !1
                    }) && o.push(e.key);
                    if (o.length !== t.peers.length) return;
                    const a = t.paths[0], i = t.paths.slice(1);
                    return {
                        code: "object.nand",
                        context: {
                            main: a,
                            mainWithLabel: h.keysToLabels(e, a),
                            peers: i,
                            peersWithLabels: h.keysToLabels(e, i)
                        }
                    };
                },
                or (e, t, r, s, n) {
                    for (const e of t.peers)if (void 0 !== e.resolve(r, s, n, null, {
                        shadow: !1
                    })) return;
                    return {
                        code: "object.missing",
                        context: {
                            peers: t.paths,
                            peersWithLabels: h.keysToLabels(e, t.paths)
                        }
                    };
                },
                oxor (e, t, r, s, n) {
                    const o = [];
                    for (const e of t.peers)void 0 !== e.resolve(r, s, n, null, {
                        shadow: !1
                    }) && o.push(e.key);
                    if (!o.length || 1 === o.length) return;
                    const a = {
                        peers: t.paths,
                        peersWithLabels: h.keysToLabels(e, t.paths)
                    };
                    return a.present = o, a.presentWithLabels = h.keysToLabels(e, o), {
                        code: "object.oxor",
                        context: a
                    };
                },
                with (e, t, r, s, n) {
                    for (const o of t.peers)if (void 0 === o.resolve(r, s, n, null, {
                        shadow: !1
                    })) return {
                        code: "object.with",
                        context: {
                            main: t.key.key,
                            mainWithLabel: h.keysToLabels(e, t.key.key),
                            peer: o.key,
                            peerWithLabel: h.keysToLabels(e, o.key)
                        }
                    };
                },
                without (e, t, r, s, n) {
                    for (const o of t.peers)if (void 0 !== o.resolve(r, s, n, null, {
                        shadow: !1
                    })) return {
                        code: "object.without",
                        context: {
                            main: t.key.key,
                            mainWithLabel: h.keysToLabels(e, t.key.key),
                            peer: o.key,
                            peerWithLabel: h.keysToLabels(e, o.key)
                        }
                    };
                },
                xor (e, t, r, s, n) {
                    const o = [];
                    for (const e of t.peers)void 0 !== e.resolve(r, s, n, null, {
                        shadow: !1
                    }) && o.push(e.key);
                    if (1 === o.length) return;
                    const a = {
                        peers: t.paths,
                        peersWithLabels: h.keysToLabels(e, t.paths)
                    };
                    return 0 === o.length ? {
                        code: "object.missing",
                        context: a
                    } : (a.present = o, a.presentWithLabels = h.keysToLabels(e, o), {
                        code: "object.xor",
                        context: a
                    });
                }
            }, h.keysToLabels = function(e, t) {
                return Array.isArray(t) ? t.map((t)=>e.$_mapLabels(t)) : e.$_mapLabels(t);
            }, h.rename = function(e, t, r, s, n) {
                const o = {};
                for (const a of e.$_terms.renames){
                    const i = [], l = "string" != typeof a.from;
                    if (l) for(const e in t){
                        if (void 0 === t[e] && a.options.ignoreUndefined) continue;
                        if (e === a.to) continue;
                        const r = a.from.exec(e);
                        r && i.push({
                            from: e,
                            to: a.to,
                            match: r
                        });
                    }
                    else !Object.prototype.hasOwnProperty.call(t, a.from) || void 0 === t[a.from] && a.options.ignoreUndefined || i.push(a);
                    for (const c of i){
                        const i = c.from;
                        let u = c.to;
                        if (u instanceof m && (u = u.render(t, r, s, c.match)), i !== u) {
                            if (!a.options.multiple && o[u] && (n.push(e.$_createError("object.rename.multiple", t, {
                                from: i,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            if (Object.prototype.hasOwnProperty.call(t, u) && !a.options.override && !o[u] && (n.push(e.$_createError("object.rename.override", t, {
                                from: i,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            void 0 === t[i] ? delete t[u] : t[u] = t[i], o[u] = !0, a.options.alias || delete t[i];
                        }
                    }
                }
                return !0;
            }, h.unknown = function(e, t, r, s, n, o) {
                if (e.$_terms.patterns) {
                    let a = !1;
                    const i = e.$_terms.patterns.map((e)=>{
                        if (e.matches) return a = !0, [];
                    }), l = [
                        t,
                        ...n.ancestors
                    ];
                    for (const a of r){
                        const c = t[a], u = [
                            ...n.path,
                            a
                        ];
                        for(let f = 0; f < e.$_terms.patterns.length; ++f){
                            const m = e.$_terms.patterns[f];
                            if (m.regex) {
                                const e = m.regex.test(a);
                                if (n.mainstay.tracer.debug(n, "rule", "pattern.".concat(f), e ? "pass" : "error"), !e) continue;
                            } else if (!m.schema.$_match(a, n.nest(m.schema, "pattern.".concat(f)), o)) continue;
                            r.delete(a);
                            const h = n.localize(u, l, {
                                schema: m.rule,
                                key: a
                            }), d = m.rule.$_validate(c, h, o);
                            if (d.errors) {
                                if (o.abortEarly) return {
                                    value: t,
                                    errors: d.errors
                                };
                                s.push(...d.errors);
                            }
                            if (m.matches && i[f].push(a), t[a] = d.value, !m.fallthrough) break;
                        }
                    }
                    if (a) for(let r = 0; r < i.length; ++r){
                        const a = i[r];
                        if (!a) continue;
                        const c = e.$_terms.patterns[r].matches, f = n.localize(n.path, l, c), m = c.$_validate(a, f, o);
                        if (m.errors) {
                            const r = u.details(m.errors, {
                                override: !1
                            });
                            r.matches = a;
                            const i = e.$_createError("object.pattern.match", t, r, n, o);
                            if (o.abortEarly) return {
                                value: t,
                                errors: i
                            };
                            s.push(i);
                        }
                    }
                }
                if (!r.size || !e.$_terms.keys && !e.$_terms.patterns) return;
                if (o.stripUnknown && !e._flags.unknown || o.skipFunctions) {
                    const e = !!o.stripUnknown && (!0 === o.stripUnknown || !!o.stripUnknown.objects);
                    for (const s of r)e ? (delete t[s], r.delete(s)) : "function" == typeof t[s] && r.delete(s);
                }
                if (!l.default(e._flags.unknown, o.allowUnknown)) for (const a of r){
                    const r = n.localize([
                        ...n.path,
                        a
                    ], []), i = e.$_createError("object.unknown", t[a], {
                        child: a
                    }, r, o, {
                        flags: !1
                    });
                    if (o.abortEarly) return {
                        value: t,
                        errors: i
                    };
                    s.push(i);
                }
            }, h.Dependency = class {
                constructor(e, t, r, s){
                    this.rel = e, this.key = t, this.peers = r, this.paths = s;
                }
                describe() {
                    const e = {
                        rel: this.rel,
                        peers: this.paths
                    };
                    return null !== this.key && (e.key = this.key.key), "." !== this.peers[0].separator && (e.options = {
                        separator: this.peers[0].separator
                    }), e;
                }
            }, h.Keys = class extends Array {
                concat(e) {
                    const t = this.slice(), r = new Map;
                    for(let e = 0; e < t.length; ++e)r.set(t[e].key, e);
                    for (const s of e){
                        const e = s.key, n = r.get(e);
                        void 0 !== n ? t[n] = {
                            key: e,
                            schema: t[n].schema.concat(s.schema)
                        } : t.push(s);
                    }
                    return t;
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(24), n = r(25), o = {
                minDomainSegments: 2,
                nonAsciiRx: /[^\x00-\x7f]/,
                domainControlRx: /[\x00-\x20@\:\/]/,
                tldSegmentRx: /^[a-zA-Z](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                domainSegmentRx: /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                URL: s.URL || URL
            };
            t.analyze = function(e, t = {}) {
                if ("string" != typeof e) throw new Error("Invalid input: domain must be a string");
                if (!e) return n.code("DOMAIN_NON_EMPTY_STRING");
                if (e.length > 256) return n.code("DOMAIN_TOO_LONG");
                if (!!o.nonAsciiRx.test(e)) {
                    if (!1 === t.allowUnicode) return n.code("DOMAIN_INVALID_UNICODE_CHARS");
                    e = e.normalize("NFC");
                }
                if (o.domainControlRx.test(e)) return n.code("DOMAIN_INVALID_CHARS");
                e = o.punycode(e);
                const r = t.minDomainSegments || o.minDomainSegments, s = e.split(".");
                if (s.length < r) return n.code("DOMAIN_SEGMENTS_COUNT");
                const a = t.tlds;
                if (a) {
                    const e = s[s.length - 1].toLowerCase();
                    if (a.deny && a.deny.has(e) || a.allow && !a.allow.has(e)) return n.code("DOMAIN_FORBIDDEN_TLDS");
                }
                for(let e = 0; e < s.length; ++e){
                    const t = s[e];
                    if (!t.length) return n.code("DOMAIN_EMPTY_SEGMENT");
                    if (t.length > 63) return n.code("DOMAIN_LONG_SEGMENT");
                    if (e < s.length - 1) {
                        if (!o.domainSegmentRx.test(t)) return n.code("DOMAIN_INVALID_CHARS");
                    } else if (!o.tldSegmentRx.test(t)) return n.code("DOMAIN_INVALID_TLDS_CHARS");
                }
                return null;
            }, t.isValid = function(e, r) {
                return !t.analyze(e, r);
            }, o.punycode = function(e) {
                try {
                    return new o.URL("http://".concat(e)).host;
                } catch (t) {
                    return e;
                }
            };
        },
        function(e, t) {},
        function(e, t, r) {
            "use strict";
            t.codes = {
                EMPTY_STRING: "Address must be a non-empty string",
                FORBIDDEN_UNICODE: "Address contains forbidden Unicode characters",
                MULTIPLE_AT_CHAR: "Address cannot contain more than one @ character",
                MISSING_AT_CHAR: "Address must contain one @ character",
                EMPTY_LOCAL: "Address local part cannot be empty",
                ADDRESS_TOO_LONG: "Address too long",
                LOCAL_TOO_LONG: "Address local part too long",
                EMPTY_LOCAL_SEGMENT: "Address local part contains empty dot-separated segment",
                INVALID_LOCAL_CHARS: "Address local part contains invalid character",
                DOMAIN_NON_EMPTY_STRING: "Domain must be a non-empty string",
                DOMAIN_TOO_LONG: "Domain too long",
                DOMAIN_INVALID_UNICODE_CHARS: "Domain contains forbidden Unicode characters",
                DOMAIN_INVALID_CHARS: "Domain contains invalid character",
                DOMAIN_INVALID_TLDS_CHARS: "Domain contains invalid tld character",
                DOMAIN_SEGMENTS_COUNT: "Domain lacks the minimum required number of segments",
                DOMAIN_FORBIDDEN_TLDS: "Domain uses forbidden TLD",
                DOMAIN_EMPTY_SEGMENT: "Domain contains empty dot-separated segment",
                DOMAIN_LONG_SEGMENT: "Domain contains dot-separated segment that is too long"
            }, t.code = function(e) {
                return {
                    code: e,
                    error: t.codes[e]
                };
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(27), o = {
                generate: function() {
                    const e = {}, t = "!\\$&'\\(\\)\\*\\+,;=", r = "\\w-\\.~%\\dA-Fa-f" + t + ":@", s = "[" + r + "]", n = "(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])";
                    e.ipv4address = "(?:" + n + "\\.){3}" + n;
                    const o = "[\\dA-Fa-f]{1,4}", a = "(?:" + o + ":" + o + "|" + e.ipv4address + ")", i = "(?:" + o + ":){6}" + a, l = "::(?:" + o + ":){5}" + a, c = "(?:" + o + ")?::(?:" + o + ":){4}" + a, u = "(?:(?:" + o + ":){0,1}" + o + ")?::(?:" + o + ":){3}" + a, f = "(?:(?:" + o + ":){0,2}" + o + ")?::(?:" + o + ":){2}" + a, m = "(?:(?:" + o + ":){0,3}" + o + ")?::" + o + ":" + a, h = "(?:(?:" + o + ":){0,4}" + o + ")?::" + a;
                    e.ipv4Cidr = "(?:\\d|[1-2]\\d|3[0-2])", e.ipv6Cidr = "(?:0{0,2}\\d|0?[1-9]\\d|1[01]\\d|12[0-8])", e.ipv6address = "(?:" + i + "|" + l + "|" + c + "|" + u + "|" + f + "|" + m + "|" + h + "|(?:(?:[\\dA-Fa-f]{1,4}:){0,5}[\\dA-Fa-f]{1,4})?::[\\dA-Fa-f]{1,4}|(?:(?:[\\dA-Fa-f]{1,4}:){0,6}[\\dA-Fa-f]{1,4})?::)", e.ipvFuture = "v[\\dA-Fa-f]+\\.[\\w-\\.~" + t + ":]+", e.scheme = "[a-zA-Z][a-zA-Z\\d+-\\.]*", e.schemeRegex = new RegExp(e.scheme);
                    const d = "[\\w-\\.~%\\dA-Fa-f" + t + ":]*", p = "(?:" + ("\\[(?:" + e.ipv6address + "|" + e.ipvFuture + ")\\]") + "|" + e.ipv4address + "|[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=]{1,255})", g = "(?:" + d + "@)?" + p + "(?::\\d*)?", y = "(?:" + d + "@)?(" + p + ")(?::\\d*)?", b = s + "*", v = s + "+", _ = "(?:\\/" + b + ")*", w = "\\/(?:" + v + _ + ")?", $ = v + _, x = "[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=@]+" + _;
                    return e.hierPart = "(?:(?:\\/\\/" + g + _ + ")|" + w + "|" + $ + "|(?:\\/\\/\\/[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=:@]*(?:\\/[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=:@]*)*))", e.hierPartCapture = "(?:(?:\\/\\/" + y + _ + ")|" + w + "|" + $ + ")", e.relativeRef = "(?:(?:\\/\\/" + g + _ + ")|" + w + "|" + x + "|)", e.relativeRefCapture = "(?:(?:\\/\\/" + y + _ + ")|" + w + "|" + x + "|)", e.query = "[" + r + "\\/\\?]*(?=#|$)", e.queryWithSquareBrackets = "[" + r + "\\[\\]\\/\\?]*(?=#|$)", e.fragment = "[" + r + "\\/\\?]*", e;
                }
            };
            o.rfc3986 = o.generate(), t.ip = {
                v4Cidr: o.rfc3986.ipv4Cidr,
                v6Cidr: o.rfc3986.ipv6Cidr,
                ipv4: o.rfc3986.ipv4address,
                ipv6: o.rfc3986.ipv6address,
                ipvfuture: o.rfc3986.ipvFuture
            }, o.createRegex = function(e) {
                const t = o.rfc3986, r = "(?:\\?" + (e.allowQuerySquareBrackets ? t.queryWithSquareBrackets : t.query) + ")?(?:#" + t.fragment + ")?", a = e.domain ? t.relativeRefCapture : t.relativeRef;
                if (e.relativeOnly) return o.wrap(a + r);
                let i = "";
                if (e.scheme) {
                    s(e.scheme instanceof RegExp || "string" == typeof e.scheme || Array.isArray(e.scheme), "scheme must be a RegExp, String, or Array");
                    const r = [].concat(e.scheme);
                    s(r.length >= 1, "scheme must have at least 1 scheme specified");
                    const o = [];
                    for(let e = 0; e < r.length; ++e){
                        const a = r[e];
                        s(a instanceof RegExp || "string" == typeof a, "scheme at position " + e + " must be a RegExp or String"), a instanceof RegExp ? o.push(a.source.toString()) : (s(t.schemeRegex.test(a), "scheme at position " + e + " must be a valid scheme"), o.push(n(a)));
                    }
                    i = o.join("|");
                }
                const l = "(?:" + (i ? "(?:" + i + ")" : t.scheme) + ":" + (e.domain ? t.hierPartCapture : t.hierPart) + ")", c = e.allowRelative ? "(?:" + l + "|" + a + ")" : l;
                return o.wrap(c + r, i);
            }, o.wrap = function(e, t) {
                return {
                    raw: e = "(?=.)(?!https?:/$)".concat(e),
                    regex: new RegExp("^".concat(e, "$")),
                    scheme: t
                };
            }, o.uriRegex = o.createRegex({}), t.regex = function(e = {}) {
                return e.scheme || e.allowRelative || e.relativeOnly || e.allowQuerySquareBrackets || e.domain ? o.createRegex(e) : o.uriRegex;
            };
        },
        function(e, t, r) {
            "use strict";
            e.exports = function(e) {
                return e.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, "\\$&");
            };
        },
        function(e, t, r) {
            "use strict";
            e.exports = function(...e) {
                try {
                    return JSON.stringify.apply(null, e);
                } catch (e) {
                    return "[Cannot display object: " + e.message + "]";
                }
            };
        },
        function(e) {
            e.exports = JSON.parse('{"version":"17.1.1"}');
        },
        function(e, t, r) {
            "use strict";
            const s = {};
            e.exports = function(e) {
                if (!e) return "";
                let t = "";
                for(let r = 0; r < e.length; ++r){
                    const n = e.charCodeAt(r);
                    s.isSafe(n) ? t += e[r] : t += s.escapeHtmlChar(n);
                }
                return t;
            }, s.escapeHtmlChar = function(e) {
                const t = s.namedHtml[e];
                if (void 0 !== t) return t;
                if (e >= 256) return "&#" + e + ";";
                const r = e.toString(16).padStart(2, "0");
                return "&#x".concat(r, ";");
            }, s.isSafe = function(e) {
                return void 0 !== s.safeCharCodes[e];
            }, s.namedHtml = {
                38: "&amp;",
                60: "&lt;",
                62: "&gt;",
                34: "&quot;",
                160: "&nbsp;",
                162: "&cent;",
                163: "&pound;",
                164: "&curren;",
                169: "&copy;",
                174: "&reg;"
            }, s.safeCharCodes = function() {
                const e = {};
                for(let t = 32; t < 123; ++t)(t >= 97 || t >= 65 && t <= 90 || t >= 48 && t <= 57 || 32 === t || 46 === t || 44 === t || 45 === t || 58 === t || 95 === t) && (e[t] = null);
                return e;
            }();
        },
        function(e, t, r) {
            "use strict";
            const s = {
                operators: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "<=",
                    ">",
                    ">=",
                    "==",
                    "!=",
                    "&&",
                    "||",
                    "??"
                ],
                operatorCharacters: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "=",
                    ">",
                    "&",
                    "|",
                    "?"
                ],
                operatorsOrder: [
                    [
                        "^"
                    ],
                    [
                        "*",
                        "/",
                        "%"
                    ],
                    [
                        "+",
                        "-"
                    ],
                    [
                        "<",
                        "<=",
                        ">",
                        ">="
                    ],
                    [
                        "==",
                        "!="
                    ],
                    [
                        "&&"
                    ],
                    [
                        "||",
                        "??"
                    ]
                ],
                operatorsPrefix: [
                    "!",
                    "n"
                ],
                literals: {
                    '"': '"',
                    "`": "`",
                    "'": "'",
                    "[": "]"
                },
                numberRx: /^(?:[0-9]*\.?[0-9]*){1}$/,
                tokenRx: /^[\w\$\#\.\@\:\{\}]+$/,
                symbol: Symbol("formula"),
                settings: Symbol("settings")
            };
            t.Parser = class {
                constructor(e, t = {}){
                    if (!t[s.settings] && t.constants) for(const e in t.constants){
                        const r = t.constants[e];
                        if (null !== r && ![
                            "boolean",
                            "number",
                            "string"
                        ].includes(typeof r)) throw new Error("Formula constant ".concat(e, " contains invalid ").concat(typeof r, " value type"));
                    }
                    this.settings = t[s.settings] ? t : Object.assign({
                        [s.settings]: !0,
                        constants: {},
                        functions: {}
                    }, t), this.single = null, this._parts = null, this._parse(e);
                }
                _parse(e) {
                    let r = [], n = "", o = 0, a = !1;
                    const i = (e)=>{
                        if (o) throw new Error("Formula missing closing parenthesis");
                        const i = r.length ? r[r.length - 1] : null;
                        if (a || n || e) {
                            if (i && "reference" === i.type && ")" === e) return i.type = "function", i.value = this._subFormula(n, i.value), void (n = "");
                            if (")" === e) {
                                const e = new t.Parser(n, this.settings);
                                r.push({
                                    type: "segment",
                                    value: e
                                });
                            } else if (a) {
                                if ("]" === a) return r.push({
                                    type: "reference",
                                    value: n
                                }), void (n = "");
                                r.push({
                                    type: "literal",
                                    value: n
                                });
                            } else if (s.operatorCharacters.includes(n)) i && "operator" === i.type && s.operators.includes(i.value + n) ? i.value += n : r.push({
                                type: "operator",
                                value: n
                            });
                            else if (n.match(s.numberRx)) r.push({
                                type: "constant",
                                value: parseFloat(n)
                            });
                            else if (void 0 !== this.settings.constants[n]) r.push({
                                type: "constant",
                                value: this.settings.constants[n]
                            });
                            else {
                                if (!n.match(s.tokenRx)) throw new Error("Formula contains invalid token: ".concat(n));
                                r.push({
                                    type: "reference",
                                    value: n
                                });
                            }
                            n = "";
                        }
                    };
                    for (const t of e)a ? t === a ? (i(), a = !1) : n += t : o ? "(" === t ? (n += t, ++o) : ")" === t ? (--o, o ? n += t : i(t)) : n += t : t in s.literals ? a = s.literals[t] : "(" === t ? (i(), ++o) : s.operatorCharacters.includes(t) ? (i(), n = t, i()) : " " !== t ? n += t : i();
                    i(), r = r.map((e, t)=>"operator" !== e.type || "-" !== e.value || t && "operator" !== r[t - 1].type ? e : {
                            type: "operator",
                            value: "n"
                        });
                    let l = !1;
                    for (const e of r){
                        if ("operator" === e.type) {
                            if (s.operatorsPrefix.includes(e.value)) continue;
                            if (!l) throw new Error("Formula contains an operator in invalid position");
                            if (!s.operators.includes(e.value)) throw new Error("Formula contains an unknown operator ".concat(e.value));
                        } else if (l) throw new Error("Formula missing expected operator");
                        l = !l;
                    }
                    if (!l) throw new Error("Formula contains invalid trailing operator");
                    1 === r.length && [
                        "reference",
                        "literal",
                        "constant"
                    ].includes(r[0].type) && (this.single = {
                        type: "reference" === r[0].type ? "reference" : "value",
                        value: r[0].value
                    }), this._parts = r.map((e)=>{
                        if ("operator" === e.type) return s.operatorsPrefix.includes(e.value) ? e : e.value;
                        if ("reference" !== e.type) return e.value;
                        if (this.settings.tokenRx && !this.settings.tokenRx.test(e.value)) throw new Error("Formula contains invalid reference ".concat(e.value));
                        return this.settings.reference ? this.settings.reference(e.value) : s.reference(e.value);
                    });
                }
                _subFormula(e, r) {
                    const n = this.settings.functions[r];
                    if ("function" != typeof n) throw new Error("Formula contains unknown function ".concat(r));
                    let o = [];
                    if (e) {
                        let t = "", n = 0, a = !1;
                        const i = ()=>{
                            if (!t) throw new Error("Formula contains function ".concat(r, " with invalid arguments ").concat(e));
                            o.push(t), t = "";
                        };
                        for(let r = 0; r < e.length; ++r){
                            const o = e[r];
                            a ? (t += o, o === a && (a = !1)) : o in s.literals && !n ? (t += o, a = s.literals[o]) : "," !== o || n ? (t += o, "(" === o ? ++n : ")" === o && --n) : i();
                        }
                        i();
                    }
                    return o = o.map((e)=>new t.Parser(e, this.settings)), function(e) {
                        const t = [];
                        for (const r of o)t.push(r.evaluate(e));
                        return n.call(e, ...t);
                    };
                }
                evaluate(e) {
                    const t = this._parts.slice();
                    for(let r = t.length - 2; r >= 0; --r){
                        const n = t[r];
                        if (n && "operator" === n.type) {
                            const o = t[r + 1];
                            t.splice(r + 1, 1);
                            const a = s.evaluate(o, e);
                            t[r] = s.single(n.value, a);
                        }
                    }
                    return s.operatorsOrder.forEach((r)=>{
                        for(let n = 1; n < t.length - 1;)if (r.includes(t[n])) {
                            const r = t[n], o = s.evaluate(t[n - 1], e), a = s.evaluate(t[n + 1], e);
                            t.splice(n, 2);
                            const i = s.calculate(r, o, a);
                            t[n - 1] = 0 === i ? 0 : i;
                        } else n += 2;
                    }), s.evaluate(t[0], e);
                }
            }, t.Parser.prototype[s.symbol] = !0, s.reference = function(e) {
                return function(t) {
                    return t && void 0 !== t[e] ? t[e] : null;
                };
            }, s.evaluate = function(e, t) {
                return null === e ? null : "function" == typeof e ? e(t) : e[s.symbol] ? e.evaluate(t) : e;
            }, s.single = function(e, t) {
                if ("!" === e) return !t;
                const r = -t;
                return 0 === r ? 0 : r;
            }, s.calculate = function(e, t, r) {
                if ("??" === e) return s.exists(t) ? t : r;
                if ("string" == typeof t || "string" == typeof r) {
                    if ("+" === e) return (t = s.exists(t) ? t : "") + (r = s.exists(r) ? r : "");
                } else switch(e){
                    case "^":
                        return Math.pow(t, r);
                    case "*":
                        return t * r;
                    case "/":
                        return t / r;
                    case "%":
                        return t % r;
                    case "+":
                        return t + r;
                    case "-":
                        return t - r;
                }
                switch(e){
                    case "<":
                        return t < r;
                    case "<=":
                        return t <= r;
                    case ">":
                        return t > r;
                    case ">=":
                        return t >= r;
                    case "==":
                        return t === r;
                    case "!=":
                        return t !== r;
                    case "&&":
                        return t && r;
                    case "||":
                        return t || r;
                }
                return null;
            }, s.exists = function(e) {
                return null != e;
            };
        },
        function(e, t) {},
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = r(8), i = r(4), l = r(5), c = {};
            e.exports = n.extend({
                type: "alternatives",
                flags: {
                    match: {
                        default: "any"
                    }
                },
                terms: {
                    matches: {
                        init: [],
                        register: l.toSibling
                    }
                },
                args: (e, ...t)=>1 === t.length && Array.isArray(t[0]) ? e.try(...t[0]) : e.try(...t),
                validate (e, t) {
                    const { schema: r, error: s, state: n, prefs: o } = t;
                    if (r._flags.match) {
                        let t, a = 0;
                        for(let s = 0; s < r.$_terms.matches.length; ++s){
                            const i = r.$_terms.matches[s], l = n.nest(i.schema, "match.".concat(s));
                            l.snapshot();
                            const c = i.schema.$_validate(e, l, o);
                            c.errors ? l.restore() : (++a, t = c.value);
                        }
                        return a ? "one" === r._flags.match ? 1 === a ? {
                            value: t
                        } : {
                            errors: s("alternatives.one")
                        } : a === r.$_terms.matches.length ? {
                            value: e
                        } : {
                            errors: s("alternatives.all")
                        } : {
                            errors: s("alternatives.any")
                        };
                    }
                    const a = [];
                    for(let t = 0; t < r.$_terms.matches.length; ++t){
                        const s = r.$_terms.matches[t];
                        if (s.schema) {
                            const r = n.nest(s.schema, "match.".concat(t));
                            r.snapshot();
                            const i = s.schema.$_validate(e, r, o);
                            if (!i.errors) return i;
                            r.restore(), a.push({
                                schema: s.schema,
                                reports: i.errors
                            });
                            continue;
                        }
                        const i = s.ref ? s.ref.resolve(e, n, o) : e, l = s.is ? [
                            s
                        ] : s.switch;
                        for(let r = 0; r < l.length; ++r){
                            const a = l[r], { is: c, then: u, otherwise: f } = a, m = "match.".concat(t).concat(s.switch ? "." + r : "");
                            if (c.$_match(i, n.nest(c, "".concat(m, ".is")), o)) {
                                if (u) return u.$_validate(e, n.nest(u, "".concat(m, ".then")), o);
                            } else if (f) return f.$_validate(e, n.nest(f, "".concat(m, ".otherwise")), o);
                        }
                    }
                    return c.errors(a, t);
                },
                rules: {
                    conditional: {
                        method (e, t) {
                            s(!this._flags._endedSwitch, "Unreachable condition"), s(!this._flags.match, "Cannot combine match mode", this._flags.match, "with conditional rule"), s(void 0 === t.break, "Cannot use break option with alternatives conditional");
                            const r = this.clone(), n = a.when(r, e, t), o = n.is ? [
                                n
                            ] : n.switch;
                            for (const e of o)if (e.then && e.otherwise) {
                                r.$_setFlag("_endedSwitch", !0, {
                                    clone: !1
                                });
                                break;
                            }
                            return r.$_terms.matches.push(n), r.$_mutateRebuild();
                        }
                    },
                    match: {
                        method (e) {
                            if (s([
                                "any",
                                "one",
                                "all"
                            ].includes(e), "Invalid alternatives match mode", e), "any" !== e) for (const t of this.$_terms.matches)s(t.schema, "Cannot combine match mode", e, "with conditional rules");
                            return this.$_setFlag("match", e);
                        }
                    },
                    try: {
                        method (...e) {
                            s(e.length, "Missing alternative schemas"), o.verifyFlat(e, "try"), s(!this._flags._endedSwitch, "Unreachable condition");
                            const t = this.clone();
                            for (const r of e)t.$_terms.matches.push({
                                schema: t.$_compile(r)
                            });
                            return t.$_mutateRebuild();
                        }
                    }
                },
                overrides: {
                    label (e) {
                        return this.$_super.label(e).$_modify({
                            each: (t, r)=>"is" !== r.path[0] ? t.label(e) : void 0,
                            ref: !1
                        });
                    }
                },
                rebuild (e) {
                    e.$_modify({
                        each: (t)=>{
                            o.isSchema(t) && "array" === t.type && e.$_setFlag("_arrayItems", !0, {
                                clone: !1
                            });
                        }
                    });
                },
                manifest: {
                    build (e, t) {
                        if (t.matches) for (const r of t.matches){
                            const { schema: t, ref: s, is: n, not: o, then: a, otherwise: i } = r;
                            e = t ? e.try(t) : s ? e.conditional(s, {
                                is: n,
                                then: a,
                                not: o,
                                otherwise: i,
                                switch: r.switch
                            }) : e.conditional(n, {
                                then: a,
                                otherwise: i
                            });
                        }
                        return e;
                    }
                },
                messages: {
                    "alternatives.all": "{{#label}} does not match all of the required types",
                    "alternatives.any": "{{#label}} does not match any of the allowed types",
                    "alternatives.match": "{{#label}} does not match any of the allowed types",
                    "alternatives.one": "{{#label}} matches more than one allowed type",
                    "alternatives.types": "{{#label}} must be one of {{#types}}"
                }
            }), c.errors = function(e, { error: t, state: r }) {
                if (!e.length) return {
                    errors: t("alternatives.any")
                };
                if (1 === e.length) return {
                    errors: e[0].reports
                };
                const s = new Set, n = [];
                for (const { reports: o, schema: a } of e){
                    if (o.length > 1) return c.unmatched(e, t);
                    const l = o[0];
                    if (l instanceof i.Report == !1) return c.unmatched(e, t);
                    if (l.state.path.length !== r.path.length) {
                        n.push({
                            type: a.type,
                            report: l
                        });
                        continue;
                    }
                    if ("any.only" === l.code) {
                        for (const e of l.local.valids)s.add(e);
                        continue;
                    }
                    const [u, f] = l.code.split(".");
                    "base" === f ? s.add(u) : n.push({
                        type: a.type,
                        report: l
                    });
                }
                return n.length ? 1 === n.length ? {
                    errors: n[0].report
                } : c.unmatched(e, t) : {
                    errors: t("alternatives.types", {
                        types: [
                            ...s
                        ]
                    })
                };
            }, c.unmatched = function(e, t) {
                const r = [];
                for (const t of e)r.push(...t.reports);
                return {
                    errors: t("alternatives.match", i.details(r, {
                        override: !1
                    }))
                };
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(10), a = r(20), i = r(15), l = r(1), c = r(8), u = r(4), f = r(17), m = r(18), h = r(9), d = r(35), p = r(5), g = r(19), y = r(36), b = r(21), v = {
                Base: class {
                    constructor(e){
                        this.type = e, this.$_root = null, this._definition = {}, this._ids = new d.Ids, this._preferences = null, this._refs = new p.Manager, this._cache = null, this._valids = null, this._invalids = null, this._flags = {}, this._rules = [], this._singleRules = new Map, this.$_terms = {}, this.$_temp = {
                            ruleset: null,
                            whens: {}
                        };
                    }
                    describe() {
                        return s("function" == typeof m.describe, "Manifest functionality disabled"), m.describe(this);
                    }
                    allow(...e) {
                        return l.verifyFlat(e, "allow"), this._values(e, "_valids");
                    }
                    alter(e) {
                        s(e && "object" == typeof e && !Array.isArray(e), "Invalid targets argument"), s(!this._inRuleset(), "Cannot set alterations inside a ruleset");
                        const t = this.clone();
                        t.$_terms.alterations = t.$_terms.alterations || [];
                        for(const r in e){
                            const n = e[r];
                            s("function" == typeof n, "Alteration adjuster for", r, "must be a function"), t.$_terms.alterations.push({
                                target: r,
                                adjuster: n
                            });
                        }
                        return t.$_temp.ruleset = !1, t;
                    }
                    cast(e) {
                        return s(!1 === e || "string" == typeof e, "Invalid to value"), s(!1 === e || this._definition.cast[e], "Type", this.type, "does not support casting to", e), this.$_setFlag("cast", !1 === e ? void 0 : e);
                    }
                    default(e, t) {
                        return this._default("default", e, t);
                    }
                    description(e) {
                        return s(e && "string" == typeof e, "Description must be a non-empty string"), this.$_setFlag("description", e);
                    }
                    empty(e) {
                        const t = this.clone();
                        return void 0 !== e && (e = t.$_compile(e, {
                            override: !1
                        })), t.$_setFlag("empty", e, {
                            clone: !1
                        });
                    }
                    error(e) {
                        return s(e, "Missing error"), s(e instanceof Error || "function" == typeof e, "Must provide a valid Error object or a function"), this.$_setFlag("error", e);
                    }
                    example(e, t = {}) {
                        return s(void 0 !== e, "Missing example"), l.assertOptions(t, [
                            "override"
                        ]), this._inner("examples", e, {
                            single: !0,
                            override: t.override
                        });
                    }
                    external(e, t) {
                        return "object" == typeof e && (s(!t, "Cannot combine options with description"), t = e.description, e = e.method), s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this._inner("externals", {
                            method: e,
                            description: t
                        }, {
                            single: !0
                        });
                    }
                    failover(e, t) {
                        return this._default("failover", e, t);
                    }
                    forbidden() {
                        return this.presence("forbidden");
                    }
                    id(e) {
                        return e ? (s("string" == typeof e, "id must be a non-empty string"), s(/^[^\.]+$/.test(e), "id cannot contain period character"), this.$_setFlag("id", e)) : this.$_setFlag("id", void 0);
                    }
                    invalid(...e) {
                        return this._values(e, "_invalids");
                    }
                    label(e) {
                        return s(e && "string" == typeof e, "Label name must be a non-empty string"), this.$_setFlag("label", e);
                    }
                    meta(e) {
                        return s(void 0 !== e, "Meta cannot be undefined"), this._inner("metas", e, {
                            single: !0
                        });
                    }
                    note(...e) {
                        s(e.length, "Missing notes");
                        for (const t of e)s(t && "string" == typeof t, "Notes must be non-empty strings");
                        return this._inner("notes", e);
                    }
                    only(e = !0) {
                        return s("boolean" == typeof e, "Invalid mode:", e), this.$_setFlag("only", e);
                    }
                    optional() {
                        return this.presence("optional");
                    }
                    prefs(e) {
                        s(e, "Missing preferences"), s(void 0 === e.context, "Cannot override context"), s(void 0 === e.externals, "Cannot override externals"), s(void 0 === e.warnings, "Cannot override warnings"), s(void 0 === e.debug, "Cannot override debug"), l.checkPreferences(e);
                        const t = this.clone();
                        return t._preferences = l.preferences(t._preferences, e), t;
                    }
                    presence(e) {
                        return s([
                            "optional",
                            "required",
                            "forbidden"
                        ].includes(e), "Unknown presence mode", e), this.$_setFlag("presence", e);
                    }
                    raw(e = !0) {
                        return this.$_setFlag("result", e ? "raw" : void 0);
                    }
                    result(e) {
                        return s([
                            "raw",
                            "strip"
                        ].includes(e), "Unknown result mode", e), this.$_setFlag("result", e);
                    }
                    required() {
                        return this.presence("required");
                    }
                    strict(e) {
                        const t = this.clone(), r = void 0 !== e && !e;
                        return t._preferences = l.preferences(t._preferences, {
                            convert: r
                        }), t;
                    }
                    strip(e = !0) {
                        return this.$_setFlag("result", e ? "strip" : void 0);
                    }
                    tag(...e) {
                        s(e.length, "Missing tags");
                        for (const t of e)s(t && "string" == typeof t, "Tags must be non-empty strings");
                        return this._inner("tags", e);
                    }
                    unit(e) {
                        return s(e && "string" == typeof e, "Unit name must be a non-empty string"), this.$_setFlag("unit", e);
                    }
                    valid(...e) {
                        l.verifyFlat(e, "valid");
                        const t = this.allow(...e);
                        return t.$_setFlag("only", !!t._valids, {
                            clone: !1
                        }), t;
                    }
                    when(e, t) {
                        const r = this.clone();
                        r.$_terms.whens || (r.$_terms.whens = []);
                        const n = c.when(r, e, t);
                        if (![
                            "any",
                            "link"
                        ].includes(r.type)) {
                            const e = n.is ? [
                                n
                            ] : n.switch;
                            for (const t of e)s(!t.then || "any" === t.then.type || t.then.type === r.type, "Cannot combine", r.type, "with", t.then && t.then.type), s(!t.otherwise || "any" === t.otherwise.type || t.otherwise.type === r.type, "Cannot combine", r.type, "with", t.otherwise && t.otherwise.type);
                        }
                        return r.$_terms.whens.push(n), r.$_mutateRebuild();
                    }
                    cache(e) {
                        s(!this._inRuleset(), "Cannot set caching inside a ruleset"), s(!this._cache, "Cannot override schema cache");
                        const t = this.clone();
                        return t._cache = e || i.provider.provision(), t.$_temp.ruleset = !1, t;
                    }
                    clone() {
                        const e = Object.create(Object.getPrototypeOf(this));
                        return this._assign(e);
                    }
                    concat(e) {
                        s(l.isSchema(e), "Invalid schema object"), s("any" === this.type || "any" === e.type || e.type === this.type, "Cannot merge type", this.type, "with another type:", e.type), s(!this._inRuleset(), "Cannot concatenate onto a schema with open ruleset"), s(!e._inRuleset(), "Cannot concatenate a schema with open ruleset");
                        let t = this.clone();
                        if ("any" === this.type && "any" !== e.type) {
                            const r = e.clone();
                            for (const e of Object.keys(t))"type" !== e && (r[e] = t[e]);
                            t = r;
                        }
                        t._ids.concat(e._ids), t._refs.register(e, p.toSibling), t._preferences = t._preferences ? l.preferences(t._preferences, e._preferences) : e._preferences, t._valids = b.merge(t._valids, e._valids, e._invalids), t._invalids = b.merge(t._invalids, e._invalids, e._valids);
                        for (const r of e._singleRules.keys())t._singleRules.has(r) && (t._rules = t._rules.filter((e)=>e.keep || e.name !== r), t._singleRules.delete(r));
                        for (const r of e._rules)e._definition.rules[r.method].multi || t._singleRules.set(r.name, r), t._rules.push(r);
                        if (t._flags.empty && e._flags.empty) {
                            t._flags.empty = t._flags.empty.concat(e._flags.empty);
                            const r = Object.assign({}, e._flags);
                            delete r.empty, a(t._flags, r);
                        } else if (e._flags.empty) {
                            t._flags.empty = e._flags.empty;
                            const r = Object.assign({}, e._flags);
                            delete r.empty, a(t._flags, r);
                        } else a(t._flags, e._flags);
                        for(const r in e.$_terms){
                            const s = e.$_terms[r];
                            s ? t.$_terms[r] ? t.$_terms[r] = t.$_terms[r].concat(s) : t.$_terms[r] = s.slice() : t.$_terms[r] || (t.$_terms[r] = s);
                        }
                        return this.$_root._tracer && this.$_root._tracer._combine(t, [
                            this,
                            e
                        ]), t.$_mutateRebuild();
                    }
                    extend(e) {
                        return s(!e.base, "Cannot extend type with another base"), f.type(this, e);
                    }
                    extract(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.reach(e);
                    }
                    fork(e, t) {
                        s(!this._inRuleset(), "Cannot fork inside a ruleset");
                        let r = this;
                        for (let s of [].concat(e))s = Array.isArray(s) ? s : s.split("."), r = r._ids.fork(s, t, r);
                        return r.$_temp.ruleset = !1, r;
                    }
                    rule(e) {
                        const t = this._definition;
                        l.assertOptions(e, Object.keys(t.modifiers)), s(!1 !== this.$_temp.ruleset, "Cannot apply rules to empty ruleset or the last rule added does not support rule properties");
                        const r = null === this.$_temp.ruleset ? this._rules.length - 1 : this.$_temp.ruleset;
                        s(r >= 0 && r < this._rules.length, "Cannot apply rules to empty ruleset");
                        const o = this.clone();
                        for(let a = r; a < o._rules.length; ++a){
                            const r = o._rules[a], i = n(r);
                            for(const n in e)t.modifiers[n](i, e[n]), s(i.name === r.name, "Cannot change rule name");
                            o._rules[a] = i, o._singleRules.get(i.name) === r && o._singleRules.set(i.name, i);
                        }
                        return o.$_temp.ruleset = !1, o.$_mutateRebuild();
                    }
                    get ruleset() {
                        s(!this._inRuleset(), "Cannot start a new ruleset without closing the previous one");
                        const e = this.clone();
                        return e.$_temp.ruleset = e._rules.length, e;
                    }
                    get $() {
                        return this.ruleset;
                    }
                    tailor(e) {
                        e = [].concat(e), s(!this._inRuleset(), "Cannot tailor inside a ruleset");
                        let t = this;
                        if (this.$_terms.alterations) for (const { target: r, adjuster: n } of this.$_terms.alterations)e.includes(r) && (t = n(t), s(l.isSchema(t), "Alteration adjuster for", r, "failed to return a schema object"));
                        return t = t.$_modify({
                            each: (t)=>t.tailor(e),
                            ref: !1
                        }), t.$_temp.ruleset = !1, t.$_mutateRebuild();
                    }
                    tracer() {
                        return g.location ? g.location(this) : this;
                    }
                    validate(e, t) {
                        return y.entry(e, this, t);
                    }
                    validateAsync(e, t) {
                        return y.entryAsync(e, this, t);
                    }
                    $_addRule(e) {
                        "string" == typeof e && (e = {
                            name: e
                        }), s(e && "object" == typeof e, "Invalid options"), s(e.name && "string" == typeof e.name, "Invalid rule name");
                        for(const t in e)s("_" !== t[0], "Cannot set private rule properties");
                        const t = Object.assign({}, e);
                        t._resolve = [], t.method = t.method || t.name;
                        const r = this._definition.rules[t.method], n = t.args;
                        s(r, "Unknown rule", t.method);
                        const o = this.clone();
                        if (n) {
                            s(1 === Object.keys(n).length || Object.keys(n).length === this._definition.rules[t.name].args.length, "Invalid rule definition for", this.type, t.name);
                            for(const e in n){
                                let a = n[e];
                                if (void 0 !== a) {
                                    if (r.argsByName) {
                                        const i = r.argsByName.get(e);
                                        if (i.ref && l.isResolvable(a)) t._resolve.push(e), o.$_mutateRegister(a);
                                        else if (i.normalize && (a = i.normalize(a), n[e] = a), i.assert) {
                                            const t = l.validateArg(a, e, i);
                                            s(!t, t, "or reference");
                                        }
                                    }
                                    n[e] = a;
                                } else delete n[e];
                            }
                        }
                        return r.multi || (o._ruleRemove(t.name, {
                            clone: !1
                        }), o._singleRules.set(t.name, t)), !1 === o.$_temp.ruleset && (o.$_temp.ruleset = null), r.priority ? o._rules.unshift(t) : o._rules.push(t), o;
                    }
                    $_compile(e, t) {
                        return c.schema(this.$_root, e, t);
                    }
                    $_createError(e, t, r, s, n, o = {}) {
                        const a = !1 !== o.flags ? this._flags : {}, i = o.messages ? h.merge(this._definition.messages, o.messages) : this._definition.messages;
                        return new u.Report(e, t, r, a, i, s, n);
                    }
                    $_getFlag(e) {
                        return this._flags[e];
                    }
                    $_getRule(e) {
                        return this._singleRules.get(e);
                    }
                    $_mapLabels(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.labels(e);
                    }
                    $_match(e, t, r, s) {
                        (r = Object.assign({}, r)).abortEarly = !0, r._externals = !1, t.snapshot();
                        const n = !y.validate(e, this, t, r, s).errors;
                        return t.restore(), n;
                    }
                    $_modify(e) {
                        return l.assertOptions(e, [
                            "each",
                            "once",
                            "ref",
                            "schema"
                        ]), d.schema(this, e) || this;
                    }
                    $_mutateRebuild() {
                        s(!this._inRuleset(), "Cannot add this rule inside a ruleset"), this._refs.reset(), this._ids.reset();
                        return this.$_modify({
                            each: (e, { source: t, name: r, path: s, key: n })=>{
                                const o = this._definition[t][r] && this._definition[t][r].register;
                                !1 !== o && this.$_mutateRegister(e, {
                                    family: o,
                                    key: n
                                });
                            }
                        }), this._definition.rebuild && this._definition.rebuild(this), this.$_temp.ruleset = !1, this;
                    }
                    $_mutateRegister(e, { family: t, key: r } = {}) {
                        this._refs.register(e, t), this._ids.register(e, {
                            key: r
                        });
                    }
                    $_property(e) {
                        return this._definition.properties[e];
                    }
                    $_reach(e) {
                        return this._ids.reach(e);
                    }
                    $_rootReferences() {
                        return this._refs.roots();
                    }
                    $_setFlag(e, t, r = {}) {
                        s("_" === e[0] || !this._inRuleset(), "Cannot set flag inside a ruleset");
                        const n = this._definition.flags[e] || {};
                        if (o(t, n.default) && (t = void 0), o(t, this._flags[e])) return this;
                        const a = !1 !== r.clone ? this.clone() : this;
                        return void 0 !== t ? (a._flags[e] = t, a.$_mutateRegister(t)) : delete a._flags[e], "_" !== e[0] && (a.$_temp.ruleset = !1), a;
                    }
                    $_validate(e, t, r) {
                        return y.validate(e, this, t, r);
                    }
                    _assign(e) {
                        e.type = this.type, e.$_root = this.$_root, e.$_temp = Object.assign({}, this.$_temp), e.$_temp.whens = {}, e._ids = this._ids.clone(), e._preferences = this._preferences, e._valids = this._valids && this._valids.clone(), e._invalids = this._invalids && this._invalids.clone(), e._rules = this._rules.slice(), e._singleRules = n(this._singleRules, {
                            shallow: !0
                        }), e._refs = this._refs.clone(), e._flags = Object.assign({}, this._flags), e._cache = null, e.$_terms = {};
                        for(const t in this.$_terms)e.$_terms[t] = this.$_terms[t] ? this.$_terms[t].slice() : null;
                        e.$_super = {};
                        for(const t in this.$_super)e.$_super[t] = this._super[t].bind(e);
                        return e;
                    }
                    _default(e, t, r = {}) {
                        return l.assertOptions(r, "literal"), s(void 0 !== t, "Missing", e, "value"), s("function" == typeof t || !r.literal, "Only function value supports literal option"), "function" == typeof t && r.literal && (t = {
                            [l.symbols.literal]: !0,
                            literal: t
                        }), this.$_setFlag(e, t);
                    }
                    _generate(e, t, r) {
                        if (!this.$_terms.whens) return {
                            schema: this
                        };
                        const s = [], n = [];
                        for(let o = 0; o < this.$_terms.whens.length; ++o){
                            const a = this.$_terms.whens[o];
                            if (a.concat) {
                                s.push(a.concat), n.push("".concat(o, ".concat"));
                                continue;
                            }
                            const i = a.ref ? a.ref.resolve(e, t, r) : e, l = a.is ? [
                                a
                            ] : a.switch, c = n.length;
                            for(let c = 0; c < l.length; ++c){
                                const { is: u, then: f, otherwise: m } = l[c], h = "".concat(o).concat(a.switch ? "." + c : "");
                                if (u.$_match(i, t.nest(u, "".concat(h, ".is")), r)) {
                                    if (f) {
                                        const o = t.localize([
                                            ...t.path,
                                            "".concat(h, ".then")
                                        ], t.ancestors, t.schemas), { schema: a, id: i } = f._generate(e, o, r);
                                        s.push(a), n.push("".concat(h, ".then").concat(i ? "(".concat(i, ")") : ""));
                                        break;
                                    }
                                } else if (m) {
                                    const o = t.localize([
                                        ...t.path,
                                        "".concat(h, ".otherwise")
                                    ], t.ancestors, t.schemas), { schema: a, id: i } = m._generate(e, o, r);
                                    s.push(a), n.push("".concat(h, ".otherwise").concat(i ? "(".concat(i, ")") : ""));
                                    break;
                                }
                            }
                            if (a.break && n.length > c) break;
                        }
                        const o = n.join(", ");
                        if (t.mainstay.tracer.debug(t, "rule", "when", o), !o) return {
                            schema: this
                        };
                        if (!t.mainstay.tracer.active && this.$_temp.whens[o]) return {
                            schema: this.$_temp.whens[o],
                            id: o
                        };
                        let a = this;
                        this._definition.generate && (a = this._definition.generate(this, e, t, r));
                        for (const e of s)a = a.concat(e);
                        return this.$_root._tracer && this.$_root._tracer._combine(a, [
                            this,
                            ...s
                        ]), this.$_temp.whens[o] = a, {
                            schema: a,
                            id: o
                        };
                    }
                    _inner(e, t, r = {}) {
                        s(!this._inRuleset(), "Cannot set ".concat(e, " inside a ruleset"));
                        const n = this.clone();
                        return n.$_terms[e] && !r.override || (n.$_terms[e] = []), r.single ? n.$_terms[e].push(t) : n.$_terms[e].push(...t), n.$_temp.ruleset = !1, n;
                    }
                    _inRuleset() {
                        return null !== this.$_temp.ruleset && !1 !== this.$_temp.ruleset;
                    }
                    _ruleRemove(e, t = {}) {
                        if (!this._singleRules.has(e)) return this;
                        const r = !1 !== t.clone ? this.clone() : this;
                        r._singleRules.delete(e);
                        const s = [];
                        for(let t = 0; t < r._rules.length; ++t){
                            const n = r._rules[t];
                            n.name !== e || n.keep ? s.push(n) : r._inRuleset() && t < r.$_temp.ruleset && --r.$_temp.ruleset;
                        }
                        return r._rules = s, r;
                    }
                    _values(e, t) {
                        l.verifyFlat(e, t.slice(1, -1));
                        const r = this.clone(), n = e[0] === l.symbols.override;
                        if (n && (e = e.slice(1)), !r[t] && e.length ? r[t] = new b : n && (r[t] = e.length ? new b : null, r.$_mutateRebuild()), !r[t]) return r;
                        n && r[t].override();
                        for (const n of e){
                            s(void 0 !== n, "Cannot call allow/valid/invalid with undefined"), s(n !== l.symbols.override, "Override must be the first value");
                            const e = "_invalids" === t ? "_valids" : "_invalids";
                            r[e] && (r[e].remove(n), r[e].length || (s("_valids" === t || !r._flags.only, "Setting invalid value", n, "leaves schema rejecting all values due to previous valid rule"), r[e] = null)), r[t].add(n, r._refs);
                        }
                        return r;
                    }
                }
            };
            v.Base.prototype[l.symbols.any] = {
                version: l.version,
                compile: c.compile,
                root: "$_root"
            }, v.Base.prototype.isImmutable = !0, v.Base.prototype.deny = v.Base.prototype.invalid, v.Base.prototype.disallow = v.Base.prototype.invalid, v.Base.prototype.equal = v.Base.prototype.valid, v.Base.prototype.exist = v.Base.prototype.required, v.Base.prototype.not = v.Base.prototype.invalid, v.Base.prototype.options = v.Base.prototype.prefs, v.Base.prototype.preferences = v.Base.prototype.prefs, e.exports = new v.Base;
        },
        function(e, t, r) {
            "use strict";
            function s(e, t) {
                var r = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var s = Object.getOwnPropertySymbols(e);
                    t && (s = s.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), r.push.apply(r, s);
                }
                return r;
            }
            function n(e, t, r) {
                return t in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r, e;
            }
            const o = r(0), a = r(1), i = r(5), l = {};
            t.Ids = l.Ids = class {
                constructor(){
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                clone() {
                    const e = new l.Ids;
                    return e._byId = new Map(this._byId), e._byKey = new Map(this._byKey), e._schemaChain = this._schemaChain, e;
                }
                concat(e) {
                    e._schemaChain && (this._schemaChain = !0);
                    for (const [t, r] of e._byId.entries())o(!this._byKey.has(t), "Schema id conflicts with existing key:", t), this._byId.set(t, r);
                    for (const [t, r] of e._byKey.entries())o(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, r);
                }
                fork(e, t, r) {
                    const s = this._collect(e);
                    s.push({
                        schema: r
                    });
                    const n = s.shift();
                    let i = {
                        id: n.id,
                        schema: t(n.schema)
                    };
                    o(a.isSchema(i.schema), "adjuster function failed to return a joi schema type");
                    for (const e of s)i = {
                        id: e.id,
                        schema: l.fork(e.schema, i.id, i.schema)
                    };
                    return i.schema;
                }
                labels(e, t = []) {
                    const r = e[0], s = this._get(r);
                    if (!s) return [
                        ...t,
                        ...e
                    ].join(".");
                    const n = e.slice(1);
                    return t = [
                        ...t,
                        s.schema._flags.label || r
                    ], n.length ? s.schema._ids.labels(n, t) : t.join(".");
                }
                reach(e, t = []) {
                    const r = e[0], s = this._get(r);
                    o(s, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join("."));
                    const n = e.slice(1);
                    return n.length ? s.schema._ids.reach(n, [
                        ...t,
                        r
                    ]) : s.schema;
                }
                register(e, { key: t } = {}) {
                    if (!e || !a.isSchema(e)) return;
                    (e.$_property("schemaChain") || e._ids._schemaChain) && (this._schemaChain = !0);
                    const r = e._flags.id;
                    if (r) {
                        const t = this._byId.get(r);
                        o(!t || t.schema === e, "Cannot add different schemas with the same id:", r), o(!this._byKey.has(r), "Schema id conflicts with existing key:", r), this._byId.set(r, {
                            schema: e,
                            id: r
                        });
                    }
                    t && (o(!this._byKey.has(t), "Schema already contains key:", t), o(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, {
                        schema: e,
                        id: t
                    }));
                }
                reset() {
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                _collect(e, t = [], r = []) {
                    const s = e[0], n = this._get(s);
                    o(n, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join(".")), r = [
                        n,
                        ...r
                    ];
                    const a = e.slice(1);
                    return a.length ? n.schema._ids._collect(a, [
                        ...t,
                        s
                    ], r) : r;
                }
                _get(e) {
                    return this._byId.get(e) || this._byKey.get(e);
                }
            }, l.fork = function(e, r, s) {
                const n = t.schema(e, {
                    each: (e, { key: t })=>{
                        if (r === (e._flags.id || t)) return s;
                    },
                    ref: !1
                });
                return n ? n.$_mutateRebuild() : e;
            }, t.schema = function(e, t) {
                let r;
                for(const s in e._flags){
                    if ("_" === s[0]) continue;
                    const n = l.scan(e._flags[s], {
                        source: "flags",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r._flags[s] = n);
                }
                for(let s = 0; s < e._rules.length; ++s){
                    const n = e._rules[s], o = l.scan(n.args, {
                        source: "rules",
                        name: n.name
                    }, t);
                    if (void 0 !== o) {
                        r = r || e.clone();
                        const t = Object.assign({}, n);
                        t.args = o, r._rules[s] = t, r._singleRules.get(n.name) === n && r._singleRules.set(n.name, t);
                    }
                }
                for(const s in e.$_terms){
                    if ("_" === s[0]) continue;
                    const n = l.scan(e.$_terms[s], {
                        source: "terms",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r.$_terms[s] = n);
                }
                return r;
            }, l.scan = function(e, t, r, o, c) {
                const u = o || [];
                if (null === e || "object" != typeof e) return;
                let f;
                if (Array.isArray(e)) {
                    for(let s = 0; s < e.length; ++s){
                        const n = "terms" === t.source && "keys" === t.name && e[s].key, o = l.scan(e[s], t, r, [
                            s,
                            ...u
                        ], n);
                        void 0 !== o && (f = f || e.slice(), f[s] = o);
                    }
                    return f;
                }
                if (!1 !== r.schema && a.isSchema(e) || !1 !== r.ref && i.isRef(e)) {
                    const o = r.each(e, function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? s(Object(r), !0).forEach(function(t) {
                                n(e, t, r[t]);
                            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function(t) {
                                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                            });
                        }
                        return e;
                    }({}, t, {
                        path: u,
                        key: c
                    }));
                    if (o === e) return;
                    return o;
                }
                for(const s in e){
                    if ("_" === s[0]) continue;
                    const n = l.scan(e[s], t, r, [
                        s,
                        ...u
                    ], c);
                    void 0 !== n && (f = f || Object.assign({}, e), f[s] = n);
                }
                return f;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(37), a = r(6), i = r(1), l = r(4), c = r(38), u = {
                result: Symbol("result")
            };
            t.entry = function(e, t, r) {
                let n = i.defaults;
                r && (s(void 0 === r.warnings, "Cannot override warnings preference in synchronous validation"), n = i.preferences(i.defaults, r));
                const o = u.entry(e, t, n);
                s(!o.mainstay.externals.length, "Schema with external rules must use validateAsync()");
                const a = {
                    value: o.value
                };
                return o.error && (a.error = o.error), o.mainstay.warnings.length && (a.warning = l.details(o.mainstay.warnings)), o.mainstay.debug && (a.debug = o.mainstay.debug), a;
            }, t.entryAsync = async function(e, t, r) {
                let s = i.defaults;
                r && (s = i.preferences(i.defaults, r));
                const n = u.entry(e, t, s), o = n.mainstay;
                if (n.error) throw o.debug && (n.error.debug = o.debug), n.error;
                if (o.externals.length) {
                    let e = n.value;
                    for (const { method: t, path: r, label: s } of o.externals){
                        let n, o, i = e;
                        r.length && (n = r[r.length - 1], o = a(e, r.slice(0, -1)), i = o[n]);
                        try {
                            const r = await t(i);
                            if (void 0 === r || r === i) continue;
                            o ? o[n] = r : e = r;
                        } catch (e) {
                            throw e.message += " (".concat(s, ")"), e;
                        }
                    }
                    n.value = e;
                }
                if (!s.warnings && !s.debug) return n.value;
                const c = {
                    value: n.value
                };
                return o.warnings.length && (c.warning = l.details(o.warnings)), o.debug && (c.debug = o.debug), c;
            }, u.entry = function(e, r, s) {
                const { tracer: n, cleanup: o } = u.tracer(r, s), a = {
                    externals: [],
                    warnings: [],
                    tracer: n,
                    debug: s.debug ? [] : null,
                    links: r._ids._schemaChain ? new Map : null
                }, i = r._ids._schemaChain ? [
                    {
                        schema: r
                    }
                ] : null, f = new c([], [], {
                    mainstay: a,
                    schemas: i
                }), m = t.validate(e, r, f, s);
                o && r.$_root.untrace();
                const h = l.process(m.errors, e, s);
                return {
                    value: m.value,
                    error: h,
                    mainstay: a
                };
            }, u.tracer = function(e, t) {
                return e.$_root._tracer ? {
                    tracer: e.$_root._tracer._register(e)
                } : t.debug ? (s(e.$_root.trace, "Debug mode not supported"), {
                    tracer: e.$_root.trace()._register(e),
                    cleanup: !0
                }) : {
                    tracer: u.ignore
                };
            }, t.validate = function(e, t, r, s, n = {}) {
                if (t.$_terms.whens && (t = t._generate(e, r, s).schema), t._preferences && (s = u.prefs(t, s)), t._cache && s.cache) {
                    const s = t._cache.get(e);
                    if (r.mainstay.tracer.debug(r, "validate", "cached", !!s), s) return s;
                }
                const o = (n, o, a)=>t.$_createError(n, e, o, a || r, s), a = {
                    original: e,
                    prefs: s,
                    schema: t,
                    state: r,
                    error: o,
                    warn: (e, t, s)=>r.mainstay.warnings.push(o(e, t, s)),
                    message: (n, o)=>t.$_createError("custom", e, o, r, s, {
                            messages: n
                        })
                };
                r.mainstay.tracer.entry(t, r);
                const l = t._definition;
                if (l.prepare && void 0 !== e && s.convert) {
                    const t = l.prepare(e, a);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "prepare", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), a);
                        e = t.value;
                    }
                }
                if (l.coerce && void 0 !== e && s.convert && (!l.coerce.from || l.coerce.from.includes(typeof e))) {
                    const t = l.coerce.method(e, a);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "coerced", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), a);
                        e = t.value;
                    }
                }
                const c = t._flags.empty;
                c && c.$_match(u.trim(e, t), r.nest(c), i.defaults) && (r.mainstay.tracer.value(r, "empty", e, void 0), e = void 0);
                const f = n.presence || t._flags.presence || (t._flags._endedSwitch ? "ignore" : s.presence);
                if (void 0 === e) {
                    if ("forbidden" === f) return u.finalize(e, null, a);
                    if ("required" === f) return u.finalize(e, [
                        t.$_createError("any.required", e, null, r, s)
                    ], a);
                    if ("optional" === f) {
                        if (t._flags.default !== i.symbols.deepDefault) return u.finalize(e, null, a);
                        r.mainstay.tracer.value(r, "default", e, {}), e = {};
                    }
                } else if ("forbidden" === f) return u.finalize(e, [
                    t.$_createError("any.unknown", e, null, r, s)
                ], a);
                const m = [];
                if (t._valids) {
                    const n = t._valids.get(e, r, s, t._flags.insensitive);
                    if (n) return s.convert && (r.mainstay.tracer.value(r, "valids", e, n.value), e = n.value), r.mainstay.tracer.filter(t, r, "valid", n), u.finalize(e, null, a);
                    if (t._flags.only) {
                        const n = t.$_createError("any.only", e, {
                            valids: t._valids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            n
                        ], a);
                        m.push(n);
                    }
                }
                if (t._invalids) {
                    const n = t._invalids.get(e, r, s, t._flags.insensitive);
                    if (n) {
                        r.mainstay.tracer.filter(t, r, "invalid", n);
                        const o = t.$_createError("any.invalid", e, {
                            invalids: t._invalids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            o
                        ], a);
                        m.push(o);
                    }
                }
                if (l.validate) {
                    const t = l.validate(e, a);
                    if (t && (r.mainstay.tracer.value(r, "base", e, t.value), e = t.value, t.errors)) {
                        if (!Array.isArray(t.errors)) return m.push(t.errors), u.finalize(e, m, a);
                        if (t.errors.length) return m.push(...t.errors), u.finalize(e, m, a);
                    }
                }
                return t._rules.length ? u.rules(e, m, a) : u.finalize(e, m, a);
            }, u.rules = function(e, t, r) {
                const { schema: s, state: n, prefs: o } = r;
                for (const a of s._rules){
                    const l = s._definition.rules[a.method];
                    if (l.convert && o.convert) {
                        n.mainstay.tracer.log(s, n, "rule", a.name, "full");
                        continue;
                    }
                    let c, f = a.args;
                    if (a._resolve.length) {
                        f = Object.assign({}, f);
                        for (const t of a._resolve){
                            const r = l.argsByName.get(t), a = f[t].resolve(e, n, o), u = r.normalize ? r.normalize(a) : a, m = i.validateArg(u, null, r);
                            if (m) {
                                c = s.$_createError("any.ref", a, {
                                    arg: t,
                                    ref: f[t],
                                    reason: m
                                }, n, o);
                                break;
                            }
                            f[t] = u;
                        }
                    }
                    c = c || l.validate(e, r, f, a);
                    const m = u.rule(c, a);
                    if (m.errors) {
                        if (n.mainstay.tracer.log(s, n, "rule", a.name, "error"), a.warn) {
                            n.mainstay.warnings.push(...m.errors);
                            continue;
                        }
                        if (o.abortEarly) return u.finalize(e, m.errors, r);
                        t.push(...m.errors);
                    } else n.mainstay.tracer.log(s, n, "rule", a.name, "pass"), n.mainstay.tracer.value(n, "rule", e, m.value, a.name), e = m.value;
                }
                return u.finalize(e, t, r);
            }, u.rule = function(e, t) {
                return e instanceof l.Report ? (u.error(e, t), {
                    errors: [
                        e
                    ],
                    value: null
                }) : Array.isArray(e) && (e[0] instanceof l.Report || e[0] instanceof Error) ? (e.forEach((e)=>u.error(e, t)), {
                    errors: e,
                    value: null
                }) : {
                    errors: null,
                    value: e
                };
            }, u.error = function(e, t) {
                return t.message && e._setTemplate(t.message), e;
            }, u.finalize = function(e, t, r) {
                t = t || [];
                const { schema: n, state: o, prefs: a } = r;
                if (t.length) {
                    const s = u.default("failover", void 0, t, r);
                    void 0 !== s && (o.mainstay.tracer.value(o, "failover", e, s), e = s, t = []);
                }
                if (t.length && n._flags.error) {
                    if ("function" == typeof n._flags.error) {
                        t = n._flags.error(t), Array.isArray(t) || (t = [
                            t
                        ]);
                        for (const e of t)s(e instanceof Error || e instanceof l.Report, "error() must return an Error object");
                    } else t = [
                        n._flags.error
                    ];
                }
                if (void 0 === e) {
                    const s = u.default("default", e, t, r);
                    o.mainstay.tracer.value(o, "default", e, s), e = s;
                }
                if (n._flags.cast && void 0 !== e) {
                    const t = n._definition.cast[n._flags.cast];
                    if (t.from(e)) {
                        const s = t.to(e, r);
                        o.mainstay.tracer.value(o, "cast", e, s, n._flags.cast), e = s;
                    }
                }
                if (n.$_terms.externals && a.externals && !1 !== a._externals) for (const { method: e } of n.$_terms.externals)o.mainstay.externals.push({
                    method: e,
                    path: o.path,
                    label: l.label(n._flags, o, a)
                });
                const i = {
                    value: e,
                    errors: t.length ? t : null
                };
                return n._flags.result && (i.value = "strip" === n._flags.result ? void 0 : r.original, o.mainstay.tracer.value(o, n._flags.result, e, i.value), o.shadow(e, n._flags.result)), n._cache && !1 !== a.cache && !n._refs.length && n._cache.set(r.original, i), i;
            }, u.prefs = function(e, t) {
                const r = t === i.defaults;
                return r && e._preferences[i.symbols.prefs] ? e._preferences[i.symbols.prefs] : (t = i.preferences(t, e._preferences), r && (e._preferences[i.symbols.prefs] = t), t);
            }, u.default = function(e, t, r, s) {
                const { schema: o, state: a, prefs: l } = s, c = o._flags[e];
                if (l.noDefaults || void 0 === c) return t;
                if (a.mainstay.tracer.log(o, a, "rule", e, "full"), !c) return c;
                if ("function" == typeof c) {
                    const t = c.length ? [
                        n(a.ancestors[0]),
                        s
                    ] : [];
                    try {
                        return c(...t);
                    } catch (t) {
                        return void r.push(o.$_createError("any.".concat(e), null, {
                            error: t
                        }, a, l));
                    }
                }
                return "object" != typeof c ? c : c[i.symbols.literal] ? c.literal : i.isResolvable(c) ? c.resolve(t, a, l) : n(c);
            }, u.trim = function(e, t) {
                if ("string" != typeof e) return e;
                const r = t.$_getRule("trim");
                return r && r.args.enabled ? e.trim() : e;
            }, u.ignore = {
                active: !1,
                debug: o,
                entry: o,
                filter: o,
                log: o,
                resolve: o,
                value: o
            };
        },
        function(e, t, r) {
            "use strict";
            e.exports = function() {};
        },
        function(e, t, r) {
            "use strict";
            const s = r(2), n = r(6), o = r(1), a = {
                value: Symbol("value")
            };
            e.exports = a.State = class {
                constructor(e, t, r){
                    this.path = e, this.ancestors = t, this.mainstay = r.mainstay, this.schemas = r.schemas, this.debug = null;
                }
                localize(e, t = null, r = null) {
                    const s = new a.State(e, t, this);
                    return r && s.schemas && (s.schemas = [
                        a.schemas(r),
                        ...s.schemas
                    ]), s;
                }
                nest(e, t) {
                    const r = new a.State(this.path, this.ancestors, this);
                    return r.schemas = r.schemas && [
                        a.schemas(e),
                        ...r.schemas
                    ], r.debug = t, r;
                }
                shadow(e, t) {
                    this.mainstay.shadow = this.mainstay.shadow || new a.Shadow, this.mainstay.shadow.set(this.path, e, t);
                }
                snapshot() {
                    this.mainstay.shadow && (this._snapshot = s(this.mainstay.shadow.node(this.path)));
                }
                restore() {
                    this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0);
                }
            }, a.schemas = function(e) {
                return o.isSchema(e) ? {
                    schema: e
                } : e;
            }, a.Shadow = class {
                constructor(){
                    this._values = null;
                }
                set(e, t, r) {
                    if (!e.length) return;
                    if ("strip" === r && "number" == typeof e[e.length - 1]) return;
                    this._values = this._values || new Map;
                    let s = this._values;
                    for(let t = 0; t < e.length; ++t){
                        const r = e[t];
                        let n = s.get(r);
                        n || (n = new Map, s.set(r, n)), s = n;
                    }
                    s[a.value] = t;
                }
                get(e) {
                    const t = this.node(e);
                    if (t) return t[a.value];
                }
                node(e) {
                    if (this._values) return n(this._values, e, {
                        iterables: !0
                    });
                }
                override(e, t) {
                    if (!this._values) return;
                    const r = e.slice(0, -1), s = e[e.length - 1], o = n(this._values, r, {
                        iterables: !0
                    });
                    t ? o.set(s, t) : o && o.delete(s);
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(10), o = r(6), a = r(3), i = r(1), l = r(8), c = {};
            e.exports = a.extend({
                type: "array",
                flags: {
                    single: {
                        default: !1
                    },
                    sparse: {
                        default: !1
                    }
                },
                terms: {
                    items: {
                        init: [],
                        manifest: "schema"
                    },
                    ordered: {
                        init: [],
                        manifest: "schema"
                    },
                    _exclusions: {
                        init: []
                    },
                    _inclusions: {
                        init: []
                    },
                    _requireds: {
                        init: []
                    }
                },
                coerce: {
                    from: "object",
                    method (e, { schema: t, state: r, prefs: s }) {
                        if (!Array.isArray(e)) return;
                        const n = t.$_getRule("sort");
                        return n ? c.sort(t, e, n.args.options, r, s) : void 0;
                    }
                },
                validate (e, { schema: t, error: r }) {
                    if (!Array.isArray(e)) {
                        if (t._flags.single) {
                            const t = [
                                e
                            ];
                            return t[i.symbols.arraySingle] = !0, {
                                value: t
                            };
                        }
                        return {
                            errors: r("array.base")
                        };
                    }
                    if (t.$_getRule("items") || t.$_terms.externals) return {
                        value: e.slice()
                    };
                },
                rules: {
                    has: {
                        method (e) {
                            e = this.$_compile(e, {
                                appendPath: !0
                            });
                            const t = this.$_addRule({
                                name: "has",
                                args: {
                                    schema: e
                                }
                            });
                            return t.$_mutateRegister(e), t;
                        },
                        validate (e, { state: t, prefs: r, error: s }, { schema: n }) {
                            const o = [
                                e,
                                ...t.ancestors
                            ];
                            for(let s = 0; s < e.length; ++s){
                                const a = t.localize([
                                    ...t.path,
                                    s
                                ], o, n);
                                if (n.$_match(e[s], a, r)) return e;
                            }
                            const a = n._flags.label;
                            return a ? s("array.hasKnown", {
                                patternLabel: a
                            }) : s("array.hasUnknown", null);
                        },
                        multi: !0
                    },
                    items: {
                        method (...e) {
                            i.verifyFlat(e, "items");
                            const t = this.$_addRule("items");
                            for(let r = 0; r < e.length; ++r){
                                const s = i.tryWithPath(()=>this.$_compile(e[r]), r, {
                                    append: !0
                                });
                                t.$_terms.items.push(s);
                            }
                            return t.$_mutateRebuild();
                        },
                        validate (e, { schema: t, error: r, state: s, prefs: n }) {
                            const o = t.$_terms._requireds.slice(), a = t.$_terms.ordered.slice(), l = [
                                ...t.$_terms._inclusions,
                                ...o
                            ], u = !e[i.symbols.arraySingle];
                            delete e[i.symbols.arraySingle];
                            const f = [];
                            let m = e.length;
                            for(let i = 0; i < m; ++i){
                                const h = e[i];
                                let d = !1, p = !1;
                                const g = u ? i : new Number(i), y = [
                                    ...s.path,
                                    g
                                ];
                                if (!t._flags.sparse && void 0 === h) {
                                    if (f.push(r("array.sparse", {
                                        key: g,
                                        path: y,
                                        pos: i,
                                        value: void 0
                                    }, s.localize(y))), n.abortEarly) return f;
                                    a.shift();
                                    continue;
                                }
                                const b = [
                                    e,
                                    ...s.ancestors
                                ];
                                for (const e of t.$_terms._exclusions)if (e.$_match(h, s.localize(y, b, e), n, {
                                    presence: "ignore"
                                })) {
                                    if (f.push(r("array.excludes", {
                                        pos: i,
                                        value: h
                                    }, s.localize(y))), n.abortEarly) return f;
                                    d = !0, a.shift();
                                    break;
                                }
                                if (d) continue;
                                if (t.$_terms.ordered.length) {
                                    if (a.length) {
                                        const o = a.shift(), l = o.$_validate(h, s.localize(y, b, o), n);
                                        if (l.errors) {
                                            if (f.push(...l.errors), n.abortEarly) return f;
                                        } else if ("strip" === o._flags.result) c.fastSplice(e, i), --i, --m;
                                        else {
                                            if (!t._flags.sparse && void 0 === l.value) {
                                                if (f.push(r("array.sparse", {
                                                    key: g,
                                                    path: y,
                                                    pos: i,
                                                    value: void 0
                                                }, s.localize(y))), n.abortEarly) return f;
                                                continue;
                                            }
                                            e[i] = l.value;
                                        }
                                        continue;
                                    }
                                    if (!t.$_terms.items.length) {
                                        if (f.push(r("array.orderedLength", {
                                            pos: i,
                                            limit: t.$_terms.ordered.length
                                        })), n.abortEarly) return f;
                                        break;
                                    }
                                }
                                const v = [];
                                let _ = o.length;
                                for(let a = 0; a < _; ++a){
                                    const l = s.localize(y, b, o[a]);
                                    l.snapshot();
                                    const u = o[a].$_validate(h, l, n);
                                    if (v[a] = u, !u.errors) {
                                        if (e[i] = u.value, p = !0, c.fastSplice(o, a), --a, --_, !t._flags.sparse && void 0 === u.value && (f.push(r("array.sparse", {
                                            key: g,
                                            path: y,
                                            pos: i,
                                            value: void 0
                                        }, s.localize(y))), n.abortEarly)) return f;
                                        break;
                                    }
                                    l.restore();
                                }
                                if (p) continue;
                                const w = n.stripUnknown && !!n.stripUnknown.arrays || !1;
                                _ = l.length;
                                for (const a of l){
                                    let l;
                                    const u = o.indexOf(a);
                                    if (-1 !== u) l = v[u];
                                    else {
                                        const o = s.localize(y, b, a);
                                        if (o.snapshot(), l = a.$_validate(h, o, n), !l.errors) {
                                            "strip" === a._flags.result ? (c.fastSplice(e, i), --i, --m) : t._flags.sparse || void 0 !== l.value ? e[i] = l.value : (f.push(r("array.sparse", {
                                                key: g,
                                                path: y,
                                                pos: i,
                                                value: void 0
                                            }, s.localize(y))), d = !0), p = !0;
                                            break;
                                        }
                                        o.restore();
                                    }
                                    if (1 === _) {
                                        if (w) {
                                            c.fastSplice(e, i), --i, --m, p = !0;
                                            break;
                                        }
                                        if (f.push(...l.errors), n.abortEarly) return f;
                                        d = !0;
                                        break;
                                    }
                                }
                                if (!d && t.$_terms._inclusions.length && !p) {
                                    if (w) {
                                        c.fastSplice(e, i), --i, --m;
                                        continue;
                                    }
                                    if (f.push(r("array.includes", {
                                        pos: i,
                                        value: h
                                    }, s.localize(y))), n.abortEarly) return f;
                                }
                            }
                            return o.length && c.fillMissedErrors(t, f, o, e, s, n), a.length && c.fillOrderedErrors(t, f, a, e, s, n), f.length ? f : e;
                        },
                        priority: !0,
                        manifest: !1
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate: (e, t, { limit: r }, { name: s, operator: n, args: o })=>i.compare(e.length, r, n) ? e : t.error("array." + s, {
                                limit: o.limit,
                                value: e
                            }),
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: i.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    ordered: {
                        method (...e) {
                            i.verifyFlat(e, "ordered");
                            const t = this.$_addRule("items");
                            for(let r = 0; r < e.length; ++r){
                                const s = i.tryWithPath(()=>this.$_compile(e[r]), r, {
                                    append: !0
                                });
                                c.validateSingle(s, t), t.$_mutateRegister(s), t.$_terms.ordered.push(s);
                            }
                            return t.$_mutateRebuild();
                        }
                    },
                    single: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return s(!t || !this._flags._arrayItems, "Cannot specify single rule when array has array items"), this.$_setFlag("single", t);
                        }
                    },
                    sort: {
                        method (e = {}) {
                            i.assertOptions(e, [
                                "by",
                                "order"
                            ]);
                            const t = {
                                order: e.order || "ascending"
                            };
                            return e.by && (t.by = l.ref(e.by, {
                                ancestor: 0
                            }), s(!t.by.ancestor, "Cannot sort by ancestor")), this.$_addRule({
                                name: "sort",
                                args: {
                                    options: t
                                }
                            });
                        },
                        validate (e, { error: t, state: r, prefs: s, schema: n }, { options: o }) {
                            const { value: a, errors: i } = c.sort(n, e, o, r, s);
                            if (i) return i;
                            for(let r = 0; r < e.length; ++r)if (e[r] !== a[r]) return t("array.sort", {
                                order: o.order,
                                by: o.by ? o.by.key : "value"
                            });
                            return e;
                        },
                        convert: !0
                    },
                    sparse: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return this._flags.sparse === t ? this : (t ? this.clone() : this.$_addRule("items")).$_setFlag("sparse", t, {
                                clone: !1
                            });
                        }
                    },
                    unique: {
                        method (e, t = {}) {
                            s(!e || "function" == typeof e || "string" == typeof e, "comparator must be a function or a string"), i.assertOptions(t, [
                                "ignoreUndefined",
                                "separator"
                            ]);
                            const r = {
                                name: "unique",
                                args: {
                                    options: t,
                                    comparator: e
                                }
                            };
                            if (e) {
                                if ("string" == typeof e) {
                                    const s = i.default(t.separator, ".");
                                    r.path = s ? e.split(s) : [
                                        e
                                    ];
                                } else r.comparator = e;
                            }
                            return this.$_addRule(r);
                        },
                        validate (e, { state: t, error: r, schema: a }, { comparator: i, options: l }, { comparator: c, path: u }) {
                            const f = {
                                string: Object.create(null),
                                number: Object.create(null),
                                undefined: Object.create(null),
                                boolean: Object.create(null),
                                object: new Map,
                                function: new Map,
                                custom: new Map
                            }, m = c || n, h = l.ignoreUndefined;
                            for(let n = 0; n < e.length; ++n){
                                const a = u ? o(e[n], u) : e[n], l = c ? f.custom : f[typeof a];
                                if (s(l, "Failed to find unique map container for type", typeof a), l instanceof Map) {
                                    const s = l.entries();
                                    let o;
                                    for(; !(o = s.next()).done;)if (m(o.value[0], a)) {
                                        const s = t.localize([
                                            ...t.path,
                                            n
                                        ], [
                                            e,
                                            ...t.ancestors
                                        ]), a = {
                                            pos: n,
                                            value: e[n],
                                            dupePos: o.value[1],
                                            dupeValue: e[o.value[1]]
                                        };
                                        return u && (a.path = i), r("array.unique", a, s);
                                    }
                                    l.set(a, n);
                                } else {
                                    if ((!h || void 0 !== a) && void 0 !== l[a]) {
                                        const s = {
                                            pos: n,
                                            value: e[n],
                                            dupePos: l[a],
                                            dupeValue: e[l[a]]
                                        };
                                        return u && (s.path = i), r("array.unique", s, t.localize([
                                            ...t.path,
                                            n
                                        ], [
                                            e,
                                            ...t.ancestors
                                        ]));
                                    }
                                    l[a] = n;
                                }
                            }
                            return e;
                        },
                        args: [
                            "comparator",
                            "options"
                        ],
                        multi: !0
                    }
                },
                cast: {
                    set: {
                        from: Array.isArray,
                        to: (e, t)=>new Set(e)
                    }
                },
                rebuild (e) {
                    e.$_terms._inclusions = [], e.$_terms._exclusions = [], e.$_terms._requireds = [];
                    for (const t of e.$_terms.items)c.validateSingle(t, e), "required" === t._flags.presence ? e.$_terms._requireds.push(t) : "forbidden" === t._flags.presence ? e.$_terms._exclusions.push(t) : e.$_terms._inclusions.push(t);
                    for (const t of e.$_terms.ordered)c.validateSingle(t, e);
                },
                manifest: {
                    build: (e, t)=>(t.items && (e = e.items(...t.items)), t.ordered && (e = e.ordered(...t.ordered)), e)
                },
                messages: {
                    "array.base": "{{#label}} must be an array",
                    "array.excludes": "{{#label}} contains an excluded value",
                    "array.hasKnown": '{{#label}} does not contain at least one required match for type "{#patternLabel}"',
                    "array.hasUnknown": "{{#label}} does not contain at least one required match",
                    "array.includes": "{{#label}} does not match any of the allowed types",
                    "array.includesRequiredBoth": "{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)",
                    "array.includesRequiredKnowns": "{{#label}} does not contain {{#knownMisses}}",
                    "array.includesRequiredUnknowns": "{{#label}} does not contain {{#unknownMisses}} required value(s)",
                    "array.length": "{{#label}} must contain {{#limit}} items",
                    "array.max": "{{#label}} must contain less than or equal to {{#limit}} items",
                    "array.min": "{{#label}} must contain at least {{#limit}} items",
                    "array.orderedLength": "{{#label}} must contain at most {{#limit}} items",
                    "array.sort": "{{#label}} must be sorted in {#order} order by {{#by}}",
                    "array.sort.mismatching": "{{#label}} cannot be sorted due to mismatching types",
                    "array.sort.unsupported": "{{#label}} cannot be sorted due to unsupported type {#type}",
                    "array.sparse": "{{#label}} must not be a sparse array item",
                    "array.unique": "{{#label}} contains a duplicate value"
                }
            }), c.fillMissedErrors = function(e, t, r, s, n, o) {
                const a = [];
                let i = 0;
                for (const e of r){
                    const t = e._flags.label;
                    t ? a.push(t) : ++i;
                }
                a.length ? i ? t.push(e.$_createError("array.includesRequiredBoth", s, {
                    knownMisses: a,
                    unknownMisses: i
                }, n, o)) : t.push(e.$_createError("array.includesRequiredKnowns", s, {
                    knownMisses: a
                }, n, o)) : t.push(e.$_createError("array.includesRequiredUnknowns", s, {
                    unknownMisses: i
                }, n, o));
            }, c.fillOrderedErrors = function(e, t, r, s, n, o) {
                const a = [];
                for (const e of r)"required" === e._flags.presence && a.push(e);
                a.length && c.fillMissedErrors(e, t, a, s, n, o);
            }, c.fastSplice = function(e, t) {
                let r = t;
                for(; r < e.length;)e[r++] = e[r];
                --e.length;
            }, c.validateSingle = function(e, t) {
                ("array" === e.type || e._flags._arrayItems) && (s(!t._flags.single, "Cannot specify array item with single rule enabled"), t.$_setFlag("_arrayItems", !0, {
                    clone: !1
                }));
            }, c.sort = function(e, t, r, s, n) {
                const o = "ascending" === r.order ? 1 : -1, a = -1 * o, i = o, l = (l, u)=>{
                    let f = c.compare(l, u, a, i);
                    if (null !== f) return f;
                    if (r.by && (l = r.by.resolve(l, s, n), u = r.by.resolve(u, s, n)), f = c.compare(l, u, a, i), null !== f) return f;
                    const m = typeof l;
                    if (m !== typeof u) throw e.$_createError("array.sort.mismatching", t, null, s, n);
                    if ("number" !== m && "string" !== m) throw e.$_createError("array.sort.unsupported", t, {
                        type: m
                    }, s, n);
                    return "number" === m ? (l - u) * o : l < u ? a : i;
                };
                try {
                    return {
                        value: t.slice().sort(l)
                    };
                } catch (e) {
                    return {
                        errors: e
                    };
                }
            }, c.compare = function(e, t, r, s) {
                return e === t ? 0 : void 0 === e ? 1 : void 0 === t ? -1 : null === e ? s : null === t ? r : null;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = r(21), i = {
                isBool: function(e) {
                    return "boolean" == typeof e;
                }
            };
            e.exports = n.extend({
                type: "boolean",
                flags: {
                    sensitive: {
                        default: !1
                    }
                },
                terms: {
                    falsy: {
                        init: null,
                        manifest: "values"
                    },
                    truthy: {
                        init: null,
                        manifest: "values"
                    }
                },
                coerce (e, { schema: t }) {
                    if ("boolean" != typeof e) {
                        if ("string" == typeof e) {
                            const r = t._flags.sensitive ? e : e.toLowerCase();
                            e = "true" === r || "false" !== r && e;
                        }
                        return "boolean" != typeof e && (e = t.$_terms.truthy && t.$_terms.truthy.has(e, null, null, !t._flags.sensitive) || (!t.$_terms.falsy || !t.$_terms.falsy.has(e, null, null, !t._flags.sensitive)) && e), {
                            value: e
                        };
                    }
                },
                validate (e, { error: t }) {
                    if ("boolean" != typeof e) return {
                        value: e,
                        errors: t("boolean.base")
                    };
                },
                rules: {
                    truthy: {
                        method (...e) {
                            o.verifyFlat(e, "truthy");
                            const t = this.clone();
                            t.$_terms.truthy = t.$_terms.truthy || new a;
                            for(let r = 0; r < e.length; ++r){
                                const n = e[r];
                                s(void 0 !== n, "Cannot call truthy with undefined"), t.$_terms.truthy.add(n);
                            }
                            return t;
                        }
                    },
                    falsy: {
                        method (...e) {
                            o.verifyFlat(e, "falsy");
                            const t = this.clone();
                            t.$_terms.falsy = t.$_terms.falsy || new a;
                            for(let r = 0; r < e.length; ++r){
                                const n = e[r];
                                s(void 0 !== n, "Cannot call falsy with undefined"), t.$_terms.falsy.add(n);
                            }
                            return t;
                        }
                    },
                    sensitive: {
                        method (e = !0) {
                            return this.$_setFlag("sensitive", e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: i.isBool,
                        to: (e, t)=>e ? 1 : 0
                    },
                    string: {
                        from: i.isBool,
                        to: (e, t)=>e ? "true" : "false"
                    }
                },
                manifest: {
                    build: (e, t)=>(t.truthy && (e = e.truthy(...t.truthy)), t.falsy && (e = e.falsy(...t.falsy)), e)
                },
                messages: {
                    "boolean.base": "{{#label}} must be a boolean"
                }
            });
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = r(7), i = {
                isDate: function(e) {
                    return e instanceof Date;
                }
            };
            e.exports = n.extend({
                type: "date",
                coerce: {
                    from: [
                        "number",
                        "string"
                    ],
                    method: (e, { schema: t })=>({
                            value: i.parse(e, t._flags.format) || e
                        })
                },
                validate (e, { schema: t, error: r, prefs: s }) {
                    if (e instanceof Date && !isNaN(e.getTime())) return;
                    const n = t._flags.format;
                    return s.convert && n && "string" == typeof e ? {
                        value: e,
                        errors: r("date.format", {
                            format: n
                        })
                    } : {
                        value: e,
                        errors: r("date.base")
                    };
                },
                rules: {
                    compare: {
                        method: !1,
                        validate (e, t, { date: r }, { name: s, operator: n, args: a }) {
                            const i = "now" === r ? Date.now() : r.getTime();
                            return o.compare(e.getTime(), i, n) ? e : t.error("date." + s, {
                                limit: a.date,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "date",
                                ref: !0,
                                normalize: (e)=>"now" === e ? e : i.parse(e),
                                assert: (e)=>null !== e,
                                message: "must have a valid date format"
                            }
                        ]
                    },
                    format: {
                        method (e) {
                            return s([
                                "iso",
                                "javascript",
                                "unix"
                            ].includes(e), "Unknown date format", e), this.$_setFlag("format", e);
                        }
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    iso: {
                        method () {
                            return this.format("iso");
                        }
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    timestamp: {
                        method (e = "javascript") {
                            return s([
                                "javascript",
                                "unix"
                            ].includes(e), '"type" must be one of "javascript, unix"'), this.format(e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: i.isDate,
                        to: (e, t)=>e.getTime()
                    },
                    string: {
                        from: i.isDate,
                        to: (e, { prefs: t })=>a.date(e, t)
                    }
                },
                messages: {
                    "date.base": "{{#label}} must be a valid date",
                    "date.format": '{{#label}} must be in {msg("date.format." + #format) || #format} format',
                    "date.greater": '{{#label}} must be greater than "{{#limit}}"',
                    "date.less": '{{#label}} must be less than "{{#limit}}"',
                    "date.max": '{{#label}} must be less than or equal to "{{#limit}}"',
                    "date.min": '{{#label}} must be larger than or equal to "{{#limit}}"',
                    "date.format.iso": "ISO 8601 date",
                    "date.format.javascript": "timestamp or number of milliseconds",
                    "date.format.unix": "timestamp or number of seconds"
                }
            }), i.parse = function(e, t) {
                if (e instanceof Date) return e;
                if ("string" != typeof e && (isNaN(e) || !isFinite(e))) return null;
                if (/^\s*$/.test(e)) return null;
                if ("iso" === t) return o.isIsoDate(e) ? i.date(e.toString()) : null;
                const r = e;
                if ("string" == typeof e && /^[+-]?\d+(\.\d+)?$/.test(e) && (e = parseFloat(e)), t) {
                    if ("javascript" === t) return i.date(1 * e);
                    if ("unix" === t) return i.date(1e3 * e);
                    if ("string" == typeof r) return null;
                }
                return i.date(e);
            }, i.date = function(e) {
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(22);
            e.exports = n.extend({
                type: "function",
                properties: {
                    typeof: "function"
                },
                rules: {
                    arity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "arity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate: (e, t, { n: r })=>e.length === r ? e : t.error("function.arity", {
                                n: r
                            })
                    },
                    class: {
                        method () {
                            return this.$_addRule("class");
                        },
                        validate: (e, t)=>/^\s*class\s/.test(e.toString()) ? e : t.error("function.class", {
                                value: e
                            })
                    },
                    minArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e > 0, "n must be a strict positive integer"), this.$_addRule({
                                name: "minArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate: (e, t, { n: r })=>e.length >= r ? e : t.error("function.minArity", {
                                n: r
                            })
                    },
                    maxArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "maxArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate: (e, t, { n: r })=>e.length <= r ? e : t.error("function.maxArity", {
                                n: r
                            })
                    }
                },
                messages: {
                    "function.arity": "{{#label}} must have an arity of {{#n}}",
                    "function.class": "{{#label}} must be a class",
                    "function.maxArity": "{{#label}} must have an arity lesser or equal to {{#n}}",
                    "function.minArity": "{{#label}} must have an arity greater or equal to {{#n}}"
                }
            });
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(20), a = r(6), i = {};
            e.exports = function(e, t, r = {}) {
                if (s(e && "object" == typeof e, "Invalid defaults value: must be an object"), s(!t || !0 === t || "object" == typeof t, "Invalid source value: must be true, falsy or an object"), s("object" == typeof r, "Invalid options: must be an object"), !t) return null;
                if (r.shallow) return i.applyToDefaultsWithShallow(e, t, r);
                const a = n(e);
                if (!0 === t) return a;
                const l = void 0 !== r.nullOverride && r.nullOverride;
                return o(a, t, {
                    nullOverride: l,
                    mergeArrays: !1
                });
            }, i.applyToDefaultsWithShallow = function(e, t, r) {
                const l = r.shallow;
                s(Array.isArray(l), "Invalid keys");
                const c = new Map, u = !0 === t ? null : new Set;
                for (let r of l){
                    r = Array.isArray(r) ? r : r.split(".");
                    const s = a(e, r);
                    s && "object" == typeof s ? c.set(s, u && a(t, r) || s) : u && u.add(r);
                }
                const f = n(e, {}, c);
                if (!u) return f;
                for (const e of u)i.reachCopy(f, t, e);
                return o(f, t, {
                    mergeArrays: !1,
                    nullOverride: !1
                });
            }, i.reachCopy = function(e, t, r) {
                for (const e of r){
                    if (!(e in t)) return;
                    t = t[e];
                }
                const s = t;
                let n = e;
                for(let e = 0; e < r.length - 1; ++e){
                    const t = r[e];
                    "object" != typeof n[t] && (n[t] = {}), n = n[t];
                }
                n[r[r.length - 1]] = s;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = {};
            t.Sorter = class {
                constructor(){
                    this._items = [], this.nodes = [];
                }
                add(e, t) {
                    const r = [].concat((t = t || {}).before || []), n = [].concat(t.after || []), o = t.group || "?", a = t.sort || 0;
                    s(!r.includes(o), "Item cannot come before itself: ".concat(o)), s(!r.includes("?"), "Item cannot come before unassociated items"), s(!n.includes(o), "Item cannot come after itself: ".concat(o)), s(!n.includes("?"), "Item cannot come after unassociated items"), Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e){
                        const e = {
                            seq: this._items.length,
                            sort: a,
                            before: r,
                            after: n,
                            group: o,
                            node: t
                        };
                        this._items.push(e);
                    }
                    const i = this._sort();
                    return s(i, "item", "?" !== o ? "added into group ".concat(o) : "", "created a dependencies error"), this.nodes;
                }
                merge(e) {
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e)if (t) for (const e of t._items)this._items.push(Object.assign({}, e));
                    this._items.sort(n.mergeSort);
                    for(let e = 0; e < this._items.length; ++e)this._items[e].seq = e;
                    const t = this._sort();
                    return s(t, "merge created a dependencies error"), this.nodes;
                }
                _sort() {
                    const e = {}, t = Object.create(null), r = Object.create(null);
                    for (const s of this._items){
                        const n = s.seq, o = s.group;
                        r[o] = r[o] || [], r[o].push(n), e[n] = s.before;
                        for (const e of s.after)t[e] = t[e] || [], t[e].push(n);
                    }
                    for(const t in e){
                        const s = [];
                        for(const n in e[t]){
                            const o = e[t][n];
                            r[o] = r[o] || [], s.push(...r[o]);
                        }
                        e[t] = s;
                    }
                    for(const s in t)if (r[s]) for (const n of r[s])e[n].push(...t[s]);
                    const s = {};
                    for(const t in e){
                        const r = e[t];
                        for (const e of r)s[e] = s[e] || [], s[e].push(t);
                    }
                    const n = {}, o = [];
                    for(let e = 0; e < this._items.length; ++e){
                        let t = e;
                        if (s[e]) {
                            t = null;
                            for(let e = 0; e < this._items.length; ++e){
                                if (!0 === n[e]) continue;
                                s[e] || (s[e] = []);
                                const r = s[e].length;
                                let o = 0;
                                for(let t = 0; t < r; ++t)n[s[e][t]] && ++o;
                                if (o === r) {
                                    t = e;
                                    break;
                                }
                            }
                        }
                        null !== t && (n[t] = !0, o.push(t));
                    }
                    if (o.length !== this._items.length) return !1;
                    const a = {};
                    for (const e of this._items)a[e.seq] = e;
                    this._items = [], this.nodes = [];
                    for (const e of o){
                        const t = a[e];
                        this.nodes.push(t.node), this._items.push(t);
                    }
                    return !0;
                }
            }, n.mergeSort = (e, t)=>e.sort === t.sort ? 0 : e.sort < t.sort ? -1 : 1;
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = r(8), i = r(4), l = {};
            e.exports = n.extend({
                type: "link",
                properties: {
                    schemaChain: !0
                },
                terms: {
                    link: {
                        init: null,
                        manifest: "single",
                        register: !1
                    }
                },
                args: (e, t)=>e.ref(t),
                validate (e, { schema: t, state: r, prefs: n }) {
                    s(t.$_terms.link, "Uninitialized link schema");
                    const o = l.generate(t, e, r, n), a = t.$_terms.link[0].ref;
                    return o.$_validate(e, r.nest(o, "link:".concat(a.display, ":").concat(o.type)), n);
                },
                generate: (e, t, r, s)=>l.generate(e, t, r, s),
                rules: {
                    ref: {
                        method (e) {
                            s(!this.$_terms.link, "Cannot reinitialize schema"), e = a.ref(e), s("value" === e.type || "local" === e.type, "Invalid reference type:", e.type), s("local" === e.type || "root" === e.ancestor || e.ancestor > 0, "Link cannot reference itself");
                            const t = this.clone();
                            return t.$_terms.link = [
                                {
                                    ref: e
                                }
                            ], t;
                        }
                    },
                    relative: {
                        method (e = !0) {
                            return this.$_setFlag("relative", e);
                        }
                    }
                },
                overrides: {
                    concat (e) {
                        s(this.$_terms.link, "Uninitialized link schema"), s(o.isSchema(e), "Invalid schema object"), s("link" !== e.type, "Cannot merge type link with another link");
                        const t = this.clone();
                        return t.$_terms.whens || (t.$_terms.whens = []), t.$_terms.whens.push({
                            concat: e
                        }), t.$_mutateRebuild();
                    }
                },
                manifest: {
                    build: (e, t)=>(s(t.link, "Invalid link description missing link"), e.ref(t.link))
                }
            }), l.generate = function(e, t, r, s) {
                let n = r.mainstay.links.get(e);
                if (n) return n._generate(t, r, s).schema;
                const o = e.$_terms.link[0].ref, { perspective: a, path: i } = l.perspective(o, r);
                l.assert(a, "which is outside of schema boundaries", o, e, r, s);
                try {
                    n = i.length ? a.$_reach(i) : a;
                } catch (t) {
                    l.assert(!1, "to non-existing schema", o, e, r, s);
                }
                return l.assert("link" !== n.type, "which is another link", o, e, r, s), e._flags.relative || r.mainstay.links.set(e, n), n._generate(t, r, s).schema;
            }, l.perspective = function(e, t) {
                if ("local" === e.type) {
                    for (const { schema: r, key: s } of t.schemas){
                        if ((r._flags.id || s) === e.path[0]) return {
                            perspective: r,
                            path: e.path.slice(1)
                        };
                        if (r.$_terms.shared) {
                            for (const t of r.$_terms.shared)if (t._flags.id === e.path[0]) return {
                                perspective: t,
                                path: e.path.slice(1)
                            };
                        }
                    }
                    return {
                        perspective: null,
                        path: null
                    };
                }
                return "root" === e.ancestor ? {
                    perspective: t.schemas[t.schemas.length - 1].schema,
                    path: e.path
                } : {
                    perspective: t.schemas[e.ancestor] && t.schemas[e.ancestor].schema,
                    path: e.path
                };
            }, l.assert = function(e, t, r, n, o, a) {
                e || s(!1, '"'.concat(i.label(n._flags, o, a), '" contains link reference "').concat(r.display, '" ').concat(t));
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = {
                numberRx: /^\s*[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e([+-]?\d+))?\s*$/i,
                precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/
            };
            e.exports = n.extend({
                type: "number",
                flags: {
                    unsafe: {
                        default: !1
                    }
                },
                coerce: {
                    from: "string",
                    method (e, { schema: t, error: r }) {
                        const s = e.match(a.numberRx);
                        if (!s) return;
                        e = e.trim();
                        const n = {
                            value: parseFloat(e)
                        };
                        if (0 === n.value && (n.value = 0), !t._flags.unsafe) {
                            if (e.match(/e/i)) {
                                if (a.normalizeExponent("".concat(n.value / Math.pow(10, s[1]), "e").concat(s[1])) !== a.normalizeExponent(e)) return n.errors = r("number.unsafe"), n;
                            } else {
                                const t = n.value.toString();
                                if (t.match(/e/i)) return n;
                                if (t !== a.normalizeDecimal(e)) return n.errors = r("number.unsafe"), n;
                            }
                        }
                        return n;
                    }
                },
                validate (e, { schema: t, error: r, prefs: s }) {
                    if (e === 1 / 0 || e === -1 / 0) return {
                        value: e,
                        errors: r("number.infinity")
                    };
                    if (!o.isNumber(e)) return {
                        value: e,
                        errors: r("number.base")
                    };
                    const n = {
                        value: e
                    };
                    if (s.convert) {
                        const e = t.$_getRule("precision");
                        if (e) {
                            const t = Math.pow(10, e.args.limit);
                            n.value = Math.round(n.value * t) / t;
                        }
                    }
                    return 0 === n.value && (n.value = 0), !t._flags.unsafe && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) && (n.errors = r("number.unsafe")), n;
                },
                rules: {
                    compare: {
                        method: !1,
                        validate: (e, t, { limit: r }, { name: s, operator: n, args: a })=>o.compare(e, r, n) ? e : t.error("number." + s, {
                                limit: a.limit,
                                value: e
                            }),
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: o.isNumber,
                                message: "must be a number"
                            }
                        ]
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    integer: {
                        method () {
                            return this.$_addRule("integer");
                        },
                        validate: (e, t)=>Math.trunc(e) - e == 0 ? e : t.error("number.integer")
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    multiple: {
                        method (e) {
                            return this.$_addRule({
                                name: "multiple",
                                args: {
                                    base: e
                                }
                            });
                        },
                        validate: (e, t, { base: r }, s)=>e % r == 0 ? e : t.error("number.multiple", {
                                multiple: s.args.base,
                                value: e
                            }),
                        args: [
                            {
                                name: "base",
                                ref: !0,
                                assert: (e)=>"number" == typeof e && isFinite(e) && e > 0,
                                message: "must be a positive number"
                            }
                        ],
                        multi: !0
                    },
                    negative: {
                        method () {
                            return this.sign("negative");
                        }
                    },
                    port: {
                        method () {
                            return this.$_addRule("port");
                        },
                        validate: (e, t)=>Number.isSafeInteger(e) && e >= 0 && e <= 65535 ? e : t.error("number.port")
                    },
                    positive: {
                        method () {
                            return this.sign("positive");
                        }
                    },
                    precision: {
                        method (e) {
                            return s(Number.isSafeInteger(e), "limit must be an integer"), this.$_addRule({
                                name: "precision",
                                args: {
                                    limit: e
                                }
                            });
                        },
                        validate (e, t, { limit: r }) {
                            const s = e.toString().match(a.precisionRx);
                            return Math.max((s[1] ? s[1].length : 0) - (s[2] ? parseInt(s[2], 10) : 0), 0) <= r ? e : t.error("number.precision", {
                                limit: r,
                                value: e
                            });
                        },
                        convert: !0
                    },
                    sign: {
                        method (e) {
                            return s([
                                "negative",
                                "positive"
                            ].includes(e), "Invalid sign", e), this.$_addRule({
                                name: "sign",
                                args: {
                                    sign: e
                                }
                            });
                        },
                        validate: (e, t, { sign: r })=>"negative" === r && e < 0 || "positive" === r && e > 0 ? e : t.error("number.".concat(r))
                    },
                    unsafe: {
                        method (e = !0) {
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("unsafe", e);
                        }
                    }
                },
                cast: {
                    string: {
                        from: (e)=>"number" == typeof e,
                        to: (e, t)=>e.toString()
                    }
                },
                messages: {
                    "number.base": "{{#label}} must be a number",
                    "number.greater": "{{#label}} must be greater than {{#limit}}",
                    "number.infinity": "{{#label}} cannot be infinity",
                    "number.integer": "{{#label}} must be an integer",
                    "number.less": "{{#label}} must be less than {{#limit}}",
                    "number.max": "{{#label}} must be less than or equal to {{#limit}}",
                    "number.min": "{{#label}} must be larger than or equal to {{#limit}}",
                    "number.multiple": "{{#label}} must be a multiple of {{#multiple}}",
                    "number.negative": "{{#label}} must be a negative number",
                    "number.port": "{{#label}} must be a valid port",
                    "number.positive": "{{#label}} must be a positive number",
                    "number.precision": "{{#label}} must have no more than {{#limit}} decimal places",
                    "number.unsafe": "{{#label}} must be a safe number"
                }
            }), a.normalizeExponent = function(e) {
                return e.replace(/E/, "e").replace(/\.(\d*[1-9])?0+e/, ".$1e").replace(/\.e/, "e").replace(/e\+/, "e").replace(/^\+/, "").replace(/^(-?)0+([1-9])/, "$1$2");
            }, a.normalizeDecimal = function(e) {
                return (e = e.replace(/^\+/, "").replace(/\.0+$/, "").replace(/^(-?)\.([^\.]*)$/, "$10.$2").replace(/^(-?)0+([1-9])/, "$1$2")).includes(".") && e.endsWith("0") && (e = e.replace(/0+$/, "")), "-0" === e ? "0" : e;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(22);
            e.exports = s.extend({
                type: "object",
                cast: {
                    map: {
                        from: (e)=>e && "object" == typeof e,
                        to: (e, t)=>new Map(Object.entries(e))
                    }
                }
            });
        },
        function(e, t, r) {
            "use strict";
            function s(e, t) {
                var r = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var s = Object.getOwnPropertySymbols(e);
                    t && (s = s.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), r.push.apply(r, s);
                }
                return r;
            }
            function n(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? s(Object(r), !0).forEach(function(t) {
                        o(e, t, r[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                    });
                }
                return e;
            }
            function o(e, t, r) {
                return t in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r, e;
            }
            const a = r(0), i = r(23), l = r(49), c = r(50), u = r(27), f = r(51), m = r(26), h = r(3), d = r(1), p = {
                tlds: f instanceof Set && {
                    tlds: {
                        allow: f,
                        deny: null
                    }
                },
                base64Regex: {
                    true: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}==|[\w\-]{3}=)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
                    },
                    false: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}(==)?|[\w\-]{3}=?)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/
                    }
                },
                dataUriRegex: /^data:[\w+.-]+\/[\w+.-]+;((charset=[\w-]+|base64),)?(.*)$/,
                hexRegex: /^[a-f0-9]+$/i,
                ipRegex: c.regex().regex,
                isoDurationRegex: /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?$/,
                guidBrackets: {
                    "{": "}",
                    "[": "]",
                    "(": ")",
                    "": ""
                },
                guidVersions: {
                    uuidv1: "1",
                    uuidv2: "2",
                    uuidv3: "3",
                    uuidv4: "4",
                    uuidv5: "5"
                },
                cidrPresences: [
                    "required",
                    "optional",
                    "forbidden"
                ],
                normalizationForms: [
                    "NFC",
                    "NFD",
                    "NFKC",
                    "NFKD"
                ]
            };
            e.exports = h.extend({
                type: "string",
                flags: {
                    insensitive: {
                        default: !1
                    },
                    truncate: {
                        default: !1
                    }
                },
                terms: {
                    replacements: {
                        init: null
                    }
                },
                coerce: {
                    from: "string",
                    method (e, { schema: t, state: r, prefs: s }) {
                        const n = t.$_getRule("normalize");
                        n && (e = e.normalize(n.args.form));
                        const o = t.$_getRule("case");
                        o && (e = "upper" === o.args.direction ? e.toLocaleUpperCase() : e.toLocaleLowerCase());
                        const a = t.$_getRule("trim");
                        if (a && a.args.enabled && (e = e.trim()), t.$_terms.replacements) for (const r of t.$_terms.replacements)e = e.replace(r.pattern, r.replacement);
                        const i = t.$_getRule("hex");
                        if (i && i.args.options.byteAligned && e.length % 2 != 0 && (e = "0".concat(e)), t.$_getRule("isoDate")) {
                            const t = p.isoDate(e);
                            t && (e = t);
                        }
                        if (t._flags.truncate) {
                            const n = t.$_getRule("max");
                            if (n) {
                                let o = n.args.limit;
                                if (d.isResolvable(o) && (o = o.resolve(e, r, s), !d.limit(o))) return {
                                    value: e,
                                    errors: t.$_createError("any.ref", o, {
                                        ref: n.args.limit,
                                        arg: "limit",
                                        reason: "must be a positive integer"
                                    }, r, s)
                                };
                                e = e.slice(0, o);
                            }
                        }
                        return {
                            value: e
                        };
                    }
                },
                validate: (e, { error: t })=>"string" != typeof e ? {
                        value: e,
                        errors: t("string.base")
                    } : "" === e ? {
                        value: e,
                        errors: t("string.empty")
                    } : void 0,
                rules: {
                    alphanum: {
                        method () {
                            return this.$_addRule("alphanum");
                        },
                        validate: (e, t)=>/^[a-zA-Z0-9]+$/.test(e) ? e : t.error("string.alphanum")
                    },
                    base64: {
                        method (e = {}) {
                            return d.assertOptions(e, [
                                "paddingRequired",
                                "urlSafe"
                            ]), e = n({
                                urlSafe: !1,
                                paddingRequired: !0
                            }, e), a("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), a("boolean" == typeof e.urlSafe, "urlSafe must be boolean"), this.$_addRule({
                                name: "base64",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate: (e, t, { options: r })=>p.base64Regex[r.paddingRequired][r.urlSafe].test(e) ? e : t.error("string.base64")
                    },
                    case: {
                        method (e) {
                            return a([
                                "lower",
                                "upper"
                            ].includes(e), "Invalid case:", e), this.$_addRule({
                                name: "case",
                                args: {
                                    direction: e
                                }
                            });
                        },
                        validate: (e, t, { direction: r })=>"lower" === r && e === e.toLocaleLowerCase() || "upper" === r && e === e.toLocaleUpperCase() ? e : t.error("string.".concat(r, "case")),
                        convert: !0
                    },
                    creditCard: {
                        method () {
                            return this.$_addRule("creditCard");
                        },
                        validate (e, t) {
                            let r = e.length, s = 0, n = 1;
                            for(; r--;){
                                const t = e.charAt(r) * n;
                                s += t - 9 * (t > 9), n ^= 3;
                            }
                            return s > 0 && s % 10 == 0 ? e : t.error("string.creditCard");
                        }
                    },
                    dataUri: {
                        method (e = {}) {
                            return d.assertOptions(e, [
                                "paddingRequired"
                            ]), e = n({
                                paddingRequired: !0
                            }, e), a("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), this.$_addRule({
                                name: "dataUri",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate (e, t, { options: r }) {
                            const s = e.match(p.dataUriRegex);
                            if (s) {
                                if (!s[2]) return e;
                                if ("base64" !== s[2]) return e;
                                if (p.base64Regex[r.paddingRequired].false.test(s[3])) return e;
                            }
                            return t.error("string.dataUri");
                        }
                    },
                    domain: {
                        method (e) {
                            e && d.assertOptions(e, [
                                "allowUnicode",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const t = p.addressOptions(e);
                            return this.$_addRule({
                                name: "domain",
                                args: {
                                    options: e
                                },
                                address: t
                            });
                        },
                        validate: (e, t, r, { address: s })=>i.isValid(e, s) ? e : t.error("string.domain")
                    },
                    email: {
                        method (e = {}) {
                            d.assertOptions(e, [
                                "allowUnicode",
                                "ignoreLength",
                                "minDomainSegments",
                                "multiple",
                                "separator",
                                "tlds"
                            ]), a(void 0 === e.multiple || "boolean" == typeof e.multiple, "multiple option must be an boolean");
                            const t = p.addressOptions(e), r = new RegExp("\\s*[".concat(e.separator ? u(e.separator) : ",", "]\\s*"));
                            return this.$_addRule({
                                name: "email",
                                args: {
                                    options: e
                                },
                                regex: r,
                                address: t
                            });
                        },
                        validate (e, t, { options: r }, { regex: s, address: n }) {
                            const o = r.multiple ? e.split(s) : [
                                e
                            ], a = [];
                            for (const e of o)l.isValid(e, n) || a.push(e);
                            return a.length ? t.error("string.email", {
                                value: e,
                                invalids: a
                            }) : e;
                        }
                    },
                    guid: {
                        alias: "uuid",
                        method (e = {}) {
                            d.assertOptions(e, [
                                "version"
                            ]);
                            let t = "";
                            if (e.version) {
                                const r = [].concat(e.version);
                                a(r.length >= 1, "version must have at least 1 valid version specified");
                                const s = new Set;
                                for(let e = 0; e < r.length; ++e){
                                    const n = r[e];
                                    a("string" == typeof n, "version at position " + e + " must be a string");
                                    const o = p.guidVersions[n.toLowerCase()];
                                    a(o, "version at position " + e + " must be one of " + Object.keys(p.guidVersions).join(", ")), a(!s.has(o), "version at position " + e + " must not be a duplicate"), t += o, s.add(o);
                                }
                            }
                            const r = new RegExp("^([\\[{\\(]?)[0-9A-F]{8}([:-]?)[0-9A-F]{4}\\2?[".concat(t || "0-9A-F", "][0-9A-F]{3}\\2?[").concat(t ? "89AB" : "0-9A-F", "][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$"), "i");
                            return this.$_addRule({
                                name: "guid",
                                args: {
                                    options: e
                                },
                                regex: r
                            });
                        },
                        validate (e, t, r, { regex: s }) {
                            const n = s.exec(e);
                            return n ? p.guidBrackets[n[1]] !== n[n.length - 1] ? t.error("string.guid") : e : t.error("string.guid");
                        }
                    },
                    hex: {
                        method (e = {}) {
                            return d.assertOptions(e, [
                                "byteAligned"
                            ]), e = n({
                                byteAligned: !1
                            }, e), a("boolean" == typeof e.byteAligned, "byteAligned must be boolean"), this.$_addRule({
                                name: "hex",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate: (e, t, { options: r })=>p.hexRegex.test(e) ? r.byteAligned && e.length % 2 != 0 ? t.error("string.hexAlign") : e : t.error("string.hex")
                    },
                    hostname: {
                        method () {
                            return this.$_addRule("hostname");
                        },
                        validate: (e, t)=>i.isValid(e, {
                                minDomainSegments: 1
                            }) || p.ipRegex.test(e) ? e : t.error("string.hostname")
                    },
                    insensitive: {
                        method () {
                            return this.$_setFlag("insensitive", !0);
                        }
                    },
                    ip: {
                        method (e = {}) {
                            d.assertOptions(e, [
                                "cidr",
                                "version"
                            ]);
                            const { cidr: t, versions: r, regex: s } = c.regex(e), n = e.version ? r : void 0;
                            return this.$_addRule({
                                name: "ip",
                                args: {
                                    options: {
                                        cidr: t,
                                        version: n
                                    }
                                },
                                regex: s
                            });
                        },
                        validate: (e, t, { options: r }, { regex: s })=>s.test(e) ? e : r.version ? t.error("string.ipVersion", {
                                value: e,
                                cidr: r.cidr,
                                version: r.version
                            }) : t.error("string.ip", {
                                value: e,
                                cidr: r.cidr
                            })
                    },
                    isoDate: {
                        method () {
                            return this.$_addRule("isoDate");
                        },
                        validate: (e, { error: t })=>p.isoDate(e) ? e : t("string.isoDate")
                    },
                    isoDuration: {
                        method () {
                            return this.$_addRule("isoDuration");
                        },
                        validate: (e, t)=>p.isoDurationRegex.test(e) ? e : t.error("string.isoDuration")
                    },
                    length: {
                        method (e, t) {
                            return p.length(this, "length", e, "=", t);
                        },
                        validate (e, t, { limit: r, encoding: s }, { name: n, operator: o, args: a }) {
                            const i = !s && e.length;
                            return d.compare(i, r, o) ? e : t.error("string." + n, {
                                limit: a.limit,
                                value: e,
                                encoding: s
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: d.limit,
                                message: "must be a positive integer"
                            },
                            "encoding"
                        ]
                    },
                    lowercase: {
                        method () {
                            return this.case("lower");
                        }
                    },
                    max: {
                        method (e, t) {
                            return p.length(this, "max", e, "<=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    min: {
                        method (e, t) {
                            return p.length(this, "min", e, ">=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    normalize: {
                        method (e = "NFC") {
                            return a(p.normalizationForms.includes(e), "normalization form must be one of " + p.normalizationForms.join(", ")), this.$_addRule({
                                name: "normalize",
                                args: {
                                    form: e
                                }
                            });
                        },
                        validate: (e, { error: t }, { form: r })=>e === e.normalize(r) ? e : t("string.normalize", {
                                value: e,
                                form: r
                            }),
                        convert: !0
                    },
                    pattern: {
                        alias: "regex",
                        method (e, t = {}) {
                            a(e instanceof RegExp, "regex must be a RegExp"), a(!e.flags.includes("g") && !e.flags.includes("y"), "regex should not use global or sticky mode"), "string" == typeof t && (t = {
                                name: t
                            }), d.assertOptions(t, [
                                "invert",
                                "name"
                            ]);
                            const r = [
                                "string.pattern",
                                t.invert ? ".invert" : "",
                                t.name ? ".name" : ".base"
                            ].join("");
                            return this.$_addRule({
                                name: "pattern",
                                args: {
                                    regex: e,
                                    options: t
                                },
                                errorCode: r
                            });
                        },
                        validate: (e, t, { regex: r, options: s }, { errorCode: n })=>r.test(e) ^ s.invert ? e : t.error(n, {
                                name: s.name,
                                regex: r,
                                value: e
                            }),
                        args: [
                            "regex",
                            "options"
                        ],
                        multi: !0
                    },
                    replace: {
                        method (e, t) {
                            "string" == typeof e && (e = new RegExp(u(e), "g")), a(e instanceof RegExp, "pattern must be a RegExp"), a("string" == typeof t, "replacement must be a String");
                            const r = this.clone();
                            return r.$_terms.replacements || (r.$_terms.replacements = []), r.$_terms.replacements.push({
                                pattern: e,
                                replacement: t
                            }), r;
                        }
                    },
                    token: {
                        method () {
                            return this.$_addRule("token");
                        },
                        validate: (e, t)=>/^\w+$/.test(e) ? e : t.error("string.token")
                    },
                    trim: {
                        method (e = !0) {
                            return a("boolean" == typeof e, "enabled must be a boolean"), this.$_addRule({
                                name: "trim",
                                args: {
                                    enabled: e
                                }
                            });
                        },
                        validate: (e, t, { enabled: r })=>r && e !== e.trim() ? t.error("string.trim") : e,
                        convert: !0
                    },
                    truncate: {
                        method (e = !0) {
                            return a("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("truncate", e);
                        }
                    },
                    uppercase: {
                        method () {
                            return this.case("upper");
                        }
                    },
                    uri: {
                        method (e = {}) {
                            d.assertOptions(e, [
                                "allowRelative",
                                "allowQuerySquareBrackets",
                                "domain",
                                "relativeOnly",
                                "scheme"
                            ]), e.domain && d.assertOptions(e.domain, [
                                "allowUnicode",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const { regex: t, scheme: r } = m.regex(e), s = e.domain ? p.addressOptions(e.domain) : null;
                            return this.$_addRule({
                                name: "uri",
                                args: {
                                    options: e
                                },
                                regex: t,
                                domain: s,
                                scheme: r
                            });
                        },
                        validate (e, t, { options: r }, { regex: s, domain: n, scheme: o }) {
                            if ([
                                "http:/",
                                "https:/"
                            ].includes(e)) return t.error("string.uri");
                            const a = s.exec(e);
                            if (a) {
                                if (n) {
                                    const e = a[1] || a[2];
                                    if (!i.isValid(e, n)) return t.error("string.domain", {
                                        value: e
                                    });
                                }
                                return e;
                            }
                            return r.relativeOnly ? t.error("string.uriRelativeOnly") : r.scheme ? t.error("string.uriCustomScheme", {
                                scheme: o,
                                value: e
                            }) : t.error("string.uri");
                        }
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.replacements) for (const { pattern: r, replacement: s } of t.replacements)e = e.replace(r, s);
                        return e;
                    }
                },
                messages: {
                    "string.alphanum": "{{#label}} must only contain alpha-numeric characters",
                    "string.base": "{{#label}} must be a string",
                    "string.base64": "{{#label}} must be a valid base64 string",
                    "string.creditCard": "{{#label}} must be a credit card",
                    "string.dataUri": "{{#label}} must be a valid dataUri string",
                    "string.domain": "{{#label}} must contain a valid domain name",
                    "string.email": "{{#label}} must be a valid email",
                    "string.empty": "{{#label}} is not allowed to be empty",
                    "string.guid": "{{#label}} must be a valid GUID",
                    "string.hex": "{{#label}} must only contain hexadecimal characters",
                    "string.hexAlign": "{{#label}} hex decoded representation must be byte aligned",
                    "string.hostname": "{{#label}} must be a valid hostname",
                    "string.ip": "{{#label}} must be a valid ip address with a {{#cidr}} CIDR",
                    "string.ipVersion": "{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR",
                    "string.isoDate": "{{#label}} must be in iso format",
                    "string.isoDuration": "{{#label}} must be a valid ISO 8601 duration",
                    "string.length": "{{#label}} length must be {{#limit}} characters long",
                    "string.lowercase": "{{#label}} must only contain lowercase characters",
                    "string.max": "{{#label}} length must be less than or equal to {{#limit}} characters long",
                    "string.min": "{{#label}} length must be at least {{#limit}} characters long",
                    "string.normalize": "{{#label}} must be unicode normalized in the {{#form}} form",
                    "string.token": "{{#label}} must only contain alpha-numeric and underscore characters",
                    "string.pattern.base": '{{#label}} with value "{[.]}" fails to match the required pattern: {{#regex}}',
                    "string.pattern.name": '{{#label}} with value "{[.]}" fails to match the {{#name}} pattern',
                    "string.pattern.invert.base": '{{#label}} with value "{[.]}" matches the inverted pattern: {{#regex}}',
                    "string.pattern.invert.name": '{{#label}} with value "{[.]}" matches the inverted {{#name}} pattern',
                    "string.trim": "{{#label}} must not have leading or trailing whitespace",
                    "string.uri": "{{#label}} must be a valid uri",
                    "string.uriCustomScheme": "{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern",
                    "string.uriRelativeOnly": "{{#label}} must be a valid relative uri",
                    "string.uppercase": "{{#label}} must only contain uppercase characters"
                }
            }), p.addressOptions = function(e) {
                if (!e) return e;
                if (a(void 0 === e.minDomainSegments || Number.isSafeInteger(e.minDomainSegments) && e.minDomainSegments > 0, "minDomainSegments must be a positive integer"), !1 === e.tlds) return e;
                if (!0 === e.tlds || void 0 === e.tlds) return a(p.tlds, "Built-in TLD list disabled"), Object.assign({}, e, p.tlds);
                a("object" == typeof e.tlds, "tlds must be true, false, or an object");
                const t = e.tlds.deny;
                if (t) return Array.isArray(t) && (e = Object.assign({}, e, {
                    tlds: {
                        deny: new Set(t)
                    }
                })), a(e.tlds.deny instanceof Set, "tlds.deny must be an array, Set, or boolean"), a(!e.tlds.allow, "Cannot specify both tlds.allow and tlds.deny lists"), e;
                const r = e.tlds.allow;
                return r ? !0 === r ? (a(p.tlds, "Built-in TLD list disabled"), Object.assign({}, e, p.tlds)) : (Array.isArray(r) && (e = Object.assign({}, e, {
                    tlds: {
                        allow: new Set(r)
                    }
                })), a(e.tlds.allow instanceof Set, "tlds.allow must be an array, Set, or boolean"), e) : e;
            }, p.isoDate = function(e) {
                if (!d.isIsoDate(e)) return null;
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t.toISOString();
            }, p.length = function(e, t, r, s, n) {
                return a(!n || !1, "Invalid encoding:", n), e.$_addRule({
                    name: t,
                    method: "length",
                    args: {
                        limit: r,
                        encoding: n
                    },
                    operator: s
                });
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(24), n = r(23), o = r(25), a = {
                nonAsciiRx: /[^\x00-\x7f]/,
                encoder: new (s.TextEncoder || TextEncoder)
            };
            t.analyze = function(e, t) {
                return a.email(e, t);
            }, t.isValid = function(e, t) {
                return !a.email(e, t);
            }, a.email = function(e, t = {}) {
                if ("string" != typeof e) throw new Error("Invalid input: email must be a string");
                if (!e) return o.code("EMPTY_STRING");
                const r = !a.nonAsciiRx.test(e);
                if (!r) {
                    if (!1 === t.allowUnicode) return o.code("FORBIDDEN_UNICODE");
                    e = e.normalize("NFC");
                }
                const s = e.split("@");
                if (2 !== s.length) return s.length > 2 ? o.code("MULTIPLE_AT_CHAR") : o.code("MISSING_AT_CHAR");
                const [i, l] = s;
                if (!i) return o.code("EMPTY_LOCAL");
                if (!t.ignoreLength) {
                    if (e.length > 254) return o.code("ADDRESS_TOO_LONG");
                    if (a.encoder.encode(i).length > 64) return o.code("LOCAL_TOO_LONG");
                }
                return a.local(i, r) || n.analyze(l, t);
            }, a.local = function(e, t) {
                const r = e.split(".");
                for (const e of r){
                    if (!e.length) return o.code("EMPTY_LOCAL_SEGMENT");
                    if (t) {
                        if (!a.atextRx.test(e)) return o.code("INVALID_LOCAL_CHARS");
                    } else for (const t of e){
                        if (a.atextRx.test(t)) continue;
                        const e = a.binary(t);
                        if (!a.atomRx.test(e)) return o.code("INVALID_LOCAL_CHARS");
                    }
                }
            }, a.binary = function(e) {
                return Array.from(a.encoder.encode(e)).map((e)=>String.fromCharCode(e)).join("");
            }, a.atextRx = /^[\w!#\$%&'\*\+\-/=\?\^`\{\|\}~]+$/, a.atomRx = new RegExp([
                "(?:[\\xc2-\\xdf][\\x80-\\xbf])",
                "(?:\\xe0[\\xa0-\\xbf][\\x80-\\xbf])|(?:[\\xe1-\\xec][\\x80-\\xbf]{2})|(?:\\xed[\\x80-\\x9f][\\x80-\\xbf])|(?:[\\xee-\\xef][\\x80-\\xbf]{2})",
                "(?:\\xf0[\\x90-\\xbf][\\x80-\\xbf]{2})|(?:[\\xf1-\\xf3][\\x80-\\xbf]{3})|(?:\\xf4[\\x80-\\x8f][\\x80-\\xbf]{2})"
            ].join("|"));
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(26);
            t.regex = function(e = {}) {
                s(void 0 === e.cidr || "string" == typeof e.cidr, "options.cidr must be a string");
                const t = e.cidr ? e.cidr.toLowerCase() : "optional";
                s([
                    "required",
                    "optional",
                    "forbidden"
                ].includes(t), "options.cidr must be one of required, optional, forbidden"), s(void 0 === e.version || "string" == typeof e.version || Array.isArray(e.version), "options.version must be a string or an array of string");
                let r = e.version || [
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ];
                Array.isArray(r) || (r = [
                    r
                ]), s(r.length >= 1, "options.version must have at least 1 version specified");
                for(let e = 0; e < r.length; ++e)s("string" == typeof r[e], "options.version must only contain strings"), r[e] = r[e].toLowerCase(), s([
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ].includes(r[e]), "options.version contains unknown version " + r[e] + " - must be one of ipv4, ipv6, ipvfuture");
                r = Array.from(new Set(r));
                const o = r.map((e)=>{
                    if ("forbidden" === t) return n.ip[e];
                    const r = "\\/".concat("ipv4" === e ? n.ip.v4Cidr : n.ip.v6Cidr);
                    return "required" === t ? "".concat(n.ip[e]).concat(r) : "".concat(n.ip[e], "(?:").concat(r, ")?");
                }), a = "(?:".concat(o.join("|"), ")"), i = new RegExp("^".concat(a, "$"));
                return {
                    cidr: t,
                    versions: r,
                    regex: i,
                    raw: a
                };
            };
        },
        function(e, t) {},
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = {};
            o.Map = class extends Map {
                slice() {
                    return new o.Map(this);
                }
            }, e.exports = n.extend({
                type: "symbol",
                terms: {
                    map: {
                        init: new o.Map
                    }
                },
                coerce: {
                    method (e, { schema: t, error: r }) {
                        const s = t.$_terms.map.get(e);
                        return s && (e = s), t._flags.only && "symbol" != typeof e ? {
                            value: e,
                            errors: r("symbol.map", {
                                map: t.$_terms.map
                            })
                        } : {
                            value: e
                        };
                    }
                },
                validate (e, { error: t }) {
                    if ("symbol" != typeof e) return {
                        value: e,
                        errors: t("symbol.base")
                    };
                },
                rules: {
                    map: {
                        method (e) {
                            e && !e[Symbol.iterator] && "object" == typeof e && (e = Object.entries(e)), s(e && e[Symbol.iterator], "Iterable must be an iterable or object");
                            const t = this.clone(), r = [];
                            for (const n of e){
                                s(n && n[Symbol.iterator], "Entry must be an iterable");
                                const [e, o] = n;
                                s("object" != typeof e && "function" != typeof e && "symbol" != typeof e, "Key must not be of type object, function, or Symbol"), s("symbol" == typeof o, "Value must be a Symbol"), t.$_terms.map.set(e, o), r.push(o);
                            }
                            return t.valid(...r);
                        }
                    }
                },
                manifest: {
                    build: (e, t)=>(t.map && (e = e.map(t.map)), e)
                },
                messages: {
                    "symbol.base": "{{#label}} must be a symbol",
                    "symbol.map": "{{#label}} must be one of {{#map}}"
                }
            });
        }
    ]);
});

});





var $lgFxF = parcelRequire("lgFxF");

var $aBztI = parcelRequire("aBztI");
/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by Niazye and ChiyoYuki from ECNU-minus on 2025-12-03
 * Changes:
 * - feat: update info
 *
 * Modified by 霧雨バニラ from BetterECNU on 2026-05-23
 * Changes:
 * - feat: 添加全局搜索(/search)与课程详情(/course)页面路由，独立页面隐藏侧栏全宽布局
 * - refactor: 提取 AppLayout 组件与 colorize 函数，事件处理函数使用 useCallback 优化，色彩映射使用 useMemo 缓存
 * - fix: 组织名链接后添加空格以改善排版
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ 
var $ce12fe3b4e8bd060$exports = {};

$ce12fe3b4e8bd060$exports = (parcelRequire("9d9Fx"));


var $8dabe6189ccff055$exports = {};
/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2019, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */ (function(global, factory) {
    $8dabe6189ccff055$exports = factory();
})($8dabe6189ccff055$exports, function() {
    'use strict';
    var limit = function(x, min, max) {
        if (min === void 0) min = 0;
        if (max === void 0) max = 1;
        return x < min ? min : x > max ? max : x;
    };
    var clip_rgb = function(rgb) {
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for(var i = 0; i <= 3; i++){
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
                rgb[i] = limit(rgb[i], 0, 255);
            } else if (i === 3) rgb[i] = limit(rgb[i], 0, 1);
        }
        return rgb;
    };
    // ported from jQuery's $.type
    var classToType = {};
    for(var i = 0, list = [
        'Boolean',
        'Number',
        'String',
        'Function',
        'Array',
        'Date',
        'RegExp',
        'Undefined',
        'Null'
    ]; i < list.length; i += 1){
        var name = list[i];
        classToType["[object " + name + "]"] = name.toLowerCase();
    }
    var type = function(obj) {
        return classToType[Object.prototype.toString.call(obj)] || "object";
    };
    var unpack = function(args, keyOrder) {
        if (keyOrder === void 0) keyOrder = null;
        // if called with more than 3 arguments, we return the arguments
        if (args.length >= 3) return Array.prototype.slice.call(args);
        // with less than 3 args we check if first arg is object
        // and use the keyOrder string to extract and sort properties
        if (type(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter(function(k) {
            return args[0][k] !== undefined;
        }).map(function(k) {
            return args[0][k];
        });
        // otherwise we just return the first argument
        // (which we suppose is an array of args)
        return args[0];
    };
    var last = function(args) {
        if (args.length < 2) return null;
        var l = args.length - 1;
        if (type(args[l]) == 'string') return args[l].toLowerCase();
        return null;
    };
    var PI = Math.PI;
    var utils = {
        clip_rgb: clip_rgb,
        limit: limit,
        type: type,
        unpack: unpack,
        last: last,
        PI: PI,
        TWOPI: PI * 2,
        PITHIRD: PI / 3,
        DEG2RAD: PI / 180,
        RAD2DEG: 180 / PI
    };
    var input = {
        format: {},
        autodetect: []
    };
    var last$1 = utils.last;
    var clip_rgb$1 = utils.clip_rgb;
    var type$1 = utils.type;
    var Color = function Color() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var me = this;
        if (type$1(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        var mode = last$1(args);
        var autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!input.sorted) {
                input.autodetect = input.autodetect.sort(function(a, b) {
                    return b.p - a.p;
                });
                input.sorted = true;
            }
            // auto-detect format
            for(var i = 0, list = input.autodetect; i < list.length; i += 1){
                var chk = list[i];
                mode = chk.test.apply(chk, args);
                if (mode) break;
            }
        }
        if (input.format[mode]) {
            var rgb = input.format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = clip_rgb$1(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    };
    Color.prototype.toString = function toString() {
        if (type$1(this.hex) == 'function') return this.hex();
        return "[" + this._rgb.join(',') + "]";
    };
    var Color_1 = Color;
    var chroma = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(chroma.Color, [
            null
        ].concat(args)));
    };
    chroma.Color = Color_1;
    chroma.version = '2.1.0';
    var chroma_1 = chroma;
    var unpack$1 = utils.unpack;
    var max = Math.max;
    var rgb2cmyk = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$1(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        var k = 1 - max(r, max(g, b));
        var f = k < 1 ? 1 / (1 - k) : 0;
        var c = (1 - r - k) * f;
        var m = (1 - g - k) * f;
        var y = (1 - b - k) * f;
        return [
            c,
            m,
            y,
            k
        ];
    };
    var rgb2cmyk_1 = rgb2cmyk;
    var unpack$2 = utils.unpack;
    var cmyk2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$2(args, 'cmyk');
        var c = args[0];
        var m = args[1];
        var y = args[2];
        var k = args[3];
        var alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) return [
            0,
            0,
            0,
            alpha
        ];
        return [
            c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
            m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
            y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
            alpha
        ];
    };
    var cmyk2rgb_1 = cmyk2rgb;
    var unpack$3 = utils.unpack;
    var type$2 = utils.type;
    Color_1.prototype.cmyk = function() {
        return rgb2cmyk_1(this._rgb);
    };
    chroma_1.cmyk = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'cmyk'
        ])));
    };
    input.format.cmyk = cmyk2rgb_1;
    input.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$3(args, 'cmyk');
            if (type$2(args) === 'array' && args.length === 4) return 'cmyk';
        }
    });
    var unpack$4 = utils.unpack;
    var last$2 = utils.last;
    var rnd = function(a) {
        return Math.round(a * 100) / 100;
    };
    /*
     * supported arguments:
     * - hsl2css(h,s,l)
     * - hsl2css(h,s,l,a)
     * - hsl2css([h,s,l], mode)
     * - hsl2css([h,s,l,a], mode)
     * - hsl2css({h,s,l,a}, mode)
     */ var hsl2css = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hsla = unpack$4(args, 'hsla');
        var mode = last$2(args) || 'lsa';
        hsla[0] = rnd(hsla[0] || 0);
        hsla[1] = rnd(hsla[1] * 100) + '%';
        hsla[2] = rnd(hsla[2] * 100) + '%';
        if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
            hsla[3] = hsla.length > 3 ? hsla[3] : 1;
            mode = 'hsla';
        } else hsla.length = 3;
        return mode + "(" + hsla.join(',') + ")";
    };
    var hsl2css_1 = hsl2css;
    var unpack$5 = utils.unpack;
    /*
     * supported arguments:
     * - rgb2hsl(r,g,b)
     * - rgb2hsl(r,g,b,a)
     * - rgb2hsl([r,g,b])
     * - rgb2hsl([r,g,b,a])
     * - rgb2hsl({r,g,b,a})
     */ var rgb2hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$5(args, 'rgba');
        var r = args[0];
        var g = args[1];
        var b = args[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var l = (max + min) / 2;
        var s, h;
        if (max === min) {
            s = 0;
            h = Number.NaN;
        } else s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        if (r == max) h = (g - b) / (max - min);
        else if (g == max) h = 2 + (b - r) / (max - min);
        else if (b == max) h = 4 + (r - g) / (max - min);
        h *= 60;
        if (h < 0) h += 360;
        if (args.length > 3 && args[3] !== undefined) return [
            h,
            s,
            l,
            args[3]
        ];
        return [
            h,
            s,
            l
        ];
    };
    var rgb2hsl_1 = rgb2hsl;
    var unpack$6 = utils.unpack;
    var last$3 = utils.last;
    var round = Math.round;
    /*
     * supported arguments:
     * - rgb2css(r,g,b)
     * - rgb2css(r,g,b,a)
     * - rgb2css([r,g,b], mode)
     * - rgb2css([r,g,b,a], mode)
     * - rgb2css({r,g,b,a}, mode)
     */ var rgb2css = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$6(args, 'rgba');
        var mode = last$3(args) || 'rgb';
        if (mode.substr(0, 3) == 'hsl') return hsl2css_1(rgb2hsl_1(rgba), mode);
        rgba[0] = round(rgba[0]);
        rgba[1] = round(rgba[1]);
        rgba[2] = round(rgba[2]);
        if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
            rgba[3] = rgba.length > 3 ? rgba[3] : 1;
            mode = 'rgba';
        }
        return mode + "(" + rgba.slice(0, mode === 'rgb' ? 3 : 4).join(',') + ")";
    };
    var rgb2css_1 = rgb2css;
    var unpack$7 = utils.unpack;
    var round$1 = Math.round;
    var hsl2rgb = function() {
        var assign;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$7(args, 'hsl');
        var h = args[0];
        var s = args[1];
        var l = args[2];
        var r, g, b;
        if (s === 0) r = g = b = l * 255;
        else {
            var t3 = [
                0,
                0,
                0
            ];
            var c = [
                0,
                0,
                0
            ];
            var t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var t1 = 2 * l - t2;
            var h_ = h / 360;
            t3[0] = h_ + 1 / 3;
            t3[1] = h_;
            t3[2] = h_ - 1 / 3;
            for(var i = 0; i < 3; i++){
                if (t3[i] < 0) t3[i] += 1;
                if (t3[i] > 1) t3[i] -= 1;
                if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
                else if (2 * t3[i] < 1) c[i] = t2;
                else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
                else c[i] = t1;
            }
            assign = [
                round$1(c[0] * 255),
                round$1(c[1] * 255),
                round$1(c[2] * 255)
            ], r = assign[0], g = assign[1], b = assign[2];
        }
        if (args.length > 3) // keep alpha channel
        return [
            r,
            g,
            b,
            args[3]
        ];
        return [
            r,
            g,
            b,
            1
        ];
    };
    var hsl2rgb_1 = hsl2rgb;
    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var round$2 = Math.round;
    var css2rgb = function(css) {
        css = css.toLowerCase().trim();
        var m;
        if (input.format.named) try {
            return input.format.named(css);
        } catch (e) {
        // eslint-disable-next-line
        }
        // rgb(250,20,0)
        if (m = css.match(RE_RGB)) {
            var rgb = m.slice(1, 4);
            for(var i = 0; i < 3; i++)rgb[i] = +rgb[i];
            rgb[3] = 1; // default alpha
            return rgb;
        }
        // rgba(250,20,0,0.4)
        if (m = css.match(RE_RGBA)) {
            var rgb$1 = m.slice(1, 5);
            for(var i$1 = 0; i$1 < 4; i$1++)rgb$1[i$1] = +rgb$1[i$1];
            return rgb$1;
        }
        // rgb(100%,0%,0%)
        if (m = css.match(RE_RGB_PCT)) {
            var rgb$2 = m.slice(1, 4);
            for(var i$2 = 0; i$2 < 3; i$2++)rgb$2[i$2] = round$2(rgb$2[i$2] * 2.55);
            rgb$2[3] = 1; // default alpha
            return rgb$2;
        }
        // rgba(100%,0%,0%,0.4)
        if (m = css.match(RE_RGBA_PCT)) {
            var rgb$3 = m.slice(1, 5);
            for(var i$3 = 0; i$3 < 3; i$3++)rgb$3[i$3] = round$2(rgb$3[i$3] * 2.55);
            rgb$3[3] = +rgb$3[3];
            return rgb$3;
        }
        // hsl(0,100%,50%)
        if (m = css.match(RE_HSL)) {
            var hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            var rgb$4 = hsl2rgb_1(hsl);
            rgb$4[3] = 1;
            return rgb$4;
        }
        // hsla(0,100%,50%,0.5)
        if (m = css.match(RE_HSLA)) {
            var hsl$1 = m.slice(1, 4);
            hsl$1[1] *= 0.01;
            hsl$1[2] *= 0.01;
            var rgb$5 = hsl2rgb_1(hsl$1);
            rgb$5[3] = +m[4]; // default alpha = 1
            return rgb$5;
        }
    };
    css2rgb.test = function(s) {
        return RE_RGB.test(s) || RE_RGBA.test(s) || RE_RGB_PCT.test(s) || RE_RGBA_PCT.test(s) || RE_HSL.test(s) || RE_HSLA.test(s);
    };
    var css2rgb_1 = css2rgb;
    var type$3 = utils.type;
    Color_1.prototype.css = function(mode) {
        return rgb2css_1(this._rgb, mode);
    };
    chroma_1.css = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'css'
        ])));
    };
    input.format.css = css2rgb_1;
    input.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$3(h) === 'string' && css2rgb_1.test(h)) return 'css';
        }
    });
    var unpack$8 = utils.unpack;
    input.format.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$8(args, 'rgba');
        rgb[0] *= 255;
        rgb[1] *= 255;
        rgb[2] *= 255;
        return rgb;
    };
    chroma_1.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'gl'
        ])));
    };
    Color_1.prototype.gl = function() {
        var rgb = this._rgb;
        return [
            rgb[0] / 255,
            rgb[1] / 255,
            rgb[2] / 255,
            rgb[3]
        ];
    };
    var unpack$9 = utils.unpack;
    var rgb2hcg = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$9(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var c = delta * 100 / 255;
        var _g = min / (255 - delta) * 100;
        var h;
        if (delta === 0) h = Number.NaN;
        else {
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            c,
            _g
        ];
    };
    var rgb2hcg_1 = rgb2hcg;
    var unpack$a = utils.unpack;
    var floor = Math.floor;
    /*
     * this is basically just HSV with some minor tweaks
     *
     * hue.. [0..360]
     * chroma .. [0..1]
     * grayness .. [0..1]
     */ var hcg2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$a(args, 'hcg');
        var h = args[0];
        var c = args[1];
        var _g = args[2];
        var r, g, b;
        _g = _g * 255;
        var _c = c * 255;
        if (c === 0) r = g = b = _g;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor(h);
            var f = h - i;
            var p = _g * (1 - c);
            var q = p + _c * (1 - f);
            var t = p + _c * f;
            var v = p + _c;
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hcg2rgb_1 = hcg2rgb;
    var unpack$b = utils.unpack;
    var type$4 = utils.type;
    Color_1.prototype.hcg = function() {
        return rgb2hcg_1(this._rgb);
    };
    chroma_1.hcg = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'hcg'
        ])));
    };
    input.format.hcg = hcg2rgb_1;
    input.autodetect.push({
        p: 1,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$b(args, 'hcg');
            if (type$4(args) === 'array' && args.length === 3) return 'hcg';
        }
    });
    var unpack$c = utils.unpack;
    var last$4 = utils.last;
    var round$3 = Math.round;
    var rgb2hex = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$c(args, 'rgba');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var a = ref[3];
        var mode = last$4(args) || 'auto';
        if (a === undefined) a = 1;
        if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
        r = round$3(r);
        g = round$3(g);
        b = round$3(b);
        var u = r << 16 | g << 8 | b;
        var str = "000000" + u.toString(16); //#.toUpperCase();
        str = str.substr(str.length - 6);
        var hxa = '0' + round$3(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        switch(mode.toLowerCase()){
            case 'rgba':
                return "#" + str + hxa;
            case 'argb':
                return "#" + hxa + str;
            default:
                return "#" + str;
        }
    };
    var rgb2hex_1 = rgb2hex;
    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    var RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
    var hex2rgb = function(hex) {
        if (hex.match(RE_HEX)) {
            // remove optional leading #
            if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
            // expand short-notation to full six-digit
            if (hex.length === 3) {
                hex = hex.split('');
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            var u = parseInt(hex, 16);
            var r = u >> 16;
            var g = u >> 8 & 0xFF;
            var b = u & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        // match rgba hex format, eg #FF000077
        if (hex.match(RE_HEXA)) {
            if (hex.length === 5 || hex.length === 9) // remove optional leading #
            hex = hex.substr(1);
            // expand short-notation to full eight-digit
            if (hex.length === 4) {
                hex = hex.split('');
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }
            var u$1 = parseInt(hex, 16);
            var r$1 = u$1 >> 24 & 0xFF;
            var g$1 = u$1 >> 16 & 0xFF;
            var b$1 = u$1 >> 8 & 0xFF;
            var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
            return [
                r$1,
                g$1,
                b$1,
                a
            ];
        }
        // we used to check for css colors here
        // if _input.css? and rgb = _input.css hex
        //     return rgb
        throw new Error("unknown hex color: " + hex);
    };
    var hex2rgb_1 = hex2rgb;
    var type$5 = utils.type;
    Color_1.prototype.hex = function(mode) {
        return rgb2hex_1(this._rgb, mode);
    };
    chroma_1.hex = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'hex'
        ])));
    };
    input.format.hex = hex2rgb_1;
    input.autodetect.push({
        p: 4,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$5(h) === 'string' && [
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ].indexOf(h.length) >= 0) return 'hex';
        }
    });
    var unpack$d = utils.unpack;
    var TWOPI = utils.TWOPI;
    var min = Math.min;
    var sqrt = Math.sqrt;
    var acos = Math.acos;
    var rgb2hsi = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
        */ var ref = unpack$d(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var h;
        var min_ = min(r, g, b);
        var i = (r + g + b) / 3;
        var s = i > 0 ? 1 - min_ / i : 0;
        if (s === 0) h = NaN;
        else {
            h = (r - g + (r - b)) / 2;
            h /= sqrt((r - g) * (r - g) + (r - b) * (g - b));
            h = acos(h);
            if (b > g) h = TWOPI - h;
            h /= TWOPI;
        }
        return [
            h * 360,
            s,
            i
        ];
    };
    var rgb2hsi_1 = rgb2hsi;
    var unpack$e = utils.unpack;
    var limit$1 = utils.limit;
    var TWOPI$1 = utils.TWOPI;
    var PITHIRD = utils.PITHIRD;
    var cos = Math.cos;
    /*
     * hue [0..360]
     * saturation [0..1]
     * intensity [0..1]
     */ var hsi2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
        */ args = unpack$e(args, 'hsi');
        var h = args[0];
        var s = args[1];
        var i = args[2];
        var r, g, b;
        if (isNaN(h)) h = 0;
        if (isNaN(s)) s = 0;
        // normalize hue
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 360;
        if (h < 1 / 3) {
            b = (1 - s) / 3;
            r = (1 + s * cos(TWOPI$1 * h) / cos(PITHIRD - TWOPI$1 * h)) / 3;
            g = 1 - (b + r);
        } else if (h < 2 / 3) {
            h -= 1 / 3;
            r = (1 - s) / 3;
            g = (1 + s * cos(TWOPI$1 * h) / cos(PITHIRD - TWOPI$1 * h)) / 3;
            b = 1 - (r + g);
        } else {
            h -= 2 / 3;
            g = (1 - s) / 3;
            b = (1 + s * cos(TWOPI$1 * h) / cos(PITHIRD - TWOPI$1 * h)) / 3;
            r = 1 - (g + b);
        }
        r = limit$1(i * r * 3);
        g = limit$1(i * g * 3);
        b = limit$1(i * b * 3);
        return [
            r * 255,
            g * 255,
            b * 255,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsi2rgb_1 = hsi2rgb;
    var unpack$f = utils.unpack;
    var type$6 = utils.type;
    Color_1.prototype.hsi = function() {
        return rgb2hsi_1(this._rgb);
    };
    chroma_1.hsi = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'hsi'
        ])));
    };
    input.format.hsi = hsi2rgb_1;
    input.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$f(args, 'hsi');
            if (type$6(args) === 'array' && args.length === 3) return 'hsi';
        }
    });
    var unpack$g = utils.unpack;
    var type$7 = utils.type;
    Color_1.prototype.hsl = function() {
        return rgb2hsl_1(this._rgb);
    };
    chroma_1.hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'hsl'
        ])));
    };
    input.format.hsl = hsl2rgb_1;
    input.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$g(args, 'hsl');
            if (type$7(args) === 'array' && args.length === 3) return 'hsl';
        }
    });
    var unpack$h = utils.unpack;
    var min$1 = Math.min;
    var max$1 = Math.max;
    /*
     * supported arguments:
     * - rgb2hsv(r,g,b)
     * - rgb2hsv([r,g,b])
     * - rgb2hsv({r,g,b})
     */ var rgb2hsl$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$h(args, 'rgb');
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var min_ = min$1(r, g, b);
        var max_ = max$1(r, g, b);
        var delta = max_ - min_;
        var h, s, v;
        v = max_ / 255.0;
        if (max_ === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max_;
            if (r === max_) h = (g - b) / delta;
            if (g === max_) h = 2 + (b - r) / delta;
            if (b === max_) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            s,
            v
        ];
    };
    var rgb2hsv = rgb2hsl$1;
    var unpack$i = utils.unpack;
    var floor$1 = Math.floor;
    var hsv2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$i(args, 'hsv');
        var h = args[0];
        var s = args[1];
        var v = args[2];
        var r, g, b;
        v *= 255;
        if (s === 0) r = g = b = v;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor$1(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - s * f);
            var t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsv2rgb_1 = hsv2rgb;
    var unpack$j = utils.unpack;
    var type$8 = utils.type;
    Color_1.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };
    chroma_1.hsv = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'hsv'
        ])));
    };
    input.format.hsv = hsv2rgb_1;
    input.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$j(args, 'hsv');
            if (type$8(args) === 'array' && args.length === 3) return 'hsv';
        }
    });
    var labConstants = {
        // Corresponds roughly to RGB brighter/darker
        Kn: 18,
        // D65 standard referent
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,
        t0: 0.137931034,
        t1: 0.206896552,
        t2: 0.12841855,
        t3: 0.008856452
    };
    var unpack$k = utils.unpack;
    var pow = Math.pow;
    var rgb2lab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$k(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2xyz(r, g, b);
        var x = ref$1[0];
        var y = ref$1[1];
        var z = ref$1[2];
        var l = 116 * y - 16;
        return [
            l < 0 ? 0 : l,
            500 * (x - y),
            200 * (y - z)
        ];
    };
    var rgb_xyz = function(r) {
        if ((r /= 255) <= 0.04045) return r / 12.92;
        return pow((r + 0.055) / 1.055, 2.4);
    };
    var xyz_lab = function(t) {
        if (t > labConstants.t3) return pow(t, 1 / 3);
        return t / labConstants.t2 + labConstants.t0;
    };
    var rgb2xyz = function(r, g, b) {
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / labConstants.Xn);
        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / labConstants.Yn);
        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / labConstants.Zn);
        return [
            x,
            y,
            z
        ];
    };
    var rgb2lab_1 = rgb2lab;
    var unpack$l = utils.unpack;
    var pow$1 = Math.pow;
    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */ var lab2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$l(args, 'lab');
        var l = args[0];
        var a = args[1];
        var b = args[2];
        var x, y, z, r, g, b_;
        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;
        y = labConstants.Yn * lab_xyz(y);
        x = labConstants.Xn * lab_xyz(x);
        z = labConstants.Zn * lab_xyz(z);
        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z); // D65 -> sRGB
        g = xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z);
        b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
        return [
            r,
            g,
            b_,
            args.length > 3 ? args[3] : 1
        ];
    };
    var xyz_rgb = function(r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$1(r, 1 / 2.4) - 0.055);
    };
    var lab_xyz = function(t) {
        return t > labConstants.t1 ? t * t * t : labConstants.t2 * (t - labConstants.t0);
    };
    var lab2rgb_1 = lab2rgb;
    var unpack$m = utils.unpack;
    var type$9 = utils.type;
    Color_1.prototype.lab = function() {
        return rgb2lab_1(this._rgb);
    };
    chroma_1.lab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'lab'
        ])));
    };
    input.format.lab = lab2rgb_1;
    input.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$m(args, 'lab');
            if (type$9(args) === 'array' && args.length === 3) return 'lab';
        }
    });
    var unpack$n = utils.unpack;
    var RAD2DEG = utils.RAD2DEG;
    var sqrt$1 = Math.sqrt;
    var atan2 = Math.atan2;
    var round$4 = Math.round;
    var lab2lch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$n(args, 'lab');
        var l = ref[0];
        var a = ref[1];
        var b = ref[2];
        var c = sqrt$1(a * a + b * b);
        var h = (atan2(b, a) * RAD2DEG + 360) % 360;
        if (round$4(c * 10000) === 0) h = Number.NaN;
        return [
            l,
            c,
            h
        ];
    };
    var lab2lch_1 = lab2lch;
    var unpack$o = utils.unpack;
    var rgb2lch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$o(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2lab_1(r, g, b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch_1(l, a, b_);
    };
    var rgb2lch_1 = rgb2lch;
    var unpack$p = utils.unpack;
    var DEG2RAD = utils.DEG2RAD;
    var sin = Math.sin;
    var cos$1 = Math.cos;
    var lch2lab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
        These formulas were invented by David Dalrymple to obtain maximum contrast without going
        out of gamut if the parameters are in the range 0-1.

        A saturation multiplier was added by Gregor Aisch
        */ var ref = unpack$p(args, 'lch');
        var l = ref[0];
        var c = ref[1];
        var h = ref[2];
        if (isNaN(h)) h = 0;
        h = h * DEG2RAD;
        return [
            l,
            cos$1(h) * c,
            sin(h) * c
        ];
    };
    var lch2lab_1 = lch2lab;
    var unpack$q = utils.unpack;
    var lch2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$q(args, 'lch');
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab_1(l, c, h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = lab2rgb_1(L, a, b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var lch2rgb_1 = lch2rgb;
    var unpack$r = utils.unpack;
    var hcl2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hcl = unpack$r(args, 'hcl').reverse();
        return lch2rgb_1.apply(void 0, hcl);
    };
    var hcl2rgb_1 = hcl2rgb;
    var unpack$s = utils.unpack;
    var type$a = utils.type;
    Color_1.prototype.lch = function() {
        return rgb2lch_1(this._rgb);
    };
    Color_1.prototype.hcl = function() {
        return rgb2lch_1(this._rgb).reverse();
    };
    chroma_1.lch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'lch'
        ])));
    };
    chroma_1.hcl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'hcl'
        ])));
    };
    input.format.lch = lch2rgb_1;
    input.format.hcl = hcl2rgb_1;
    [
        'lch',
        'hcl'
    ].forEach(function(m) {
        return input.autodetect.push({
            p: 2,
            test: function() {
                var args = [], len = arguments.length;
                while(len--)args[len] = arguments[len];
                args = unpack$s(args, m);
                if (type$a(args) === 'array' && args.length === 3) return m;
            }
        });
    });
    /**
    	X11 color names

    	http://www.w3.org/TR/css3-color/#svg-color
    */ var w3cx11 = {
        aliceblue: '#f0f8ff',
        antiquewhite: '#faebd7',
        aqua: '#00ffff',
        aquamarine: '#7fffd4',
        azure: '#f0ffff',
        beige: '#f5f5dc',
        bisque: '#ffe4c4',
        black: '#000000',
        blanchedalmond: '#ffebcd',
        blue: '#0000ff',
        blueviolet: '#8a2be2',
        brown: '#a52a2a',
        burlywood: '#deb887',
        cadetblue: '#5f9ea0',
        chartreuse: '#7fff00',
        chocolate: '#d2691e',
        coral: '#ff7f50',
        cornflower: '#6495ed',
        cornflowerblue: '#6495ed',
        cornsilk: '#fff8dc',
        crimson: '#dc143c',
        cyan: '#00ffff',
        darkblue: '#00008b',
        darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b',
        darkgray: '#a9a9a9',
        darkgreen: '#006400',
        darkgrey: '#a9a9a9',
        darkkhaki: '#bdb76b',
        darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f',
        darkorange: '#ff8c00',
        darkorchid: '#9932cc',
        darkred: '#8b0000',
        darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f',
        darkslateblue: '#483d8b',
        darkslategray: '#2f4f4f',
        darkslategrey: '#2f4f4f',
        darkturquoise: '#00ced1',
        darkviolet: '#9400d3',
        deeppink: '#ff1493',
        deepskyblue: '#00bfff',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1e90ff',
        firebrick: '#b22222',
        floralwhite: '#fffaf0',
        forestgreen: '#228b22',
        fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc',
        ghostwhite: '#f8f8ff',
        gold: '#ffd700',
        goldenrod: '#daa520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#adff2f',
        grey: '#808080',
        honeydew: '#f0fff0',
        hotpink: '#ff69b4',
        indianred: '#cd5c5c',
        indigo: '#4b0082',
        ivory: '#fffff0',
        khaki: '#f0e68c',
        laserlemon: '#ffff54',
        lavender: '#e6e6fa',
        lavenderblush: '#fff0f5',
        lawngreen: '#7cfc00',
        lemonchiffon: '#fffacd',
        lightblue: '#add8e6',
        lightcoral: '#f08080',
        lightcyan: '#e0ffff',
        lightgoldenrod: '#fafad2',
        lightgoldenrodyellow: '#fafad2',
        lightgray: '#d3d3d3',
        lightgreen: '#90ee90',
        lightgrey: '#d3d3d3',
        lightpink: '#ffb6c1',
        lightsalmon: '#ffa07a',
        lightseagreen: '#20b2aa',
        lightskyblue: '#87cefa',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0',
        lime: '#00ff00',
        limegreen: '#32cd32',
        linen: '#faf0e6',
        magenta: '#ff00ff',
        maroon: '#800000',
        maroon2: '#7f0000',
        maroon3: '#b03060',
        mediumaquamarine: '#66cdaa',
        mediumblue: '#0000cd',
        mediumorchid: '#ba55d3',
        mediumpurple: '#9370db',
        mediumseagreen: '#3cb371',
        mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a',
        mediumturquoise: '#48d1cc',
        mediumvioletred: '#c71585',
        midnightblue: '#191970',
        mintcream: '#f5fffa',
        mistyrose: '#ffe4e1',
        moccasin: '#ffe4b5',
        navajowhite: '#ffdead',
        navy: '#000080',
        oldlace: '#fdf5e6',
        olive: '#808000',
        olivedrab: '#6b8e23',
        orange: '#ffa500',
        orangered: '#ff4500',
        orchid: '#da70d6',
        palegoldenrod: '#eee8aa',
        palegreen: '#98fb98',
        paleturquoise: '#afeeee',
        palevioletred: '#db7093',
        papayawhip: '#ffefd5',
        peachpuff: '#ffdab9',
        peru: '#cd853f',
        pink: '#ffc0cb',
        plum: '#dda0dd',
        powderblue: '#b0e0e6',
        purple: '#800080',
        purple2: '#7f007f',
        purple3: '#a020f0',
        rebeccapurple: '#663399',
        red: '#ff0000',
        rosybrown: '#bc8f8f',
        royalblue: '#4169e1',
        saddlebrown: '#8b4513',
        salmon: '#fa8072',
        sandybrown: '#f4a460',
        seagreen: '#2e8b57',
        seashell: '#fff5ee',
        sienna: '#a0522d',
        silver: '#c0c0c0',
        skyblue: '#87ceeb',
        slateblue: '#6a5acd',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#fffafa',
        springgreen: '#00ff7f',
        steelblue: '#4682b4',
        tan: '#d2b48c',
        teal: '#008080',
        thistle: '#d8bfd8',
        tomato: '#ff6347',
        turquoise: '#40e0d0',
        violet: '#ee82ee',
        wheat: '#f5deb3',
        white: '#ffffff',
        whitesmoke: '#f5f5f5',
        yellow: '#ffff00',
        yellowgreen: '#9acd32'
    };
    var w3cx11_1 = w3cx11;
    var type$b = utils.type;
    Color_1.prototype.name = function() {
        var hex = rgb2hex_1(this._rgb, 'rgb');
        for(var i = 0, list = Object.keys(w3cx11_1); i < list.length; i += 1){
            var n = list[i];
            if (w3cx11_1[n] === hex) return n.toLowerCase();
        }
        return hex;
    };
    input.format.named = function(name) {
        name = name.toLowerCase();
        if (w3cx11_1[name]) return hex2rgb_1(w3cx11_1[name]);
        throw new Error('unknown color name: ' + name);
    };
    input.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$b(h) === 'string' && w3cx11_1[h.toLowerCase()]) return 'named';
        }
    });
    var unpack$t = utils.unpack;
    var rgb2num = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$t(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        return (r << 16) + (g << 8) + b;
    };
    var rgb2num_1 = rgb2num;
    var type$c = utils.type;
    var num2rgb = function(num) {
        if (type$c(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
            var r = num >> 16;
            var g = num >> 8 & 0xFF;
            var b = num & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        throw new Error("unknown num color: " + num);
    };
    var num2rgb_1 = num2rgb;
    var type$d = utils.type;
    Color_1.prototype.num = function() {
        return rgb2num_1(this._rgb);
    };
    chroma_1.num = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'num'
        ])));
    };
    input.format.num = num2rgb_1;
    input.autodetect.push({
        p: 5,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            if (args.length === 1 && type$d(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xFFFFFF) return 'num';
        }
    });
    var unpack$u = utils.unpack;
    var type$e = utils.type;
    var round$5 = Math.round;
    Color_1.prototype.rgb = function(rnd) {
        if (rnd === void 0) rnd = true;
        if (rnd === false) return this._rgb.slice(0, 3);
        return this._rgb.slice(0, 3).map(round$5);
    };
    Color_1.prototype.rgba = function(rnd) {
        if (rnd === void 0) rnd = true;
        return this._rgb.slice(0, 4).map(function(v, i) {
            return i < 3 ? rnd === false ? v : round$5(v) : v;
        });
    };
    chroma_1.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'rgb'
        ])));
    };
    input.format.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$u(args, 'rgba');
        if (rgba[3] === undefined) rgba[3] = 1;
        return rgba;
    };
    input.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$u(args, 'rgba');
            if (type$e(args) === 'array' && (args.length === 3 || args.length === 4 && type$e(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
        }
    });
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     */ var log = Math.log;
    var temperature2rgb = function(kelvin) {
        var temp = kelvin / 100;
        var r, g, b;
        if (temp < 66) {
            r = 255;
            g = -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log(g);
            b = 255;
        }
        return [
            r,
            g,
            b,
            1
        ];
    };
    var temperature2rgb_1 = temperature2rgb;
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     **/ var unpack$v = utils.unpack;
    var round$6 = Math.round;
    var rgb2temperature = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$v(args, 'rgb');
        var r = rgb[0], b = rgb[2];
        var minTemp = 1000;
        var maxTemp = 40000;
        var eps = 0.4;
        var temp;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            var rgb$1 = temperature2rgb_1(temp);
            if (rgb$1[2] / rgb$1[0] >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return round$6(temp);
    };
    var rgb2temperature_1 = rgb2temperature;
    Color_1.prototype.temp = Color_1.prototype.kelvin = Color_1.prototype.temperature = function() {
        return rgb2temperature_1(this._rgb);
    };
    chroma_1.temp = chroma_1.kelvin = chroma_1.temperature = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color_1, [
            null
        ].concat(args, [
            'temp'
        ])));
    };
    input.format.temp = input.format.kelvin = input.format.temperature = temperature2rgb_1;
    var type$f = utils.type;
    Color_1.prototype.alpha = function(a, mutate) {
        if (mutate === void 0) mutate = false;
        if (a !== undefined && type$f(a) === 'number') {
            if (mutate) {
                this._rgb[3] = a;
                return this;
            }
            return new Color_1([
                this._rgb[0],
                this._rgb[1],
                this._rgb[2],
                a
            ], 'rgb');
        }
        return this._rgb[3];
    };
    Color_1.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };
    Color_1.prototype.darken = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lab = me.lab();
        lab[0] -= labConstants.Kn * amount;
        return new Color_1(lab, 'lab').alpha(me.alpha(), true);
    };
    Color_1.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 1;
        return this.darken(-amount);
    };
    Color_1.prototype.darker = Color_1.prototype.darken;
    Color_1.prototype.brighter = Color_1.prototype.brighten;
    Color_1.prototype.get = function(mc) {
        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel);
            if (i > -1) return src[i];
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var type$g = utils.type;
    var pow$2 = Math.pow;
    var EPS = 1e-7;
    var MAX_ITER = 20;
    Color_1.prototype.luminance = function(lum) {
        if (lum !== undefined && type$g(lum) === 'number') {
            if (lum === 0) // return pure black
            return new Color_1([
                0,
                0,
                0,
                this._rgb[3]
            ], 'rgb');
            if (lum === 1) // return pure white
            return new Color_1([
                255,
                255,
                255,
                this._rgb[3]
            ], 'rgb');
            // compute new color using...
            var cur_lum = this.luminance();
            var mode = 'rgb';
            var max_iter = MAX_ITER;
            var test = function(low, high) {
                var mid = low.interpolate(high, 0.5, mode);
                var lm = mid.luminance();
                if (Math.abs(lum - lm) < EPS || !max_iter--) // close enough
                return mid;
                return lm > lum ? test(low, mid) : test(mid, high);
            };
            var rgb = (cur_lum > lum ? test(new Color_1([
                0,
                0,
                0
            ]), this) : test(this, new Color_1([
                255,
                255,
                255
            ]))).rgb();
            return new Color_1(rgb.concat([
                this._rgb[3]
            ]));
        }
        return rgb2luminance.apply(void 0, this._rgb.slice(0, 3));
    };
    var rgb2luminance = function(r, g, b) {
        // relative luminance
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    var luminance_x = function(x) {
        x /= 255;
        return x <= 0.03928 ? x / 12.92 : pow$2((x + 0.055) / 1.055, 2.4);
    };
    var interpolator = {};
    var type$h = utils.type;
    var mix = function(col1, col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 3;
        while(len-- > 0)rest[len] = arguments[len + 3];
        var mode = rest[0] || 'lrgb';
        if (!interpolator[mode] && !rest.length) // fall back to the first supported mode
        mode = Object.keys(interpolator)[0];
        if (!interpolator[mode]) throw new Error("interpolation mode " + mode + " is not defined");
        if (type$h(col1) !== 'object') col1 = new Color_1(col1);
        if (type$h(col2) !== 'object') col2 = new Color_1(col2);
        return interpolator[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };
    Color_1.prototype.mix = Color_1.prototype.interpolate = function(col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 2;
        while(len-- > 0)rest[len] = arguments[len + 2];
        return mix.apply(void 0, [
            this,
            col2,
            f
        ].concat(rest));
    };
    Color_1.prototype.premultiply = function(mutate) {
        if (mutate === void 0) mutate = false;
        var rgb = this._rgb;
        var a = rgb[3];
        if (mutate) {
            this._rgb = [
                rgb[0] * a,
                rgb[1] * a,
                rgb[2] * a,
                a
            ];
            return this;
        } else return new Color_1([
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ], 'rgb');
    };
    Color_1.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lch = me.lch();
        lch[1] += labConstants.Kn * amount;
        if (lch[1] < 0) lch[1] = 0;
        return new Color_1(lch, 'lch').alpha(me.alpha(), true);
    };
    Color_1.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 1;
        return this.saturate(-amount);
    };
    var type$i = utils.type;
    Color_1.prototype.set = function(mc, value, mutate) {
        if (mutate === void 0) mutate = false;
        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel);
            if (i > -1) {
                if (type$i(value) == 'string') switch(value.charAt(0)){
                    case '+':
                        src[i] += +value;
                        break;
                    case '-':
                        src[i] += +value;
                        break;
                    case '*':
                        src[i] *= +value.substr(1);
                        break;
                    case '/':
                        src[i] /= +value.substr(1);
                        break;
                    default:
                        src[i] = +value;
                }
                else if (type$i(value) === 'number') src[i] = value;
                else throw new Error("unsupported value for Color.set");
                var out = new Color_1(src, mode);
                if (mutate) {
                    this._rgb = out._rgb;
                    return this;
                }
                return out;
            }
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var rgb$1 = function(col1, col2, f) {
        var xyz0 = col1._rgb;
        var xyz1 = col2._rgb;
        return new Color_1(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
    };
    // register interpolator
    interpolator.rgb = rgb$1;
    var sqrt$2 = Math.sqrt;
    var pow$3 = Math.pow;
    var lrgb = function(col1, col2, f) {
        var ref = col1._rgb;
        var x1 = ref[0];
        var y1 = ref[1];
        var z1 = ref[2];
        var ref$1 = col2._rgb;
        var x2 = ref$1[0];
        var y2 = ref$1[1];
        var z2 = ref$1[2];
        return new Color_1(sqrt$2(pow$3(x1, 2) * (1 - f) + pow$3(x2, 2) * f), sqrt$2(pow$3(y1, 2) * (1 - f) + pow$3(y2, 2) * f), sqrt$2(pow$3(z1, 2) * (1 - f) + pow$3(z2, 2) * f), 'rgb');
    };
    // register interpolator
    interpolator.lrgb = lrgb;
    var lab$1 = function(col1, col2, f) {
        var xyz0 = col1.lab();
        var xyz1 = col2.lab();
        return new Color_1(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
    };
    // register interpolator
    interpolator.lab = lab$1;
    var _hsx = function(col1, col2, f, m) {
        var assign, assign$1;
        var xyz0, xyz1;
        if (m === 'hsl') {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === 'hsv') {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === 'hcg') {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === 'hsi') {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === 'lch' || m === 'hcl') {
            m = 'hcl';
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        }
        var hue0, hue1, sat0, sat1, lbv0, lbv1;
        if (m.substr(0, 1) === 'h') {
            assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2];
            assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2];
        }
        var sat, hue, lbv, dh;
        if (!isNaN(hue0) && !isNaN(hue1)) {
            // both colors have hue
            if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
            else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
            else dh = hue1 - hue0;
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
        } else hue = Number.NaN;
        if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
        lbv = lbv0 + f * (lbv1 - lbv0);
        return new Color_1([
            hue,
            sat,
            lbv
        ], m);
    };
    var lch$1 = function(col1, col2, f) {
        return _hsx(col1, col2, f, 'lch');
    };
    // register interpolator
    interpolator.lch = lch$1;
    interpolator.hcl = lch$1;
    var num$1 = function(col1, col2, f) {
        var c1 = col1.num();
        var c2 = col2.num();
        return new Color_1(c1 + f * (c2 - c1), 'num');
    };
    // register interpolator
    interpolator.num = num$1;
    var hcg$1 = function(col1, col2, f) {
        return _hsx(col1, col2, f, 'hcg');
    };
    // register interpolator
    interpolator.hcg = hcg$1;
    var hsi$1 = function(col1, col2, f) {
        return _hsx(col1, col2, f, 'hsi');
    };
    // register interpolator
    interpolator.hsi = hsi$1;
    var hsl$1 = function(col1, col2, f) {
        return _hsx(col1, col2, f, 'hsl');
    };
    // register interpolator
    interpolator.hsl = hsl$1;
    var hsv$1 = function(col1, col2, f) {
        return _hsx(col1, col2, f, 'hsv');
    };
    // register interpolator
    interpolator.hsv = hsv$1;
    var clip_rgb$2 = utils.clip_rgb;
    var pow$4 = Math.pow;
    var sqrt$3 = Math.sqrt;
    var PI$1 = Math.PI;
    var cos$2 = Math.cos;
    var sin$1 = Math.sin;
    var atan2$1 = Math.atan2;
    var average = function(colors, mode, weights) {
        if (mode === void 0) mode = 'lrgb';
        if (weights === void 0) weights = null;
        var l = colors.length;
        if (!weights) weights = Array.from(new Array(l)).map(function() {
            return 1;
        });
        // normalize weights
        var k = l / weights.reduce(function(a, b) {
            return a + b;
        });
        weights.forEach(function(w, i) {
            weights[i] *= k;
        });
        // convert colors to Color objects
        colors = colors.map(function(c) {
            return new Color_1(c);
        });
        if (mode === 'lrgb') return _average_lrgb(colors, weights);
        var first = colors.shift();
        var xyz = first.get(mode);
        var cnt = [];
        var dx = 0;
        var dy = 0;
        // initial color
        for(var i = 0; i < xyz.length; i++){
            xyz[i] = (xyz[i] || 0) * weights[0];
            cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
            if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
                var A = xyz[i] / 180 * PI$1;
                dx += cos$2(A) * weights[0];
                dy += sin$1(A) * weights[0];
            }
        }
        var alpha = first.alpha() * weights[0];
        colors.forEach(function(c, ci) {
            var xyz2 = c.get(mode);
            alpha += c.alpha() * weights[ci + 1];
            for(var i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
                cnt[i] += weights[ci + 1];
                if (mode.charAt(i) === 'h') {
                    var A = xyz2[i] / 180 * PI$1;
                    dx += cos$2(A) * weights[ci + 1];
                    dy += sin$1(A) * weights[ci + 1];
                } else xyz[i] += xyz2[i] * weights[ci + 1];
            }
        });
        for(var i$1 = 0; i$1 < xyz.length; i$1++)if (mode.charAt(i$1) === 'h') {
            var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
            while(A$1 < 0)A$1 += 360;
            while(A$1 >= 360)A$1 -= 360;
            xyz[i$1] = A$1;
        } else xyz[i$1] = xyz[i$1] / cnt[i$1];
        alpha /= l;
        return new Color_1(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
    };
    var _average_lrgb = function(colors, weights) {
        var l = colors.length;
        var xyz = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0; i < colors.length; i++){
            var col = colors[i];
            var f = weights[i] / l;
            var rgb = col._rgb;
            xyz[0] += pow$4(rgb[0], 2) * f;
            xyz[1] += pow$4(rgb[1], 2) * f;
            xyz[2] += pow$4(rgb[2], 2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt$3(xyz[0]);
        xyz[1] = sqrt$3(xyz[1]);
        xyz[2] = sqrt$3(xyz[2]);
        if (xyz[3] > 0.9999999) xyz[3] = 1;
        return new Color_1(clip_rgb$2(xyz));
    };
    // minimal multi-purpose interface
    // @requires utils color analyze
    var type$j = utils.type;
    var pow$5 = Math.pow;
    var scale = function(colors) {
        // constructor
        var _mode = 'rgb';
        var _nacol = chroma_1('#ccc');
        var _spread = 0;
        // const _fixed = false;
        var _domain = [
            0,
            1
        ];
        var _pos = [];
        var _padding = [
            0,
            0
        ];
        var _classes = false;
        var _colors = [];
        var _out = false;
        var _min = 0;
        var _max = 1;
        var _correctLightness = false;
        var _colorCache = {};
        var _useCache = true;
        var _gamma = 1;
        // private methods
        var setColors = function(colors) {
            colors = colors || [
                '#fff',
                '#000'
            ];
            if (colors && type$j(colors) === 'string' && chroma_1.brewer && chroma_1.brewer[colors.toLowerCase()]) colors = chroma_1.brewer[colors.toLowerCase()];
            if (type$j(colors) === 'array') {
                // handle single color
                if (colors.length === 1) colors = [
                    colors[0],
                    colors[0]
                ];
                // make a copy of the colors
                colors = colors.slice(0);
                // convert to chroma classes
                for(var c = 0; c < colors.length; c++)colors[c] = chroma_1(colors[c]);
                // auto-fill color position
                _pos.length = 0;
                for(var c$1 = 0; c$1 < colors.length; c$1++)_pos.push(c$1 / (colors.length - 1));
            }
            resetCache();
            return _colors = colors;
        };
        var getClass = function(value) {
            if (_classes != null) {
                var n = _classes.length - 1;
                var i = 0;
                while(i < n && value >= _classes[i])i++;
                return i - 1;
            }
            return 0;
        };
        var tMapLightness = function(t) {
            return t;
        };
        var tMapDomain = function(t) {
            return t;
        };
        // const classifyValue = function(value) {
        //     let val = value;
        //     if (_classes.length > 2) {
        //         const n = _classes.length-1;
        //         const i = getClass(value);
        //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
        //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
        //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
        //     }
        //     return val;
        // };
        var getColor = function(val, bypassMap) {
            var col, t;
            if (bypassMap == null) bypassMap = false;
            if (isNaN(val) || val === null) return _nacol;
            if (!bypassMap) {
                if (_classes && _classes.length > 2) {
                    // find the class
                    var c = getClass(val);
                    t = c / (_classes.length - 2);
                } else if (_max !== _min) // just interpolate between min/max
                t = (val - _min) / (_max - _min);
                else t = 1;
            } else t = val;
            // domain map
            t = tMapDomain(t);
            if (!bypassMap) t = tMapLightness(t); // lightness correction
            if (_gamma !== 1) t = pow$5(t, _gamma);
            t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
            t = Math.min(1, Math.max(0, t));
            var k = Math.floor(t * 10000);
            if (_useCache && _colorCache[k]) col = _colorCache[k];
            else {
                if (type$j(_colors) === 'array') //for i in [0.._pos.length-1]
                for(var i = 0; i < _pos.length; i++){
                    var p = _pos[i];
                    if (t <= p) {
                        col = _colors[i];
                        break;
                    }
                    if (t >= p && i === _pos.length - 1) {
                        col = _colors[i];
                        break;
                    }
                    if (t > p && t < _pos[i + 1]) {
                        t = (t - p) / (_pos[i + 1] - p);
                        col = chroma_1.interpolate(_colors[i], _colors[i + 1], t, _mode);
                        break;
                    }
                }
                else if (type$j(_colors) === 'function') col = _colors(t);
                if (_useCache) _colorCache[k] = col;
            }
            return col;
        };
        var resetCache = function() {
            return _colorCache = {};
        };
        setColors(colors);
        // public interface
        var f = function(v) {
            var c = chroma_1(getColor(v));
            if (_out && c[_out]) return c[_out]();
            else return c;
        };
        f.classes = function(classes) {
            if (classes != null) {
                if (type$j(classes) === 'array') {
                    _classes = classes;
                    _domain = [
                        classes[0],
                        classes[classes.length - 1]
                    ];
                } else {
                    var d = chroma_1.analyze(_domain);
                    if (classes === 0) _classes = [
                        d.min,
                        d.max
                    ];
                    else _classes = chroma_1.limits(d, 'e', classes);
                }
                return f;
            }
            return _classes;
        };
        f.domain = function(domain) {
            if (!arguments.length) return _domain;
            _min = domain[0];
            _max = domain[domain.length - 1];
            _pos = [];
            var k = _colors.length;
            if (domain.length === k && _min !== _max) // update positions
            for(var i = 0, list = Array.from(domain); i < list.length; i += 1){
                var d = list[i];
                _pos.push((d - _min) / (_max - _min));
            }
            else {
                for(var c = 0; c < k; c++)_pos.push(c / (k - 1));
                if (domain.length > 2) {
                    // set domain map
                    var tOut = domain.map(function(d, i) {
                        return i / (domain.length - 1);
                    });
                    var tBreaks = domain.map(function(d) {
                        return (d - _min) / (_max - _min);
                    });
                    if (!tBreaks.every(function(val, i) {
                        return tOut[i] === val;
                    })) tMapDomain = function(t) {
                        if (t <= 0 || t >= 1) return t;
                        var i = 0;
                        while(t >= tBreaks[i + 1])i++;
                        var f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                        var out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                        return out;
                    };
                }
            }
            _domain = [
                _min,
                _max
            ];
            return f;
        };
        f.mode = function(_m) {
            if (!arguments.length) return _mode;
            _mode = _m;
            resetCache();
            return f;
        };
        f.range = function(colors, _pos) {
            setColors(colors, _pos);
            return f;
        };
        f.out = function(_o) {
            _out = _o;
            return f;
        };
        f.spread = function(val) {
            if (!arguments.length) return _spread;
            _spread = val;
            return f;
        };
        f.correctLightness = function(v) {
            if (v == null) v = true;
            _correctLightness = v;
            resetCache();
            if (_correctLightness) tMapLightness = function(t) {
                var L0 = getColor(0, true).lab()[0];
                var L1 = getColor(1, true).lab()[0];
                var pol = L0 > L1;
                var L_actual = getColor(t, true).lab()[0];
                var L_ideal = L0 + (L1 - L0) * t;
                var L_diff = L_actual - L_ideal;
                var t0 = 0;
                var t1 = 1;
                var max_iter = 20;
                while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                    if (pol) L_diff *= -1;
                    if (L_diff < 0) {
                        t0 = t;
                        t += (t1 - t) * 0.5;
                    } else {
                        t1 = t;
                        t += (t0 - t) * 0.5;
                    }
                    L_actual = getColor(t, true).lab()[0];
                    return L_diff = L_actual - L_ideal;
                })();
                return t;
            };
            else tMapLightness = function(t) {
                return t;
            };
            return f;
        };
        f.padding = function(p) {
            if (p != null) {
                if (type$j(p) === 'number') p = [
                    p,
                    p
                ];
                _padding = p;
                return f;
            } else return _padding;
        };
        f.colors = function(numColors, out) {
            // If no arguments are given, return the original colors that were provided
            if (arguments.length < 2) out = 'hex';
            var result = [];
            if (arguments.length === 0) result = _colors.slice(0);
            else if (numColors === 1) result = [
                f(0.5)
            ];
            else if (numColors > 1) {
                var dm = _domain[0];
                var dd = _domain[1] - dm;
                result = __range__(0, numColors, false).map(function(i) {
                    return f(dm + i / (numColors - 1) * dd);
                });
            } else {
                colors = [];
                var samples = [];
                if (_classes && _classes.length > 2) for(var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
                else samples = _domain;
                result = samples.map(function(v) {
                    return f(v);
                });
            }
            if (chroma_1[out]) result = result.map(function(c) {
                return c[out]();
            });
            return result;
        };
        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else return _useCache;
        };
        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else return _gamma;
        };
        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma_1(d);
                return f;
            } else return _nacol;
        };
        return f;
    };
    function __range__(left, right, inclusive) {
        var range = [];
        var ascending = left < right;
        var end = !inclusive ? right : ascending ? right + 1 : right - 1;
        for(var i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
        return range;
    }
    //
    // interpolates between a set of colors uzing a bezier spline
    //
    // @requires utils lab
    var bezier = function(colors) {
        var assign, assign$1, assign$2;
        var I, lab0, lab1, lab2;
        colors = colors.map(function(c) {
            return new Color_1(c);
        });
        if (colors.length === 2) {
            // linear interpolation
            assign = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign[0], lab1 = assign[1];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return lab0[i] + t * (lab1[i] - lab0[i]);
                });
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 3) {
            // quadratic bezier interpolation
            assign$1 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i];
                });
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 4) {
            // cubic bezier interpolation
            var lab3;
            assign$2 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i];
                });
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 5) {
            var I0 = bezier(colors.slice(0, 3));
            var I1 = bezier(colors.slice(2, 5));
            I = function(t) {
                if (t < 0.5) return I0(t * 2);
                else return I1((t - 0.5) * 2);
            };
        }
        return I;
    };
    var bezier_1 = function(colors) {
        var f = bezier(colors);
        f.scale = function() {
            return scale(f);
        };
        return f;
    };
    /*
     * interpolates between a set of colors uzing a bezier spline
     * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
     */ var blend = function(bottom, top, mode) {
        if (!blend[mode]) throw new Error('unknown blend mode ' + mode);
        return blend[mode](bottom, top);
    };
    var blend_f = function(f) {
        return function(bottom, top) {
            var c0 = chroma_1(top).rgb();
            var c1 = chroma_1(bottom).rgb();
            return chroma_1.rgb(f(c0, c1));
        };
    };
    var each = function(f) {
        return function(c0, c1) {
            var out = [];
            out[0] = f(c0[0], c1[0]);
            out[1] = f(c0[1], c1[1]);
            out[2] = f(c0[2], c1[2]);
            return out;
        };
    };
    var normal = function(a) {
        return a;
    };
    var multiply = function(a, b) {
        return a * b / 255;
    };
    var darken$1 = function(a, b) {
        return a > b ? b : a;
    };
    var lighten = function(a, b) {
        return a > b ? a : b;
    };
    var screen = function(a, b) {
        return 255 * (1 - (1 - a / 255) * (1 - b / 255));
    };
    var overlay = function(a, b) {
        return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    };
    var burn = function(a, b) {
        return 255 * (1 - (1 - b / 255) / (a / 255));
    };
    var dodge = function(a, b) {
        if (a === 255) return 255;
        a = 255 * (b / 255) / (1 - a / 255);
        return a > 255 ? 255 : a;
    };
    // # add = (a,b) ->
    // #     if (a + b > 255) then 255 else a + b
    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken$1));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    // blend.add = blend_f(each(add));
    var blend_1 = blend;
    // cubehelix interpolation
    // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
    // http://astron-soc.in/bulletin/11June/289392011.pdf
    var type$k = utils.type;
    var clip_rgb$3 = utils.clip_rgb;
    var TWOPI$2 = utils.TWOPI;
    var pow$6 = Math.pow;
    var sin$2 = Math.sin;
    var cos$3 = Math.cos;
    var cubehelix = function(start, rotations, hue, gamma, lightness) {
        if (start === void 0) start = 300;
        if (rotations === void 0) rotations = -1.5;
        if (hue === void 0) hue = 1;
        if (gamma === void 0) gamma = 1;
        if (lightness === void 0) lightness = [
            0,
            1
        ];
        var dh = 0, dl;
        if (type$k(lightness) === 'array') dl = lightness[1] - lightness[0];
        else {
            dl = 0;
            lightness = [
                lightness,
                lightness
            ];
        }
        var f = function(fract) {
            var a = TWOPI$2 * ((start + 120) / 360 + rotations * fract);
            var l = pow$6(lightness[0] + dl * fract, gamma);
            var h = dh !== 0 ? hue[0] + fract * dh : hue;
            var amp = h * l * (1 - l) / 2;
            var cos_a = cos$3(a);
            var sin_a = sin$2(a);
            var r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
            var g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
            var b = l + amp * (1.97294 * cos_a);
            return chroma_1(clip_rgb$3([
                r * 255,
                g * 255,
                b * 255,
                1
            ]));
        };
        f.start = function(s) {
            if (s == null) return start;
            start = s;
            return f;
        };
        f.rotations = function(r) {
            if (r == null) return rotations;
            rotations = r;
            return f;
        };
        f.gamma = function(g) {
            if (g == null) return gamma;
            gamma = g;
            return f;
        };
        f.hue = function(h) {
            if (h == null) return hue;
            hue = h;
            if (type$k(hue) === 'array') {
                dh = hue[1] - hue[0];
                if (dh === 0) hue = hue[1];
            } else dh = 0;
            return f;
        };
        f.lightness = function(h) {
            if (h == null) return lightness;
            if (type$k(h) === 'array') {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [
                    h,
                    h
                ];
                dl = 0;
            }
            return f;
        };
        f.scale = function() {
            return chroma_1.scale(f);
        };
        f.hue(hue);
        return f;
    };
    var digits = '0123456789abcdef';
    var floor$2 = Math.floor;
    var random = Math.random;
    var random_1 = function() {
        var code = '#';
        for(var i = 0; i < 6; i++)code += digits.charAt(floor$2(random() * 16));
        return new Color_1(code, 'hex');
    };
    var log$1 = Math.log;
    var pow$7 = Math.pow;
    var floor$3 = Math.floor;
    var abs = Math.abs;
    var analyze = function(data, key) {
        if (key === void 0) key = null;
        var r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        if (type(data) === 'object') data = Object.values(data);
        data.forEach(function(val) {
            if (key && type(val) === 'object') val = val[key];
            if (val !== undefined && val !== null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        });
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return limits(r, mode, num);
        };
        return r;
    };
    var limits = function(data, mode, num) {
        if (mode === void 0) mode = 'equal';
        if (num === void 0) num = 7;
        if (type(data) == 'array') data = analyze(data);
        var min = data.min;
        var max = data.max;
        var values = data.values.sort(function(a, b) {
            return a - b;
        });
        if (num === 1) return [
            min,
            max
        ];
        var limits = [];
        if (mode.substr(0, 1) === 'c') {
            limits.push(min);
            limits.push(max);
        }
        if (mode.substr(0, 1) === 'e') {
            limits.push(min);
            for(var i = 1; i < num; i++)limits.push(min + i / num * (max - min));
            limits.push(max);
        } else if (mode.substr(0, 1) === 'l') {
            if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
            var min_log = Math.LOG10E * log$1(min);
            var max_log = Math.LOG10E * log$1(max);
            limits.push(min);
            for(var i$1 = 1; i$1 < num; i$1++)limits.push(pow$7(10, min_log + i$1 / num * (max_log - min_log)));
            limits.push(max);
        } else if (mode.substr(0, 1) === 'q') {
            limits.push(min);
            for(var i$2 = 1; i$2 < num; i$2++){
                var p = (values.length - 1) * i$2 / num;
                var pb = floor$3(p);
                if (pb === p) limits.push(values[pb]);
                else {
                    var pr = p - pb;
                    limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
                }
            }
            limits.push(max);
        } else if (mode.substr(0, 1) === 'k') {
            /*
            implementation based on
            http://code.google.com/p/figue/source/browse/trunk/figue.js#336
            simplified for 1-d input values
            */ var cluster;
            var n = values.length;
            var assignments = new Array(n);
            var clusterSizes = new Array(num);
            var repeat = true;
            var nb_iters = 0;
            var centroids = null;
            // get seed values
            centroids = [];
            centroids.push(min);
            for(var i$3 = 1; i$3 < num; i$3++)centroids.push(min + i$3 / num * (max - min));
            centroids.push(max);
            while(repeat){
                // assignment step
                for(var j = 0; j < num; j++)clusterSizes[j] = 0;
                for(var i$4 = 0; i$4 < n; i$4++){
                    var value = values[i$4];
                    var mindist = Number.MAX_VALUE;
                    var best = void 0;
                    for(var j$1 = 0; j$1 < num; j$1++){
                        var dist = abs(centroids[j$1] - value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j$1;
                        }
                        clusterSizes[best]++;
                        assignments[i$4] = best;
                    }
                }
                // update centroids step
                var newCentroids = new Array(num);
                for(var j$2 = 0; j$2 < num; j$2++)newCentroids[j$2] = null;
                for(var i$5 = 0; i$5 < n; i$5++){
                    cluster = assignments[i$5];
                    if (newCentroids[cluster] === null) newCentroids[cluster] = values[i$5];
                    else newCentroids[cluster] += values[i$5];
                }
                for(var j$3 = 0; j$3 < num; j$3++)newCentroids[j$3] *= 1 / clusterSizes[j$3];
                // check convergence
                repeat = false;
                for(var j$4 = 0; j$4 < num; j$4++)if (newCentroids[j$4] !== centroids[j$4]) {
                    repeat = true;
                    break;
                }
                centroids = newCentroids;
                nb_iters++;
                if (nb_iters > 200) repeat = false;
            }
            // finished k-means clustering
            // the next part is borrowed from gabrielflor.it
            var kClusters = {};
            for(var j$5 = 0; j$5 < num; j$5++)kClusters[j$5] = [];
            for(var i$6 = 0; i$6 < n; i$6++){
                cluster = assignments[i$6];
                kClusters[cluster].push(values[i$6]);
            }
            var tmpKMeansBreaks = [];
            for(var j$6 = 0; j$6 < num; j$6++){
                tmpKMeansBreaks.push(kClusters[j$6][0]);
                tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length - 1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
                return a - b;
            });
            limits.push(tmpKMeansBreaks[0]);
            for(var i$7 = 1; i$7 < tmpKMeansBreaks.length; i$7 += 2){
                var v = tmpKMeansBreaks[i$7];
                if (!isNaN(v) && limits.indexOf(v) === -1) limits.push(v);
            }
        }
        return limits;
    };
    var analyze_1 = {
        analyze: analyze,
        limits: limits
    };
    var contrast = function(a, b) {
        // WCAG contrast ratio
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
        a = new Color_1(a);
        b = new Color_1(b);
        var l1 = a.luminance();
        var l2 = b.luminance();
        return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
    };
    var sqrt$4 = Math.sqrt;
    var atan2$2 = Math.atan2;
    var abs$1 = Math.abs;
    var cos$4 = Math.cos;
    var PI$2 = Math.PI;
    var deltaE = function(a, b, L, C) {
        if (L === void 0) L = 1;
        if (C === void 0) C = 1;
        // Delta E (CMC)
        // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CMC.html
        a = new Color_1(a);
        b = new Color_1(b);
        var ref = Array.from(a.lab());
        var L1 = ref[0];
        var a1 = ref[1];
        var b1 = ref[2];
        var ref$1 = Array.from(b.lab());
        var L2 = ref$1[0];
        var a2 = ref$1[1];
        var b2 = ref$1[2];
        var c1 = sqrt$4(a1 * a1 + b1 * b1);
        var c2 = sqrt$4(a2 * a2 + b2 * b2);
        var sl = L1 < 16.0 ? 0.511 : 0.040975 * L1 / (1.0 + 0.01765 * L1);
        var sc = 0.0638 * c1 / (1.0 + 0.0131 * c1) + 0.638;
        var h1 = c1 < 0.000001 ? 0.0 : atan2$2(b1, a1) * 180.0 / PI$2;
        while(h1 < 0)h1 += 360;
        while(h1 >= 360)h1 -= 360;
        var t = h1 >= 164.0 && h1 <= 345.0 ? 0.56 + abs$1(0.2 * cos$4(PI$2 * (h1 + 168.0) / 180.0)) : 0.36 + abs$1(0.4 * cos$4(PI$2 * (h1 + 35.0) / 180.0));
        var c4 = c1 * c1 * c1 * c1;
        var f = sqrt$4(c4 / (c4 + 1900.0));
        var sh = sc * (f * t + 1.0 - f);
        var delL = L1 - L2;
        var delC = c1 - c2;
        var delA = a1 - a2;
        var delB = b1 - b2;
        var dH2 = delA * delA + delB * delB - delC * delC;
        var v1 = delL / (L * sl);
        var v2 = delC / (C * sc);
        var v3 = sh;
        return sqrt$4(v1 * v1 + v2 * v2 + dH2 / (v3 * v3));
    };
    // simple Euclidean distance
    var distance = function(a, b, mode) {
        if (mode === void 0) mode = 'lab';
        // Delta E (CIE 1976)
        // see http://www.brucelindbloom.com/index.html?Equations.html
        a = new Color_1(a);
        b = new Color_1(b);
        var l1 = a.get(mode);
        var l2 = b.get(mode);
        var sum_sq = 0;
        for(var i in l1){
            var d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d * d;
        }
        return Math.sqrt(sum_sq);
    };
    var valid = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        try {
            new (Function.prototype.bind.apply(Color_1, [
                null
            ].concat(args)));
            return true;
        } catch (e) {
            return false;
        }
    };
    // some pre-defined color scales:
    var scales = {
        cool: function cool() {
            return scale([
                chroma_1.hsl(180, 1, .9),
                chroma_1.hsl(250, .7, .4)
            ]);
        },
        hot: function hot() {
            return scale([
                '#000',
                '#f00',
                '#ff0',
                '#fff'
            ], [
                0,
                .25,
                .75,
                1
            ]).mode('rgb');
        }
    };
    /**
        ColorBrewer colors for chroma.js

        Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
        Pennsylvania State University.

        Licensed under the Apache License, Version 2.0 (the "License");
        you may not use this file except in compliance with the License.
        You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0

        Unless required by applicable law or agreed to in writing, software distributed
        under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for the
        specific language governing permissions and limitations under the License.
    */ var colorbrewer = {
        // sequential
        OrRd: [
            '#fff7ec',
            '#fee8c8',
            '#fdd49e',
            '#fdbb84',
            '#fc8d59',
            '#ef6548',
            '#d7301f',
            '#b30000',
            '#7f0000'
        ],
        PuBu: [
            '#fff7fb',
            '#ece7f2',
            '#d0d1e6',
            '#a6bddb',
            '#74a9cf',
            '#3690c0',
            '#0570b0',
            '#045a8d',
            '#023858'
        ],
        BuPu: [
            '#f7fcfd',
            '#e0ecf4',
            '#bfd3e6',
            '#9ebcda',
            '#8c96c6',
            '#8c6bb1',
            '#88419d',
            '#810f7c',
            '#4d004b'
        ],
        Oranges: [
            '#fff5eb',
            '#fee6ce',
            '#fdd0a2',
            '#fdae6b',
            '#fd8d3c',
            '#f16913',
            '#d94801',
            '#a63603',
            '#7f2704'
        ],
        BuGn: [
            '#f7fcfd',
            '#e5f5f9',
            '#ccece6',
            '#99d8c9',
            '#66c2a4',
            '#41ae76',
            '#238b45',
            '#006d2c',
            '#00441b'
        ],
        YlOrBr: [
            '#ffffe5',
            '#fff7bc',
            '#fee391',
            '#fec44f',
            '#fe9929',
            '#ec7014',
            '#cc4c02',
            '#993404',
            '#662506'
        ],
        YlGn: [
            '#ffffe5',
            '#f7fcb9',
            '#d9f0a3',
            '#addd8e',
            '#78c679',
            '#41ab5d',
            '#238443',
            '#006837',
            '#004529'
        ],
        Reds: [
            '#fff5f0',
            '#fee0d2',
            '#fcbba1',
            '#fc9272',
            '#fb6a4a',
            '#ef3b2c',
            '#cb181d',
            '#a50f15',
            '#67000d'
        ],
        RdPu: [
            '#fff7f3',
            '#fde0dd',
            '#fcc5c0',
            '#fa9fb5',
            '#f768a1',
            '#dd3497',
            '#ae017e',
            '#7a0177',
            '#49006a'
        ],
        Greens: [
            '#f7fcf5',
            '#e5f5e0',
            '#c7e9c0',
            '#a1d99b',
            '#74c476',
            '#41ab5d',
            '#238b45',
            '#006d2c',
            '#00441b'
        ],
        YlGnBu: [
            '#ffffd9',
            '#edf8b1',
            '#c7e9b4',
            '#7fcdbb',
            '#41b6c4',
            '#1d91c0',
            '#225ea8',
            '#253494',
            '#081d58'
        ],
        Purples: [
            '#fcfbfd',
            '#efedf5',
            '#dadaeb',
            '#bcbddc',
            '#9e9ac8',
            '#807dba',
            '#6a51a3',
            '#54278f',
            '#3f007d'
        ],
        GnBu: [
            '#f7fcf0',
            '#e0f3db',
            '#ccebc5',
            '#a8ddb5',
            '#7bccc4',
            '#4eb3d3',
            '#2b8cbe',
            '#0868ac',
            '#084081'
        ],
        Greys: [
            '#ffffff',
            '#f0f0f0',
            '#d9d9d9',
            '#bdbdbd',
            '#969696',
            '#737373',
            '#525252',
            '#252525',
            '#000000'
        ],
        YlOrRd: [
            '#ffffcc',
            '#ffeda0',
            '#fed976',
            '#feb24c',
            '#fd8d3c',
            '#fc4e2a',
            '#e31a1c',
            '#bd0026',
            '#800026'
        ],
        PuRd: [
            '#f7f4f9',
            '#e7e1ef',
            '#d4b9da',
            '#c994c7',
            '#df65b0',
            '#e7298a',
            '#ce1256',
            '#980043',
            '#67001f'
        ],
        Blues: [
            '#f7fbff',
            '#deebf7',
            '#c6dbef',
            '#9ecae1',
            '#6baed6',
            '#4292c6',
            '#2171b5',
            '#08519c',
            '#08306b'
        ],
        PuBuGn: [
            '#fff7fb',
            '#ece2f0',
            '#d0d1e6',
            '#a6bddb',
            '#67a9cf',
            '#3690c0',
            '#02818a',
            '#016c59',
            '#014636'
        ],
        Viridis: [
            '#440154',
            '#482777',
            '#3f4a8a',
            '#31678e',
            '#26838f',
            '#1f9d8a',
            '#6cce5a',
            '#b6de2b',
            '#fee825'
        ],
        // diverging
        Spectral: [
            '#9e0142',
            '#d53e4f',
            '#f46d43',
            '#fdae61',
            '#fee08b',
            '#ffffbf',
            '#e6f598',
            '#abdda4',
            '#66c2a5',
            '#3288bd',
            '#5e4fa2'
        ],
        RdYlGn: [
            '#a50026',
            '#d73027',
            '#f46d43',
            '#fdae61',
            '#fee08b',
            '#ffffbf',
            '#d9ef8b',
            '#a6d96a',
            '#66bd63',
            '#1a9850',
            '#006837'
        ],
        RdBu: [
            '#67001f',
            '#b2182b',
            '#d6604d',
            '#f4a582',
            '#fddbc7',
            '#f7f7f7',
            '#d1e5f0',
            '#92c5de',
            '#4393c3',
            '#2166ac',
            '#053061'
        ],
        PiYG: [
            '#8e0152',
            '#c51b7d',
            '#de77ae',
            '#f1b6da',
            '#fde0ef',
            '#f7f7f7',
            '#e6f5d0',
            '#b8e186',
            '#7fbc41',
            '#4d9221',
            '#276419'
        ],
        PRGn: [
            '#40004b',
            '#762a83',
            '#9970ab',
            '#c2a5cf',
            '#e7d4e8',
            '#f7f7f7',
            '#d9f0d3',
            '#a6dba0',
            '#5aae61',
            '#1b7837',
            '#00441b'
        ],
        RdYlBu: [
            '#a50026',
            '#d73027',
            '#f46d43',
            '#fdae61',
            '#fee090',
            '#ffffbf',
            '#e0f3f8',
            '#abd9e9',
            '#74add1',
            '#4575b4',
            '#313695'
        ],
        BrBG: [
            '#543005',
            '#8c510a',
            '#bf812d',
            '#dfc27d',
            '#f6e8c3',
            '#f5f5f5',
            '#c7eae5',
            '#80cdc1',
            '#35978f',
            '#01665e',
            '#003c30'
        ],
        RdGy: [
            '#67001f',
            '#b2182b',
            '#d6604d',
            '#f4a582',
            '#fddbc7',
            '#ffffff',
            '#e0e0e0',
            '#bababa',
            '#878787',
            '#4d4d4d',
            '#1a1a1a'
        ],
        PuOr: [
            '#7f3b08',
            '#b35806',
            '#e08214',
            '#fdb863',
            '#fee0b6',
            '#f7f7f7',
            '#d8daeb',
            '#b2abd2',
            '#8073ac',
            '#542788',
            '#2d004b'
        ],
        // qualitative
        Set2: [
            '#66c2a5',
            '#fc8d62',
            '#8da0cb',
            '#e78ac3',
            '#a6d854',
            '#ffd92f',
            '#e5c494',
            '#b3b3b3'
        ],
        Accent: [
            '#7fc97f',
            '#beaed4',
            '#fdc086',
            '#ffff99',
            '#386cb0',
            '#f0027f',
            '#bf5b17',
            '#666666'
        ],
        Set1: [
            '#e41a1c',
            '#377eb8',
            '#4daf4a',
            '#984ea3',
            '#ff7f00',
            '#ffff33',
            '#a65628',
            '#f781bf',
            '#999999'
        ],
        Set3: [
            '#8dd3c7',
            '#ffffb3',
            '#bebada',
            '#fb8072',
            '#80b1d3',
            '#fdb462',
            '#b3de69',
            '#fccde5',
            '#d9d9d9',
            '#bc80bd',
            '#ccebc5',
            '#ffed6f'
        ],
        Dark2: [
            '#1b9e77',
            '#d95f02',
            '#7570b3',
            '#e7298a',
            '#66a61e',
            '#e6ab02',
            '#a6761d',
            '#666666'
        ],
        Paired: [
            '#a6cee3',
            '#1f78b4',
            '#b2df8a',
            '#33a02c',
            '#fb9a99',
            '#e31a1c',
            '#fdbf6f',
            '#ff7f00',
            '#cab2d6',
            '#6a3d9a',
            '#ffff99',
            '#b15928'
        ],
        Pastel2: [
            '#b3e2cd',
            '#fdcdac',
            '#cbd5e8',
            '#f4cae4',
            '#e6f5c9',
            '#fff2ae',
            '#f1e2cc',
            '#cccccc'
        ],
        Pastel1: [
            '#fbb4ae',
            '#b3cde3',
            '#ccebc5',
            '#decbe4',
            '#fed9a6',
            '#ffffcc',
            '#e5d8bd',
            '#fddaec',
            '#f2f2f2'
        ]
    };
    // add lowercase aliases for case-insensitive matches
    for(var i$1 = 0, list$1 = Object.keys(colorbrewer); i$1 < list$1.length; i$1 += 1){
        var key = list$1[i$1];
        colorbrewer[key.toLowerCase()] = colorbrewer[key];
    }
    var colorbrewer_1 = colorbrewer;
    // feel free to comment out anything to rollup
    // a smaller chroma.js built
    // io --> convert colors
    // operators --> modify existing Colors
    // interpolators
    // generators -- > create new colors
    chroma_1.average = average;
    chroma_1.bezier = bezier_1;
    chroma_1.blend = blend_1;
    chroma_1.cubehelix = cubehelix;
    chroma_1.mix = chroma_1.interpolate = mix;
    chroma_1.random = random_1;
    chroma_1.scale = scale;
    // other utility methods
    chroma_1.analyze = analyze_1.analyze;
    chroma_1.contrast = contrast;
    chroma_1.deltaE = deltaE;
    chroma_1.distance = distance;
    chroma_1.limits = analyze_1.limits;
    chroma_1.valid = valid;
    // scale
    chroma_1.scales = scales;
    // colors
    chroma_1.colors = w3cx11_1;
    chroma_1.brewer = colorbrewer_1;
    var chroma_js = chroma_1;
    return chroma_js;
});



var $aHLOA = parcelRequire("aHLOA");
var $fd4b61c353ee6397$exports = {};
var $ac590f7f1fef67ad$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ac590f7f1fef67ad$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$ac590f7f1fef67ad$exports = $ac590f7f1fef67ad$var$arrayEach;


var $29b0a0eb2844d66d$exports = {};
var $aaf49aa8181669f4$exports = {};
var $1d373c3561b6550e$exports = {};
var $d5656b49dc855430$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d5656b49dc855430$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$d5656b49dc855430$exports = $d5656b49dc855430$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $1d373c3561b6550e$var$baseFor = $d5656b49dc855430$exports();
$1d373c3561b6550e$exports = $1d373c3561b6550e$var$baseFor;



var $gRgFA = parcelRequire("gRgFA");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $aaf49aa8181669f4$var$baseForOwn(object, iteratee) {
    return object && $1d373c3561b6550e$exports(object, iteratee, $gRgFA);
}
$aaf49aa8181669f4$exports = $aaf49aa8181669f4$var$baseForOwn;


var $6b0f87d1ff458925$exports = {};

var $50iuD = parcelRequire("50iuD");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6b0f87d1ff458925$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$50iuD(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$6b0f87d1ff458925$exports = $6b0f87d1ff458925$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $29b0a0eb2844d66d$var$baseEach = $6b0f87d1ff458925$exports($aaf49aa8181669f4$exports);
$29b0a0eb2844d66d$exports = $29b0a0eb2844d66d$var$baseEach;


var $f98a335dfb3bb161$exports = {};

var $bHMyM = parcelRequire("bHMyM");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $f98a335dfb3bb161$var$castFunction(value) {
    return typeof value == 'function' ? value : $bHMyM;
}
$f98a335dfb3bb161$exports = $f98a335dfb3bb161$var$castFunction;



var $ae8en = parcelRequire("ae8en");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $fd4b61c353ee6397$var$forEach(collection, iteratee) {
    var func = $ae8en(collection) ? $ac590f7f1fef67ad$exports : $29b0a0eb2844d66d$exports;
    return func(collection, $f98a335dfb3bb161$exports(iteratee));
}
$fd4b61c353ee6397$exports = $fd4b61c353ee6397$var$forEach;


var $96e2fee1941156ba$exports = {};
var $3103d8a23e4e2ae3$exports = {};

var $836c9 = parcelRequire("836c9");
var $b6aadce202f651ef$exports = {};

var $bpT63 = parcelRequire("bpT63");

var $jmUZP = parcelRequire("jmUZP");

var $ae8en = parcelRequire("ae8en");
/** Built-in value references. */ var $b6aadce202f651ef$var$spreadableSymbol = $bpT63 ? $bpT63.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $b6aadce202f651ef$var$isFlattenable(value) {
    return $ae8en(value) || $jmUZP(value) || !!($b6aadce202f651ef$var$spreadableSymbol && value && value[$b6aadce202f651ef$var$spreadableSymbol]);
}
$b6aadce202f651ef$exports = $b6aadce202f651ef$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $3103d8a23e4e2ae3$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $b6aadce202f651ef$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $3103d8a23e4e2ae3$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $836c9(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$3103d8a23e4e2ae3$exports = $3103d8a23e4e2ae3$var$baseFlatten;


var $77a1bc7c0a1d2ec2$exports = {};

var $g7GeS = parcelRequire("g7GeS");

var $eI84R = parcelRequire("eI84R");

var $2oilF = parcelRequire("2oilF");
var $4bcdfc647454ecfa$exports = {};


var $50iuD = parcelRequire("50iuD");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4bcdfc647454ecfa$var$baseMap(collection, iteratee) {
    var index = -1, result = $50iuD(collection) ? Array(collection.length) : [];
    $29b0a0eb2844d66d$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$4bcdfc647454ecfa$exports = $4bcdfc647454ecfa$var$baseMap;


var $7b2d02fb463af113$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $7b2d02fb463af113$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$7b2d02fb463af113$exports = $7b2d02fb463af113$var$baseSortBy;



var $3B3Jp = parcelRequire("3B3Jp");
var $34deedb3495a6f6d$exports = {};
var $6c14f67ba649d2a1$exports = {};

var $tMqsp = parcelRequire("tMqsp");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $6c14f67ba649d2a1$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $tMqsp(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $tMqsp(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$6c14f67ba649d2a1$exports = $6c14f67ba649d2a1$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $34deedb3495a6f6d$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $6c14f67ba649d2a1$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$34deedb3495a6f6d$exports = $34deedb3495a6f6d$var$compareMultiple;



var $bHMyM = parcelRequire("bHMyM");

var $ae8en = parcelRequire("ae8en");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $77a1bc7c0a1d2ec2$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $g7GeS(iteratees, function(iteratee) {
        if ($ae8en(iteratee)) return function(value) {
            return $eI84R(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $bHMyM
    ];
    var index = -1;
    iteratees = $g7GeS(iteratees, $3B3Jp($2oilF));
    var result = $4bcdfc647454ecfa$exports(collection, function(value, key, collection) {
        var criteria = $g7GeS(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $7b2d02fb463af113$exports(result, function(object, other) {
        return $34deedb3495a6f6d$exports(object, other, orders);
    });
}
$77a1bc7c0a1d2ec2$exports = $77a1bc7c0a1d2ec2$var$baseOrderBy;


var $845a21b6a66c43ea$exports = {};

var $bHMyM = parcelRequire("bHMyM");
var $79639887e72ab027$exports = {};
var $e739a7fb339f47c4$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e739a7fb339f47c4$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$e739a7fb339f47c4$exports = $e739a7fb339f47c4$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $79639887e72ab027$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $79639887e72ab027$var$overRest(func, start, transform) {
    start = $79639887e72ab027$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $79639887e72ab027$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $e739a7fb339f47c4$exports(func, this, otherArgs);
    };
}
$79639887e72ab027$exports = $79639887e72ab027$var$overRest;


var $70011ad32a955258$exports = {};
var $aa8a4d1ddae4e4b2$exports = {};
var $3d04e6fb9e156fac$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $3d04e6fb9e156fac$var$constant(value) {
    return function() {
        return value;
    };
}
$3d04e6fb9e156fac$exports = $3d04e6fb9e156fac$var$constant;



var $2WeUr = parcelRequire("2WeUr");

var $bHMyM = parcelRequire("bHMyM");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $aa8a4d1ddae4e4b2$var$baseSetToString = !$2WeUr ? $bHMyM : function(func, string) {
    return $2WeUr(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $3d04e6fb9e156fac$exports(string),
        'writable': true
    });
};
$aa8a4d1ddae4e4b2$exports = $aa8a4d1ddae4e4b2$var$baseSetToString;


var $8fea028ad543df0e$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $8fea028ad543df0e$var$HOT_COUNT = 800, $8fea028ad543df0e$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8fea028ad543df0e$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $8fea028ad543df0e$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $8fea028ad543df0e$var$nativeNow(), remaining = $8fea028ad543df0e$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $8fea028ad543df0e$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$8fea028ad543df0e$exports = $8fea028ad543df0e$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $70011ad32a955258$var$setToString = $8fea028ad543df0e$exports($aa8a4d1ddae4e4b2$exports);
$70011ad32a955258$exports = $70011ad32a955258$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $845a21b6a66c43ea$var$baseRest(func, start) {
    return $70011ad32a955258$exports($79639887e72ab027$exports(func, start, $bHMyM), func + '');
}
$845a21b6a66c43ea$exports = $845a21b6a66c43ea$var$baseRest;


var $d6d9b434b5276597$exports = {};

var $h2kXj = parcelRequire("h2kXj");

var $50iuD = parcelRequire("50iuD");

var $iVSLT = parcelRequire("iVSLT");

var $e9Eyz = parcelRequire("e9Eyz");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $d6d9b434b5276597$var$isIterateeCall(value, index, object) {
    if (!$e9Eyz(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $50iuD(object) && $iVSLT(index, object.length) : type == 'string' && index in object) return $h2kXj(object[index], value);
    return false;
}
$d6d9b434b5276597$exports = $d6d9b434b5276597$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $96e2fee1941156ba$var$sortBy = $845a21b6a66c43ea$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $d6d9b434b5276597$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $d6d9b434b5276597$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $77a1bc7c0a1d2ec2$exports(collection, $3103d8a23e4e2ae3$exports(iteratees, 1), []);
});
$96e2fee1941156ba$exports = $96e2fee1941156ba$var$sortBy;



var $lgFxF = parcelRequire("lgFxF");

var $lgFxF = parcelRequire("lgFxF");

class $3a8ee79cdacea239$var$GitHubButton extends (0, $lgFxF.PureComponent) {
    constructor(props){
        super(props);
        this.$ = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createRef();
        this._ = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createRef();
    }
    render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement('span', {
            ref: this.$
        }, (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement('a', {
            ...this.props,
            ref: this._
        }, this.props.children));
    }
    componentDidMount() {
        this.paint();
    }
    getSnapshotBeforeUpdate() {
        this.reset();
        return null;
    }
    componentDidUpdate() {
        this.paint();
    }
    componentWillUnmount() {
        this.reset();
    }
    paint() {
        const _ = this.$.current.appendChild(document.createElement('span'));
        (parcelRequire("6ZVPo")).then(({ render: render })=>{
            render(_.appendChild(this._.current), function(el) {
                try {
                    _.parentNode.replaceChild(el, _);
                } catch (_) {}
            });
        });
    }
    reset() {
        this.$.current.replaceChild(this._.current, this.$.current.lastChild);
    }
}
var $3a8ee79cdacea239$export$2e2bcd8739ae039 = $3a8ee79cdacea239$var$GitHubButton;


function $fbf48de18e303cae$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}



var $lgFxF = parcelRequire("lgFxF");
var $09247dea77919ddb$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $09247dea77919ddb$var$ReactIs, $09247dea77919ddb$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$09247dea77919ddb$exports = (parcelRequire("iJ0c1"))();


function $807f637a155dfb5a$export$2e2bcd8739ae039() {
    $807f637a155dfb5a$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $807f637a155dfb5a$export$2e2bcd8739ae039.apply(this, arguments);
}


function $1a7208d5fe9f96e5$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $1a7208d5fe9f96e5$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $1a7208d5fe9f96e5$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $1a7208d5fe9f96e5$var$isAbsolute(to);
    var isFromAbs = from && $1a7208d5fe9f96e5$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $1a7208d5fe9f96e5$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $1a7208d5fe9f96e5$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $1a7208d5fe9f96e5$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $1a7208d5fe9f96e5$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$1a7208d5fe9f96e5$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $1a7208d5fe9f96e5$export$2e2bcd8739ae039 = $1a7208d5fe9f96e5$var$resolvePathname;


function $3a8fa8893d938f8c$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $3a8fa8893d938f8c$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $3a8fa8893d938f8c$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $3a8fa8893d938f8c$var$valueOf(a);
        var bValue = $3a8fa8893d938f8c$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $3a8fa8893d938f8c$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $3a8fa8893d938f8c$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $3a8fa8893d938f8c$export$2e2bcd8739ae039 = $3a8fa8893d938f8c$var$valueEqual;



var $c2e959bb0779c277$var$isProduction = true;
var $c2e959bb0779c277$var$prefix = 'Invariant failed';
function $c2e959bb0779c277$var$invariant(condition, message) {
    if (condition) return;
    if ($c2e959bb0779c277$var$isProduction) throw new Error($c2e959bb0779c277$var$prefix);
    throw new Error($c2e959bb0779c277$var$prefix + ": " + (message || ''));
}
var $c2e959bb0779c277$export$2e2bcd8739ae039 = $c2e959bb0779c277$var$invariant;


function $8827ca830b12da22$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $8827ca830b12da22$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $8827ca830b12da22$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $8827ca830b12da22$var$stripBasename(path, prefix) {
    return $8827ca830b12da22$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $8827ca830b12da22$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $8827ca830b12da22$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $8827ca830b12da22$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $8827ca830b12da22$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $8827ca830b12da22$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $1a7208d5fe9f96e5$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $8827ca830b12da22$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $3a8fa8893d938f8c$export$2e2bcd8739ae039)(a.state, b.state);
}
function $8827ca830b12da22$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $8827ca830b12da22$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $8827ca830b12da22$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $8827ca830b12da22$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $8827ca830b12da22$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $8827ca830b12da22$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $8827ca830b12da22$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $8827ca830b12da22$var$PopStateEvent = 'popstate';
var $8827ca830b12da22$var$HashChangeEvent = 'hashchange';
function $8827ca830b12da22$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $8827ca830b12da22$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$8827ca830b12da22$var$canUseDOM && (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $8827ca830b12da22$var$supportsHistory();
    var needsHashChangeListener = !$8827ca830b12da22$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $8827ca830b12da22$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $8827ca830b12da22$var$stripTrailingSlash($8827ca830b12da22$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $8827ca830b12da22$var$stripBasename(path, basename);
        return $8827ca830b12da22$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $8827ca830b12da22$var$createTransitionManager();
    function setState(nextState) {
        (0, $807f637a155dfb5a$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($8827ca830b12da22$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($8827ca830b12da22$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($8827ca830b12da22$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $8827ca830b12da22$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $8827ca830b12da22$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $8827ca830b12da22$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($8827ca830b12da22$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($8827ca830b12da22$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($8827ca830b12da22$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($8827ca830b12da22$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $8827ca830b12da22$var$HashChangeEvent$1 = 'hashchange';
var $8827ca830b12da22$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $8827ca830b12da22$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $8827ca830b12da22$var$stripLeadingSlash,
        decodePath: $8827ca830b12da22$var$addLeadingSlash
    },
    slash: {
        encodePath: $8827ca830b12da22$var$addLeadingSlash,
        decodePath: $8827ca830b12da22$var$addLeadingSlash
    }
};
function $8827ca830b12da22$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $8827ca830b12da22$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $8827ca830b12da22$var$pushHashPath(path) {
    window.location.hash = path;
}
function $8827ca830b12da22$var$replaceHashPath(path) {
    window.location.replace($8827ca830b12da22$var$stripHash(window.location.href) + '#' + path);
}
function $8827ca830b12da22$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$8827ca830b12da22$var$canUseDOM && (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $8827ca830b12da22$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $8827ca830b12da22$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $8827ca830b12da22$var$stripTrailingSlash($8827ca830b12da22$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $8827ca830b12da22$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($8827ca830b12da22$var$getHashPath());
        if (basename) path = $8827ca830b12da22$var$stripBasename(path, basename);
        return $8827ca830b12da22$export$90c043f1c57770b8(path);
    }
    var transitionManager = $8827ca830b12da22$var$createTransitionManager();
    function setState(nextState) {
        (0, $807f637a155dfb5a$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $8827ca830b12da22$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $8827ca830b12da22$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $8827ca830b12da22$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($8827ca830b12da22$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($8827ca830b12da22$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $8827ca830b12da22$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $8827ca830b12da22$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $8827ca830b12da22$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $8827ca830b12da22$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $8827ca830b12da22$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $8827ca830b12da22$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $8827ca830b12da22$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $8827ca830b12da22$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $8827ca830b12da22$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($8827ca830b12da22$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $8827ca830b12da22$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $8827ca830b12da22$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $8827ca830b12da22$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $8827ca830b12da22$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($8827ca830b12da22$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($8827ca830b12da22$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($8827ca830b12da22$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $8827ca830b12da22$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $8827ca830b12da22$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $8827ca830b12da22$var$createTransitionManager();
    function setState(nextState) {
        (0, $807f637a155dfb5a$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $8827ca830b12da22$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $8827ca830b12da22$export$90c043f1c57770b8(entry, undefined, createKey()) : $8827ca830b12da22$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $8827ca830b12da22$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $8827ca830b12da22$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $8827ca830b12da22$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $8827ca830b12da22$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}




var $lgFxF = parcelRequire("lgFxF");



var $9bfbd415a0909c37$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $9bfbd415a0909c37$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
function $9bfbd415a0909c37$var$getUniqueId() {
    var key = '__global_unique_id__';
    return $9bfbd415a0909c37$var$commonjsGlobal[key] = ($9bfbd415a0909c37$var$commonjsGlobal[key] || 0) + 1;
}
function $9bfbd415a0909c37$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $9bfbd415a0909c37$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $9bfbd415a0909c37$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $9bfbd415a0909c37$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + $9bfbd415a0909c37$var$getUniqueId() + '__';
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $9bfbd415a0909c37$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($9bfbd415a0909c37$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : $9bfbd415a0909c37$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $lgFxF.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $9bfbd415a0909c37$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $9bfbd415a0909c37$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $9bfbd415a0909c37$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $lgFxF.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $9bfbd415a0909c37$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createContext || $9bfbd415a0909c37$var$createReactContext;
var $9bfbd415a0909c37$export$2e2bcd8739ae039 = $9bfbd415a0909c37$var$index;




var $98b3efc38b72a2c9$exports = {};
var $d6b8020a094b4a7f$exports = {};
$d6b8020a094b4a7f$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $98b3efc38b72a2c9$exports = $98b3efc38b72a2c9$var$pathToRegexp;
$98b3efc38b72a2c9$exports.parse = $98b3efc38b72a2c9$var$parse;
$98b3efc38b72a2c9$exports.compile = $98b3efc38b72a2c9$var$compile;
$98b3efc38b72a2c9$exports.tokensToFunction = $98b3efc38b72a2c9$var$tokensToFunction;
$98b3efc38b72a2c9$exports.tokensToRegExp = $98b3efc38b72a2c9$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $98b3efc38b72a2c9$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $98b3efc38b72a2c9$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $98b3efc38b72a2c9$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $98b3efc38b72a2c9$var$escapeGroup(pattern) : asterisk ? '.*' : '[^' + $98b3efc38b72a2c9$var$escapeString(delimiter) + ']+?'
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $98b3efc38b72a2c9$var$compile(str, options) {
    return $98b3efc38b72a2c9$var$tokensToFunction($98b3efc38b72a2c9$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $98b3efc38b72a2c9$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $98b3efc38b72a2c9$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $98b3efc38b72a2c9$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $98b3efc38b72a2c9$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $98b3efc38b72a2c9$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($d6b8020a094b4a7f$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $98b3efc38b72a2c9$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $98b3efc38b72a2c9$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $98b3efc38b72a2c9$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $98b3efc38b72a2c9$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $98b3efc38b72a2c9$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $98b3efc38b72a2c9$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $98b3efc38b72a2c9$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $98b3efc38b72a2c9$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($98b3efc38b72a2c9$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $98b3efc38b72a2c9$var$flags(options));
    return $98b3efc38b72a2c9$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $98b3efc38b72a2c9$var$stringToRegexp(path, keys, options) {
    return $98b3efc38b72a2c9$var$tokensToRegExp($98b3efc38b72a2c9$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $98b3efc38b72a2c9$var$tokensToRegExp(tokens, keys, options) {
    if (!$d6b8020a094b4a7f$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $98b3efc38b72a2c9$var$escapeString(token);
        else {
            var prefix = $98b3efc38b72a2c9$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $98b3efc38b72a2c9$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $98b3efc38b72a2c9$var$attachKeys(new RegExp('^' + route, $98b3efc38b72a2c9$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $98b3efc38b72a2c9$var$pathToRegexp(path, keys, options) {
    if (!$d6b8020a094b4a7f$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $98b3efc38b72a2c9$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($d6b8020a094b4a7f$exports(path)) return $98b3efc38b72a2c9$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $98b3efc38b72a2c9$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $c00bd76a7b5d9fc1$exports = {};
'use strict';

$c00bd76a7b5d9fc1$exports = (parcelRequire("bilGQ"));


function $f708a45bab77cec9$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $c847abe75d13d2af$exports = {};
'use strict';

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $c847abe75d13d2af$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c847abe75d13d2af$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c847abe75d13d2af$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c847abe75d13d2af$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c847abe75d13d2af$var$TYPE_STATICS = {};
$c847abe75d13d2af$var$TYPE_STATICS[$c00bd76a7b5d9fc1$exports.ForwardRef] = $c847abe75d13d2af$var$FORWARD_REF_STATICS;
$c847abe75d13d2af$var$TYPE_STATICS[$c00bd76a7b5d9fc1$exports.Memo] = $c847abe75d13d2af$var$MEMO_STATICS;
function $c847abe75d13d2af$var$getStatics(component) {
    // React v16.11 and below
    if ($c00bd76a7b5d9fc1$exports.isMemo(component)) return $c847abe75d13d2af$var$MEMO_STATICS;
     // React v16.12 and above
    return $c847abe75d13d2af$var$TYPE_STATICS[component['$$typeof']] || $c847abe75d13d2af$var$REACT_STATICS;
}
var $c847abe75d13d2af$var$defineProperty = Object.defineProperty;
var $c847abe75d13d2af$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c847abe75d13d2af$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c847abe75d13d2af$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c847abe75d13d2af$var$getPrototypeOf = Object.getPrototypeOf;
var $c847abe75d13d2af$var$objectPrototype = Object.prototype;
function $c847abe75d13d2af$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($c847abe75d13d2af$var$objectPrototype) {
            var inheritedComponent = $c847abe75d13d2af$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c847abe75d13d2af$var$objectPrototype) $c847abe75d13d2af$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $c847abe75d13d2af$var$getOwnPropertyNames(sourceComponent);
        if ($c847abe75d13d2af$var$getOwnPropertySymbols) keys = keys.concat($c847abe75d13d2af$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $c847abe75d13d2af$var$getStatics(targetComponent);
        var sourceStatics = $c847abe75d13d2af$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$c847abe75d13d2af$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $c847abe75d13d2af$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $c847abe75d13d2af$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$c847abe75d13d2af$exports = $c847abe75d13d2af$var$hoistNonReactStatics;


// TODO: Replace with React.createContext once we can assume React 16+
var $8d84d1394a502c2f$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $9bfbd415a0909c37$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $8d84d1394a502c2f$export$c213558b66925821 = /*#__PURE__*/ $8d84d1394a502c2f$var$createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var $8d84d1394a502c2f$var$createNamedContext$1 = function createNamedContext(name) {
    var context = (0, $9bfbd415a0909c37$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $8d84d1394a502c2f$export$63baa8ccbe60bb07 = /*#__PURE__*/ $8d84d1394a502c2f$var$createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var $8d84d1394a502c2f$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $8d84d1394a502c2f$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $8827ca830b12da22$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Component);
var $8d84d1394a502c2f$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $8d84d1394a502c2f$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $8d84d1394a502c2f$var$messageType;
var $8d84d1394a502c2f$var$cache = {};
var $8d84d1394a502c2f$var$cacheLimit = 10000;
var $8d84d1394a502c2f$var$cacheCount = 0;
function $8d84d1394a502c2f$var$compilePath(path) {
    if ($8d84d1394a502c2f$var$cache[path]) return $8d84d1394a502c2f$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($98b3efc38b72a2c9$exports))).compile(path);
    if ($8d84d1394a502c2f$var$cacheCount < $8d84d1394a502c2f$var$cacheLimit) {
        $8d84d1394a502c2f$var$cache[path] = generator;
        $8d84d1394a502c2f$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $8d84d1394a502c2f$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $8d84d1394a502c2f$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $8d84d1394a502c2f$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $8827ca830b12da22$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $8d84d1394a502c2f$export$82476f982757e71e(to, computedMatch.params) : (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, to, {
            pathname: $8d84d1394a502c2f$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $8827ca830b12da22$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $8827ca830b12da22$export$c3e8bb440bd55b18)(prevLocation, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $8d84d1394a502c2f$var$cache$1 = {};
var $8d84d1394a502c2f$var$cacheLimit$1 = 10000;
var $8d84d1394a502c2f$var$cacheCount$1 = 0;
function $8d84d1394a502c2f$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $8d84d1394a502c2f$var$cache$1[cacheKey] || ($8d84d1394a502c2f$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($98b3efc38b72a2c9$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($8d84d1394a502c2f$var$cacheCount$1 < $8d84d1394a502c2f$var$cacheLimit$1) {
        pathCache[path] = result;
        $8d84d1394a502c2f$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $8d84d1394a502c2f$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $8d84d1394a502c2f$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $8d84d1394a502c2f$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Children.count(children) === 0;
}
function $8d84d1394a502c2f$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $8d84d1394a502c2f$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $8d84d1394a502c2f$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Component);
function $8d84d1394a502c2f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $8d84d1394a502c2f$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, location, {
        pathname: $8d84d1394a502c2f$var$addLeadingSlash(basename) + location.pathname
    });
}
function $8d84d1394a502c2f$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $8d84d1394a502c2f$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $8d84d1394a502c2f$var$createURL(location) {
    return typeof location === "string" ? location : (0, $8827ca830b12da22$export$fe53371bee54353d)(location);
}
function $8d84d1394a502c2f$var$staticHandler(methodName) {
    return function() {
        (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
    };
}
function $8d84d1394a502c2f$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $8d84d1394a502c2f$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $8d84d1394a502c2f$var$noop;
        };
        _this.handleBlock = function() {
            return $8d84d1394a502c2f$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $8d84d1394a502c2f$var$addBasename(basename, (0, $8827ca830b12da22$export$90c043f1c57770b8)(location));
        context.url = $8d84d1394a502c2f$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $8d84d1394a502c2f$var$addLeadingSlash(basename + $8d84d1394a502c2f$var$createURL(path));
            },
            action: "POP",
            location: $8d84d1394a502c2f$var$stripBasename(basename, (0, $8827ca830b12da22$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $8d84d1394a502c2f$var$staticHandler("go"),
            goBack: $8d84d1394a502c2f$var$staticHandler("goBack"),
            goForward: $8d84d1394a502c2f$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$55185c17a0fcbe46, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $8d84d1394a502c2f$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $8d84d1394a502c2f$export$81336c211d5ff295(location.pathname, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $8d84d1394a502c2f$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8d84d1394a502c2f$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($c847abe75d13d2af$exports)))(C, Component);
}
var $8d84d1394a502c2f$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).useContext;
function $8d84d1394a502c2f$export$3420e1dc2c4a518c() {
    return $8d84d1394a502c2f$var$useContext($8d84d1394a502c2f$export$c213558b66925821);
}
function $8d84d1394a502c2f$export$45d76561a5302f2b() {
    return $8d84d1394a502c2f$var$useContext($8d84d1394a502c2f$export$63baa8ccbe60bb07).location;
}
function $8d84d1394a502c2f$export$99eaa27ddbbb95ef() {
    var match = $8d84d1394a502c2f$var$useContext($8d84d1394a502c2f$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $8d84d1394a502c2f$export$632be4bb944c1bc7(path) {
    var location = $8d84d1394a502c2f$export$45d76561a5302f2b();
    var match = $8d84d1394a502c2f$var$useContext($8d84d1394a502c2f$export$63baa8ccbe60bb07).match;
    return path ? $8d84d1394a502c2f$export$81336c211d5ff295(location.pathname, path) : match;
}
var $8d84d1394a502c2f$var$global, $8d84d1394a502c2f$var$key, $8d84d1394a502c2f$var$buildNames, $8d84d1394a502c2f$var$initialBuildName, $8d84d1394a502c2f$var$secondaryBuildName;




var $lgFxF = parcelRequire("lgFxF");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $225277145a49d7b0$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $8827ca830b12da22$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $225277145a49d7b0$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $8827ca830b12da22$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Component);
var $225277145a49d7b0$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $225277145a49d7b0$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $8827ca830b12da22$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $225277145a49d7b0$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $225277145a49d7b0$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef;
if (typeof $225277145a49d7b0$var$forwardRef === "undefined") $225277145a49d7b0$var$forwardRef = $225277145a49d7b0$var$forwardRefShim;
function $225277145a49d7b0$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $225277145a49d7b0$var$LinkAnchor = $225277145a49d7b0$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$225277145a49d7b0$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($225277145a49d7b0$var$forwardRefShim !== $225277145a49d7b0$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $225277145a49d7b0$export$a6c7ac8248d6e38a = $225277145a49d7b0$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $225277145a49d7b0$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $225277145a49d7b0$var$normalizeToLocation($225277145a49d7b0$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $225277145a49d7b0$var$resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($225277145a49d7b0$var$forwardRefShim !== $225277145a49d7b0$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(component, props);
    });
});
var $225277145a49d7b0$var$toType, $225277145a49d7b0$var$refType;
var $225277145a49d7b0$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $225277145a49d7b0$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef;
if (typeof $225277145a49d7b0$var$forwardRef$1 === "undefined") $225277145a49d7b0$var$forwardRef$1 = $225277145a49d7b0$var$forwardRefShim$1;
function $225277145a49d7b0$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $225277145a49d7b0$export$b0d92dbee9b5b60d = $225277145a49d7b0$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $c2e959bb0779c277$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $225277145a49d7b0$var$normalizeToLocation($225277145a49d7b0$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $8d84d1394a502c2f$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? $225277145a49d7b0$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($225277145a49d7b0$var$forwardRefShim$1 !== $225277145a49d7b0$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($225277145a49d7b0$export$a6c7ac8248d6e38a, props);
    });
});
var $225277145a49d7b0$var$ariaCurrentType;


var $612b7d911d85a8d3$exports = {};
var $9a9254fe3252ad0e$exports = {};
var $9ed29a4f8b24e64f$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9ed29a4f8b24e64f$var$nativeCeil = Math.ceil, $9ed29a4f8b24e64f$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $9ed29a4f8b24e64f$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $9ed29a4f8b24e64f$var$nativeMax($9ed29a4f8b24e64f$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$9ed29a4f8b24e64f$exports = $9ed29a4f8b24e64f$var$baseRange;



var $448d68a6dedbcaf2$exports = {};
var $f6b2fa06526cb16a$exports = {};

var $e9Eyz = parcelRequire("e9Eyz");

var $tMqsp = parcelRequire("tMqsp");
/** Used as references for various `Number` constants. */ var $f6b2fa06526cb16a$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $f6b2fa06526cb16a$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $f6b2fa06526cb16a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f6b2fa06526cb16a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f6b2fa06526cb16a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f6b2fa06526cb16a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f6b2fa06526cb16a$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($tMqsp(value)) return $f6b2fa06526cb16a$var$NAN;
    if ($e9Eyz(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $e9Eyz(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($f6b2fa06526cb16a$var$reTrim, '');
    var isBinary = $f6b2fa06526cb16a$var$reIsBinary.test(value);
    return isBinary || $f6b2fa06526cb16a$var$reIsOctal.test(value) ? $f6b2fa06526cb16a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f6b2fa06526cb16a$var$reIsBadHex.test(value) ? $f6b2fa06526cb16a$var$NAN : +value;
}
$f6b2fa06526cb16a$exports = $f6b2fa06526cb16a$var$toNumber;


/** Used as references for various `Number` constants. */ var $448d68a6dedbcaf2$var$INFINITY = 1 / 0, $448d68a6dedbcaf2$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $448d68a6dedbcaf2$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $f6b2fa06526cb16a$exports(value);
    if (value === $448d68a6dedbcaf2$var$INFINITY || value === -$448d68a6dedbcaf2$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $448d68a6dedbcaf2$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$448d68a6dedbcaf2$exports = $448d68a6dedbcaf2$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9a9254fe3252ad0e$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $d6d9b434b5276597$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $448d68a6dedbcaf2$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $448d68a6dedbcaf2$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $448d68a6dedbcaf2$exports(step);
        return $9ed29a4f8b24e64f$exports(start, end, step, fromRight);
    };
}
$9a9254fe3252ad0e$exports = $9a9254fe3252ad0e$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $612b7d911d85a8d3$var$range = $9a9254fe3252ad0e$exports();
$612b7d911d85a8d3$exports = $612b7d911d85a8d3$var$range;



var $lgFxF = parcelRequire("lgFxF");

/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by Niazye and ChiyoYuki from ECNU-minus on 2025-12-03
 * Changes:
 * - feat: change weekday dots
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ var $27ebd2387777117f$exports = {};
var $675c98214622785d$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $675c98214622785d$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$675c98214622785d$exports = $675c98214622785d$var$baseSlice;



var $a5bc1ba033d9ebc1$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $a5bc1ba033d9ebc1$var$toInteger(value) {
    var result = $448d68a6dedbcaf2$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$a5bc1ba033d9ebc1$exports = $a5bc1ba033d9ebc1$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $27ebd2387777117f$var$nativeCeil = Math.ceil, $27ebd2387777117f$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $27ebd2387777117f$var$chunk(array, size, guard) {
    if (guard ? $d6d9b434b5276597$exports(array, size, guard) : size === undefined) size = 1;
    else size = $27ebd2387777117f$var$nativeMax($a5bc1ba033d9ebc1$exports(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($27ebd2387777117f$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $675c98214622785d$exports(array, index, index += size);
    return result;
}
$27ebd2387777117f$exports = $27ebd2387777117f$var$chunk;


var $6f6e293b545bced6$exports = {};

var $f3249f2aa67ea927$exports = {};

var $g7GeS = parcelRequire("g7GeS");

var $2oilF = parcelRequire("2oilF");


var $ae8en = parcelRequire("ae8en");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $f3249f2aa67ea927$var$map(collection, iteratee) {
    var func = $ae8en(collection) ? $g7GeS : $4bcdfc647454ecfa$exports;
    return func(collection, $2oilF(iteratee, 3));
}
$f3249f2aa67ea927$exports = $f3249f2aa67ea927$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $6f6e293b545bced6$var$flatMap(collection, iteratee) {
    return $3103d8a23e4e2ae3$exports($f3249f2aa67ea927$exports(collection, iteratee), 1);
}
$6f6e293b545bced6$exports = $6f6e293b545bced6$var$flatMap;



var $gRgFA = parcelRequire("gRgFA");

var $4ba9cde7c1292e45$exports = {};
var $d120f152fab47618$exports = {};

var $tMqsp = parcelRequire("tMqsp");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $d120f152fab47618$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$tMqsp(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$d120f152fab47618$exports = $d120f152fab47618$var$baseExtremum;


var $ce1f6621e021f845$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $ce1f6621e021f845$var$baseGt(value, other) {
    return value > other;
}
$ce1f6621e021f845$exports = $ce1f6621e021f845$var$baseGt;



var $bHMyM = parcelRequire("bHMyM");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $4ba9cde7c1292e45$var$max(array) {
    return array && array.length ? $d120f152fab47618$exports(array, $bHMyM, $ce1f6621e021f845$exports) : undefined;
}
$4ba9cde7c1292e45$exports = $4ba9cde7c1292e45$var$max;




var $lgFxF = parcelRequire("lgFxF");
var $87802237a54007ad$exports = {};



(function webpackUniversalModuleDefinition(root, factory) {
    $87802237a54007ad$exports = factory((parcelRequire("lgFxF")), (parcelRequire("3ThkG")), (parcelRequire("aBztI")));
})($87802237a54007ad$exports, function(__WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_39__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 15);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Browser = exports.Browser = {};
            if (typeof window !== 'undefined') {
                Browser.SUPPORTED = 'requestAnimationFrame' in window;
                Browser.SUPPORTS_TOUCH = 'ontouchstart' in window;
                Browser.touch = false;
                Browser.dynamicInputDetection = true;
                // Chrome device/touch emulation can make this dynamic
                Browser.iOS = function() {
                    return /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream;
                };
            }
            /**
* The global storage array which holds all data reference objects
* from every instance
* This allows us to hide tooltips from all instances, finding the ref when
* clicking on the body, and for followCursor
*/ var Store = exports.Store = [];
            /**
* Selector constants used for grabbing elements
*/ var Selectors = exports.Selectors = {
                POPPER: '.tippy-popper',
                TOOLTIP: '.tippy-tooltip',
                CONTENT: '.tippy-tooltip-content',
                CIRCLE: '[x-circle]',
                ARROW: '[x-arrow]',
                TOOLTIPPED_EL: '[data-tooltipped]',
                CONTROLLER: '[data-tippy-controller]'
            };
            /**
* The default settings applied to each instance
*/ var Defaults = exports.Defaults = {
                html: false,
                position: 'top',
                animation: 'shift',
                animateFill: true,
                arrow: false,
                arrowSize: 'regular',
                delay: 0,
                trigger: 'mouseenter focus',
                duration: 350,
                interactive: false,
                interactiveBorder: 2,
                theme: 'dark',
                size: 'regular',
                distance: 10,
                offset: 0,
                hideOnClick: true,
                multiple: false,
                followCursor: false,
                inertia: false,
                flipDuration: 350,
                sticky: false,
                stickyDuration: 200,
                appendTo: function appendTo() {
                    return document.body;
                },
                zIndex: 9999,
                touchHold: false,
                performance: false,
                dynamicTitle: false,
                useContext: false,
                reactInstance: undefined,
                popperOptions: {},
                open: undefined,
                onRequestClose: function onRequestClose() {}
            };
            /**
* The keys of the defaults object for reducing down into a new object
* Used in `getIndividualSettings()`
*/ var DefaultsKeys = exports.DefaultsKeys = Browser.SUPPORTED && Object.keys(Defaults);
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = prefix;
            /**
* Returns the supported prefixed property - only `webkit` is needed, `moz`, `ms` and `o` are obsolete
* @param {String} property
* @return {String} - browser supported prefixed property
*/ function prefix(property) {
                var prefixes = [
                    false,
                    'webkit'
                ];
                var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
                for(var i = 0; i < prefixes.length; i++){
                    var _prefix = prefixes[i];
                    var prefixedProp = _prefix ? '' + _prefix + upperProp : property;
                    if (typeof window.document.body.style[prefixedProp] !== 'undefined') return prefixedProp;
                }
                return null;
            }
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = find;
            /**
* Ponyfill for Array.prototype.find
* @param {Array} arr
* @param {Function} checkFn
* @return item in the array
*/ function find(arr, checkFn) {
                if (Array.prototype.find) return arr.find(checkFn);
                // use `filter` as fallback
                return arr.filter(checkFn)[0];
            }
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = getCorePlacement;
            /**
* Returns the non-shifted placement (e.g., 'bottom-start' => 'bottom')
* @param {String} placement
* @return {String}
*/ function getCorePlacement(placement) {
                return placement.replace(/-.+/, '');
            }
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = closest;
            var _matches = __webpack_require__(8);
            /**
* Ponyfill to get the closest parent element
* @param {Element} element - child of parent to be returned
* @param {String} parentSelector - selector to match the parent if found
* @return {Element}
*/ function closest(element, parentSelector) {
                var _closest = Element.prototype.closest || function(selector) {
                    var el = this;
                    while(el){
                        if (_matches.matches.call(el, selector)) return el;
                        el = el.parentElement;
                    }
                };
                return _closest.call(element, parentSelector);
            }
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = defer;
            /**
* Waits until next repaint to execute a fn
* @param {Function} fn
*/ function defer(fn) {
                window.requestAnimationFrame(function() {
                    setTimeout(fn, 0);
                });
            }
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = getInnerElements;
            var _globals = __webpack_require__(0);
            /**
* Returns inner elements of the popper element
* @param {Element} popper
* @return {Object}
*/ function getInnerElements(popper) {
                return {
                    tooltip: popper.querySelector(_globals.Selectors.TOOLTIP),
                    circle: popper.querySelector(_globals.Selectors.CIRCLE),
                    content: popper.querySelector(_globals.Selectors.CONTENT)
                };
            }
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = isVisible;
            /**
* Determines if a popper is currently visible
* @param {Element} popper
* @return {Boolean}
*/ function isVisible(popper) {
                return popper.style.visibility === 'visible';
            }
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function defaultMatchSelector(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s), i = matches.length;
                while(--i >= 0 && matches.item(i) !== this);
                return i > -1;
            }
            var matches = exports.matches = typeof window === 'undefined' ? defaultMatchSelector : Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || defaultMatchSelector;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _react = __webpack_require__(13);
            var _react2 = _interopRequireDefault(_react);
            var _tippy = __webpack_require__(30);
            var _tippy2 = _interopRequireDefault(_tippy);
            var _globals = __webpack_require__(0);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var stopPortalEvent = function stopPortalEvent(e) {
                return e.stopPropagation();
            };
            var defaultProps = {
                html: null,
                position: 'top',
                animation: 'shift',
                animateFill: true,
                arrow: false,
                delay: 0,
                hideDelay: 0,
                trigger: 'mouseenter focus',
                duration: 375,
                hideDuration: 375,
                interactive: false,
                interactiveBorder: 2,
                theme: 'dark',
                offset: 0,
                hideOnClick: true,
                multiple: false,
                followCursor: false,
                inertia: false,
                popperOptions: {},
                onShow: function onShow() {},
                onShown: function onShown() {},
                onHide: function onHide() {},
                onHidden: function onHidden() {},
                disabled: false,
                arrowSize: 'regular',
                size: 'regular',
                className: '',
                style: {},
                distance: 10,
                onRequestClose: function onRequestClose() {},
                sticky: false,
                stickyDuration: 200,
                tag: 'div',
                touchHold: false,
                unmountHTMLWhenHide: false,
                zIndex: 9999
            };
            var propKeys = Object.keys(defaultProps);
            var detectPropsChanged = function detectPropsChanged(props, prevProps) {
                var result = [];
                propKeys.forEach(function(key) {
                    if (props[key] !== prevProps[key]) result.push(key);
                });
                return result;
            };
            var Tooltip = function(_Component) {
                _inherits(Tooltip, _Component);
                function Tooltip(props) {
                    _classCallCheck(this, Tooltip);
                    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
                    _this.initTippy = _this._initTippy.bind(_this);
                    _this.destroyTippy = _this._destroyTippy.bind(_this);
                    _this.updateTippy = _this._updateTippy.bind(_this);
                    _this.updateReactDom = _this._updateReactDom.bind(_this);
                    _this.showTooltip = _this._showTooltip.bind(_this);
                    _this.hideTooltip = _this._hideTooltip.bind(_this);
                    _this.updateSettings = _this._updateSettings.bind(_this);
                    _this.state = {
                        reactDOMValue: null
                    };
                    return _this;
                }
                _createClass(Tooltip, [
                    {
                        key: 'componentDidMount',
                        value: function componentDidMount() {
                            if (typeof window === 'undefined' || typeof document === 'undefined') return;
                            this.initTippy();
                        }
                    },
                    {
                        key: 'componentWillUnmount',
                        value: function componentWillUnmount() {
                            if (typeof window === 'undefined' || typeof document === 'undefined') return;
                            this.destroyTippy();
                        }
                    },
                    {
                        key: 'componentDidUpdate',
                        value: function componentDidUpdate(prevProps) {
                            var _this2 = this;
                            // enable and disabled
                            if (typeof window === 'undefined' || typeof document === 'undefined') return;
                            if (this.props.disabled === false && prevProps.disabled === true) {
                                this.updateSettings('disabled', false);
                                this.destroyTippy();
                                this.initTippy();
                                return;
                            }
                            if (this.props.disabled === true && prevProps.disabled === false) {
                                this.updateSettings('disabled', true);
                                this.destroyTippy();
                                return;
                            }
                            // open
                            if (this.props.open === true && !prevProps.open) {
                                this.updateSettings('open', true);
                                setTimeout(function() {
                                    _this2.showTooltip();
                                }, 0);
                            }
                            if (this.props.open === false && prevProps.open === true) {
                                this.updateSettings('open', false);
                                this.hideTooltip();
                            }
                            if (this.props.html !== prevProps.html) this.updateReactDom();
                            // Update content
                            if (this.props.title !== prevProps.title) this.updateTippy();
                            // update otherProps
                            var propChanges = detectPropsChanged(this.props, prevProps);
                            propChanges.forEach(function(key) {
                                _this2.updateSettings(key, _this2.props[key]);
                            });
                        }
                    },
                    {
                        key: '_showTooltip',
                        value: function _showTooltip() {
                            if (typeof window === 'undefined' || typeof document === 'undefined') return;
                            if (this.tippy) {
                                var popper = this.tippy.getPopperElement(this.tooltipDOM);
                                this.tippy.show(popper, this.props.duration);
                            }
                        }
                    },
                    {
                        key: '_hideTooltip',
                        value: function _hideTooltip() {
                            if (typeof window === 'undefined' || typeof document === 'undefined') return;
                            if (this.tippy) {
                                var popper = this.tippy.getPopperElement(this.tooltipDOM);
                                this.tippy.hide(popper, this.props.hideDuration);
                            }
                        }
                    },
                    {
                        key: '_updateSettings',
                        value: function _updateSettings(name, value) {
                            if (typeof window === 'undefined' || typeof document === 'undefined') return;
                            if (this.tippy) {
                                var popper = this.tippy.getPopperElement(this.tooltipDOM);
                                this.tippy.updateSettings(popper, name, value);
                            }
                        }
                    },
                    {
                        key: '_updateReactDom',
                        value: function _updateReactDom() {
                            if (typeof window === 'undefined' || typeof document === 'undefined') return;
                            if (this.tippy) {
                                this.updateSettings('reactDOM', this.props.html);
                                var popper = this.tippy.getPopperElement(this.tooltipDOM);
                                var isVisible = popper.style.visibility === 'visible' || this.props.open;
                                if (isVisible) this.tippy.updateForReact(popper, this.props.html);
                            }
                        }
                    },
                    {
                        key: '_updateTippy',
                        value: function _updateTippy() {
                            if (typeof window === 'undefined' || typeof document === 'undefined') return;
                            if (this.tippy) {
                                var popper = this.tippy.getPopperElement(this.tooltipDOM);
                                this.tippy.update(popper);
                            }
                        }
                    },
                    {
                        key: '_initTippy',
                        value: function _initTippy() {
                            var _this3 = this;
                            if (typeof window === 'undefined' || typeof document === 'undefined' || !_globals.Browser.SUPPORTED) return;
                            if (!this.props.disabled) {
                                if (this.props.title) this.tooltipDOM.setAttribute('title', this.props.title);
                                this.tippy = (0, _tippy2.default)(this.tooltipDOM, {
                                    disabled: this.props.disabled,
                                    position: this.props.position,
                                    animation: this.props.animation,
                                    animateFill: this.props.animateFill,
                                    arrow: this.props.arrow,
                                    arrowSize: this.props.arrowSize,
                                    delay: this.props.delay,
                                    hideDelay: this.props.hideDelay,
                                    trigger: this.props.trigger,
                                    duration: this.props.duration,
                                    hideDuration: this.props.hideDuration,
                                    interactive: this.props.interactive,
                                    interactiveBorder: this.props.interactiveBorder,
                                    theme: this.props.theme,
                                    offset: this.props.offset,
                                    hideOnClick: this.props.hideOnClick,
                                    multiple: this.props.multiple,
                                    size: this.props.size,
                                    followCursor: this.props.followCursor,
                                    inertia: this.props.inertia,
                                    popperOptions: this.props.popperOptions,
                                    onShow: this.props.onShow,
                                    onShown: this.props.onShown,
                                    onHide: this.props.onHide,
                                    onHidden: this.props.onHidden,
                                    distance: this.props.distance,
                                    reactDOM: this.props.html,
                                    setReactDOMValue: function setReactDOMValue(newReactDOM) {
                                        return _this3.setState({
                                            reactDOMValue: newReactDOM
                                        });
                                    },
                                    unmountHTMLWhenHide: this.props.unmountHTMLWhenHide,
                                    open: this.props.open,
                                    sticky: this.props.sticky,
                                    stickyDuration: this.props.stickyDuration,
                                    tag: this.props.tag,
                                    touchHold: this.props.touchHold,
                                    onRequestClose: this.props.onRequestClose,
                                    useContext: this.props.useContext,
                                    reactInstance: this.props.useContext ? this : undefined,
                                    performance: true,
                                    html: this.props.rawTemplate ? this.props.rawTemplate : undefined,
                                    zIndex: this.props.zIndex
                                });
                                if (this.props.open) this.showTooltip();
                            } else this.tippy = null;
                        }
                    },
                    {
                        key: '_destroyTippy',
                        value: function _destroyTippy() {
                            if (typeof window === 'undefined' || typeof document === 'undefined') return;
                            if (this.tippy) {
                                var popper = this.tippy.getPopperElement(this.tooltipDOM);
                                this.updateSettings('open', false);
                                this.tippy.hide(popper, 0);
                                this.tippy.destroy(popper);
                                this.tippy = null;
                            }
                        }
                    },
                    {
                        key: 'render',
                        value: function render() {
                            var _this4 = this;
                            var Tag = this.props.tag;
                            return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(Tag, {
                                ref: function ref(tooltip) {
                                    _this4.tooltipDOM = tooltip;
                                },
                                title: this.props.title,
                                className: this.props.className,
                                tabIndex: this.props.tabIndex,
                                style: _extends({
                                    display: 'inline'
                                }, this.props.style)
                            }, this.props.children), this.state.reactDOMValue && _react2.default.createElement('div', {
                                onClick: stopPortalEvent,
                                onContextMenu: stopPortalEvent,
                                onDoubleClick: stopPortalEvent,
                                onDrag: stopPortalEvent,
                                onDragEnd: stopPortalEvent,
                                onDragEnter: stopPortalEvent,
                                onDragExit: stopPortalEvent,
                                onDragLeave: stopPortalEvent,
                                onDragOver: stopPortalEvent,
                                onDragStart: stopPortalEvent,
                                onDrop: stopPortalEvent,
                                onMouseDown: stopPortalEvent,
                                onMouseEnter: stopPortalEvent,
                                onMouseLeave: stopPortalEvent,
                                onMouseMove: stopPortalEvent,
                                onMouseOver: stopPortalEvent,
                                onMouseOut: stopPortalEvent,
                                onMouseUp: stopPortalEvent,
                                onKeyDown: stopPortalEvent,
                                onKeyPress: stopPortalEvent,
                                onKeyUp: stopPortalEvent,
                                onFocus: stopPortalEvent,
                                onBlur: stopPortalEvent,
                                onChange: stopPortalEvent,
                                onInput: stopPortalEvent,
                                onInvalid: stopPortalEvent,
                                onSubmit: stopPortalEvent
                            }, this.state.reactDOMValue));
                        }
                    }
                ]);
                return Tooltip;
            }(_react.Component);
            Tooltip.defaultProps = defaultProps;
            exports.default = Tooltip;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = followCursorHandler;
            var _globals = __webpack_require__(0);
            var _getCorePlacement = __webpack_require__(3);
            var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);
            var _find = __webpack_require__(2);
            var _find2 = _interopRequireDefault(_find);
            var _prefix = __webpack_require__(1);
            var _prefix2 = _interopRequireDefault(_prefix);
            var _closest = __webpack_require__(4);
            var _closest2 = _interopRequireDefault(_closest);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Mousemove event listener callback method for follow cursor setting
* @param {MouseEvent} e
*/ function followCursorHandler(e) {
                var _this = this;
                var refData = (0, _find2.default)(_globals.Store, function(refData) {
                    return refData.el === _this;
                });
                if (!refData) return;
                var popper = refData.popper, offset = refData.settings.offset;
                var position = (0, _getCorePlacement2.default)(popper.getAttribute('x-placement'));
                var halfPopperWidth = Math.round(popper.offsetWidth / 2);
                var halfPopperHeight = Math.round(popper.offsetHeight / 2);
                var viewportPadding = 5;
                var pageWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
                var pageX = e.pageX, pageY = e.pageY;
                var x = void 0, y = void 0;
                switch(position){
                    case 'top':
                        x = pageX - halfPopperWidth + offset;
                        y = pageY - 2.25 * halfPopperHeight;
                        break;
                    case 'left':
                        x = pageX - 2 * halfPopperWidth - 10;
                        y = pageY - halfPopperHeight + offset;
                        break;
                    case 'right':
                        x = pageX + halfPopperHeight;
                        y = pageY - halfPopperHeight + offset;
                        break;
                    case 'bottom':
                        x = pageX - halfPopperWidth + offset;
                        y = pageY + halfPopperHeight / 1.5;
                        break;
                }
                var isRightOverflowing = pageX + viewportPadding + halfPopperWidth + offset > pageWidth;
                var isLeftOverflowing = pageX - viewportPadding - halfPopperWidth + offset < 0;
                // Prevent left/right overflow
                if (position === 'top' || position === 'bottom') {
                    if (isRightOverflowing) x = pageWidth - viewportPadding - 2 * halfPopperWidth;
                    if (isLeftOverflowing) x = viewportPadding;
                }
                popper.style[(0, _prefix2.default)('transform')] = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
            }
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = getOffsetDistanceInPx;
            var _globals = __webpack_require__(0);
            /**
* Returns the distance taking into account the default distance due to
* the transform: translate setting in CSS
* @param {Number} distance
* @return {String}
*/ function getOffsetDistanceInPx(distance) {
                return -(distance - _globals.Defaults.distance) + 'px';
            }
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = removeTitle;
            /**
* Removes the title from the tooltipped element, setting `data-original-title`
* appropriately
* @param {Element} el
*/ function removeTitle(el) {
                var title = el.getAttribute('title');
                // Only set `data-original-title` attr if there is a title
                if (title) el.setAttribute('data-original-title', title);
                el.removeAttribute('title');
            }
        /***/ },
        /* 13 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_13__;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _react = __webpack_require__(13);
            var _react2 = _interopRequireDefault(_react);
            var _component = __webpack_require__(9);
            var _component2 = _interopRequireDefault(_component);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _objectWithoutProperties(obj, keys) {
                var target = {};
                for(var i in obj){
                    if (keys.indexOf(i) >= 0) continue;
                    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
                    target[i] = obj[i];
                }
                return target;
            }
            var withTooltip = function withTooltip(Component) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return function(_ref) {
                    var props = _objectWithoutProperties(_ref, []);
                    return _react2.default.createElement(_component2.default, options, _react2.default.createElement(Component, props));
                };
            };
            exports.default = withTooltip;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.withTooltip = exports.Tooltip = undefined;
            var _component = __webpack_require__(9);
            var _component2 = _interopRequireDefault(_component);
            var _hoc = __webpack_require__(14);
            var _hoc2 = _interopRequireDefault(_hoc);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.Tooltip = _component2.default;
            exports.withTooltip = _hoc2.default;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = bindEventListeners;
            var _globals = __webpack_require__(0);
            var _hideAllPoppers = __webpack_require__(25);
            var _hideAllPoppers2 = _interopRequireDefault(_hideAllPoppers);
            var _closest = __webpack_require__(4);
            var _closest2 = _interopRequireDefault(_closest);
            var _find = __webpack_require__(2);
            var _find2 = _interopRequireDefault(_find);
            var _matches = __webpack_require__(8);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Adds the needed event listeners
*/ function bindEventListeners() {
                var touchHandler = function touchHandler() {
                    _globals.Browser.touch = true;
                    if (_globals.Browser.iOS()) document.body.classList.add('tippy-touch');
                    if (_globals.Browser.dynamicInputDetection && window.performance) document.addEventListener('mousemove', mousemoveHandler);
                };
                var mousemoveHandler = function() {
                    var time = void 0;
                    return function() {
                        var now = performance.now();
                        // Chrome 60+ is 1 mousemove per rAF, use 20ms time difference
                        if (now - time < 20) {
                            _globals.Browser.touch = false;
                            document.removeEventListener('mousemove', mousemoveHandler);
                            if (!_globals.Browser.iOS()) document.body.classList.remove('tippy-touch');
                        }
                        time = now;
                    };
                }();
                var clickHandler = function clickHandler(event) {
                    // Simulated events dispatched on the document
                    if (!(event.target instanceof Element)) return (0, _hideAllPoppers2.default)();
                    var el = (0, _closest2.default)(event.target, _globals.Selectors.TOOLTIPPED_EL);
                    var popper = (0, _closest2.default)(event.target, _globals.Selectors.POPPER);
                    if (popper) {
                        var ref = (0, _find2.default)(_globals.Store, function(ref) {
                            return ref.popper === popper;
                        });
                        if (!ref) return;
                        var interactive = ref.settings.interactive;
                        if (interactive) return;
                    }
                    if (el) {
                        var _ref = (0, _find2.default)(_globals.Store, function(ref) {
                            return ref.el === el;
                        });
                        if (!_ref) return;
                        var _ref$settings = _ref.settings, hideOnClick = _ref$settings.hideOnClick, multiple = _ref$settings.multiple, trigger = _ref$settings.trigger;
                        // Hide all poppers except the one belonging to the element that was clicked IF
                        // `multiple` is false AND they are a touch user, OR
                        // `multiple` is false AND it's triggered by a click
                        if (!multiple && _globals.Browser.touch || !multiple && trigger.indexOf('click') !== -1) return (0, _hideAllPoppers2.default)(_ref);
                        // If hideOnClick is not strictly true or triggered by a click don't hide poppers
                        if (hideOnClick !== true || trigger.indexOf('click') !== -1) return;
                    }
                    // Don't trigger a hide for tippy controllers, and don't needlessly run loop
                    if ((0, _closest2.default)(event.target, _globals.Selectors.CONTROLLER) || !document.querySelector(_globals.Selectors.POPPER)) return;
                    (0, _hideAllPoppers2.default)();
                };
                var blurHandler = function blurHandler(event) {
                    var _document = document, el = _document.activeElement;
                    if (el && el.blur && _matches.matches.call(el, _globals.Selectors.TOOLTIPPED_EL)) el.blur();
                };
                // Hook events
                document.addEventListener('click', clickHandler);
                document.addEventListener('touchstart', touchHandler);
                window.addEventListener('blur', blurHandler);
                if (!_globals.Browser.SUPPORTS_TOUCH && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) document.addEventListener('pointerdown', touchHandler);
            }
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = createPopperElement;
            var _getCorePlacement = __webpack_require__(3);
            var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);
            var _getOffsetDistanceInPx = __webpack_require__(11);
            var _getOffsetDistanceInPx2 = _interopRequireDefault(_getOffsetDistanceInPx);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Creates a popper element then returns it
* @param {Number} id - the popper id
* @param {String} title - the tooltip's `title` attribute
* @param {Object} settings - individual settings
* @return {Element} - the popper element
*/ function createPopperElement(id, title, settings) {
                var position = settings.position, distance = settings.distance, arrow = settings.arrow, animateFill = settings.animateFill, inertia = settings.inertia, animation = settings.animation, arrowSize = settings.arrowSize, size = settings.size, theme = settings.theme, html = settings.html, zIndex = settings.zIndex, interactive = settings.interactive;
                var popper = document.createElement('div');
                popper.setAttribute('class', 'tippy-popper');
                popper.setAttribute('role', 'tooltip');
                popper.setAttribute('aria-hidden', 'true');
                popper.setAttribute('id', 'tippy-tooltip-' + id);
                popper.style.zIndex = zIndex;
                var tooltip = document.createElement('div');
                tooltip.setAttribute('class', 'tippy-tooltip tippy-tooltip--' + size + ' leave');
                tooltip.setAttribute('data-animation', animation);
                theme.split(' ').forEach(function(t) {
                    tooltip.classList.add(t + '-theme');
                });
                if (arrow) {
                    // Add an arrow
                    var _arrow = document.createElement('div');
                    _arrow.setAttribute('class', 'arrow-' + arrowSize);
                    _arrow.setAttribute('x-arrow', '');
                    tooltip.appendChild(_arrow);
                }
                if (animateFill) {
                    // Create animateFill circle element for animation
                    tooltip.setAttribute('data-animatefill', '');
                    var circle = document.createElement('div');
                    circle.setAttribute('class', 'leave');
                    circle.setAttribute('x-circle', '');
                    tooltip.appendChild(circle);
                }
                if (inertia) // Change transition timing function cubic bezier
                tooltip.setAttribute('data-inertia', '');
                if (interactive) tooltip.setAttribute('data-interactive', '');
                // Tooltip content (text or HTML)
                var content = document.createElement('div');
                content.setAttribute('class', 'tippy-tooltip-content');
                if (html) {
                    var templateId = void 0;
                    if (html instanceof Element) {
                        content.appendChild(html);
                        templateId = '#' + html.id;
                    } else {
                        content.innerHTML = document.getElementById(html.replace('#', '')).innerHTML;
                        templateId = html;
                    }
                    popper.classList.add('html-template');
                    interactive && popper.setAttribute('tabindex', '-1');
                    tooltip.setAttribute('data-template-id', templateId);
                } else content.innerHTML = title;
                // Init distance. Further updates are made in the popper instance's `onUpdate()` method
                tooltip.style[(0, _getCorePlacement2.default)(position)] = (0, _getOffsetDistanceInPx2.default)(distance);
                tooltip.appendChild(content);
                popper.appendChild(tooltip);
                return popper;
            }
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            exports.default = createPopperInstance;
            var _popper = __webpack_require__(38);
            var _popper2 = _interopRequireDefault(_popper);
            var _defer = __webpack_require__(5);
            var _defer2 = _interopRequireDefault(_defer);
            var _prefix = __webpack_require__(1);
            var _prefix2 = _interopRequireDefault(_prefix);
            var _getCorePlacement = __webpack_require__(3);
            var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);
            var _getInnerElements2 = __webpack_require__(6);
            var _getInnerElements3 = _interopRequireDefault(_getInnerElements2);
            var _getOffsetDistanceInPx = __webpack_require__(11);
            var _getOffsetDistanceInPx2 = _interopRequireDefault(_getOffsetDistanceInPx);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Creates a new popper instance
* @param {Object} data
* @return {Object} - the popper instance
*/ function createPopperInstance(data) {
                var el = data.el, popper = data.popper, _data$settings = data.settings, position = _data$settings.position, popperOptions = _data$settings.popperOptions, offset = _data$settings.offset, distance = _data$settings.distance, flipDuration = _data$settings.flipDuration;
                var _getInnerElements = (0, _getInnerElements3.default)(popper), tooltip = _getInnerElements.tooltip;
                var config = _extends({
                    placement: position
                }, popperOptions || {}, {
                    modifiers: _extends({}, popperOptions ? popperOptions.modifiers : {}, {
                        flip: _extends({
                            padding: distance + 5 /* 5px from viewport boundary */ 
                        }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.flip : {}),
                        offset: _extends({
                            offset: offset
                        }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.offset : {})
                    }),
                    onUpdate: function onUpdate() {
                        var styles = tooltip.style;
                        styles.top = '';
                        styles.bottom = '';
                        styles.left = '';
                        styles.right = '';
                        styles[(0, _getCorePlacement2.default)(popper.getAttribute('x-placement'))] = (0, _getOffsetDistanceInPx2.default)(distance);
                    }
                });
                // Update the popper's position whenever its content changes
                // Not supported in IE10 unless polyfilled
                if (window.MutationObserver) {
                    var styles = popper.style;
                    var observer = new MutationObserver(function() {
                        styles[(0, _prefix2.default)('transitionDuration')] = '0ms';
                        data.popperInstance.update();
                        (0, _defer2.default)(function() {
                            styles[(0, _prefix2.default)('transitionDuration')] = flipDuration + 'ms';
                        });
                    });
                    observer.observe(popper, {
                        childList: true,
                        subtree: true,
                        characterData: true
                    });
                    data._mutationObserver = observer;
                }
                return new _popper2.default(el, popper, config);
            }
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = createTooltips;
            var _getIndividualSettings = __webpack_require__(24);
            var _getIndividualSettings2 = _interopRequireDefault(_getIndividualSettings);
            var _createPopperElement = __webpack_require__(17);
            var _createPopperElement2 = _interopRequireDefault(_createPopperElement);
            var _createTrigger = __webpack_require__(20);
            var _createTrigger2 = _interopRequireDefault(_createTrigger);
            var _getEventListenerHandlers = __webpack_require__(23);
            var _getEventListenerHandlers2 = _interopRequireDefault(_getEventListenerHandlers);
            var _evaluateSettings = __webpack_require__(21);
            var _evaluateSettings2 = _interopRequireDefault(_evaluateSettings);
            var _removeTitle = __webpack_require__(12);
            var _removeTitle2 = _interopRequireDefault(_removeTitle);
            var _globals = __webpack_require__(0);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var idCounter = 1;
            /**
* Creates tooltips for all el elements that match the instance's selector
* @param {Element[]} els
* @return {Object[]} Array of ref data objects
*/ function createTooltips(els) {
                var _this = this;
                return els.reduce(function(a, el) {
                    var id = idCounter;
                    var settings = (0, _evaluateSettings2.default)(_this.settings.performance ? _this.settings : (0, _getIndividualSettings2.default)(el, _this.settings));
                    var html = settings.html, reactDOM = settings.reactDOM, trigger = settings.trigger, touchHold = settings.touchHold;
                    var title = el.getAttribute('title');
                    if (!title && !html && !reactDOM) return a;
                    el.setAttribute('data-tooltipped', '');
                    el.setAttribute('aria-describedby', 'tippy-tooltip-' + id);
                    (0, _removeTitle2.default)(el);
                    var popper = (0, _createPopperElement2.default)(id, title, settings);
                    var handlers = _getEventListenerHandlers2.default.call(_this, el, popper, settings);
                    var listeners = [];
                    trigger.trim().split(' ').forEach(function(event) {
                        return listeners = listeners.concat((0, _createTrigger2.default)(event, el, handlers, touchHold));
                    });
                    a.push({
                        id: id,
                        el: el,
                        popper: popper,
                        settings: settings,
                        listeners: listeners,
                        tippyInstance: _this
                    });
                    idCounter++;
                    return a;
                }, []);
            }
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = createTrigger;
            var _globals = __webpack_require__(0);
            /**
* Creates a trigger
* @param {Object} event - the custom event specified in the `trigger` setting
* @param {Element} el - tooltipped element
* @param {Object} handlers - the handlers for each listener
* @param {Boolean} touchHold
* @return {Array} - array of listener objects
*/ function createTrigger(event, el, handlers, touchHold) {
                var listeners = [];
                if (event === 'manual') return listeners;
                // Enter
                el.addEventListener(event, handlers.handleTrigger);
                listeners.push({
                    event: event,
                    handler: handlers.handleTrigger
                });
                // Leave
                if (event === 'mouseenter') {
                    if (_globals.Browser.SUPPORTS_TOUCH && touchHold) {
                        el.addEventListener('touchstart', handlers.handleTrigger);
                        listeners.push({
                            event: 'touchstart',
                            handler: handlers.handleTrigger
                        });
                        el.addEventListener('touchend', handlers.handleMouseleave);
                        listeners.push({
                            event: 'touchend',
                            handler: handlers.handleMouseleave
                        });
                    }
                    el.addEventListener('mouseleave', handlers.handleMouseleave);
                    listeners.push({
                        event: 'mouseleave',
                        handler: handlers.handleMouseleave
                    });
                }
                if (event === 'focus') {
                    el.addEventListener('blur', handlers.handleBlur);
                    listeners.push({
                        event: 'blur',
                        handler: handlers.handleBlur
                    });
                }
                return listeners;
            }
        /***/ },
        /* 21 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = evaluateSettings;
            /**
* Evaluates/modifies the settings object for appropriate behavior
* @param {Object} settings
* @return {Object} modified/evaluated settings
*/ function evaluateSettings(settings) {
                // animateFill is disabled if an arrow is true
                if (settings.arrow) settings.animateFill = false;
                // reassign appendTo into the result of evaluating appendTo
                // if it's set as a function instead of Element
                if (settings.appendTo && typeof settings.appendTo === 'function') settings.appendTo = settings.appendTo();
                return settings;
            }
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = getArrayOfElements;
            /**
* Returns an array of elements based on the selector input
* @param {String|Element|Element[]} selector
* @return {Element[]}
*/ function getArrayOfElements(selector) {
                if (selector instanceof Element) return [
                    selector
                ];
                if (Array.isArray(selector)) return selector;
                return [].slice.call(document.querySelectorAll(selector));
            }
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = getEventListenerHandlers;
            var _globals = __webpack_require__(0);
            var _isVisible = __webpack_require__(7);
            var _isVisible2 = _interopRequireDefault(_isVisible);
            var _closest = __webpack_require__(4);
            var _closest2 = _interopRequireDefault(_closest);
            var _cursorIsOutsideInteractiveBorder = __webpack_require__(32);
            var _cursorIsOutsideInteractiveBorder2 = _interopRequireDefault(_cursorIsOutsideInteractiveBorder);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Returns relevant listener callbacks for each ref
* @param {Element} el
* @param {Element} popper
* @param {Object} settings
* @return {Object} - relevant listener handlers
*/ function getEventListenerHandlers(el, popper, settings) {
                var _this = this;
                var position = settings.position, delay = settings.delay, duration = settings.duration, interactive = settings.interactive, interactiveBorder = settings.interactiveBorder, distance = settings.distance, hideOnClick = settings.hideOnClick, trigger = settings.trigger, touchHold = settings.touchHold, touchWait = settings.touchWait;
                var showDelay = void 0, hideDelay = void 0;
                var clearTimeouts = function clearTimeouts() {
                    clearTimeout(showDelay);
                    clearTimeout(hideDelay);
                };
                var _show = function _show() {
                    clearTimeouts();
                    // Not hidden. For clicking when it also has a `focus` event listener
                    if ((0, _isVisible2.default)(popper)) return;
                    var _delay = Array.isArray(delay) ? delay[0] : delay;
                    if (delay) showDelay = setTimeout(function() {
                        return _this.show(popper);
                    }, _delay);
                    else _this.show(popper);
                };
                var show = function show(event) {
                    return _this.callbacks.wait ? _this.callbacks.wait.call(popper, _show, event) : _show();
                };
                var hide = function hide() {
                    clearTimeouts();
                    var _delay = Array.isArray(delay) ? delay[1] : delay;
                    if (delay) hideDelay = setTimeout(function() {
                        return _this.hide(popper);
                    }, _delay);
                    else _this.hide(popper);
                };
                var handleTrigger = function handleTrigger(event) {
                    var mouseenterTouch = event.type === 'mouseenter' && _globals.Browser.SUPPORTS_TOUCH && _globals.Browser.touch;
                    if (mouseenterTouch && touchHold) return;
                    // Toggle show/hide when clicking click-triggered tooltips
                    var isClick = event.type === 'click';
                    var isNotPersistent = hideOnClick !== 'persistent';
                    isClick && (0, _isVisible2.default)(popper) && isNotPersistent ? hide() : show(event);
                    if (mouseenterTouch && _globals.Browser.iOS() && el.click) el.click();
                };
                var handleMouseleave = function handleMouseleave(event) {
                    // Don't fire 'mouseleave', use the 'touchend'
                    if (event.type === 'mouseleave' && _globals.Browser.SUPPORTS_TOUCH && _globals.Browser.touch && touchHold) return;
                    if (interactive) {
                        // Temporarily handle mousemove to check if the mouse left somewhere
                        // other than its popper
                        var handleMousemove = function handleMousemove(event) {
                            var triggerHide = function triggerHide() {
                                document.body.removeEventListener('mouseleave', hide);
                                document.removeEventListener('mousemove', handleMousemove);
                                hide();
                            };
                            var closestTooltippedEl = (0, _closest2.default)(event.target, _globals.Selectors.TOOLTIPPED_EL);
                            var isOverPopper = (0, _closest2.default)(event.target, _globals.Selectors.POPPER) === popper;
                            var isOverEl = closestTooltippedEl === el;
                            var isClickTriggered = trigger.indexOf('click') !== -1;
                            var isOverOtherTooltippedEl = closestTooltippedEl && closestTooltippedEl !== el;
                            if (isOverOtherTooltippedEl) return triggerHide();
                            if (isOverPopper || isOverEl || isClickTriggered) return;
                            if ((0, _cursorIsOutsideInteractiveBorder2.default)(event, popper, settings)) triggerHide();
                        };
                        document.body.addEventListener('mouseleave', hide);
                        document.addEventListener('mousemove', handleMousemove);
                        return;
                    }
                    // If it's not interactive, just hide it
                    hide();
                };
                var handleBlur = function handleBlur(event) {
                    // Ignore blur on touch devices, if there is no `relatedTarget`, hide
                    // If the related target is a popper, ignore
                    if (!event.relatedTarget || _globals.Browser.touch) return;
                    if ((0, _closest2.default)(event.relatedTarget, _globals.Selectors.POPPER)) return;
                    hide();
                };
                return {
                    handleTrigger: handleTrigger,
                    handleMouseleave: handleMouseleave,
                    handleBlur: handleBlur
                };
            }
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = getIndividualSettings;
            var _globals = __webpack_require__(0);
            /**
* Returns an object of settings to override global settings
* @param {Element} el - the tooltipped element
* @param {Object} instanceSettings
* @return {Object} - individual settings
*/ function getIndividualSettings(el, instanceSettings) {
                var settings = _globals.DefaultsKeys.reduce(function(acc, key) {
                    var val = el.getAttribute('data-' + key.toLowerCase()) || instanceSettings[key];
                    // Convert strings to booleans
                    if (val === 'false') val = false;
                    if (val === 'true') val = true;
                    // Convert number strings to true numbers
                    if (isFinite(val) && !isNaN(parseFloat(val))) val = parseFloat(val);
                    // Convert array strings to actual arrays
                    if (typeof val === 'string' && val.trim().charAt(0) === '[') val = JSON.parse(val);
                    acc[key] = val;
                    return acc;
                }, {});
                return Object.assign({}, instanceSettings, settings);
            }
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = hideAllPoppers;
            var _globals = __webpack_require__(0);
            /**
* Hides all poppers
* @param {Object} exclude - refData to exclude if needed
*/ function hideAllPoppers(exclude) {
                _globals.Store.forEach(function(refData) {
                    var popper = refData.popper, tippyInstance = refData.tippyInstance, _refData$settings = refData.settings, appendTo = _refData$settings.appendTo, hideOnClick = _refData$settings.hideOnClick, trigger = _refData$settings.trigger;
                    // Don't hide already hidden ones
                    if (!appendTo.contains(popper)) return;
                    // hideOnClick can have the truthy value of 'persistent', so strict check is needed
                    var isHideOnClick = hideOnClick === true || trigger.indexOf('focus') !== -1;
                    var isNotCurrentRef = !exclude || popper !== exclude.popper;
                    if (isHideOnClick && isNotCurrentRef) {
                        refData.settings.onRequestClose();
                        tippyInstance.hide(popper);
                    }
                });
            }
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = init;
            var _bindEventListeners = __webpack_require__(16);
            var _bindEventListeners2 = _interopRequireDefault(_bindEventListeners);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* To run a single time, once DOM is presumed to be ready
* @return {Boolean} whether the function has run or not
*/ function init() {
                if (init.done) return false;
                init.done = true;
                (0, _bindEventListeners2.default)();
                return true;
            }
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = makeSticky;
            var _defer = __webpack_require__(5);
            var _defer2 = _interopRequireDefault(_defer);
            var _prefix = __webpack_require__(1);
            var _prefix2 = _interopRequireDefault(_prefix);
            var _isVisible = __webpack_require__(7);
            var _isVisible2 = _interopRequireDefault(_isVisible);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Updates a popper's position on each animation frame to make it stick to a moving element
* @param {Object} refData
*/ function makeSticky(refData) {
                var popper = refData.popper, popperInstance = refData.popperInstance, stickyDuration = refData.settings.stickyDuration;
                var applyTransitionDuration = function applyTransitionDuration() {
                    return popper.style[(0, _prefix2.default)('transitionDuration')] = stickyDuration + 'ms';
                };
                var removeTransitionDuration = function removeTransitionDuration() {
                    return popper.style[(0, _prefix2.default)('transitionDuration')] = '';
                };
                var updatePosition = function updatePosition() {
                    popperInstance && popperInstance.scheduleUpdate();
                    applyTransitionDuration();
                    (0, _isVisible2.default)(popper) ? window.requestAnimationFrame(updatePosition) : removeTransitionDuration();
                };
                // Wait until Popper's position has been updated initially
                (0, _defer2.default)(updatePosition);
            }
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = mountPopper;
            var _globals = __webpack_require__(0);
            var _followCursorHandler = __webpack_require__(10);
            var _followCursorHandler2 = _interopRequireDefault(_followCursorHandler);
            var _createPopperInstance = __webpack_require__(18);
            var _createPopperInstance2 = _interopRequireDefault(_createPopperInstance);
            var _prefix = __webpack_require__(1);
            var _prefix2 = _interopRequireDefault(_prefix);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Appends the popper and creates a popper instance if one does not exist
* Also updates its position if need be and enables event listeners
* @param {Object} data -  the element/popper reference data
*/ function mountPopper(data) {
                var el = data.el, popper = data.popper, _data$settings = data.settings, appendTo = _data$settings.appendTo, followCursor = _data$settings.followCursor;
                // Already on the DOM
                if (appendTo.contains(popper)) return;
                appendTo.appendChild(popper);
                if (!data.popperInstance) data.popperInstance = (0, _createPopperInstance2.default)(data);
                else {
                    data.popperInstance.update();
                    if (!followCursor || _globals.Browser.touch) data.popperInstance.enableEventListeners();
                }
                // Since touch is determined dynamically, followCursor is set on mount
                if (followCursor && !_globals.Browser.touch) {
                    el.addEventListener('mousemove', _followCursorHandler2.default);
                    data.popperInstance.disableEventListeners();
                }
            }
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = onTransitionEnd;
            var _globals = __webpack_require__(0);
            var _getInnerElements2 = __webpack_require__(6);
            var _getInnerElements3 = _interopRequireDefault(_getInnerElements2);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Prepares the callback functions for `show` and `hide` methods
* @param {Object} data
* @param {Number} duration
* @param {Function} callback - callback function to fire once transitions complete
*/ function onTransitionEnd(data, duration, callback) {
                // Make callback synchronous if duration is 0
                if (!duration) return callback();
                var _getInnerElements = (0, _getInnerElements3.default)(data.popper), tooltip = _getInnerElements.tooltip;
                var transitionendFired = false;
                var listenerCallback = function listenerCallback(e) {
                    if (e.target === tooltip && !transitionendFired) {
                        transitionendFired = true;
                        callback();
                    }
                };
                // Fire callback upon transition completion
                tooltip.addEventListener('webkitTransitionEnd', listenerCallback);
                tooltip.addEventListener('transitionend', listenerCallback);
                // Fallback: transitionend listener sometimes may not fire
                clearTimeout(data._transitionendTimeout);
                data._transitionendTimeout = setTimeout(function() {
                    if (!transitionendFired) callback();
                }, duration);
            }
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            /* Utility functions */ /* Core library functions */ var _globals = __webpack_require__(0);
            var _reactDom = __webpack_require__(39);
            var _reactDom2 = _interopRequireDefault(_reactDom);
            var _init = __webpack_require__(26);
            var _init2 = _interopRequireDefault(_init);
            var _defer = __webpack_require__(5);
            var _defer2 = _interopRequireDefault(_defer);
            var _prefix = __webpack_require__(1);
            var _prefix2 = _interopRequireDefault(_prefix);
            var _find = __webpack_require__(2);
            var _find2 = _interopRequireDefault(_find);
            var _findIndex = __webpack_require__(34);
            var _findIndex2 = _interopRequireDefault(_findIndex);
            var _removeTitle = __webpack_require__(12);
            var _removeTitle2 = _interopRequireDefault(_removeTitle);
            var _elementIsInViewport = __webpack_require__(33);
            var _elementIsInViewport2 = _interopRequireDefault(_elementIsInViewport);
            var _triggerReflow = __webpack_require__(37);
            var _triggerReflow2 = _interopRequireDefault(_triggerReflow);
            var _modifyClassList = __webpack_require__(35);
            var _modifyClassList2 = _interopRequireDefault(_modifyClassList);
            var _getInnerElements4 = __webpack_require__(6);
            var _getInnerElements5 = _interopRequireDefault(_getInnerElements4);
            var _applyTransitionDuration = __webpack_require__(31);
            var _applyTransitionDuration2 = _interopRequireDefault(_applyTransitionDuration);
            var _isVisible = __webpack_require__(7);
            var _isVisible2 = _interopRequireDefault(_isVisible);
            var _noop = __webpack_require__(36);
            var _noop2 = _interopRequireDefault(_noop);
            var _followCursorHandler = __webpack_require__(10);
            var _followCursorHandler2 = _interopRequireDefault(_followCursorHandler);
            var _getArrayOfElements = __webpack_require__(22);
            var _getArrayOfElements2 = _interopRequireDefault(_getArrayOfElements);
            var _onTransitionEnd = __webpack_require__(29);
            var _onTransitionEnd2 = _interopRequireDefault(_onTransitionEnd);
            var _mountPopper = __webpack_require__(28);
            var _mountPopper2 = _interopRequireDefault(_mountPopper);
            var _makeSticky = __webpack_require__(27);
            var _makeSticky2 = _interopRequireDefault(_makeSticky);
            var _createTooltips = __webpack_require__(19);
            var _createTooltips2 = _interopRequireDefault(_createTooltips);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
* @param {String|Element|Element[]} selector
* @param {Object} settings (optional) - the object of settings to be applied to the instance
*/ var Tippy = function() {
                function Tippy(selector) {
                    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, Tippy);
                    // Use default browser tooltip on unsupported browsers
                    if (!_globals.Browser.SUPPORTED) return;
                    (0, _init2.default)();
                    this.state = {
                        destroyed: false
                    };
                    this.selector = selector;
                    this.settings = _extends({}, _globals.Defaults, settings);
                    if (settings.show || settings.shown || settings.hide || settings.hidden) console.warn("Callbacks without the `on` prefix are deprecated (with the exception of `wait`). Use onShow, onShown, onHide, and onHidden instead.");
                    this.callbacks = {
                        wait: settings.wait,
                        show: settings.onShow || settings.show || _noop2.default,
                        shown: settings.onShown || settings.shown || _noop2.default,
                        hide: settings.onHide || settings.hide || _noop2.default,
                        hidden: settings.onHidden || settings.hidden || _noop2.default
                    };
                    this.store = _createTooltips2.default.call(this, (0, _getArrayOfElements2.default)(selector));
                    _globals.Store.push.apply(_globals.Store, this.store);
                }
                /**
  * Returns the reference element's popper element
  * @param {Element} el
  * @return {Element}
  */ _createClass(Tippy, [
                    {
                        key: 'getPopperElement',
                        value: function getPopperElement(el) {
                            try {
                                return (0, _find2.default)(this.store, function(data) {
                                    return data.el === el;
                                }).popper;
                            } catch (e) {
                                console.error('[getPopperElement]: Element passed as the argument does not exist in the instance');
                            }
                        }
                    },
                    {
                        key: 'getReferenceElement',
                        value: function getReferenceElement(popper) {
                            try {
                                return (0, _find2.default)(this.store, function(data) {
                                    return data.popper === popper;
                                }).el;
                            } catch (e) {
                                console.error('[getReferenceElement]: Popper passed as the argument does not exist in the instance');
                            }
                        }
                    },
                    {
                        key: 'getReferenceData',
                        value: function getReferenceData(x) {
                            return (0, _find2.default)(this.store, function(data) {
                                return data.el === x || data.popper === x;
                            });
                        }
                    },
                    {
                        key: 'updateSettings',
                        value: function updateSettings(popper, name, value) {
                            var data = (0, _find2.default)(this.store, function(data) {
                                return data.popper === popper;
                            });
                            if (!data) return;
                            var newSettings = _extends({}, data.settings, _defineProperty({}, name, value));
                            data.settings = newSettings;
                        }
                    },
                    {
                        key: 'updateForReact',
                        /**
    * Update for React
    * @param {DOMElement} - popper
    * @param {ReactElement} - content
    */ value: function updateForReact(popper, updatedContent) {
                            var tooltipContent = popper.querySelector(_globals.Selectors.CONTENT);
                            var data = (0, _find2.default)(this.store, function(data) {
                                return data.popper === popper;
                            });
                            if (!data) return;
                            var _data$settings = data.settings, useContext = _data$settings.useContext, setReactDOMValue = _data$settings.setReactDOMValue;
                            if (useContext) setReactDOMValue(_reactDom2.default.createPortal(updatedContent, tooltipContent));
                            else _reactDom2.default.render(updatedContent, tooltipContent);
                        }
                    },
                    {
                        key: 'show',
                        value: function show(popper, customDuration) {
                            var _this = this;
                            if (this.state.destroyed) return;
                            var data = (0, _find2.default)(this.store, function(data) {
                                return data.popper === popper;
                            });
                            if (!data) return;
                            var _getInnerElements = (0, _getInnerElements5.default)(popper), tooltip = _getInnerElements.tooltip, circle = _getInnerElements.circle, content = _getInnerElements.content;
                            if (!document.body.contains(data.el)) {
                                this.destroy(popper);
                                return;
                            }
                            this.callbacks.show.call(popper);
                            // Custom react
                            if (data.settings && data.settings.open === false) return;
                            if (data.settings.reactDOM) this.updateForReact(popper, data.settings.reactDOM);
                            // end: Custom react
                            var el = data.el, _data$settings2 = data.settings, appendTo = _data$settings2.appendTo, sticky = _data$settings2.sticky, interactive = _data$settings2.interactive, followCursor = _data$settings2.followCursor, flipDuration = _data$settings2.flipDuration, duration = _data$settings2.duration, dynamicTitle = _data$settings2.dynamicTitle;
                            if (dynamicTitle) {
                                var title = el.getAttribute('title');
                                if (title) {
                                    content.innerHTML = title;
                                    (0, _removeTitle2.default)(el);
                                }
                            }
                            var _duration = customDuration !== undefined ? customDuration : Array.isArray(duration) ? duration[0] : duration;
                            // Prevent a transition when popper changes position
                            (0, _applyTransitionDuration2.default)([
                                popper,
                                tooltip,
                                circle
                            ], 0);
                            (0, _mountPopper2.default)(data);
                            popper.style.visibility = 'visible';
                            popper.setAttribute('aria-hidden', 'false');
                            // Wait for popper's position to update
                            (0, _defer2.default)(function() {
                                // Sometimes the arrow will not be in the correct position, force another update
                                if (!followCursor || _globals.Browser.touch) {
                                    data.popperInstance.update();
                                    (0, _applyTransitionDuration2.default)([
                                        popper
                                    ], flipDuration);
                                }
                                // Re-apply transition durations
                                (0, _applyTransitionDuration2.default)([
                                    tooltip,
                                    circle
                                ], _duration);
                                // Make content fade out a bit faster than the tooltip if `animateFill`
                                if (circle) content.style.opacity = 1;
                                // Interactive tooltips receive a class of 'active'
                                interactive && el.classList.add('active');
                                // Update popper's position on every animation frame
                                sticky && (0, _makeSticky2.default)(data);
                                // Repaint/reflow is required for CSS transition when appending
                                (0, _triggerReflow2.default)(tooltip, circle);
                                (0, _modifyClassList2.default)([
                                    tooltip,
                                    circle
                                ], function(list) {
                                    list.contains('tippy-notransition') && list.remove('tippy-notransition');
                                    list.remove('leave');
                                    list.add('enter');
                                });
                                // Wait for transitions to complete
                                (0, _onTransitionEnd2.default)(data, _duration, function() {
                                    if (!(0, _isVisible2.default)(popper) || data._onShownFired) return;
                                    // Focus interactive tooltips only
                                    interactive && popper.focus();
                                    // Remove transitions from tooltip
                                    tooltip.classList.add('tippy-notransition');
                                    // Prevents shown() from firing more than once from early transition cancellations
                                    data._onShownFired = true;
                                    _this.callbacks.shown.call(popper);
                                });
                            });
                        }
                    },
                    {
                        key: 'hide',
                        value: function hide(popper, customDuration) {
                            var _this2 = this;
                            if (this.state.destroyed) return;
                            this.callbacks.hide.call(popper);
                            var data = (0, _find2.default)(this.store, function(data) {
                                return data.popper === popper;
                            });
                            if (!data) return;
                            var _getInnerElements2 = (0, _getInnerElements5.default)(popper), tooltip = _getInnerElements2.tooltip, circle = _getInnerElements2.circle, content = _getInnerElements2.content;
                            // custom react
                            // Prevent hide if open
                            if (data.settings.disabled === false && data && data.settings.open) return;
                            var isUnmount = data && data.settings && data.settings.unmountHTMLWhenHide && data.settings.reactDOM;
                            // end: custom react
                            var el = data.el, _data$settings3 = data.settings, appendTo = _data$settings3.appendTo, sticky = _data$settings3.sticky, interactive = _data$settings3.interactive, followCursor = _data$settings3.followCursor, html = _data$settings3.html, trigger = _data$settings3.trigger, duration = _data$settings3.duration;
                            var _duration = customDuration !== undefined ? customDuration : Array.isArray(duration) ? duration[1] : duration;
                            data._onShownFired = false;
                            interactive && el.classList.remove('active');
                            popper.style.visibility = 'hidden';
                            popper.setAttribute('aria-hidden', 'true');
                            (0, _applyTransitionDuration2.default)([
                                tooltip,
                                circle,
                                circle ? content : null
                            ], _duration);
                            if (circle) content.style.opacity = 0;
                            (0, _modifyClassList2.default)([
                                tooltip,
                                circle
                            ], function(list) {
                                list.contains('tippy-tooltip') && list.remove('tippy-notransition');
                                list.remove('enter');
                                list.add('leave');
                            });
                            // Re-focus click-triggered html elements
                            // and the tooltipped element IS in the viewport (otherwise it causes unsightly scrolling
                            // if the tooltip is closed and the element isn't in the viewport anymore)
                            if (html && trigger.indexOf('click') !== -1 && (0, _elementIsInViewport2.default)(el)) el.focus();
                            // Wait for transitions to complete
                            (0, _onTransitionEnd2.default)(data, _duration, function() {
                                // `isVisible` is not completely reliable to determine if we shouldn't
                                // run the hidden callback, we need to check the computed opacity style.
                                // This prevents glitchy behavior of the transition when quickly showing
                                // and hiding a tooltip.
                                if ((0, _isVisible2.default)(popper) || !appendTo.contains(popper) || getComputedStyle(tooltip).opacity === '1') return;
                                el.removeEventListener('mousemove', _followCursorHandler2.default);
                                data.popperInstance.disableEventListeners();
                                appendTo.removeChild(popper);
                                _this2.callbacks.hidden.call(popper);
                                // custom react
                                if (isUnmount) _reactDom2.default.unmountComponentAtNode(content);
                            });
                        }
                    },
                    {
                        key: 'update',
                        value: function update(popper) {
                            if (this.state.destroyed) return;
                            var data = (0, _find2.default)(this.store, function(data) {
                                return data.popper === popper;
                            });
                            if (!data) return;
                            var _getInnerElements3 = (0, _getInnerElements5.default)(popper), content = _getInnerElements3.content;
                            var el = data.el, html = data.settings.html;
                            if (html instanceof Element) {
                                console.warn('Aborted: update() should not be used if `html` is a DOM element');
                                return;
                            }
                            content.innerHTML = html ? document.getElementById(html.replace('#', '')).innerHTML : el.getAttribute('title') || el.getAttribute('data-original-title');
                            if (!html) (0, _removeTitle2.default)(el);
                        }
                    },
                    {
                        key: 'destroy',
                        value: function destroy(popper, _isLast) {
                            var _this3 = this;
                            if (this.state.destroyed) return;
                            var data = (0, _find2.default)(this.store, function(data) {
                                return data.popper === popper;
                            });
                            if (!data) return;
                            var el = data.el, popperInstance = data.popperInstance, listeners = data.listeners, _mutationObserver = data._mutationObserver;
                            // Ensure the popper is hidden
                            if ((0, _isVisible2.default)(popper)) this.hide(popper, 0);
                            // Remove Tippy-only event listeners from tooltipped element
                            listeners.forEach(function(listener) {
                                return el.removeEventListener(listener.event, listener.handler);
                            });
                            // Restore original title
                            el.setAttribute('title', el.getAttribute('data-original-title'));
                            el.removeAttribute('data-original-title');
                            el.removeAttribute('data-tooltipped');
                            el.removeAttribute('aria-describedby');
                            popperInstance && popperInstance.destroy();
                            _mutationObserver && _mutationObserver.disconnect();
                            // Remove from store
                            _globals.Store.splice((0, _findIndex2.default)(_globals.Store, function(data) {
                                return data.popper === popper;
                            }), 1);
                            // Ensure filter is called only once
                            if (_isLast === undefined || _isLast) this.store = _globals.Store.filter(function(data) {
                                return data.tippyInstance === _this3;
                            });
                        }
                    },
                    {
                        key: 'destroyAll',
                        value: function destroyAll() {
                            var _this4 = this;
                            if (this.state.destroyed) return;
                            var storeLength = this.store.length;
                            this.store.forEach(function(_ref, index) {
                                var popper = _ref.popper;
                                _this4.destroy(popper, index === storeLength - 1);
                            });
                            this.store = null;
                            this.state.destroyed = true;
                        }
                    }
                ]);
                return Tippy;
            }();
            function tippy(selector, settings) {
                return new Tippy(selector, settings);
            }
            tippy.Browser = _globals.Browser;
            tippy.Defaults = _globals.Defaults;
            tippy.disableDynamicInputDetection = function() {
                return _globals.Browser.dynamicInputDetection = false;
            };
            tippy.enableDynamicInputDetection = function() {
                return _globals.Browser.dynamicInputDetection = true;
            };
            exports.default = tippy;
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = applyTransitionDuration;
            var _globals = __webpack_require__(0);
            var _prefix = __webpack_require__(1);
            var _prefix2 = _interopRequireDefault(_prefix);
            var _matches = __webpack_require__(8);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Applies the transition duration to each element
* @param {Element[]} els - Array of elements
* @param {Number} duration
*/ function applyTransitionDuration(els, duration) {
                els.forEach(function(el) {
                    if (!el) return;
                    var isContent = _matches.matches.call(el, _globals.Selectors.CONTENT);
                    var _duration = isContent ? Math.round(duration / 1.3) : duration;
                    el.style[(0, _prefix2.default)('transitionDuration')] = _duration + 'ms';
                });
            }
        /***/ },
        /* 32 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = cursorIsOutsideInteractiveBorder;
            var _getCorePlacement = __webpack_require__(3);
            var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Determines if the mouse's cursor is outside the interactive border
* @param {MouseEvent} event
* @param {Element} popper
* @param {Object} settings
* @return {Boolean}
*/ function cursorIsOutsideInteractiveBorder(event, popper, settings) {
                if (!popper.getAttribute('x-placement')) return true;
                var x = event.clientX, y = event.clientY;
                var interactiveBorder = settings.interactiveBorder, distance = settings.distance;
                var rect = popper.getBoundingClientRect();
                var corePosition = (0, _getCorePlacement2.default)(popper.getAttribute('x-placement'));
                var borderWithDistance = interactiveBorder + distance;
                var exceeds = {
                    top: rect.top - y > interactiveBorder,
                    bottom: y - rect.bottom > interactiveBorder,
                    left: rect.left - x > interactiveBorder,
                    right: x - rect.right > interactiveBorder
                };
                switch(corePosition){
                    case 'top':
                        exceeds.top = rect.top - y > borderWithDistance;
                        break;
                    case 'bottom':
                        exceeds.bottom = y - rect.bottom > borderWithDistance;
                        break;
                    case 'left':
                        exceeds.left = rect.left - x > borderWithDistance;
                        break;
                    case 'right':
                        exceeds.right = x - rect.right > borderWithDistance;
                        break;
                }
                return exceeds.top || exceeds.bottom || exceeds.left || exceeds.right;
            }
        /***/ },
        /* 33 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = elementIsInViewport;
            /**
* Determines if an element is visible in the viewport
* @param {Element} el
* @return {Boolean}
*/ function elementIsInViewport(el) {
                var rect = el.getBoundingClientRect();
                return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            }
        /***/ },
        /* 34 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = findIndex;
            var _find = __webpack_require__(2);
            var _find2 = _interopRequireDefault(_find);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Ponyfill for Array.prototype.findIndex
* @param {Array} arr
* @param {Function} checkFn
* @return index of the item in the array
*/ function findIndex(arr, checkFn) {
                if (Array.prototype.findIndex) return arr.findIndex(checkFn);
                // fallback
                return arr.indexOf((0, _find2.default)(arr, checkFn));
            }
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = modifyClassList;
            /**
* Modifies elements' class lists
* @param {Element[]} els - Array of elements
* @param {Function} callback
*/ function modifyClassList(els, callback) {
                els.forEach(function(el) {
                    if (!el) return;
                    callback(el.classList);
                });
            }
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = noop;
            function noop() {}
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = triggerReflow;
            var _prefix = __webpack_require__(1);
            var _prefix2 = _interopRequireDefault(_prefix);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
* Triggers a document repaint or reflow for CSS transition
* @param {Element} tooltip
* @param {Element} circle
*/ function triggerReflow(tooltip, circle) {
                // Safari needs the specific 'transform' property to be accessed
                circle ? window.getComputedStyle(circle)[(0, _prefix2.default)('transform')] : window.getComputedStyle(tooltip).opacity;
            }
        /***/ },
        /* 38 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_38__;
        /***/ },
        /* 39 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_39__;
        /***/ }
    ]);
});


/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by ChiyoYuki from ECNU-minus on 2025-05-29
 * Changes:
 * - feat: 不显示“上课老师”标注
 *
 * Copyright 2026 ECNU-minus
 * ----------------------------------------------------------------
 */ 
var $lgFxF = parcelRequire("lgFxF");
/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by Niazye from ECNU-minus on 2025-11-21
 * Changes:
 * - feat: browse and star
 *
 * Modified by 霧雨バニラ from BetterECNU on 2026-05-23
 * Changes:
 * - feat: 新增 useAllLessons 钩子，支持跨所有学期的课程数据获取，兼容 under/post 拆分格式并回退旧格式
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ 
var $lgFxF = parcelRequire("lgFxF");

var $lgFxF = parcelRequire("lgFxF");
var $14f5c221cb476668$exports = {};
'use strict';
var $14f5c221cb476668$var$isArray = Array.isArray;
var $14f5c221cb476668$var$keyList = Object.keys;
var $14f5c221cb476668$var$hasProp = Object.prototype.hasOwnProperty;
$14f5c221cb476668$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $14f5c221cb476668$var$isArray(a), arrB = $14f5c221cb476668$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $14f5c221cb476668$var$keyList(a);
        length = keys.length;
        if (length !== $14f5c221cb476668$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$14f5c221cb476668$var$hasProp.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
};


function $7d69233daa83b15c$export$2e2bcd8739ae039() {
    if (typeof document !== 'undefined' && typeof document.visibilityState !== 'undefined') return document.visibilityState !== 'hidden';
    // always assume it's visible
    return true;
}


// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var $86e693982c5ed2c0$var$table = new WeakMap();
// counter of the key
var $86e693982c5ed2c0$var$counter = 0;
function $86e693982c5ed2c0$export$2e2bcd8739ae039(args) {
    if (!args.length) return '';
    var key = 'arg';
    for(var i = 0; i < args.length; ++i){
        var _hash = void 0;
        if (args[i] === null || typeof args[i] !== 'object' && typeof args[i] !== 'function') {
            // need to consider the case that args[i] is a string:
            // args[i]        _hash
            // "undefined" -> '"undefined"'
            // undefined   -> 'undefined'
            // 123         -> '123'
            // null        -> 'null'
            // "null"      -> '"null"'
            if (typeof args[i] === 'string') _hash = '"' + args[i] + '"';
            else _hash = String(args[i]);
        } else if (!$86e693982c5ed2c0$var$table.has(args[i])) {
            _hash = $86e693982c5ed2c0$var$counter;
            $86e693982c5ed2c0$var$table.set(args[i], $86e693982c5ed2c0$var$counter++);
        } else _hash = $86e693982c5ed2c0$var$table.get(args[i]);
        key += '@' + _hash;
    }
    return key;
}


var $9747e9c78cd07ff4$var$Cache = /** @class */ function() {
    function Cache(initialData) {
        if (initialData === void 0) initialData = {};
        this.__cache = new Map(Object.entries(initialData));
        this.__listeners = [];
    }
    Cache.prototype.get = function(key) {
        var _key = this.serializeKey(key)[0];
        return this.__cache.get(_key);
    };
    Cache.prototype.set = function(key, value) {
        var _key = this.serializeKey(key)[0];
        this.__cache.set(_key, value);
        this.notify();
    };
    Cache.prototype.keys = function() {
        return Array.from(this.__cache.keys());
    };
    Cache.prototype.has = function(key) {
        var _key = this.serializeKey(key)[0];
        return this.__cache.has(_key);
    };
    Cache.prototype.clear = function() {
        this.__cache.clear();
        this.notify();
    };
    Cache.prototype.delete = function(key) {
        var _key = this.serializeKey(key)[0];
        this.__cache.delete(_key);
        this.notify();
    };
    // TODO: introduce namespace for the cache
    Cache.prototype.serializeKey = function(key) {
        var args = null;
        if (typeof key === 'function') try {
            key = key();
        } catch (err) {
            // dependencies not ready
            key = '';
        }
        if (Array.isArray(key)) {
            // args array
            args = key;
            key = (0, $86e693982c5ed2c0$export$2e2bcd8739ae039)(key);
        } else // convert null to ''
        key = String(key || '');
        var errorKey = key ? 'err@' + key : '';
        return [
            key,
            args,
            errorKey
        ];
    };
    Cache.prototype.subscribe = function(listener) {
        var _this = this;
        if (typeof listener !== 'function') throw new Error('Expected the listener to be a function.');
        var isSubscribed = true;
        this.__listeners.push(listener);
        return function() {
            if (!isSubscribed) return;
            isSubscribed = false;
            var index = _this.__listeners.indexOf(listener);
            if (index > -1) {
                _this.__listeners[index] = _this.__listeners[_this.__listeners.length - 1];
                _this.__listeners.length--;
            }
        };
    };
    // Notify Cache subscribers about a change in the cache
    Cache.prototype.notify = function() {
        for(var _i = 0, _a = this.__listeners; _i < _a.length; _i++){
            var listener = _a[_i];
            listener();
        }
    };
    return Cache;
}();
var $9747e9c78cd07ff4$export$2e2bcd8739ae039 = $9747e9c78cd07ff4$var$Cache;


// cache
var $573c55dc3ba23a86$export$69a3209f1a06c04d = new (0, $9747e9c78cd07ff4$export$2e2bcd8739ae039)();
// error retry
function $573c55dc3ba23a86$var$onErrorRetry(_, __, config, revalidate, opts) {
    if (!(0, $7d69233daa83b15c$export$2e2bcd8739ae039)()) // if it's hidden, stop
    // it will auto revalidate when focus
    return;
    if (typeof config.errorRetryCount === 'number' && opts.retryCount > config.errorRetryCount) return;
    // exponential backoff
    var count = Math.min(opts.retryCount || 0, 8);
    var timeout = ~~((Math.random() + 0.5) * (1 << count)) * config.errorRetryInterval;
    setTimeout(revalidate, timeout, opts);
}
// client side: need to adjust the config
// based on the browser status
// slow connection (<= 70Kbps)
var $573c55dc3ba23a86$var$slowConnection = typeof window !== 'undefined' && navigator['connection'] && [
    'slow-2g',
    '2g'
].indexOf(navigator['connection'].effectiveType) !== -1;
// config
var $573c55dc3ba23a86$var$defaultConfig = {
    // events
    onLoadingSlow: function() {},
    onSuccess: function() {},
    onError: function() {},
    onErrorRetry: $573c55dc3ba23a86$var$onErrorRetry,
    errorRetryInterval: ($573c55dc3ba23a86$var$slowConnection ? 10 : 5) * 1000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: ($573c55dc3ba23a86$var$slowConnection ? 5 : 3) * 1000,
    refreshInterval: 0,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    refreshWhenHidden: false,
    refreshWhenOffline: false,
    shouldRetryOnError: true,
    suspense: false,
    compare: (0, (/*@__PURE__*/$parcel$interopDefault($14f5c221cb476668$exports)))
};
var $573c55dc3ba23a86$export$2e2bcd8739ae039 = $573c55dc3ba23a86$var$defaultConfig;



function $53fb8b455c62254c$export$2e2bcd8739ae039() {
    if (typeof navigator.onLine !== 'undefined') return navigator.onLine;
    // always assume it's online
    return true;
}



var $lgFxF = parcelRequire("lgFxF");
var $459bdf5bf33b1baa$var$SWRConfigContext = (0, $lgFxF.createContext)({});
$459bdf5bf33b1baa$var$SWRConfigContext.displayName = 'SWRConfigContext';
var $459bdf5bf33b1baa$export$2e2bcd8739ae039 = $459bdf5bf33b1baa$var$SWRConfigContext;


var $09891d3af042c3f3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $09891d3af042c3f3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $09891d3af042c3f3$var$IS_SERVER = typeof window === 'undefined';
// polyfill for requestIdleCallback
var $09891d3af042c3f3$var$rIC = $09891d3af042c3f3$var$IS_SERVER ? null : window['requestIdleCallback'] || function(f) {
    return setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var $09891d3af042c3f3$var$useIsomorphicLayoutEffect = $09891d3af042c3f3$var$IS_SERVER ? (0, $lgFxF.useEffect) : (0, $lgFxF.useLayoutEffect);
// global state managers
var $09891d3af042c3f3$var$CONCURRENT_PROMISES = {};
var $09891d3af042c3f3$var$CONCURRENT_PROMISES_TS = {};
var $09891d3af042c3f3$var$FOCUS_REVALIDATORS = {};
var $09891d3af042c3f3$var$RECONNECT_REVALIDATORS = {};
var $09891d3af042c3f3$var$CACHE_REVALIDATORS = {};
var $09891d3af042c3f3$var$MUTATION_TS = {};
var $09891d3af042c3f3$var$MUTATION_END_TS = {};
// setup DOM events listeners for `focus` and `reconnect` actions
if (!$09891d3af042c3f3$var$IS_SERVER && window.addEventListener) {
    var $09891d3af042c3f3$var$revalidate_1 = function(revalidators) {
        if (!(0, $7d69233daa83b15c$export$2e2bcd8739ae039)() || !(0, $53fb8b455c62254c$export$2e2bcd8739ae039)()) return;
        for(var key in revalidators)if (revalidators[key][0]) revalidators[key][0]();
    };
    // focus revalidate
    window.addEventListener('visibilitychange', function() {
        return $09891d3af042c3f3$var$revalidate_1($09891d3af042c3f3$var$FOCUS_REVALIDATORS);
    }, false);
    window.addEventListener('focus', function() {
        return $09891d3af042c3f3$var$revalidate_1($09891d3af042c3f3$var$FOCUS_REVALIDATORS);
    }, false);
    // reconnect revalidate
    window.addEventListener('online', function() {
        return $09891d3af042c3f3$var$revalidate_1($09891d3af042c3f3$var$RECONNECT_REVALIDATORS);
    }, false);
}
var $09891d3af042c3f3$export$e614dc9140f7ae71 = function(_key, shouldRevalidate) {
    if (shouldRevalidate === void 0) shouldRevalidate = true;
    // we are ignoring the second argument which correspond to the arguments
    // the fetcher will receive when key is an array
    var _a = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).serializeKey(_key), key = _a[0], keyErr = _a[2];
    if (!key) return Promise.resolve();
    var updaters = $09891d3af042c3f3$var$CACHE_REVALIDATORS[key];
    if (key && updaters) {
        var currentData = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(key);
        var currentError = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(keyErr);
        var promises = [];
        for(var i = 0; i < updaters.length; ++i)promises.push(updaters[i](shouldRevalidate, currentData, currentError, i > 0));
        // return new updated value
        return Promise.all(promises).then(function() {
            return (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(key);
        });
    }
    return Promise.resolve((0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(key));
};
var $09891d3af042c3f3$var$broadcastState = function(key, data, error) {
    var updaters = $09891d3af042c3f3$var$CACHE_REVALIDATORS[key];
    if (key && updaters) for(var i = 0; i < updaters.length; ++i)updaters[i](false, data, error);
};
var $09891d3af042c3f3$export$57e795267c26e600 = function(_key, _data, shouldRevalidate) {
    if (shouldRevalidate === void 0) shouldRevalidate = true;
    return $09891d3af042c3f3$var$__awaiter(void 0, void 0, void 0, function() {
        var _a, key, keyErr, beforeMutationTs, beforeConcurrentPromisesTs, data, error, err_1, err_2, updaters, promises, i;
        return $09891d3af042c3f3$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).serializeKey(_key), key = _a[0], keyErr = _a[2];
                    if (!key) return [
                        2 /*return*/ 
                    ];
                    // if there is no new data, call revalidate against the key
                    if (typeof _data === 'undefined') return [
                        2 /*return*/ ,
                        $09891d3af042c3f3$export$e614dc9140f7ae71(_key, shouldRevalidate)
                    ];
                    // update timestamps
                    $09891d3af042c3f3$var$MUTATION_TS[key] = Date.now() - 1;
                    $09891d3af042c3f3$var$MUTATION_END_TS[key] = 0;
                    beforeMutationTs = $09891d3af042c3f3$var$MUTATION_TS[key];
                    beforeConcurrentPromisesTs = $09891d3af042c3f3$var$CONCURRENT_PROMISES_TS[key];
                    if (!(_data && typeof _data === 'function')) return [
                        3 /*break*/ ,
                        5
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        _data((0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(key))
                    ];
                case 2:
                    data = _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    err_1 = _b.sent();
                    error = err_1;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 5:
                    if (!(_data && typeof _data.then === 'function')) return [
                        3 /*break*/ ,
                        10
                    ];
                    _b.label = 6;
                case 6:
                    _b.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4 /*yield*/ ,
                        _data
                    ];
                case 7:
                    data = _b.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    err_2 = _b.sent();
                    error = err_2;
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 9:
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    data = _data;
                    _b.label = 11;
                case 11:
                    // check if other mutations have occurred since we've started awaiting, if so then do not persist this change
                    if (beforeMutationTs !== $09891d3af042c3f3$var$MUTATION_TS[key] || beforeConcurrentPromisesTs !== $09891d3af042c3f3$var$CONCURRENT_PROMISES_TS[key]) {
                        if (error) throw error;
                        return [
                            2 /*return*/ ,
                            data
                        ];
                    }
                    if (typeof data !== 'undefined') // update cached data, avoid notifying from the cache
                    (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).set(key, data);
                    (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).set(keyErr, error);
                    // reset the timestamp to mark the mutation has ended
                    $09891d3af042c3f3$var$MUTATION_END_TS[key] = Date.now() - 1;
                    updaters = $09891d3af042c3f3$var$CACHE_REVALIDATORS[key];
                    if (updaters) {
                        promises = [];
                        for(i = 0; i < updaters.length; ++i)promises.push(updaters[i](!!shouldRevalidate, data, error, i > 0));
                        // return new updated value
                        return [
                            2 /*return*/ ,
                            Promise.all(promises).then(function() {
                                if (error) throw error;
                                return (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(key);
                            })
                        ];
                    }
                    // throw error or return data to be used by caller of mutate
                    if (error) throw error;
                    return [
                        2 /*return*/ ,
                        data
                    ];
            }
        });
    });
};
function $09891d3af042c3f3$var$useSWR() {
    var _this = this;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var _key, fn, config = {};
    if (args.length >= 1) _key = args[0];
    if (args.length > 2) {
        fn = args[1];
        config = args[2];
    } else {
        if (typeof args[1] === 'function') fn = args[1];
        else if (typeof args[1] === 'object') config = args[1];
    }
    // we assume `key` as the identifier of the request
    // `key` can change but `fn` shouldn't
    // (because `revalidate` only depends on `key`)
    // `keyErr` is the cache key for error objects
    var _a = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).serializeKey(_key), key = _a[0], fnArgs = _a[1], keyErr = _a[2];
    config = Object.assign({}, (0, $573c55dc3ba23a86$export$2e2bcd8739ae039), (0, $lgFxF.useContext)((0, $459bdf5bf33b1baa$export$2e2bcd8739ae039)), config);
    var configRef = (0, $lgFxF.useRef)(config);
    $09891d3af042c3f3$var$useIsomorphicLayoutEffect(function() {
        configRef.current = config;
    });
    if (typeof fn === 'undefined') // use the global fetcher
    fn = config.fetcher;
    var initialData = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(key) || config.initialData;
    var initialError = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(keyErr);
    // if a state is accessed (data, error or isValidating),
    // we add the state to dependencies so if the state is
    // updated in the future, we can trigger a rerender
    var stateDependencies = (0, $lgFxF.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    var stateRef = (0, $lgFxF.useRef)({
        data: initialData,
        error: initialError,
        isValidating: false
    });
    // display the data label in the React DevTools next to SWR hooks
    (0, $lgFxF.useDebugValue)(stateRef.current.data);
    var rerender = (0, $lgFxF.useState)(null)[1];
    var dispatch = (0, $lgFxF.useCallback)(function(payload) {
        var shouldUpdateState = false;
        for(var k in payload){
            if (stateRef.current[k] === payload[k]) continue;
            stateRef.current[k] = payload[k];
            if (stateDependencies.current[k]) shouldUpdateState = true;
        }
        if (shouldUpdateState || config.suspense) {
            if (unmountedRef.current) return;
            rerender({});
        }
    }, []);
    // error ref inside revalidate (is last request errored?)
    var unmountedRef = (0, $lgFxF.useRef)(false);
    var keyRef = (0, $lgFxF.useRef)(key);
    // do unmount check for callbacks
    var eventsRef = (0, $lgFxF.useRef)({
        emit: function(event) {
            var _a;
            var params = [];
            for(var _i = 1; _i < arguments.length; _i++)params[_i - 1] = arguments[_i];
            if (unmountedRef.current) return;
            (_a = configRef.current)[event].apply(_a, params);
        }
    });
    var boundMutate = (0, $lgFxF.useCallback)(function(data, shouldRevalidate) {
        return $09891d3af042c3f3$export$57e795267c26e600(key, data, shouldRevalidate);
    }, [
        key
    ]);
    var addRevalidator = function(revalidators, callback) {
        if (!callback) return;
        if (!revalidators[key]) revalidators[key] = [
            callback
        ];
        else revalidators[key].push(callback);
    };
    var removeRevalidator = function(revlidators, callback) {
        if (revlidators[key]) {
            var revalidators = revlidators[key];
            var index = revalidators.indexOf(callback);
            if (index >= 0) {
                // 10x faster than splice
                // https://jsperf.com/array-remove-by-index
                revalidators[index] = revalidators[revalidators.length - 1];
                revalidators.pop();
            }
        }
    };
    // start a revalidation
    var revalidate = (0, $lgFxF.useCallback)(function(revalidateOpts) {
        if (revalidateOpts === void 0) revalidateOpts = {};
        return $09891d3af042c3f3$var$__awaiter(_this, void 0, void 0, function() {
            var loading, shouldDeduping, newData, startAt, shouldIgnoreRequest, newState, err_3, retryCount;
            return $09891d3af042c3f3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!key || !fn) return [
                            2 /*return*/ ,
                            false
                        ];
                        if (unmountedRef.current) return [
                            2 /*return*/ ,
                            false
                        ];
                        revalidateOpts = Object.assign({
                            dedupe: false
                        }, revalidateOpts);
                        loading = true;
                        shouldDeduping = typeof $09891d3af042c3f3$var$CONCURRENT_PROMISES[key] !== 'undefined' && revalidateOpts.dedupe;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        dispatch({
                            isValidating: true
                        });
                        newData = void 0;
                        startAt = void 0;
                        if (!shouldDeduping) return [
                            3 /*break*/ ,
                            3
                        ];
                        // there's already an ongoing request,
                        // this one needs to be deduplicated.
                        startAt = $09891d3af042c3f3$var$CONCURRENT_PROMISES_TS[key];
                        return [
                            4 /*yield*/ ,
                            $09891d3af042c3f3$var$CONCURRENT_PROMISES[key]
                        ];
                    case 2:
                        newData = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        // if no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !(0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(key)) setTimeout(function() {
                            if (loading) eventsRef.current.emit('onLoadingSlow', key, config);
                        }, config.loadingTimeout);
                        if (fnArgs !== null) $09891d3af042c3f3$var$CONCURRENT_PROMISES[key] = fn.apply(void 0, fnArgs);
                        else $09891d3af042c3f3$var$CONCURRENT_PROMISES[key] = fn(key);
                        $09891d3af042c3f3$var$CONCURRENT_PROMISES_TS[key] = startAt = Date.now();
                        return [
                            4 /*yield*/ ,
                            $09891d3af042c3f3$var$CONCURRENT_PROMISES[key]
                        ];
                    case 4:
                        newData = _a.sent();
                        setTimeout(function() {
                            delete $09891d3af042c3f3$var$CONCURRENT_PROMISES[key];
                            delete $09891d3af042c3f3$var$CONCURRENT_PROMISES_TS[key];
                        }, config.dedupingInterval);
                        // trigger the success event,
                        // only do this for the original request.
                        eventsRef.current.emit('onSuccess', newData, key, config);
                        _a.label = 5;
                    case 5:
                        shouldIgnoreRequest = // if there're other ongoing request(s), started after the current one,
                        // we need to ignore the current one to avoid possible race conditions:
                        //   req1------------------>res1        (current one)
                        //        req2---------------->res2
                        // the request that fired later will always be kept.
                        $09891d3af042c3f3$var$CONCURRENT_PROMISES_TS[key] > startAt || // if there're other mutations(s), overlapped with the current revalidation:
                        // case 1:
                        //   req------------------>res
                        //       mutate------>end
                        // case 2:
                        //         req------------>res
                        //   mutate------>end
                        // case 3:
                        //   req------------------>res
                        //       mutate-------...---------->
                        // we have to ignore the revalidation result (res) because it's no longer fresh.
                        // meanwhile, a new revalidation should be triggered when the mutation ends.
                        $09891d3af042c3f3$var$MUTATION_TS[key] && // case 1
                        (startAt <= $09891d3af042c3f3$var$MUTATION_TS[key] || // case 2
                        startAt <= $09891d3af042c3f3$var$MUTATION_END_TS[key] || // case 3
                        $09891d3af042c3f3$var$MUTATION_END_TS[key] === 0);
                        if (shouldIgnoreRequest) {
                            dispatch({
                                isValidating: false
                            });
                            return [
                                2 /*return*/ ,
                                false
                            ];
                        }
                        (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).set(key, newData);
                        (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).set(keyErr, undefined);
                        newState = {
                            isValidating: false
                        };
                        if (typeof stateRef.current.error !== 'undefined') // we don't have an error
                        newState.error = undefined;
                        if (!config.compare(stateRef.current.data, newData)) // deep compare to avoid extra re-render
                        // data changed
                        newState.data = newData;
                        // merge the new state
                        dispatch(newState);
                        if (!shouldDeduping) // also update other hooks
                        $09891d3af042c3f3$var$broadcastState(key, newData, undefined);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        err_3 = _a.sent();
                        delete $09891d3af042c3f3$var$CONCURRENT_PROMISES[key];
                        delete $09891d3af042c3f3$var$CONCURRENT_PROMISES_TS[key];
                        (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).set(keyErr, err_3);
                        // get a new error
                        // don't use deep equal for errors
                        if (stateRef.current.error !== err_3) {
                            // we keep the stale data
                            dispatch({
                                isValidating: false,
                                error: err_3
                            });
                            if (!shouldDeduping) // also broadcast to update other hooks
                            $09891d3af042c3f3$var$broadcastState(key, undefined, err_3);
                        }
                        // events and retry
                        eventsRef.current.emit('onError', err_3, key, config);
                        if (config.shouldRetryOnError) {
                            retryCount = (revalidateOpts.retryCount || 0) + 1;
                            eventsRef.current.emit('onErrorRetry', err_3, key, config, revalidate, Object.assign({
                                dedupe: true
                            }, revalidateOpts, {
                                retryCount: retryCount
                            }));
                        }
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        loading = false;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                }
            });
        });
    }, [
        key
    ]);
    // mounted (client side rendering)
    $09891d3af042c3f3$var$useIsomorphicLayoutEffect(function() {
        if (!key) return undefined;
        // after `key` updates, we need to mark it as mounted
        unmountedRef.current = false;
        // after the component is mounted (hydrated),
        // we need to update the data from the cache
        // and trigger a revalidation
        var currentHookData = stateRef.current.data;
        var latestKeyedData = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(key) || config.initialData;
        // update the state if the key changed (not the inital render) or cache updated
        if (keyRef.current !== key) keyRef.current = key;
        if (!config.compare(currentHookData, latestKeyedData)) dispatch({
            data: latestKeyedData
        });
        // revalidate with deduping
        var softRevalidate = function() {
            return revalidate({
                dedupe: true
            });
        };
        // trigger a revalidation
        if (config.revalidateOnMount || !config.initialData && config.revalidateOnMount === undefined) {
            if (typeof latestKeyedData !== 'undefined') // delay revalidate if there's cache
            // to not block the rendering
            $09891d3af042c3f3$var$rIC(softRevalidate);
            else softRevalidate();
        }
        var pending = false;
        var onFocus = function() {
            if (pending || !configRef.current.revalidateOnFocus) return;
            pending = true;
            softRevalidate();
            setTimeout(function() {
                return pending = false;
            }, configRef.current.focusThrottleInterval);
        };
        var onReconnect = function() {
            if (configRef.current.revalidateOnReconnect) softRevalidate();
        };
        // register global cache update listener
        var onUpdate = function(shouldRevalidate, updatedData, updatedError, dedupe) {
            if (shouldRevalidate === void 0) shouldRevalidate = true;
            if (dedupe === void 0) dedupe = true;
            // update hook state
            var newState = {};
            var needUpdate = false;
            if (typeof updatedData !== 'undefined' && !config.compare(stateRef.current.data, updatedData)) {
                newState.data = updatedData;
                needUpdate = true;
            }
            // always update error
            // because it can be `undefined`
            if (stateRef.current.error !== updatedError) {
                newState.error = updatedError;
                needUpdate = true;
            }
            if (needUpdate) dispatch(newState);
            if (shouldRevalidate) {
                if (dedupe) return softRevalidate();
                else return revalidate();
            }
            return false;
        };
        addRevalidator($09891d3af042c3f3$var$FOCUS_REVALIDATORS, onFocus);
        addRevalidator($09891d3af042c3f3$var$RECONNECT_REVALIDATORS, onReconnect);
        addRevalidator($09891d3af042c3f3$var$CACHE_REVALIDATORS, onUpdate);
        return function() {
            // cleanup
            dispatch = function() {
                return null;
            };
            // mark it as unmounted
            unmountedRef.current = true;
            removeRevalidator($09891d3af042c3f3$var$FOCUS_REVALIDATORS, onFocus);
            removeRevalidator($09891d3af042c3f3$var$RECONNECT_REVALIDATORS, onReconnect);
            removeRevalidator($09891d3af042c3f3$var$CACHE_REVALIDATORS, onUpdate);
        };
    }, [
        key,
        revalidate
    ]);
    // set up polling
    $09891d3af042c3f3$var$useIsomorphicLayoutEffect(function() {
        var timer = null;
        var tick = function() {
            return $09891d3af042c3f3$var$__awaiter(_this, void 0, void 0, function() {
                return $09891d3af042c3f3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(!stateRef.current.error && (config.refreshWhenHidden || (0, $7d69233daa83b15c$export$2e2bcd8739ae039)()) && (config.refreshWhenOffline || (0, $53fb8b455c62254c$export$2e2bcd8739ae039)()))) return [
                                3 /*break*/ ,
                                2
                            ];
                            // only revalidate when the page is visible
                            // if API request errored, we stop polling in this round
                            // and let the error retry function handle it
                            return [
                                4 /*yield*/ ,
                                revalidate({
                                    dedupe: true
                                })
                            ];
                        case 1:
                            // only revalidate when the page is visible
                            // if API request errored, we stop polling in this round
                            // and let the error retry function handle it
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (config.refreshInterval) timer = setTimeout(tick, config.refreshInterval);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        if (config.refreshInterval) timer = setTimeout(tick, config.refreshInterval);
        return function() {
            if (timer) clearTimeout(timer);
        };
    }, [
        config.refreshInterval,
        config.refreshWhenHidden,
        config.refreshWhenOffline,
        revalidate
    ]);
    // suspense
    if (config.suspense) {
        // in suspense mode, we can't return empty state
        // (it should be suspended)
        // try to get data and error from cache
        var latestData = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(key);
        var latestError = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(keyErr);
        if (typeof latestData === 'undefined') latestData = initialData;
        if (typeof latestError === 'undefined') latestError = initialError;
        if (typeof latestData === 'undefined' && typeof latestError === 'undefined') {
            // need to start the request if it hasn't
            if (!$09891d3af042c3f3$var$CONCURRENT_PROMISES[key]) // trigger revalidate immediately
            // to get the promise
            revalidate();
            if ($09891d3af042c3f3$var$CONCURRENT_PROMISES[key] && typeof $09891d3af042c3f3$var$CONCURRENT_PROMISES[key].then === 'function') // if it is a promise
            throw $09891d3af042c3f3$var$CONCURRENT_PROMISES[key];
            // it's a value, return it directly (override)
            latestData = $09891d3af042c3f3$var$CONCURRENT_PROMISES[key];
        }
        if (typeof latestData === 'undefined' && latestError) // in suspense mode, throw error if there's no content
        throw latestError;
        // return the latest data / error from cache
        // in case `key` has changed
        return {
            error: latestError,
            data: latestData,
            revalidate: revalidate,
            mutate: boundMutate,
            isValidating: stateRef.current.isValidating
        };
    }
    // define returned state
    // can be memorized since the state is a ref
    return (0, $lgFxF.useMemo)(function() {
        var state = {
            revalidate: revalidate,
            mutate: boundMutate
        };
        Object.defineProperties(state, {
            error: {
                // `key` might be changed in the upcoming hook re-render,
                // but the previous state will stay
                // so we need to match the latest key and data (fallback to `initialData`)
                get: function() {
                    stateDependencies.current.error = true;
                    return keyRef.current === key ? stateRef.current.error : initialError;
                },
                enumerable: true
            },
            data: {
                get: function() {
                    stateDependencies.current.data = true;
                    return keyRef.current === key ? stateRef.current.data : initialData;
                },
                enumerable: true
            },
            isValidating: {
                get: function() {
                    stateDependencies.current.isValidating = true;
                    return stateRef.current.isValidating;
                },
                enumerable: true
            }
        });
        return state;
    }, [
        revalidate
    ]);
}
var $09891d3af042c3f3$export$4c7bbecdacc3ca2c = (0, $459bdf5bf33b1baa$export$2e2bcd8739ae039).Provider;
var $09891d3af042c3f3$export$2e2bcd8739ae039 = $09891d3af042c3f3$var$useSWR;



var $lgFxF = parcelRequire("lgFxF");



var $b76ab695611f7910$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b76ab695611f7910$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b76ab695611f7910$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $b76ab695611f7910$export$9982c8e7e2cadcbd() {
    var _this = this;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var getKey, fn, config = {};
    if (args.length >= 1) getKey = args[0];
    if (args.length > 2) {
        fn = args[1];
        config = args[2];
    } else {
        if (typeof args[1] === 'function') fn = args[1];
        else if (typeof args[1] === 'object') config = args[1];
    }
    config = Object.assign({}, (0, $573c55dc3ba23a86$export$2e2bcd8739ae039), (0, $lgFxF.useContext)((0, $459bdf5bf33b1baa$export$2e2bcd8739ae039)), config);
    var _a = config.initialSize, initialSize = _a === void 0 ? 1 : _a, _b = config.revalidateAll, revalidateAll = _b === void 0 ? false : _b, _c = config.persistSize, persistSize = _c === void 0 ? false : _c, defaultFetcher = config.fetcher, extraConfig = $b76ab695611f7910$var$__rest(config, [
        "initialSize",
        "revalidateAll",
        "persistSize",
        "fetcher"
    ]);
    if (typeof fn === 'undefined') // use the global fetcher
    // we have to convert the type here
    fn = defaultFetcher;
    // get the serialized key of the first page
    var firstPageKey = null;
    try {
        firstPageKey = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).serializeKey(getKey(0, null))[0];
    } catch (err) {
    // not ready
    }
    var rerender = (0, $lgFxF.useState)(false)[1];
    // we use cache to pass extra info (context) to fetcher so it can be globally shared
    // here we get the key of the fetcher context cache
    var contextCacheKey = null;
    if (firstPageKey) contextCacheKey = 'context@' + firstPageKey;
    // page count is cached as well, so when navigating the list can be restored
    var pageCountCacheKey = null;
    var cachedPageSize;
    if (firstPageKey) {
        pageCountCacheKey = 'size@' + firstPageKey;
        cachedPageSize = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(pageCountCacheKey);
    }
    var pageCountRef = (0, $lgFxF.useRef)(cachedPageSize || initialSize);
    var didMountRef = (0, $lgFxF.useRef)(false);
    // every time the key changes, we reset the page size if it's not persisted
    (0, $lgFxF.useEffect)(function() {
        if (didMountRef.current) {
            if (!persistSize) pageCountRef.current = initialSize;
        } else didMountRef.current = true;
    }, [
        firstPageKey
    ]);
    // actual swr of all pages
    var swr = (0, $09891d3af042c3f3$export$2e2bcd8739ae039)(firstPageKey ? [
        'many',
        firstPageKey
    ] : null, function() {
        return $b76ab695611f7910$var$__awaiter(_this, void 0, void 0, function() {
            var _a, originalData, force, data, previousPageData, i, _b, pageKey, pageArgs, pageData, shouldRevalidatePage;
            return $b76ab695611f7910$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(contextCacheKey) || {}, originalData = _a.originalData, force = _a.force;
                        data = [];
                        previousPageData = null;
                        i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(i < pageCountRef.current)) return [
                            3 /*break*/ ,
                            8
                        ];
                        _b = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).serializeKey(getKey(i, previousPageData)), pageKey = _b[0], pageArgs = _b[1];
                        if (!pageKey) // pageKey is falsy, stop fetching next pages
                        return [
                            3 /*break*/ ,
                            8
                        ];
                        pageData = (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).get(pageKey);
                        shouldRevalidatePage = revalidateAll || force || typeof force === 'undefined' && i === 0 || originalData && !config.compare(originalData[i], pageData) || typeof pageData === 'undefined';
                        if (!shouldRevalidatePage) return [
                            3 /*break*/ ,
                            6
                        ];
                        if (!(pageArgs !== null)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            fn.apply(void 0, pageArgs)
                        ];
                    case 2:
                        pageData = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            fn(pageKey)
                        ];
                    case 4:
                        pageData = _c.sent();
                        _c.label = 5;
                    case 5:
                        (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).set(pageKey, pageData);
                        _c.label = 6;
                    case 6:
                        data.push(pageData);
                        previousPageData = pageData;
                        _c.label = 7;
                    case 7:
                        ++i;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        // once we executed the data fetching based on the context, clear the context
                        (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).delete(contextCacheKey);
                        // return the data
                        return [
                            2 /*return*/ ,
                            data
                        ];
                }
            });
        });
    }, extraConfig);
    var swrInfinite = swr;
    // extend the SWR API
    var mutate = swrInfinite.mutate;
    swrInfinite.size = pageCountRef.current;
    swrInfinite.mutate = (0, $lgFxF.useCallback)(function(data, shouldRevalidate) {
        if (shouldRevalidate === void 0) shouldRevalidate = true;
        if (shouldRevalidate && typeof data !== 'undefined') {
            // we only revalidate the pages that are changed
            var originalData = swrInfinite.data;
            (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).set(contextCacheKey, {
                originalData: originalData,
                force: false
            });
        } else if (shouldRevalidate) // calling `mutate()`, we revalidate all pages
        (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).set(contextCacheKey, {
            force: true
        });
        return mutate(data, shouldRevalidate);
    }, [
        mutate,
        swrInfinite.data,
        contextCacheKey
    ]);
    swrInfinite.setSize = (0, $lgFxF.useCallback)(function(arg) {
        if (typeof arg === 'function') pageCountRef.current = arg(pageCountRef.current);
        else if (typeof arg === 'number') pageCountRef.current = arg;
        (0, $573c55dc3ba23a86$export$69a3209f1a06c04d).set(pageCountCacheKey, pageCountRef.current);
        rerender(function(v) {
            return !v;
        });
        return swrInfinite.mutate(function(v) {
            return v;
        });
    }, [
        swrInfinite.mutate,
        pageCountCacheKey
    ]);
    return swrInfinite;
}



var $2b7bb7b14013a5cb$export$2e2bcd8739ae039 = (0, $09891d3af042c3f3$export$2e2bcd8739ae039);



var $87dd945100a191f6$exports = {};

var $9ce915dbe1496393$exports = {};
var $3b0ab1acb2ac6287$exports = {};

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $3b0ab1acb2ac6287$var$baseInverter(object, setter, iteratee, accumulator) {
    $aaf49aa8181669f4$exports(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
$3b0ab1acb2ac6287$exports = $3b0ab1acb2ac6287$var$baseInverter;


/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $9ce915dbe1496393$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $3b0ab1acb2ac6287$exports(object, setter, toIteratee(iteratee), {});
    };
}
$9ce915dbe1496393$exports = $9ce915dbe1496393$var$createInverter;



var $bHMyM = parcelRequire("bHMyM");
/** Used for built-in method references. */ var $87dd945100a191f6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $87dd945100a191f6$var$nativeObjectToString = $87dd945100a191f6$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $87dd945100a191f6$var$invert = $9ce915dbe1496393$exports(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $87dd945100a191f6$var$nativeObjectToString.call(value);
    result[value] = key;
}, $3d04e6fb9e156fac$exports($bHMyM));
$87dd945100a191f6$exports = $87dd945100a191f6$var$invert;


var $3f025cdb4fe7d1c8$export$2e2bcd8739ae039 = (...args)=>(0, $ce12fe3b4e8bd060$exports.get)(...args).then((resp)=>resp.data);
const $3f025cdb4fe7d1c8$export$b2a7e230c1a9fa7b = (...args)=>(0, $ce12fe3b4e8bd060$exports.get)(...args).then((resp)=>resp.data.map((lesson, idx)=>{
            if (!('kcxzmc' in lesson)) lesson.kcxzmc = "\u65E0\u7C7B\u578B";
            if (lesson.nj === 'wnj') lesson.nj = "\u65E0\u5E74\u7EA7";
            lesson.row_id = idx;
            return lesson;
        }));
const $3f025cdb4fe7d1c8$export$3b43970571b8041e = (...args)=>(0, $ce12fe3b4e8bd060$exports.get)(...args).then((resp)=>{
        return {
            to_new: resp.data,
            to_old: (0, (/*@__PURE__*/$parcel$interopDefault($87dd945100a191f6$exports)))(resp.data)
        };
    });


function $3ba76e806416b3fb$export$b12a0f383389ab35(props) {
    const result = props.data.split(props.sep);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("ul", {
        className: "list-unstyled"
    }, result.map((x, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("li", {
            key: idx
        }, x)));
}
function $3ba76e806416b3fb$export$4054075abaf06b2c(time, location) {
    const tl = [];
    if (!time) time = '';
    if (!location) location = '';
    const tt = time.split(';');
    const ll = location.split(';');
    for(let i = 0; i < Math.max(tt.length, ll.length); i++){
        const time = i < tt.length ? tt[i] : '';
        const location = i < ll.length ? ll[i] : '';
        if (tl.find((val)=>val.time === time && val.location === location)) continue;
        tl.push({
            time: time,
            location: location
        });
    }
    return tl;
}
function $3ba76e806416b3fb$export$bca405cc5c510d53(time, location, day) {
    const tl = $3ba76e806416b3fb$export$4054075abaf06b2c(time, location);
    let result = "\u6570\u636E\u89E3\u6790\u51FA\u9519";
    tl.forEach((x)=>{
        if (x.time.substring(0, 3) === $3ba76e806416b3fb$export$c8f2a69db759813[day - 1]) result = x.location;
    });
    return result;
}
function $3ba76e806416b3fb$export$8625cbe7968a20f8(props) {
    const result = $3ba76e806416b3fb$export$4054075abaf06b2c(props.time, props.location);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("ul", {
        className: "list-unstyled"
    }, result.map((lesson, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("li", {
            key: idx
        }, lesson.time, " ", lesson.location)));
}
function $3ba76e806416b3fb$export$991d5b48f7801974(semester) {
    return (0, $2b7bb7b14013a5cb$export$2e2bcd8739ae039)([
        'lessonData',
        semester
    ], (_, sem)=>{
        const urlUnder = `/course-plus-data/LessonData/Parsed_${sem}_under.json`;
        const urlPost = `/course-plus-data/LessonData/Parsed_${sem}_post.json`;
        const urlOld = `/course-plus-data/LessonData/Parsed_${sem}.json`;
        return Promise.all([
            (0, $3f025cdb4fe7d1c8$export$b2a7e230c1a9fa7b)(urlUnder).catch(()=>null),
            (0, $3f025cdb4fe7d1c8$export$b2a7e230c1a9fa7b)(urlPost).catch(()=>null)
        ]).then(([dataUnder, dataPost])=>{
            if (dataUnder === null && dataPost === null) return (0, $3f025cdb4fe7d1c8$export$b2a7e230c1a9fa7b)(urlOld);
            const merged = [
                ...dataUnder || [],
                ...dataPost || []
            ];
            return merged.map((lesson, idx)=>{
                lesson.row_id = idx;
                return lesson;
            });
        });
    });
}
function $3ba76e806416b3fb$export$1d3d9c805cfe1f3e() {
    return (0, $2b7bb7b14013a5cb$export$2e2bcd8739ae039)(`/course-plus-data/lessonData_index.json`, (0, $3f025cdb4fe7d1c8$export$b2a7e230c1a9fa7b));
}
function $3ba76e806416b3fb$export$8ed57c0aaa1b17bd() {
    return (0, $2b7bb7b14013a5cb$export$2e2bcd8739ae039)(`/course-plus-data/lesson_description_2020.json`, (0, $3f025cdb4fe7d1c8$export$2e2bcd8739ae039));
}
function $3ba76e806416b3fb$export$e2ee6cfef5cb8639() {
    return (0, $2b7bb7b14013a5cb$export$2e2bcd8739ae039)(`/course-plus-data/lesson_conversion.json`, (0, $3f025cdb4fe7d1c8$export$3b43970571b8041e));
}
const $3ba76e806416b3fb$export$c8f2a69db759813 = [
    "\u661F\u671F\u4E00",
    "\u661F\u671F\u4E8C",
    "\u661F\u671F\u4E09",
    "\u661F\u671F\u56DB",
    "\u661F\u671F\u4E94",
    "\u661F\u671F\u516D",
    "\u661F\u671F\u65E5"
];
function $3ba76e806416b3fb$export$41fd67b796408d0e(data) {
    const result = [];
    let i = 1;
    while(data > 0){
        if (data % 2 === 1) result.push(i);
        i += 1;
        data = data >> 1;
    }
    return result;
}
function $3ba76e806416b3fb$export$e2cc84c8ed4cded6(data, bit) {
    return (data & 1 << bit) !== 0;
}
function $3ba76e806416b3fb$export$30c60c3c30f10235(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = (0, $lgFxF.useState)(()=>{
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? new Set(JSON.parse(item)) : initialValue;
        } catch (error) {
            // If error also return initialValue
            console.log(error);
            return initialValue;
        }
    });
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value)=>{
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify([
                ...valueToStore
            ]));
        } catch (error) {
            // A more advanced implementation would handle the error case
            console.log(error);
        }
    };
    return [
        storedValue,
        setValue
    ];
}
function $3ba76e806416b3fb$export$c87d7c0a12f42435(dataRaw, filterForm, lessonConversion) {
    let filteringData = dataRaw;
    const keyword = filterForm.keyword.trim();
    const scheduleKey = filterForm.scheduleKey.trim();
    const lecturerKey = filterForm.lecturerKey.trim();
    const placeKey = filterForm.placeKey.trim();
    const composition = filterForm.composition.trim();
    const notes = filterForm.notes.trim();
    if (keyword) filteringData = filteringData.filter((lesson)=>{
        if (lesson.kcmc.toLowerCase().includes(keyword.toLowerCase())) return true;
        if (lesson.kch.toLowerCase().includes(keyword.toLowerCase())) return true;
        if (lessonConversion) {
            if (lessonConversion.to_new[lesson.kch]) {
                if (lessonConversion.to_new[lesson.kch].toLowerCase().includes(keyword.toLowerCase())) return true;
            }
            if (lessonConversion.to_old[lesson.kch]) {
                if (lessonConversion.to_old[lesson.kch].toLowerCase().includes(keyword.toLowerCase())) return true;
            }
        }
        return false;
    });
    if (scheduleKey) filteringData = filteringData.filter((lesson)=>lesson.sksj.includes(scheduleKey));
    if (lecturerKey) filteringData = filteringData.filter((lesson)=>lesson.jsxx.includes(lecturerKey));
    if (placeKey) filteringData = filteringData.filter((lesson)=>(lesson.jxdd || '').includes(placeKey));
    if (composition) filteringData = filteringData.filter((lesson)=>lesson.jxbzc.split(';').some((x)=>x.includes(composition)));
    if (notes) filteringData = filteringData.filter((lesson)=>(lesson.xkbz || '').includes(notes));
    return filteringData;
}
function $3ba76e806416b3fb$export$f0633da393a66e49(dataRaw, filterForm, lessonConversion) {
    let filteringData = $3ba76e806416b3fb$export$c87d7c0a12f42435(dataRaw, filterForm, lessonConversion);
    const checkedNj = filterForm.checkedNj;
    const checkedLx = filterForm.checkedLx;
    const checkedYx = filterForm.checkedYx;
    const checkedTy = filterForm.checkedTy;
    if (checkedNj.size) filteringData = filteringData.filter((lesson)=>lesson.nj.split(',').some((x)=>checkedNj.has(x)));
    if (checkedLx.size) filteringData = filteringData.filter((lesson)=>checkedLx.has(lesson.kcxzmc));
    if (checkedYx.size) filteringData = filteringData.filter((lesson)=>checkedYx.has(lesson.kkxy));
    if (checkedTy.size) filteringData = filteringData.filter((lesson)=>lesson.kzmc.split(',').some((x)=>checkedTy.has(x)));
    return filteringData;
}
function $3ba76e806416b3fb$export$e05f7f3137a2fed8() {
    const [data, setData] = (0, $lgFxF.useState)(null);
    const [loading, setLoading] = (0, $lgFxF.useState)(false);
    const [error, setError] = (0, $lgFxF.useState)(null);
    const fetchAll = (0, $lgFxF.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const index = await (0, $3f025cdb4fe7d1c8$export$2e2bcd8739ae039)('/course-plus-data/lessonData_index.json');
            const results = await Promise.all(index.map(async (item)=>{
                const sem = `${item.year}_${item.semester}`;
                const [underData, postData] = await Promise.all([
                    (0, $3f025cdb4fe7d1c8$export$b2a7e230c1a9fa7b)(`/course-plus-data/LessonData/Parsed_${sem}_under.json`).catch(()=>null),
                    (0, $3f025cdb4fe7d1c8$export$b2a7e230c1a9fa7b)(`/course-plus-data/LessonData/Parsed_${sem}_post.json`).catch(()=>null)
                ]);
                if (underData === null && postData === null) {
                    const oldData = await (0, $3f025cdb4fe7d1c8$export$b2a7e230c1a9fa7b)(`/course-plus-data/LessonData/Parsed_${sem}.json`).catch(()=>null);
                    return (oldData || []).map((l)=>({
                            ...l,
                            _semester: sem,
                            _year: item.year,
                            _term: item.semester
                        }));
                }
                return [
                    ...(underData || []).map((l)=>({
                            ...l,
                            _semester: sem,
                            _year: item.year,
                            _term: item.semester,
                            _source: 'under'
                        })),
                    ...(postData || []).map((l)=>({
                            ...l,
                            _semester: sem,
                            _year: item.year,
                            _term: item.semester,
                            _source: 'post'
                        }))
                ];
            }));
            setData(results.flat());
        } catch (e) {
            setError(e);
        }
        setLoading(false);
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        fetchAll: fetchAll
    };
}


function $16eb59577d700d3b$var$ArrowRightSvg({ size: size }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "bi bi-arrow-right-short",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("path", {
        fillRule: "evenodd",
        d: "M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
    }));
}
function $16eb59577d700d3b$var$ConversionInfo({ lessonConversion: lessonConversion, kch: kch }) {
    if (lessonConversion) {
        if (lessonConversion.to_new[kch]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "mr-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("b", null, kch), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($16eb59577d700d3b$var$ArrowRightSvg, {
            size: "1rem"
        }), lessonConversion.to_new[kch]);
        if (lessonConversion.to_old[kch]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "mr-1"
        }, lessonConversion.to_old[kch], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($16eb59577d700d3b$var$ArrowRightSvg, {
            size: "1rem"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("b", null, kch));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null);
}
function $16eb59577d700d3b$var$parseProfile(lessonDetail, lessonConversion, kch) {
    if (lessonDetail) {
        if (lessonDetail[kch]) return lessonDetail[kch].profile;
        if (lessonConversion) {
            let try_kch = lessonConversion.to_new[kch];
            if (try_kch) {
                if (lessonDetail[try_kch]) return lessonDetail[try_kch].profile;
            }
            try_kch = lessonConversion.to_old[kch];
            if (try_kch) {
                if (lessonDetail[try_kch]) return lessonDetail[try_kch].profile;
            }
        }
    }
    return {};
}
function $16eb59577d700d3b$export$2e2bcd8739ae039({ lesson: lesson, color: color }) {
    const { data: lessonDetail } = (0, $3ba76e806416b3fb$export$8ed57c0aaa1b17bd)();
    const { data: lessonConversion } = (0, $3ba76e806416b3fb$export$e2ee6cfef5cb8639)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "card lesson-detail-card shadow-sm font-weight-normal small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "card-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("h5", {
        className: "card-title"
    }, color ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "lesson-dot",
        style: {
            backgroundColor: color
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null), lesson.kch, " ", lesson.kcmc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("h6", {
        className: "card-subtitle mb-2 text-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($16eb59577d700d3b$var$ConversionInfo, {
        kch: lesson.kch,
        lessonConversion: lessonConversion
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", null, lesson.jszc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "card-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mr-1"
    }, lesson.kkxy), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mr-1"
    }, lesson.skyy), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mr-1"
    }, lesson.kklx), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mr-1"
    }, lesson.zhxs), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mr-1"
    }, lesson.rwzxs, " \u5B66\u65F6"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mr-1"
    }, lesson.kcxzmc)), lesson.xkbz ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "card-text"
    }, "\u5907\u6CE8\uFF1A", lesson.xkbz) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null), lesson.kzmc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "card-text"
    }, "\u901A\u8BC6\u8BFE\u6A21\u5757\uFF1A", lesson.kzmc) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "card-text"
    }, "\u73ED\u7EA7\u7EC4\u6210"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("ul", {
        className: "list-group list-group-flush border-top border-bottom mb-3"
    }, lesson.jxbzc.split(';').map((item, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("li", {
            className: "list-group-item py-1",
            key: idx
        }, item))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "card-text"
    }, "\u65F6\u95F4\u5730\u70B9"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("ul", {
        className: "list-group list-group-flush border-top border-bottom mb-3"
    }, (0, $3ba76e806416b3fb$export$4054075abaf06b2c)(lesson.sksj, lesson.jxdd).map(({ time: time, location: location }, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("li", {
            className: "list-group-item py-1",
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col-7"
        }, time), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col-5"
        }, location))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", null, $16eb59577d700d3b$var$parseProfile(lessonDetail, lessonConversion, lesson.kch)["\u4E2D\u6587\u8BFE\u7A0B\u7B80\u4ECB"]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", null, $16eb59577d700d3b$var$parseProfile(lessonDetail, lessonConversion, lesson.kch)["\u82F1\u6587\u8BFE\u7A0B\u7B80\u4ECB"]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "card-text text-muted pb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mr-1"
    }, lesson.jxbmc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mr-1"
    }, lesson.nj, " \u5E74\u7EA7,"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mr-1"
    }, lesson.xn, " \u5B66\u5E74 ", lesson.xq, " \u5B66\u671F")))));
}



function $346dfdcea95fc3df$var$splitBy(elements, by) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($27ebd2387777117f$exports)))(elements, by).map((chk, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "d-block",
            key: idx
        }, chk));
}
function $346dfdcea95fc3df$var$autoSplit(elements, chunkNumber) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-md-none week-dot-wrapper"
    }, $346dfdcea95fc3df$var$splitBy(elements, chunkNumber[0])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-none d-md-block d-xl-none week-dot-wrapper"
    }, $346dfdcea95fc3df$var$splitBy(elements, chunkNumber[1])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-none d-xl-block week-dot-wrapper"
    }, $346dfdcea95fc3df$var$splitBy(elements, chunkNumber[2])));
}
var $346dfdcea95fc3df$export$2e2bcd8739ae039 = ({ day: day, block: block, colorMapping: colorMapping, classTableConfig: classTableConfig, selectedLesson: selectedLesson })=>{
    const weekDots = [];
    const maxWeek = (0, (/*@__PURE__*/$parcel$interopDefault($4ba9cde7c1292e45$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6f6e293b545bced6$exports)))(selectedLesson, (lesson)=>(0, $3ba76e806416b3fb$export$41fd67b796408d0e)(lesson.zcd)));
    const conflictLesson = [];
    const showLesson = {};
    let showDots = false;
    const maxDay = (0, (/*@__PURE__*/$parcel$interopDefault($4ba9cde7c1292e45$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f3249f2aa67ea927$exports)))(selectedLesson, 'xqj')) || 0;
    const splitArray = maxDay <= 5 ? [
        5,
        10,
        20
    ] : [
        5,
        5,
        10
    ];
    for(let week = 0; week < maxWeek; week++){
        let dot = '';
        selectedLesson.forEach((lesson)=>{
            if ((0, $3ba76e806416b3fb$export$e2cc84c8ed4cded6)(lesson.zcd, week) && (0, $3ba76e806416b3fb$export$e2cc84c8ed4cded6)(lesson.cdjc, block - 1) && lesson.xqj === day) {
                if (dot !== '') {
                    dot = 'CONFLICT';
                    conflictLesson.push(lesson.jxbmc);
                } else dot = lesson.jxbmc;
                if (block <= 1 || !(0, $3ba76e806416b3fb$export$e2cc84c8ed4cded6)(lesson.cdjc, block - 2)) showLesson[lesson.jxbmc] = lesson;
            }
        });
        if (dot === '') weekDots.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "week-dot week-dot-empty",
            key: week
        }));
        else if (dot === 'CONFLICT') {
            weekDots.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "week-dot week-dot-conflict",
                key: week
            }));
            showDots = true;
        } else {
            weekDots.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "week-dot week-dot-color",
                style: {
                    backgroundColor: colorMapping[dot]
                },
                key: week
            }));
            showDots = true;
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "small my-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null, showDots ? $346dfdcea95fc3df$var$autoSplit(weekDots, splitArray) : ''), (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($gRgFA)))(showLesson)).map((key)=>{
        const lesson = showLesson[key];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "row mr-1",
            key: lesson.jxbmc
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col-auto p-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "week-dot week-dot-color mr-1",
            style: {
                backgroundColor: colorMapping[lesson.jxbmc]
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col p-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: conflictLesson.includes(lesson.jxbmc) ? 'text-danger' : ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $87802237a54007ad$exports.Tooltip), {
            interactive: true,
            unmountHTMLWhenHide: true,
            position: "right",
            html: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $16eb59577d700d3b$export$2e2bcd8739ae039), {
                lesson: lesson,
                color: colorMapping[lesson.jxbmc]
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "mr-1"
        }, lesson.kch), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", null, lesson.kcmc))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "mr-1"
        }, lesson.jszc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", null, lesson.xf, " \u5B66\u5206"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("br", null), (0, $3ba76e806416b3fb$export$bca405cc5c510d53)(lesson.sksj, lesson.jxdd, day))));
    }));
};



var $65585991b08f7242$export$2e2bcd8739ae039 = ({ selectedLesson: selectedLesson, colorMapping: colorMapping })=>{
    const { semester: semester } = (0, $8d84d1394a502c2f$export$99eaa27ddbbb95ef)();
    const { data: lessons } = (0, $3ba76e806416b3fb$export$991d5b48f7801974)(semester);
    if (lessons) {
        const selectedLessonObjects = lessons.filter((lesson)=>selectedLesson.has(lesson.jxbmc));
        let colMax = 5;
        selectedLessonObjects.forEach((lesson)=>{
            if (lesson.xqj > 5) colMax = 7;
        });
        const allCol = (0, (/*@__PURE__*/$parcel$interopDefault($612b7d911d85a8d3$exports)))(1, colMax + 1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "classtable-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("table", {
            className: "table classtable-table mb-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("th", {
            scope: "col",
            className: "classtable-first-col"
        }, "#"), allCol.map((n, lessonCol)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("th", {
                scope: "col",
                key: lessonCol,
                className: "classtable-col"
            }, (0, $3ba76e806416b3fb$export$c8f2a69db759813)[lessonCol])))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("tbody", null, (0, (/*@__PURE__*/$parcel$interopDefault($612b7d911d85a8d3$exports)))(1, 15).map((lessonRow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("tr", {
                "v-for": "lessonRow in 14",
                key: lessonRow
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("th", {
                scope: "row",
                className: "classtable-first-col p-1"
            }, lessonRow), allCol.map((lessonCol)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("td", {
                    scope: "col",
                    key: lessonCol,
                    className: "p-1"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $346dfdcea95fc3df$export$2e2bcd8739ae039), {
                    day: lessonCol,
                    block: lessonRow,
                    selectedLesson: selectedLessonObjects,
                    colorMapping: colorMapping
                }))))))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null);
};



var $fdeac4566d39d3d5$exports = {};

var $2oilF = parcelRequire("2oilF");
var $bbe8bdd11d73dcd9$exports = {};
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $bbe8bdd11d73dcd9$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
$bbe8bdd11d73dcd9$exports = $bbe8bdd11d73dcd9$var$baseSum;


/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $fdeac4566d39d3d5$var$sumBy(array, iteratee) {
    return array && array.length ? $bbe8bdd11d73dcd9$exports(array, $2oilF(iteratee, 2)) : 0;
}
$fdeac4566d39d3d5$exports = $fdeac4566d39d3d5$var$sumBy;


var $905bd22ff9c4e6ec$exports = {};

var $2oilF = parcelRequire("2oilF");
var $ac2a31b290f86a9e$exports = {};

var $kcaEB = parcelRequire("kcaEB");
var $2b770b5b3d7c9c50$exports = {};
var $f45bdcac793a9294$exports = {};
var $191fdd32c4d18066$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $191fdd32c4d18066$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$191fdd32c4d18066$exports = $191fdd32c4d18066$var$baseFindIndex;


var $07c7eb1df8b5d921$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $07c7eb1df8b5d921$var$baseIsNaN(value) {
    return value !== value;
}
$07c7eb1df8b5d921$exports = $07c7eb1df8b5d921$var$baseIsNaN;


var $603b518a366b4c2d$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $603b518a366b4c2d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$603b518a366b4c2d$exports = $603b518a366b4c2d$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f45bdcac793a9294$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $603b518a366b4c2d$exports(array, value, fromIndex) : $191fdd32c4d18066$exports(array, $07c7eb1df8b5d921$exports, fromIndex);
}
$f45bdcac793a9294$exports = $f45bdcac793a9294$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $2b770b5b3d7c9c50$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $f45bdcac793a9294$exports(array, value, 0) > -1;
}
$2b770b5b3d7c9c50$exports = $2b770b5b3d7c9c50$var$arrayIncludes;


var $ea64e3941b6d1f0a$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ea64e3941b6d1f0a$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$ea64e3941b6d1f0a$exports = $ea64e3941b6d1f0a$var$arrayIncludesWith;



var $dwbsX = parcelRequire("dwbsX");
var $01fec15b1746cb8c$exports = {};

var $kCCHN = parcelRequire("kCCHN");
var $71f246ad0e617597$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $71f246ad0e617597$var$noop() {
// No operation performed.
}
$71f246ad0e617597$exports = $71f246ad0e617597$var$noop;



var $ee80J = parcelRequire("ee80J");
/** Used as references for various `Number` constants. */ var $01fec15b1746cb8c$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $01fec15b1746cb8c$var$createSet = !($kCCHN && 1 / $ee80J(new $kCCHN([
    ,
    -0
]))[1] == $01fec15b1746cb8c$var$INFINITY) ? $71f246ad0e617597$exports : function(values) {
    return new $kCCHN(values);
};
$01fec15b1746cb8c$exports = $01fec15b1746cb8c$var$createSet;



var $ee80J = parcelRequire("ee80J");
/** Used as the size to enable large array optimizations. */ var $ac2a31b290f86a9e$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $ac2a31b290f86a9e$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $2b770b5b3d7c9c50$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $ea64e3941b6d1f0a$exports;
    } else if (length >= $ac2a31b290f86a9e$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $01fec15b1746cb8c$exports(array);
        if (set) return $ee80J(set);
        isCommon = false;
        includes = $dwbsX;
        seen = new $kcaEB;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$ac2a31b290f86a9e$exports = $ac2a31b290f86a9e$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $905bd22ff9c4e6ec$var$uniqBy(array, iteratee) {
    return array && array.length ? $ac2a31b290f86a9e$exports(array, $2oilF(iteratee, 2)) : [];
}
$905bd22ff9c4e6ec$exports = $905bd22ff9c4e6ec$var$uniqBy;



var $lgFxF = parcelRequire("lgFxF");


var $e600bd6cf307b673$exports = {};
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) classes.push(inner);
            } else if (argType === 'object') {
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if ($e600bd6cf307b673$exports) {
        classNames.default = classNames;
        $e600bd6cf307b673$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $lgFxF = parcelRequire("lgFxF");



var $8cfa2cea60cbefab$exports = {};
'use strict';
Object.defineProperty($8cfa2cea60cbefab$exports, "__esModule", {
    value: true
});
$8cfa2cea60cbefab$exports.default = $8cfa2cea60cbefab$var$all;
var $6000bd36485e72ed$exports = {};
'use strict';
Object.defineProperty($6000bd36485e72ed$exports, "__esModule", {
    value: true
});
$6000bd36485e72ed$exports.default = $6000bd36485e72ed$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $6000bd36485e72ed$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
$6000bd36485e72ed$exports = $6000bd36485e72ed$exports['default'];


var $8cfa2cea60cbefab$var$_createChainableTypeChecker2 = $8cfa2cea60cbefab$var$_interopRequireDefault($6000bd36485e72ed$exports);
function $8cfa2cea60cbefab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8cfa2cea60cbefab$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $8cfa2cea60cbefab$var$_createChainableTypeChecker2.default)(allPropTypes);
}
$8cfa2cea60cbefab$exports = $8cfa2cea60cbefab$exports['default'];



var $lgFxF = parcelRequire("lgFxF");




var $lgFxF = parcelRequire("lgFxF");

var $c1591a3861209c90$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).elementType
};
var $c1591a3861209c90$var$Feedback = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, className = _ref.className, _ref$type = _ref.type, type = _ref$type === void 0 ? 'valid' : _ref$type, _ref$tooltip = _ref.tooltip, tooltip = _ref$tooltip === void 0 ? false : _ref$tooltip, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "as",
        "className",
        "type",
        "tooltip"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, type + "-" + (tooltip ? 'tooltip' : 'feedback'))
    }));
});
$c1591a3861209c90$var$Feedback.displayName = 'Feedback';
$c1591a3861209c90$var$Feedback.propTypes = $c1591a3861209c90$var$propTypes;
var $c1591a3861209c90$export$2e2bcd8739ae039 = $c1591a3861209c90$var$Feedback;






var $lgFxF = parcelRequire("lgFxF");

var $lgFxF = parcelRequire("lgFxF");
var $4848d21ce4deda90$var$FormContext = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createContext({
    controlId: undefined
});
var $4848d21ce4deda90$export$2e2bcd8739ae039 = $4848d21ce4deda90$var$FormContext;




var $lgFxF = parcelRequire("lgFxF");
var $c3e34bc7febff4e7$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createContext({});
var $c3e34bc7febff4e7$export$b631efc24e9d5e2f = $c3e34bc7febff4e7$var$ThemeContext.Consumer, $c3e34bc7febff4e7$var$Provider = $c3e34bc7febff4e7$var$ThemeContext.Provider;
function $c3e34bc7febff4e7$var$ThemeProvider(_ref) {
    var prefixes = _ref.prefixes, children = _ref.children;
    var copiedPrefixes = (0, $lgFxF.useMemo)(function() {
        return (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, prefixes);
    }, [
        prefixes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($c3e34bc7febff4e7$var$Provider, {
        value: copiedPrefixes
    }, children);
}
function $c3e34bc7febff4e7$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $lgFxF.useContext)($c3e34bc7febff4e7$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $c3e34bc7febff4e7$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref
    var _opts = opts, prefix = _opts.prefix, _opts$forwardRefAs = _opts.forwardRefAs, forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
    var Wrapped = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref2, ref) {
        var props = (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, _ref2);
        props[forwardRefAs] = ref;
        var bsPrefix = $c3e34bc7febff4e7$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
    return Wrapped;
}
var $c3e34bc7febff4e7$export$2e2bcd8739ae039 = $c3e34bc7febff4e7$var$ThemeProvider;


var $5ba076703f0cc183$var$FormCheckInput = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, _ref$type = _ref.type, type = _ref$type === void 0 ? 'checkbox' : _ref$type, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, isStatic = _ref.isStatic, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'input' : _ref$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "id",
        "bsPrefix",
        "bsCustomPrefix",
        "className",
        "type",
        "isValid",
        "isInvalid",
        "isStatic",
        "as"
    ]);
    var _useContext = (0, $lgFxF.useContext)((0, $4848d21ce4deda90$export$2e2bcd8739ae039)), controlId = _useContext.controlId, custom = _useContext.custom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-control-input'
    ] : [
        bsPrefix,
        'form-check-input'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid', isStatic && 'position-static')
    }));
});
$5ba076703f0cc183$var$FormCheckInput.displayName = 'FormCheckInput';
var $5ba076703f0cc183$export$2e2bcd8739ae039 = $5ba076703f0cc183$var$FormCheckInput;






var $lgFxF = parcelRequire("lgFxF");


var $8d217eb77bcd7dbb$var$FormCheckLabel = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, htmlFor = _ref.htmlFor, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "bsCustomPrefix",
        "className",
        "htmlFor"
    ]);
    var _useContext = (0, $lgFxF.useContext)((0, $4848d21ce4deda90$export$2e2bcd8739ae039)), controlId = _useContext.controlId, custom = _useContext.custom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-control-label'
    ] : [
        bsPrefix,
        'form-check-label'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("label", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix)
    }));
});
$8d217eb77bcd7dbb$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $8d217eb77bcd7dbb$export$2e2bcd8739ae039 = $8d217eb77bcd7dbb$var$FormCheckLabel;




var $69b6fa0b19a82e2c$var$FormCheck = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, _ref$inline = _ref.inline, inline = _ref$inline === void 0 ? false : _ref$inline, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$feedbackTooltip = _ref.feedbackTooltip, feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip, feedback = _ref.feedback, className = _ref.className, style = _ref.style, _ref$title = _ref.title, title = _ref$title === void 0 ? '' : _ref$title, _ref$type = _ref.type, type = _ref$type === void 0 ? 'checkbox' : _ref$type, label = _ref.label, children = _ref.children, propCustom = _ref.custom, _ref$as = _ref.as, as = _ref$as === void 0 ? 'input' : _ref$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "id",
        "bsPrefix",
        "bsCustomPrefix",
        "inline",
        "disabled",
        "isValid",
        "isInvalid",
        "feedbackTooltip",
        "feedback",
        "className",
        "style",
        "title",
        "type",
        "label",
        "children",
        "custom",
        "as"
    ]);
    var custom = type === 'switch' ? true : propCustom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-control'
    ] : [
        bsPrefix,
        'form-check'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(prefix, defaultPrefix);
    var _useContext = (0, $lgFxF.useContext)((0, $4848d21ce4deda90$export$2e2bcd8739ae039)), controlId = _useContext.controlId;
    var innerFormContext = (0, $lgFxF.useMemo)(function() {
        return {
            controlId: id || controlId,
            custom: custom
        };
    }, [
        controlId,
        custom,
        id
    ]);
    var hasLabel = label != null && label !== false && !children;
    var input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $5ba076703f0cc183$export$2e2bcd8739ae039), (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        isStatic: !hasLabel,
        disabled: disabled,
        as: as
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $4848d21ce4deda90$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix, custom && "custom-" + type, inline && bsPrefix + "-inline")
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, input, hasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d217eb77bcd7dbb$export$2e2bcd8739ae039), {
        title: title
    }, label), (isValid || isInvalid) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $c1591a3861209c90$export$2e2bcd8739ae039), {
        type: isValid ? 'valid' : 'invalid',
        tooltip: feedbackTooltip
    }, feedback))));
});
$69b6fa0b19a82e2c$var$FormCheck.displayName = 'FormCheck';
$69b6fa0b19a82e2c$var$FormCheck.Input = (0, $5ba076703f0cc183$export$2e2bcd8739ae039);
$69b6fa0b19a82e2c$var$FormCheck.Label = (0, $8d217eb77bcd7dbb$export$2e2bcd8739ae039);
var $69b6fa0b19a82e2c$export$2e2bcd8739ae039 = $69b6fa0b19a82e2c$var$FormCheck;






var $lgFxF = parcelRequire("lgFxF");






var $lgFxF = parcelRequire("lgFxF");


var $8e95441915e6994a$var$FormFileInput = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, isValid = _ref.isValid, isInvalid = _ref.isInvalid, lang = _ref.lang, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'input' : _ref$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "id",
        "bsPrefix",
        "bsCustomPrefix",
        "className",
        "isValid",
        "isInvalid",
        "lang",
        "as"
    ]);
    var _useContext = (0, $lgFxF.useContext)((0, $4848d21ce4deda90$export$2e2bcd8739ae039)), controlId = _useContext.controlId, custom = _useContext.custom;
    var type = 'file';
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-file-input'
    ] : [
        bsPrefix,
        'form-control-file'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        id: id || controlId,
        type: type,
        lang: lang,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    }));
});
$8e95441915e6994a$var$FormFileInput.displayName = 'FormFileInput';
var $8e95441915e6994a$export$2e2bcd8739ae039 = $8e95441915e6994a$var$FormFileInput;






var $lgFxF = parcelRequire("lgFxF");


var $03b9d0d6feb0362f$var$FormFileLabel = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, htmlFor = _ref.htmlFor, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "bsCustomPrefix",
        "className",
        "htmlFor"
    ]);
    var _useContext = (0, $lgFxF.useContext)((0, $4848d21ce4deda90$export$2e2bcd8739ae039)), controlId = _useContext.controlId, custom = _useContext.custom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-file-label'
    ] : [
        bsPrefix,
        'form-file-label'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("label", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix),
        "data-browse": props['data-browse']
    }));
});
$03b9d0d6feb0362f$var$FormFileLabel.displayName = 'FormFileLabel';
var $03b9d0d6feb0362f$export$2e2bcd8739ae039 = $03b9d0d6feb0362f$var$FormFileLabel;




var $c9d405c6e647a3aa$var$FormFile = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$feedbackTooltip = _ref.feedbackTooltip, feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip, feedback = _ref.feedback, className = _ref.className, style = _ref.style, label = _ref.label, children = _ref.children, custom = _ref.custom, lang = _ref.lang, dataBrowse = _ref['data-browse'], _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, _ref$inputAs = _ref.inputAs, inputAs = _ref$inputAs === void 0 ? 'input' : _ref$inputAs, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "id",
        "bsPrefix",
        "bsCustomPrefix",
        "disabled",
        "isValid",
        "isInvalid",
        "feedbackTooltip",
        "feedback",
        "className",
        "style",
        "label",
        "children",
        "custom",
        "lang",
        "data-browse",
        "as",
        "inputAs"
    ]);
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom'
    ] : [
        bsPrefix,
        'form-file'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(prefix, defaultPrefix);
    var type = 'file';
    var _useContext = (0, $lgFxF.useContext)((0, $4848d21ce4deda90$export$2e2bcd8739ae039)), controlId = _useContext.controlId;
    var innerFormContext = (0, $lgFxF.useMemo)(function() {
        return {
            controlId: id || controlId,
            custom: custom
        };
    }, [
        controlId,
        custom,
        id
    ]);
    var hasLabel = label != null && label !== false && !children;
    var input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8e95441915e6994a$export$2e2bcd8739ae039), (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: inputAs,
        lang: lang
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $4848d21ce4deda90$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix, custom && "custom-" + type)
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, custom ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, input, hasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $03b9d0d6feb0362f$export$2e2bcd8739ae039), {
        "data-browse": dataBrowse
    }, label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, hasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $03b9d0d6feb0362f$export$2e2bcd8739ae039), null, label), input), (isValid || isInvalid) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $c1591a3861209c90$export$2e2bcd8739ae039), {
        type: isValid ? 'valid' : 'invalid',
        tooltip: feedbackTooltip
    }, feedback))));
});
$c9d405c6e647a3aa$var$FormFile.displayName = 'FormFile';
$c9d405c6e647a3aa$var$FormFile.Input = (0, $8e95441915e6994a$export$2e2bcd8739ae039);
$c9d405c6e647a3aa$var$FormFile.Label = (0, $03b9d0d6feb0362f$export$2e2bcd8739ae039);
var $c9d405c6e647a3aa$export$2e2bcd8739ae039 = $c9d405c6e647a3aa$var$FormFile;







var $lgFxF = parcelRequire("lgFxF");
var $07484a1c880f66d3$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $07484a1c880f66d3$var$__DEV__ = false;
var $07484a1c880f66d3$var$warning = function() {};
if ($07484a1c880f66d3$var$__DEV__) {
    var $07484a1c880f66d3$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $07484a1c880f66d3$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $07484a1c880f66d3$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$07484a1c880f66d3$exports = $07484a1c880f66d3$var$warning;





var $c1cf66e043360dc9$var$FormControl = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, type = _ref.type, size = _ref.size, htmlSize = _ref.htmlSize, id = _ref.id, className = _ref.className, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, plaintext = _ref.plaintext, readOnly = _ref.readOnly, custom = _ref.custom, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'input' : _ref$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "bsCustomPrefix",
        "type",
        "size",
        "htmlSize",
        "id",
        "className",
        "isValid",
        "isInvalid",
        "plaintext",
        "readOnly",
        "custom",
        "as"
    ]);
    var _useContext = (0, $lgFxF.useContext)((0, $4848d21ce4deda90$export$2e2bcd8739ae039)), controlId = _useContext.controlId;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom'
    ] : [
        bsPrefix,
        'form-control'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(prefix, defaultPrefix);
    var classes;
    if (plaintext) {
        var _classes;
        classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
    } else if (type === 'file') {
        var _classes2;
        classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
    } else if (type === 'range') {
        var _classes3;
        classes = (_classes3 = {}, _classes3[bsPrefix + "-range"] = true, _classes3);
    } else if (Component === 'select' && custom) {
        var _classes4;
        classes = (_classes4 = {}, _classes4[bsPrefix + "-select"] = true, _classes4[bsPrefix + "-select-" + size] = size, _classes4);
    } else {
        var _classes5;
        classes = (_classes5 = {}, _classes5[bsPrefix] = true, _classes5[bsPrefix + "-" + size] = size, _classes5);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
    }));
});
$c1cf66e043360dc9$var$FormControl.displayName = 'FormControl';
var $c1cf66e043360dc9$export$2e2bcd8739ae039 = Object.assign($c1cf66e043360dc9$var$FormControl, {
    Feedback: (0, $c1591a3861209c90$export$2e2bcd8739ae039)
});






var $lgFxF = parcelRequire("lgFxF");


var $6a17f7a37d942d11$var$FormGroup = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, controlId = _ref.controlId, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "className",
        "children",
        "controlId",
        "as"
    ]);
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'form-group');
    var context = (0, $lgFxF.useMemo)(function() {
        return {
            controlId: controlId
        };
    }, [
        controlId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $4848d21ce4deda90$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix)
    }), children));
});
$6a17f7a37d942d11$var$FormGroup.displayName = 'FormGroup';
var $6a17f7a37d942d11$export$2e2bcd8739ae039 = $6a17f7a37d942d11$var$FormGroup;






var $lgFxF = parcelRequire("lgFxF");





var $lgFxF = parcelRequire("lgFxF");

var $ce750138416e1623$var$DEVICE_SIZES = [
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var $ce750138416e1623$var$Col = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "className",
        "as"
    ]);
    var prefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'col');
    var spans = [];
    var classes = [];
    $ce750138416e1623$var$DEVICE_SIZES.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var span;
        var offset;
        var order;
        if (typeof propValue === 'object' && propValue != null) {
            var _propValue$span = propValue.span;
            span = _propValue$span === void 0 ? true : _propValue$span;
            offset = propValue.offset;
            order = propValue.order;
        } else span = propValue;
        var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
        if (span) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
        if (order != null) classes.push("order" + infix + "-" + order);
        if (offset != null) classes.push("offset" + infix + "-" + offset);
    });
    if (!spans.length) spans.push(prefix); // plain 'col'
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports))).apply(void 0, [
            className
        ].concat(spans, classes))
    }));
});
$ce750138416e1623$var$Col.displayName = 'Col';
var $ce750138416e1623$export$2e2bcd8739ae039 = $ce750138416e1623$var$Col;




var $5db724b783d3e91a$var$defaultProps = {
    column: false,
    srOnly: false
};
var $5db724b783d3e91a$var$FormLabel = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'label' : _ref$as, bsPrefix = _ref.bsPrefix, column = _ref.column, srOnly = _ref.srOnly, className = _ref.className, htmlFor = _ref.htmlFor, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "as",
        "bsPrefix",
        "column",
        "srOnly",
        "className",
        "htmlFor"
    ]);
    var _useContext = (0, $lgFxF.useContext)((0, $4848d21ce4deda90$export$2e2bcd8739ae039)), controlId = _useContext.controlId;
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    var columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = columnClass + "-" + column;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix, srOnly && 'sr-only', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $ce750138416e1623$export$2e2bcd8739ae039), (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        as: "label",
        className: classes,
        htmlFor: htmlFor
    }, props));
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        ref: ref,
        className: classes,
        htmlFor: htmlFor
    }, props)));
});
$5db724b783d3e91a$var$FormLabel.displayName = 'FormLabel';
$5db724b783d3e91a$var$FormLabel.defaultProps = $5db724b783d3e91a$var$defaultProps;
var $5db724b783d3e91a$export$2e2bcd8739ae039 = $5db724b783d3e91a$var$FormLabel;






var $lgFxF = parcelRequire("lgFxF");

var $8e226ffe41c4f29c$var$FormText = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'small' : _ref$as, muted = _ref.muted, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "className",
        "as",
        "muted"
    ]);
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix, muted && 'text-muted')
    }));
});
$8e226ffe41c4f29c$var$FormText.displayName = 'FormText';
var $8e226ffe41c4f29c$export$2e2bcd8739ae039 = $8e226ffe41c4f29c$var$FormText;




var $lgFxF = parcelRequire("lgFxF");

var $0941f33c5e4da268$var$Switch = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $69b6fa0b19a82e2c$export$2e2bcd8739ae039), (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        type: "switch"
    }));
});
$0941f33c5e4da268$var$Switch.displayName = 'Switch';
$0941f33c5e4da268$var$Switch.Input = (0, $69b6fa0b19a82e2c$export$2e2bcd8739ae039).Input;
$0941f33c5e4da268$var$Switch.Label = (0, $69b6fa0b19a82e2c$export$2e2bcd8739ae039).Label;
var $0941f33c5e4da268$export$2e2bcd8739ae039 = $0941f33c5e4da268$var$Switch;






var $821b5f470c52615c$var$rHyphen = /-(.)/g;
function $821b5f470c52615c$export$2e2bcd8739ae039(string) {
    return string.replace($821b5f470c52615c$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}



var $lgFxF = parcelRequire("lgFxF");

var $24bed91c55d410a8$var$pascalCase = function pascalCase(str) {
    return str[0].toUpperCase() + (0, $821b5f470c52615c$export$2e2bcd8739ae039)(str).slice(1);
};
function $24bed91c55d410a8$export$2e2bcd8739ae039(prefix, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$displayName = _ref.displayName, displayName = _ref$displayName === void 0 ? $24bed91c55d410a8$var$pascalCase(prefix) : _ref$displayName, Component = _ref.Component, defaultProps = _ref.defaultProps;
    var BsComponent = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref2, ref) {
        var className = _ref2.className, bsPrefix = _ref2.bsPrefix, _ref2$as = _ref2.as, Tag = _ref2$as === void 0 ? Component || 'div' : _ref2$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref2, [
            "className",
            "bsPrefix",
            "as"
        ]);
        var resolvedPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Tag, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, resolvedPrefix)
        }, props));
    });
    BsComponent.defaultProps = defaultProps;
    BsComponent.displayName = displayName;
    return BsComponent;
}


var $61ce1779e2da682b$var$FormRow = (0, $24bed91c55d410a8$export$2e2bcd8739ae039)('form-row');
var $61ce1779e2da682b$var$defaultProps = {
    inline: false
};
var $61ce1779e2da682b$var$FormImpl = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, inline = _ref.inline, className = _ref.className, validated = _ref.validated, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'form' : _ref$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "inline",
        "className",
        "validated",
        "as"
    ]);
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'form');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, validated && 'was-validated', inline && bsPrefix + "-inline")
    }));
});
$61ce1779e2da682b$var$FormImpl.displayName = 'Form';
$61ce1779e2da682b$var$FormImpl.defaultProps = $61ce1779e2da682b$var$defaultProps;
$61ce1779e2da682b$var$FormImpl.Row = $61ce1779e2da682b$var$FormRow;
$61ce1779e2da682b$var$FormImpl.Group = (0, $6a17f7a37d942d11$export$2e2bcd8739ae039);
$61ce1779e2da682b$var$FormImpl.Control = (0, $c1cf66e043360dc9$export$2e2bcd8739ae039);
$61ce1779e2da682b$var$FormImpl.Check = (0, $69b6fa0b19a82e2c$export$2e2bcd8739ae039);
$61ce1779e2da682b$var$FormImpl.File = (0, $c9d405c6e647a3aa$export$2e2bcd8739ae039);
$61ce1779e2da682b$var$FormImpl.Switch = (0, $0941f33c5e4da268$export$2e2bcd8739ae039);
$61ce1779e2da682b$var$FormImpl.Label = (0, $5db724b783d3e91a$export$2e2bcd8739ae039);
$61ce1779e2da682b$var$FormImpl.Text = (0, $8e226ffe41c4f29c$export$2e2bcd8739ae039);
var $61ce1779e2da682b$export$2e2bcd8739ae039 = $61ce1779e2da682b$var$FormImpl;



/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by ChiyoYuki from ECNU-minus on 2025-12-03
 * Changes:
 * - fix: remove outdated fixtures
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ var $1e628a002d486c20$exports = {};
//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

(function(global, factory) {
    factory((parcelRequire("gLKmg")));
})($1e628a002d486c20$exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var zhCn = moment.defineLocale('zh-cn', {
        months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split('_'),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split('_'),
        weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split('_'),
        weekdaysShort: "\u5468\u65E5_\u5468\u4E00_\u5468\u4E8C_\u5468\u4E09_\u5468\u56DB_\u5468\u4E94_\u5468\u516D".split('_'),
        weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5Ah\u70B9mm\u5206",
            LLLL: "YYYY\u5E74M\u6708D\u65E5ddddAh\u70B9mm\u5206",
            l: 'YYYY/M/D',
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") return hour;
            else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") return hour + 12;
            else // '中午'
            return hour >= 11 ? hour : hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u51CC\u6668";
            else if (hm < 900) return "\u65E9\u4E0A";
            else if (hm < 1130) return "\u4E0A\u5348";
            else if (hm < 1230) return "\u4E2D\u5348";
            else if (hm < 1800) return "\u4E0B\u5348";
            else return "\u665A\u4E0A";
        },
        calendar: {
            sameDay: "[\u4ECA\u5929]LT",
            nextDay: "[\u660E\u5929]LT",
            nextWeek: function(now) {
                if (now.week() !== this.week()) return "[\u4E0B]dddLT";
                else return "[\u672C]dddLT";
            },
            lastDay: "[\u6628\u5929]LT",
            lastWeek: function(now) {
                if (this.week() !== now.week()) return "[\u4E0A]dddLT";
                else return "[\u672C]dddLT";
            },
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'DDD':
                    return number + "\u65E5";
                case 'M':
                    return number + "\u6708";
                case 'w':
                case 'W':
                    return number + "\u5468";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u540E",
            past: "%s\u524D",
            s: "\u51E0\u79D2",
            ss: "%d \u79D2",
            m: "1 \u5206\u949F",
            mm: "%d \u5206\u949F",
            h: "1 \u5C0F\u65F6",
            hh: "%d \u5C0F\u65F6",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u4E2A\u6708",
            MM: "%d \u4E2A\u6708",
            y: "1 \u5E74",
            yy: "%d \u5E74"
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1,
            doy: 4
        }
    });
    return zhCn;
});



var $c2d95a3b6d205826$exports = {};

var $836c9 = parcelRequire("836c9");

var $307024f40a7a7a69$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $307024f40a7a7a69$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$307024f40a7a7a69$exports = $307024f40a7a7a69$var$copyArray;



var $ae8en = parcelRequire("ae8en");
/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */ function $c2d95a3b6d205826$var$concat() {
    var length = arguments.length;
    if (!length) return [];
    var args = Array(length - 1), array = arguments[0], index = length;
    while(index--)args[index - 1] = arguments[index];
    return $836c9($ae8en(array) ? $307024f40a7a7a69$exports(array) : [
        array
    ], $3103d8a23e4e2ae3$exports(args, 1));
}
$c2d95a3b6d205826$exports = $c2d95a3b6d205826$var$concat;


var $fe7b4781fe7c7271$exports = {};
var $97d9d2530dcf77f4$exports = {};

var $2oilF = parcelRequire("2oilF");

var $50iuD = parcelRequire("50iuD");

var $gRgFA = parcelRequire("gRgFA");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $97d9d2530dcf77f4$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$50iuD(collection)) {
            var iteratee = $2oilF(predicate, 3);
            collection = $gRgFA(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$97d9d2530dcf77f4$exports = $97d9d2530dcf77f4$var$createFind;


var $95a5c0dac88592f3$exports = {};


var $2oilF = parcelRequire("2oilF");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $95a5c0dac88592f3$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $95a5c0dac88592f3$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $a5bc1ba033d9ebc1$exports(fromIndex);
    if (index < 0) index = $95a5c0dac88592f3$var$nativeMax(length + index, 0);
    return $191fdd32c4d18066$exports(array, $2oilF(predicate, 3), index);
}
$95a5c0dac88592f3$exports = $95a5c0dac88592f3$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $fe7b4781fe7c7271$var$find = $97d9d2530dcf77f4$exports($95a5c0dac88592f3$exports);
$fe7b4781fe7c7271$exports = $fe7b4781fe7c7271$var$find;



var $gLKmg = parcelRequire("gLKmg");

var $lgFxF = parcelRequire("lgFxF");

/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by Niazye and ChiyoYuki from ECNU-minus on 2025-12-02
 * Changes:
 * - fix: time table
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ var $779795267eaa6551$exports = {};
var $5832a06b5151f0ba$exports = {};
"use strict";
Object.defineProperty($5832a06b5151f0ba$exports, "__esModule", {
    value: true
});
$5832a06b5151f0ba$exports.createEvent = $5832a06b5151f0ba$var$createEvent;
$5832a06b5151f0ba$exports.createEvents = $5832a06b5151f0ba$var$createEvents;

var $5832a06b5151f0ba$var$_v = $5832a06b5151f0ba$var$_interopRequireDefault((parcelRequire("ipmjT")));
var $9d81f42273d29557$exports = {};
"use strict";
Object.defineProperty($9d81f42273d29557$exports, "__esModule", {
    value: true
});
Object.defineProperty($9d81f42273d29557$exports, "buildEvent", {
    enumerable: true,
    get: function get() {
        return $9d81f42273d29557$var$_build["default"];
    }
});
Object.defineProperty($9d81f42273d29557$exports, "formatEvent", {
    enumerable: true,
    get: function get() {
        return $9d81f42273d29557$var$_format["default"];
    }
});
Object.defineProperty($9d81f42273d29557$exports, "validateEvent", {
    enumerable: true,
    get: function get() {
        return $9d81f42273d29557$var$_validate["default"];
    }
});

var $9d81f42273d29557$var$_build = $9d81f42273d29557$var$_interopRequireDefault((parcelRequire("1Garp")));

var $9d81f42273d29557$var$_format = $9d81f42273d29557$var$_interopRequireDefault((parcelRequire("ifLNJ")));

var $9d81f42273d29557$var$_validate = $9d81f42273d29557$var$_interopRequireDefault((parcelRequire("aWC6d")));
function $9d81f42273d29557$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}


function $5832a06b5151f0ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5832a06b5151f0ba$var$assignUniqueId(event) {
    event.uid = event.uid || (0, $5832a06b5151f0ba$var$_v["default"])();
    return event;
}
function $5832a06b5151f0ba$var$validateAndBuildEvent(event) {
    return (0, $9d81f42273d29557$exports.validateEvent)((0, $9d81f42273d29557$exports.buildEvent)(event));
}
function $5832a06b5151f0ba$var$applyInitialFormatting(_ref) {
    var error = _ref.error, value = _ref.value;
    if (error) return {
        error: error,
        value: null
    };
    return {
        error: null,
        value: (0, $9d81f42273d29557$exports.formatEvent)(value)
    };
}
function $5832a06b5151f0ba$var$reformatEventsByPosition(_ref2, idx, list) {
    var error = _ref2.error, value = _ref2.value;
    if (error) return {
        error: error,
        value: value
    };
    if (idx === 0) // beginning of list
    return {
        value: value.slice(0, value.indexOf('END:VCALENDAR')),
        error: null
    };
    if (idx === list.length - 1) // end of list
    return {
        value: value.slice(value.indexOf('BEGIN:VEVENT')),
        error: null
    };
    return {
        error: null,
        value: value.slice(value.indexOf('BEGIN:VEVENT'), value.indexOf('END:VEVENT') + 12)
    };
}
function $5832a06b5151f0ba$var$catenateEvents(accumulator, _ref3, idx) {
    var error = _ref3.error, value = _ref3.value;
    if (error) {
        accumulator.error = error;
        accumulator.value = null;
        return accumulator;
    }
    if (accumulator.value) {
        accumulator.value = accumulator.value.concat(value);
        return accumulator;
    }
    accumulator.value = value;
    return accumulator;
}
function $5832a06b5151f0ba$var$createEvent(attributes, cb) {
    if (!attributes) Error('Attributes argument is required');
    $5832a06b5151f0ba$var$assignUniqueId(attributes);
    if (!cb) {
        // No callback, so return error or value in an object
        var _validateAndBuildEven = $5832a06b5151f0ba$var$validateAndBuildEvent(attributes), _error = _validateAndBuildEven.error, _value = _validateAndBuildEven.value;
        if (_error) return {
            error: _error,
            value: _value
        };
        var event = '';
        try {
            event = (0, $9d81f42273d29557$exports.formatEvent)(_value);
        } catch (error) {
            return {
                error: error,
                value: null
            };
        }
        return {
            error: null,
            value: event
        };
    } // Return a node-style callback
    var _validateAndBuildEven2 = $5832a06b5151f0ba$var$validateAndBuildEvent(attributes), error = _validateAndBuildEven2.error, value = _validateAndBuildEven2.value;
    if (error) return cb(error);
    return cb(null, (0, $9d81f42273d29557$exports.formatEvent)(value));
}
function $5832a06b5151f0ba$var$createEvents(events, cb) {
    if (!events) return {
        error: Error('one argument is required'),
        value: null
    };
    if (events.length === 1) return $5832a06b5151f0ba$var$createEvent(events[0], cb);
    var _events$map$map$map$m = events.map($5832a06b5151f0ba$var$assignUniqueId).map($5832a06b5151f0ba$var$validateAndBuildEvent).map($5832a06b5151f0ba$var$applyInitialFormatting).map($5832a06b5151f0ba$var$reformatEventsByPosition).reduce($5832a06b5151f0ba$var$catenateEvents, {
        error: null,
        value: null
    }), error = _events$map$map$map$m.error, value = _events$map$map$map$m.value;
    if (!cb) return {
        error: error,
        value: value
    };
    return cb(error, value);
}


$779795267eaa6551$exports = $5832a06b5151f0ba$exports;



var $gLKmg = parcelRequire("gLKmg");

const $7c700215066b0d5b$var$timeAt = [
    '8:00',
    '8:50',
    '9:50',
    '10:40',
    '11:30',
    '13:00',
    '13:50',
    '14:50',
    '15:40',
    '16:30',
    '18:00',
    '18:50',
    '19:40',
    '20:30'
].map((x)=>{
    const [hour, minute] = x.split(':');
    return parseInt(hour) * 60 + parseInt(minute);
});
function $7c700215066b0d5b$export$9771d48061a3df77(lessons, begin, semester, fixtures) {
    const events = [];
    lessons.forEach((lesson)=>{
        (0, $3ba76e806416b3fb$export$41fd67b796408d0e)(lesson.zcd).forEach((week)=>{
            const blocks = (0, $3ba76e806416b3fb$export$41fd67b796408d0e)(lesson.cdjc);
            const start = Math.min(...blocks) - 1;
            const end = Math.max(...blocks) - 1;
            let time = (0, (/*@__PURE__*/$parcel$interopDefault($gLKmg)))(begin).add((week - 1) * 7 + lesson.xqj - 1, 'day');
            fixtures.forEach((rule)=>{
                if (rule.week === week && rule.day === lesson.xqj) time = rule.on;
            });
            if (!time) return;
            const startAt = $7c700215066b0d5b$var$timeAt[start];
            const endAt = $7c700215066b0d5b$var$timeAt[end] + 45;
            const duration = endAt - startAt;
            const event = {
                start: [
                    time.year(),
                    time.month() + 1,
                    time.date(),
                    Math.floor(startAt / 60),
                    startAt % 60
                ],
                duration: {
                    hours: Math.floor(duration / 60),
                    minutes: duration % 60
                },
                title: `${lesson.kch} ${lesson.kcmc}`,
                description: `${lesson.jszc}, ${lesson.xf} \u{5B66}\u{5206}, \u{7B2C} ${week} \u{5468}`,
                location: (0, $3ba76e806416b3fb$export$bca405cc5c510d53)(lesson.sksj, lesson.jxdd, lesson.xqj),
                calName: `\u{8BFE}\u{7A0B}\u{8868} ${semester}`
            };
            events.push(event);
        });
    });
    const { error: error, value: value } = (0, $779795267eaa6551$exports.createEvents)(events);
    if (error) alert(error);
    if (value) return value;
    else return '';
}



function $859bf2cdd8712ecd$var$downloadFile(filename, data, mediaType) {
    const link = document.createElement('a');
    link.download = filename;
    const blob = new Blob([
        data
    ], {
        type: mediaType
    });
    link.href = window.URL.createObjectURL(blob);
    link.click();
}
function $859bf2cdd8712ecd$export$2e2bcd8739ae039({ semester: semester, selectedLessonObj: selectedLessonObj }) {
    const [firstDayDate, setFirstDayDate] = (0, $lgFxF.useState)('');
    const [fixtures, setFixtures] = (0, $lgFxF.useState)(new Set([]));
    (0, $lgFxF.useEffect)(()=>{
        let mounted = true;
        const getLessonIndex = async ()=>{
            try {
                const semesterIndex = (await (0, (/*@__PURE__*/$parcel$interopDefault($ce12fe3b4e8bd060$exports))).get('/course-plus-data/lessonData_index.json')).data;
                if (!mounted) return;
                const index = (0, (/*@__PURE__*/$parcel$interopDefault($fe7b4781fe7c7271$exports)))(semesterIndex, (idx)=>semester === `${idx.year}_${idx.semester}`);
                setFirstDayDate((index || {}).first_day || '2021-01-01');
            } catch (e) {
                if (mounted) setFirstDayDate('2021-01-01');
            }
        };
        getLessonIndex().then();
        return ()=>{
            mounted = false;
        };
    }, [
        semester
    ]);
    // const getFixtures = () => {
    //   let result = []
    //   const selectedFixtures = allFixtures.filter((x) => fixtures.has(x.name))
    //   selectedFixtures.forEach((x) => {
    //     result = concat(result, x.rules)
    //   })
    //   return result
    // }
    const downloadAsICS = ()=>{
        $859bf2cdd8712ecd$var$downloadFile(`classtable-${semester}.ics`, (0, $7c700215066b0d5b$export$9771d48061a3df77)(selectedLessonObj, (0, (/*@__PURE__*/$parcel$interopDefault($gLKmg)))(firstDayDate), semester, [] // 传入空数组作为 fixtures 参数，原本的fixture需要手动添加，维护不便，直接舍弃
        ), 'text/calendar');
    };
    const handleCheckChange = (e)=>{
        const checked = e.target.checked;
        const value = e.target.value;
        const set = new Set(fixtures);
        if (checked) set.add(value);
        else set.delete(value);
        setFixtures(set);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Group, {
        className: "col-12 mb-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, {
        className: "small"
    }, "\u672C\u5B66\u671F\u7B2C\u4E00\u5929"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Control, {
        name: "firstDayDate",
        value: firstDayDate,
        onChange: (e)=>setFirstDayDate(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "col-12 mb-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("button", {
        type: "button",
        className: "btn btn-sm btn-outline-primary",
        onClick: downloadAsICS
    }, "\u5BFC\u51FA\u8BFE\u8868")));
}



var $1ff0334130c5ec5d$export$2e2bcd8739ae039 = ({ sjtuLesson: sjtuLesson, dataLoading: dataLoading, syncFromISJTU: syncFromISJTU, colorMapping: colorMapping, starLesson: starLesson, setStarLesson: setStarLesson })=>{
    const { semester: semester } = (0, $8d84d1394a502c2f$export$99eaa27ddbbb95ef)();
    const { data: lessons } = (0, $3ba76e806416b3fb$export$991d5b48f7801974)(semester);
    const onSyncClick = ()=>{
        syncFromISJTU(semester);
    };
    const addToStar = ()=>{
        const set = new Set(starLesson);
        sjtuLesson.forEach((lesson)=>{
            set.add(lesson);
        });
        setStarLesson(set);
    };
    if (lessons) {
        const sjtuLessonObj = (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))(lessons.filter((lesson)=>sjtuLesson.has(lesson.jxbmc)), 'kch');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "mb-1 row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col-12"
        }, "\u672C\u5B66\u671F\u8BFE\u7A0B (\u5171", ' ', (0, (/*@__PURE__*/$parcel$interopDefault($fdeac4566d39d3d5$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($905bd22ff9c4e6ec$exports)))(sjtuLessonObj, 'jxbmc').map((l)=>parseFloat(l.xf))), ' ', "\u5B66\u5206)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("ul", {
            className: "list-unstyled"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($905bd22ff9c4e6ec$exports)))(sjtuLessonObj, 'jxbmc').map((lesson)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("li", {
                className: "d-flex flex-row",
                key: lesson.jxbmc
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "course-square",
                style: {
                    backgroundColor: colorMapping[lesson.jxbmc]
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "ml-1 d-inline-block"
            }, lesson.kch), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "ml-2 d-inline-block"
            }, lesson.kcmc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "ml-2 d-inline-block"
            }, lesson.jszc))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Row, {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("button", {
            type: "button",
            className: "btn btn-sm btn-outline-primary",
            onClick: onSyncClick,
            disabled: dataLoading
        }, dataLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "spinner-border spinner-border-sm mr-1 text-primary"
        }) : '', "\u540C\u6B65\u6570\u636E"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("button", {
            type: "button",
            className: "btn btn-sm btn-outline-primary ml-3",
            onClick: addToStar
        }, "\u5C06\u5DF2\u9009\u8BFE\u7A0B\u6DFB\u52A0\u5230\u6392\u8BFE\u5F85\u9009"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("hr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $859bf2cdd8712ecd$export$2e2bcd8739ae039), {
            semester: semester,
            selectedLessonObj: sjtuLessonObj
        }));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null);
};


/*
 * Copyright 2026 BetterECNU
 */ var $30f3b24994a55528$exports = {};

var $6Gx3I = parcelRequire("6Gx3I");
var $4b5ef855e3aeeddf$exports = {};
var $9ad2f52f012a7ce5$exports = {};
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $9ad2f52f012a7ce5$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
$9ad2f52f012a7ce5$exports = $9ad2f52f012a7ce5$var$arrayAggregator;


var $360ff6bcfeec71e4$exports = {};

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $360ff6bcfeec71e4$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $29b0a0eb2844d66d$exports(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
$360ff6bcfeec71e4$exports = $360ff6bcfeec71e4$var$baseAggregator;



var $2oilF = parcelRequire("2oilF");

var $ae8en = parcelRequire("ae8en");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $4b5ef855e3aeeddf$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $ae8en(collection) ? $9ad2f52f012a7ce5$exports : $360ff6bcfeec71e4$exports, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $2oilF(iteratee, 2), accumulator);
    };
}
$4b5ef855e3aeeddf$exports = $4b5ef855e3aeeddf$var$createAggregator;


/** Used for built-in method references. */ var $30f3b24994a55528$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $30f3b24994a55528$var$hasOwnProperty = $30f3b24994a55528$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $30f3b24994a55528$var$groupBy = $4b5ef855e3aeeddf$exports(function(result, value, key) {
    if ($30f3b24994a55528$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $6Gx3I(result, key, [
        value
    ]);
});
$30f3b24994a55528$exports = $30f3b24994a55528$var$groupBy;





var $lgFxF = parcelRequire("lgFxF");




var $lgFxF = parcelRequire("lgFxF");

var $6635d28ab45464ba$var$defaultProps = {
    pill: false
};
var $6635d28ab45464ba$var$Badge = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, pill = _ref.pill, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "variant",
        "pill",
        "className",
        "as"
    ]);
    var prefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, prefix, pill && prefix + "-pill", variant && prefix + "-" + variant)
    }));
});
$6635d28ab45464ba$var$Badge.displayName = 'Badge';
$6635d28ab45464ba$var$Badge.defaultProps = $6635d28ab45464ba$var$defaultProps;
var $6635d28ab45464ba$export$2e2bcd8739ae039 = $6635d28ab45464ba$var$Badge;






var $lgFxF = parcelRequire("lgFxF");

var $16e0ea112d292bc9$var$Spinner = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, animation = _ref.animation, size = _ref.size, children = _ref.children, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, className = _ref.className, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "variant",
        "animation",
        "size",
        "children",
        "as",
        "className"
    ]);
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    var bsSpinnerPrefix = bsPrefix + "-" + animation;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsSpinnerPrefix, size && bsSpinnerPrefix + "-" + size, variant && "text-" + variant)
    }), children);
});
$16e0ea112d292bc9$var$Spinner.displayName = 'Spinner';
var $16e0ea112d292bc9$export$2e2bcd8739ae039 = $16e0ea112d292bc9$var$Spinner;




function $b204f98b29da225f$var$semesterLabel(year, term) {
    let season = term;
    if (term === 'Autumn' || term === 'Fall') season = "\u79CB";
    else if (term === 'Spring') season = "\u6625";
    else if (term === 'Summer') season = "\u590F";
    else if (term === 'Winter') season = "\u51AC";
    return `${year} ${season}`;
}
function $b204f98b29da225f$export$2e2bcd8739ae039() {
    const location = (0, $8d84d1394a502c2f$export$45d76561a5302f2b)();
    const history = (0, $8d84d1394a502c2f$export$3420e1dc2c4a518c)();
    const params = new URLSearchParams(location.search);
    const courseId = params.get('id');
    const { data: allLessons, loading: loading, error: error, fetchAll: fetchAll } = (0, $3ba76e806416b3fb$export$e05f7f3137a2fed8)();
    const { data: lessonConversion } = (0, $3ba76e806416b3fb$export$e2ee6cfef5cb8639)();
    (0, $lgFxF.useEffect)(()=>{
        if (courseId) fetchAll();
    }, [
        courseId,
        fetchAll
    ]);
    const courseLessons = (0, $lgFxF.useMemo)(()=>{
        if (!allLessons || !courseId) return null;
        // Collect all possible course codes including conversions
        const codes = new Set([
            courseId
        ]);
        if (lessonConversion) {
            if (lessonConversion.to_old[courseId]) codes.add(lessonConversion.to_old[courseId]);
            // Also check reverse: if an old code maps to courseId
            for (const [oldCode, newCode] of Object.entries(lessonConversion.to_new || {}))if (newCode === courseId) codes.add(oldCode);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($905bd22ff9c4e6ec$exports)))(allLessons.filter((l)=>codes.has(l.kch)), 'jxbmc');
    }, [
        allLessons,
        courseId,
        lessonConversion
    ]);
    const groupedByYear = (0, $lgFxF.useMemo)(()=>{
        if (!courseLessons || courseLessons.length === 0) return null;
        const sorted = (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))(courseLessons, [
            '_year',
            '_term'
        ]);
        const grouped = (0, (/*@__PURE__*/$parcel$interopDefault($30f3b24994a55528$exports)))(sorted, '_year');
        // Sort years descending (newest first)
        return (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))(Object.entries(grouped), ([year])=>year).reverse();
    }, [
        courseLessons
    ]);
    if (!courseId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "my-5 text-muted text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", null, "\u672A\u6307\u5B9A\u8BFE\u7A0B\u4EE3\u7801"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
        href: "#/search",
        className: "text-primary"
    }, "\u524D\u5F80\u5168\u5C40\u641C\u7D22")));
    const courseName = courseLessons && courseLessons.length > 0 ? courseLessons[0].kcmc : courseId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "p-3 course-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-flex align-items-center mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("button", {
        className: "mr-2 btn-outline-secondary btn btn-sm",
        onClick: ()=>history.goBack()
    }, "\u2190 \u8FD4\u56DE"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
        href: "#/search",
        className: "text-muted btn btn-sm btn-link"
    }, "\u5168\u5C40\u641C\u7D22")), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-flex align-items-center my-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $16e0ea112d292bc9$export$2e2bcd8739ae039), {
        animation: "border",
        size: "sm",
        role: "status",
        className: "mr-2 text-primary"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "text-muted small"
    }, "\u6B63\u5728\u52A0\u8F7D\u6240\u6709\u5B66\u671F\u6570\u636E\u2026\u2026")), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "alert alert-danger small"
    }, "\u52A0\u8F7D\u6570\u636E\u5931\u8D25\uFF1A", error.message), !loading && courseLessons && courseLessons.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "mb-4 course-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("h4", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "text-primary"
    }, courseLessons[0].kch), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "ml-2"
    }, courseName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "mb-0 text-muted small"
    }, "\u5171 ", courseLessons.length, " \u6761\u5F00\u8BFE\u8BB0\u5F55\uFF0C\u8986\u76D6 ", groupedByYear.length, ' ', "\u4E2A\u5B66\u5E74")), groupedByYear.map(([year, lessons])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            key: year,
            className: "course-year-group mb-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("h5", {
            className: "mb-3 course-year-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $6635d28ab45464ba$export$2e2bcd8739ae039), {
            variant: "primary",
            className: "mr-2"
        }, year), "\u5B66\u5E74"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "course-lessons"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))(lessons, [
            '_term',
            'jxbmc'
        ]).map((lesson, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
                key: lesson._source + '-' + lesson._semester + '-' + (lesson.jxbmc || '') + '-' + idx,
                className: "mb-2 card course-lesson-card"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
                className: "px-3 py-2 card-body"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
                className: "d-flex align-items-start justify-content-between mb-2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $6635d28ab45464ba$export$2e2bcd8739ae039), {
                variant: lesson._term === 'Spring' || lesson._term === 'Summer' ? 'success' : 'warning',
                className: "mr-2"
            }, $b204f98b29da225f$var$semesterLabel('', lesson._term)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "text-muted small"
            }, lesson.jxbmc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "text-muted small"
            }, lesson.xf, " \u5B66\u5206 / ", lesson.rwzxs, " \u5B66\u65F6")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
                className: "mb-2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "mr-1 text-muted small"
            }, "\u6559\u5E08\uFF1A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "small"
            }, lesson.jszc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
                className: "mb-2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "mr-1 text-muted small"
            }, "\u65F6\u95F4\u5730\u70B9\uFF1A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("ul", {
                className: "mb-0 list-unstyled small"
            }, (0, $3ba76e806416b3fb$export$4054075abaf06b2c)(lesson.sksj, lesson.jxdd).map((tl, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("li", {
                    key: i,
                    className: "mb-0"
                }, tl.time, " ", tl.location)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
                className: "d-flex flex-wrap align-items-center text-muted small"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "mr-2"
            }, lesson.kkxy), lesson.kcxzmc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "mr-2"
            }, lesson.kcxzmc), lesson.skyy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "mr-2"
            }, lesson.skyy), lesson.xkbz && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "mr-2"
            }, "\u5907\u6CE8\uFF1A", lesson.xkbz)), lesson.jxbzc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
                className: "mt-1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "text-muted small"
            }, "\u73ED\u7EA7\u7EC4\u6210\uFF1A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "small"
            }, lesson.jxbzc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
                className: "mt-2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
                href: `#/${lesson._semester}/browse`,
                className: "small",
                onClick: (e)=>{
                    e.stopPropagation();
                }
            }, "\u5728\u6B64\u5B66\u671F\u4E2D\u67E5\u770B \u2192"))))))))), !loading && !error && courseLessons && courseLessons.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "my-5 text-muted text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", null, "\u672A\u627E\u5230\u8BFE\u7A0B ", courseId, " \u7684\u5F00\u8BFE\u8BB0\u5F55"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "small"
    }, "\u8BE5\u8BFE\u7A0B\u4EE3\u7801\u53EF\u80FD\u4E0D\u5B58\u5728\u6216\u5DF2\u66F4\u65B0\uFF0C\u8BF7\u5C1D\u8BD5\u4F7F\u7528\u65B0\u8BFE\u7A0B\u4EE3\u7801\u641C\u7D22")));
}


/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by ChiyoYuki and Niazye from ECNU-minus on 2025-12-12
 * Changes:
 * - fix: wrong text
 * - fix: hide unusable filters
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ var $55df994807663249$exports = {};

var $6Gx3I = parcelRequire("6Gx3I");

/** Used for built-in method references. */ var $55df994807663249$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $55df994807663249$var$hasOwnProperty = $55df994807663249$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $55df994807663249$var$countBy = $4b5ef855e3aeeddf$exports(function(result, value, key) {
    if ($55df994807663249$var$hasOwnProperty.call(result, key)) ++result[key];
    else $6Gx3I(result, key, 1);
});
$55df994807663249$exports = $55df994807663249$var$countBy;


var $2823e9928c5072be$exports = {};

var $kfKby = parcelRequire("kfKby");
var $2a22f75bd79d1105$exports = {};

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $2a22f75bd79d1105$var$baseFilter(collection, predicate) {
    var result = [];
    $29b0a0eb2844d66d$exports(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
$2a22f75bd79d1105$exports = $2a22f75bd79d1105$var$baseFilter;



var $2oilF = parcelRequire("2oilF");

var $ae8en = parcelRequire("ae8en");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $2823e9928c5072be$var$filter(collection, predicate) {
    var func = $ae8en(collection) ? $kfKby : $2a22f75bd79d1105$exports;
    return func(collection, $2oilF(predicate, 3));
}
$2823e9928c5072be$exports = $2823e9928c5072be$var$filter;




var $gRgFA = parcelRequire("gRgFA");



var $lgFxF = parcelRequire("lgFxF");






var $lgFxF = parcelRequire("lgFxF");


var $17661e242476c9e5$var$InputGroupAppend = (0, $24bed91c55d410a8$export$2e2bcd8739ae039)('input-group-append');
var $17661e242476c9e5$var$InputGroupPrepend = (0, $24bed91c55d410a8$export$2e2bcd8739ae039)('input-group-prepend');
var $17661e242476c9e5$var$InputGroupText = (0, $24bed91c55d410a8$export$2e2bcd8739ae039)('input-group-text', {
    Component: 'span'
});
var $17661e242476c9e5$var$InputGroupCheckbox = function InputGroupCheckbox(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($17661e242476c9e5$var$InputGroupText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("input", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        type: "checkbox"
    }, props)));
};
var $17661e242476c9e5$var$InputGroupRadio = function InputGroupRadio(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($17661e242476c9e5$var$InputGroupText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("input", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        type: "radio"
    }, props)));
};
/**
 *
 * @property {InputGroupAppend} Append
 * @property {InputGroupPrepend} Prepend
 * @property {InputGroupText} Text
 * @property {InputGroupRadio} Radio
 * @property {InputGroupCheckbox} Checkbox
 */ var $17661e242476c9e5$var$InputGroup = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, size = _ref.size, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "size",
        "className",
        "as"
    ]);
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix, size && bsPrefix + "-" + size)
    }));
});
$17661e242476c9e5$var$InputGroup.displayName = 'InputGroup';
var $17661e242476c9e5$var$InputGroupWithExtras = (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, $17661e242476c9e5$var$InputGroup, {
    Text: $17661e242476c9e5$var$InputGroupText,
    Radio: $17661e242476c9e5$var$InputGroupRadio,
    Checkbox: $17661e242476c9e5$var$InputGroupCheckbox,
    Append: $17661e242476c9e5$var$InputGroupAppend,
    Prepend: $17661e242476c9e5$var$InputGroupPrepend
});
var $17661e242476c9e5$export$2e2bcd8739ae039 = $17661e242476c9e5$var$InputGroupWithExtras;




var $cc5d3b75ff45f90a$export$2e2bcd8739ae039 = (0, $8d84d1394a502c2f$export$369b6b2b30582e8e)(({ history: history, state: state, setState: setState })=>{
    const { semester: semester } = (0, $8d84d1394a502c2f$export$99eaa27ddbbb95ef)();
    const { data: lessons } = (0, $3ba76e806416b3fb$export$991d5b48f7801974)(semester);
    const handleStateChange = (e)=>{
        const value = e.target.value;
        const name = e.target.name;
        setState({
            [name]: value
        });
    };
    const handleCheckChange = (e)=>{
        const name = e.target.name;
        const checked = e.target.checked;
        const value = e.target.value;
        const set = new Set(state[name]);
        if (checked) set.add(value);
        else set.delete(value);
        setState({
            [name]: set
        });
    };
    const { data: lessonConversion } = (0, $3ba76e806416b3fb$export$e2ee6cfef5cb8639)();
    if (lessons) {
        const lessonFiltered = (0, $3ba76e806416b3fb$export$c87d7c0a12f42435)((0, (/*@__PURE__*/$parcel$interopDefault($905bd22ff9c4e6ec$exports)))(lessons, 'jxbmc'), state, lessonConversion);
        const dataNj = (0, (/*@__PURE__*/$parcel$interopDefault($55df994807663249$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6f6e293b545bced6$exports)))(lessonFiltered, (lesson)=>lesson.nj.split(',')));
        const dataLx = (0, (/*@__PURE__*/$parcel$interopDefault($55df994807663249$exports)))(lessonFiltered, 'kcxzmc');
        const dataYx = (0, (/*@__PURE__*/$parcel$interopDefault($55df994807663249$exports)))(lessonFiltered, 'kkxy');
        const dataTy = (0, (/*@__PURE__*/$parcel$interopDefault($55df994807663249$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6f6e293b545bced6$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2823e9928c5072be$exports)))(lessonFiltered, 'kzmc'), (lesson)=>lesson.kzmc.split(',')));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Group, {
            className: "col mb-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u8BFE\u7A0B\u540D\u79F0/\uFF08\u65B0\uFF09\u8BFE\u7A0B\u4EE3\u7801"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $17661e242476c9e5$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Control, {
            placeholder: "\u4E0D\u9650",
            name: "keyword",
            value: state.keyword,
            onChange: handleStateChange
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Group, {
            className: "col-md-4 mb-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u4E0A\u8BFE\u65F6\u95F4"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Control, {
            placeholder: "\u4E0D\u9650",
            name: "scheduleKey",
            value: state.scheduleKey,
            onChange: handleStateChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Group, {
            className: "col-md-4 mb-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u6559\u5E08"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Control, {
            placeholder: "\u4E0D\u9650",
            name: "lecturerKey",
            value: state.lecturerKey,
            onChange: handleStateChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Group, {
            className: "col-md-4 mb-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u5730\u70B9"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Control, {
            placeholder: "\u4E0D\u9650",
            name: "placeKey",
            value: state.placeKey,
            onChange: handleStateChange
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Group, {
            className: "col mb-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u6559\u5B66\u7EC4\u6210"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Control, {
            placeholder: "\u4E0D\u9650",
            name: "composition",
            value: state.composition,
            onChange: handleStateChange
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Group, {
            className: "col mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u5907\u6CE8"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Control, {
            placeholder: "\u4E0D\u9650",
            name: "notes",
            value: state.notes,
            onChange: handleStateChange
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("hr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Row, {
            className: "mb-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u5F00\u8BFE\u9662\u7CFB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col-12"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($gRgFA)))(dataYx)).map((key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Check, {
                type: "checkbox",
                key: key,
                id: key,
                custom: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Check.Input, {
                type: "checkbox",
                name: "checkedYx",
                checked: state.checkedYx.has(key),
                onChange: handleCheckChange,
                value: key
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Check.Label, null, key, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $6635d28ab45464ba$export$2e2bcd8739ae039), {
                pill: true,
                variant: "secondary",
                className: "ml-1"
            }, dataYx[key])))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Row, {
            className: "mb-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u901A\u8BC6\u8BFE\u6A21\u5757"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col-12"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($gRgFA)))(dataTy)).map((key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Check, {
                type: "checkbox",
                key: key,
                id: key,
                custom: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Check.Input, {
                type: "checkbox",
                name: "checkedTy",
                checked: state.checkedTy.has(key),
                onChange: handleCheckChange,
                value: key
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Check.Label, null, key, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $6635d28ab45464ba$export$2e2bcd8739ae039), {
                pill: true,
                variant: "secondary",
                className: "ml-1"
            }, dataTy[key])))))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-flex align-items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "spinner-border spinner-border-sm mr-3 text-info"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "text-info"
    }, "\u6B63\u5728\u52A0\u8F7D\u6570\u636E\u2026\u2026"));
});


/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by Niazye from ECNU-minus on 2025-12-12
 * Changes:
 * - fix: hide unusable filters
 *
 *
 * Modified by 霧雨バニラ from BetterECNU on 2026-05-23
 * Changes:
 * - fix: 异步定时器安全优化
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ 


var $lgFxF = parcelRequire("lgFxF");

var $lgFxF = parcelRequire("lgFxF");
function $be4e32f110e8fc50$var$_extends() {
    $be4e32f110e8fc50$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be4e32f110e8fc50$var$_extends.apply(this, arguments);
}
function $be4e32f110e8fc50$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $be4e32f110e8fc50$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $be4e32f110e8fc50$var$ObserverMap = new Map();
var $be4e32f110e8fc50$var$RootIds = new Map();
var $be4e32f110e8fc50$var$consecutiveRootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $be4e32f110e8fc50$var$getRootId(root) {
    if (!root) return '';
    if ($be4e32f110e8fc50$var$RootIds.has(root)) return $be4e32f110e8fc50$var$RootIds.get(root);
    $be4e32f110e8fc50$var$consecutiveRootId += 1;
    $be4e32f110e8fc50$var$RootIds.set(root, $be4e32f110e8fc50$var$consecutiveRootId.toString());
    return $be4e32f110e8fc50$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer for, when observer elements with the same options.
 * @param options
 */ function $be4e32f110e8fc50$var$optionsToId(options) {
    return Object.keys(options).sort().map(function(key) {
        return key + "_" + (key === 'root' ? $be4e32f110e8fc50$var$getRootId(options.root) : options[key]);
    }).join('|');
}
function $be4e32f110e8fc50$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $be4e32f110e8fc50$var$optionsToId(options);
    var instance = $be4e32f110e8fc50$var$ObserverMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && observer.thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $be4e32f110e8fc50$var$ObserverMap.set(id, instance);
    }
    return instance;
}
function $be4e32f110e8fc50$var$observe(element, callback, options) {
    if (options === void 0) options = {};
    if (!element) return function() {}; // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $be4e32f110e8fc50$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $be4e32f110e8fc50$var$ObserverMap["delete"](id);
        }
    };
}
function $be4e32f110e8fc50$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 * Monitors scroll, and triggers the children function with updated props
 */ var $be4e32f110e8fc50$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $be4e32f110e8fc50$var$_inheritsLoose(InView, _React$Component);
    function InView() {
        var _this;
        _this = _React$Component.apply(this, arguments) || this;
        _this.state = {
            inView: false,
            entry: undefined
        };
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) _this.setState({
                    inView: false,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            // Only trigger a state update if inView has changed.
            // This prevents an unnecessary extra state update during mount, when the element stats outside the viewport
            if (inView !== _this.state.inView || inView) _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
        if (prevState.inView !== this.state.inView) {
            if (this.state.inView && this.props.triggerOnce) {
                this.unobserve();
                this.node = null;
            }
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.node) {
            this.unobserve();
            this.node = null;
        }
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay;
        this._unobserveCb = $be4e32f110e8fc50$var$observe(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        });
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
        if (!$be4e32f110e8fc50$var$isPlainChildren(this.props)) return this.props.children({
            inView: inView,
            entry: entry,
            ref: this.handleNode
        });
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, tag = _this$props2.tag, props = $be4e32f110e8fc50$var$_objectWithoutPropertiesLoose(_this$props2, [
            "children",
            "as",
            "tag",
            "triggerOnce",
            "threshold",
            "root",
            "rootMargin",
            "onChange",
            "skip",
            "trackVisibility",
            "delay"
        ]);
        return /*#__PURE__*/ (0, $lgFxF.createElement)(as || tag || 'div', $be4e32f110e8fc50$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}((0, $lgFxF.Component));
$be4e32f110e8fc50$export$a62107ca74432f44.displayName = 'InView';
$be4e32f110e8fc50$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false
};
/* eslint-disable react-hooks/exhaustive-deps */ var $be4e32f110e8fc50$var$initialState = {
    inView: false,
    entry: undefined
};
function $be4e32f110e8fc50$export$2f62ee6831462844(options) {
    if (options === void 0) options = {};
    var unobserve = (0, $lgFxF.useRef)();
    var _React$useState = (0, $lgFxF.useState)($be4e32f110e8fc50$var$initialState), state = _React$useState[0], setState = _React$useState[1];
    var setRef = (0, $lgFxF.useCallback)(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        }
        if (options.skip) return;
        if (node) unobserve.current = $be4e32f110e8fc50$var$observe(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && options.triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, options);
    }, [
        options.threshold,
        options.root,
        options.rootMargin,
        options.triggerOnce,
        options.skip,
        options.trackVisibility,
        options.delay
    ]);
    (0, $lgFxF.useEffect)(function() {
        if (!unobserve.current && !options.triggerOnce && !options.skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState($be4e32f110e8fc50$var$initialState);
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}
var $be4e32f110e8fc50$export$2e2bcd8739ae039 = $be4e32f110e8fc50$export$a62107ca74432f44;



/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by Niazye from ECNU-minus on 2025-12-12
 * Changes:
 * - fix: hide unusable filters
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ 
var $lgFxF = parcelRequire("lgFxF");



function $05a862ee3145ca2d$var$StarSvg({ size: size }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        className: "bi bi-star",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("path", {
        fillRule: "evenodd",
        d: "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.523-3.356c.329-.314.158-.888-.283-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767l-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288l1.847-3.658 1.846 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.564.564 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"
    }));
}
function $05a862ee3145ca2d$var$StarSvgColor({ size: size }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        className: "bi bi-star",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("linearGradient", {
        id: "gradient",
        gradientTransform: "rotate(45)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("stop", {
        offset: "0%",
        stopColor: "#24C6DC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("stop", {
        offset: "100%",
        stopColor: "#514A9D"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("path", {
        fillRule: "evenodd",
        fill: "url(#gradient)",
        d: "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.523-3.356c.329-.314.158-.888-.283-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767l-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288l1.847-3.658 1.846 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.564.564 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"
    }));
}
function $05a862ee3145ca2d$var$StarFillSvg({ size: size }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        className: "bi bi-star-fill",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("linearGradient", {
        id: "gradient",
        gradientTransform: "rotate(45)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("stop", {
        offset: "0%",
        stopColor: "#24C6DC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("stop", {
        offset: "100%",
        stopColor: "#514A9D"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("path", {
        fill: "url(#gradient)",
        d: "M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.283.95l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
    }));
}
function $05a862ee3145ca2d$var$Star({ size: size, state: state, hover: hover }) {
    if (state) return $05a862ee3145ca2d$var$StarFillSvg({
        size: size
    });
    else {
        if (hover) return $05a862ee3145ca2d$var$StarSvgColor({
            size: size
        });
        return $05a862ee3145ca2d$var$StarSvg({
            size: size
        });
    }
}
function $05a862ee3145ca2d$var$PopperClass({ lesson: lesson }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $87802237a54007ad$exports.Tooltip), {
        interactive: true,
        position: "right",
        unmountHTMLWhenHide: true,
        html: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $16eb59577d700d3b$export$2e2bcd8739ae039), {
            lesson: lesson
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
        className: "btn btn-link btn-sm text-reset p-0"
    }, "\u8BE6\u60C5"));
}
function $05a862ee3145ca2d$var$ConversionInfo({ lessonConversion: lessonConversion, kch: kch }) {
    if (lessonConversion) {
        if (lessonConversion.to_new[kch]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "text-muted"
        }, "(\u65B0 ", lessonConversion.to_new[kch], ")"));
        if (lessonConversion.to_old[kch]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "text-muted"
        }, "(\u539F ", lessonConversion.to_old[kch], ")"));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null);
}
function $05a862ee3145ca2d$export$2e2bcd8739ae039({ lesson: lesson, name: name, state: state, setState: setState, lessonConversion: lessonConversion }) {
    const [onHover, setOnHover] = (0, $lgFxF.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("tr", {
        key: lesson.jxbmc
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("td", {
        className: "kcbm",
        scope: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
        className: "btn btn-link btn-sm text-reset p-0",
        onClick: ()=>setState({
                name: name,
                value: !state
            }),
        onMouseEnter: ()=>setOnHover(true),
        onMouseLeave: ()=>setOnHover(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($05a862ee3145ca2d$var$Star, {
        size: "1rem",
        state: state,
        hover: onHover
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "ml-1"
    }, lesson.kch)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($05a862ee3145ca2d$var$ConversionInfo, {
        lessonConversion: lessonConversion,
        kch: lesson.kch
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($05a862ee3145ca2d$var$PopperClass, {
        lesson: lesson
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("td", {
        className: "yxmc"
    }, lesson.kkxy), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("td", {
        className: "xm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $3ba76e806416b3fb$export$b12a0f383389ab35), {
        data: lesson.jszc,
        sep: ","
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("td", {
        className: "kcmc"
    }, lesson.kcmc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("td", {
        className: "xsxf"
    }, lesson.rwzxs, " / ", lesson.xf), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("td", {
        className: "sksj"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $3ba76e806416b3fb$export$8625cbe7968a20f8), {
        time: lesson.sksj,
        location: lesson.jxdd
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("td", {
        className: "bz"
    }, lesson.xkbz), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("td", {
        className: "jxbzc"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $3ba76e806416b3fb$export$b12a0f383389ab35), {
        data: lesson.jxbzc,
        sep: ";"
    })));
}



const $fe20ce721ac6c732$var$tableHeader = [
    "\u8BFE\u53F7",
    "\u5F00\u8BFE\u9662\u7CFB",
    "\u6559\u5E08\u59D3\u540D",
    "\u8BFE\u7A0B",
    "\u5B66\u65F6/\u5B66\u5206",
    "\u4E0A\u8BFE\u65F6\u95F4\u5730\u70B9",
    "\u5907\u6CE8",
    // '年级',
    "\u6559\u5B66\u7EC4\u6210"
];
function $fe20ce721ac6c732$var$DataLoaded({ loaded: loaded, size: size }) {
    if (!loaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "spinner-border spinner-border-sm mr-3 text-muted"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "text-muted"
    }, "\u6B63\u5728\u52A0\u8F7D\u6570\u636E\u2026\u2026"));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-flex align-items-center justify-content-center mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "text-muted"
    }, "\u4EE5\u4E0A\u4E3A\u5168\u90E8 ", size, " \u6761\u8BB0\u5F55")));
}
var $fe20ce721ac6c732$export$2e2bcd8739ae039 = ({ filterData: filterData, state: state, setState: setState })=>{
    const { semester: semester } = (0, $8d84d1394a502c2f$export$99eaa27ddbbb95ef)();
    const { data: lessonsRaw } = (0, $3ba76e806416b3fb$export$991d5b48f7801974)(semester);
    const [entries, setEntries] = (0, $lgFxF.useState)(20);
    const timerRef = (0, $lgFxF.useRef)(null);
    (0, $lgFxF.useEffect)(()=>{
        return ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);
    const handleStateChange = ({ name: name, value: value })=>{
        const set = new Set(state);
        if (value) set.add(name);
        else set.delete(name);
        setState(set);
    };
    const { data: lessonConversion } = (0, $3ba76e806416b3fb$export$e2ee6cfef5cb8639)();
    if (lessonsRaw) {
        const lessons = (0, $3ba76e806416b3fb$export$f0633da393a66e49)((0, (/*@__PURE__*/$parcel$interopDefault($905bd22ff9c4e6ec$exports)))(lessonsRaw, 'jxbmc'), filterData, lessonConversion);
        const truncatedLessons = (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))(lessons, 'kch').slice(0, entries);
        const moreEntries = ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>setEntries((prev)=>Math.max(Math.min(prev + 100, lessons.length), 100)), 300);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
            className: "text-center mt-3"
        }, "\u5171 ", lessons.length, " \u6761\u8BB0\u5F55"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "table-responsive-md"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("table", {
            className: "table table-sm small sjtu-table"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("tr", null, $fe20ce721ac6c732$var$tableHeader.map((header)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("th", {
                scope: "col",
                className: "table-header",
                key: header
            }, header)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("tbody", null, truncatedLessons.map((lesson)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $05a862ee3145ca2d$export$2e2bcd8739ae039), {
                lesson: lesson,
                key: lesson.jxbmc,
                name: lesson.jxbmc,
                state: state.has(lesson.jxbmc),
                setState: handleStateChange,
                lessonConversion: lessonConversion
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $be4e32f110e8fc50$export$a62107ca74432f44), {
            as: "div",
            onChange: (inView)=>{
                if (inView) moreEntries();
            },
            className: "d-flex align-items-center justify-content-center mb-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($fe20ce721ac6c732$var$DataLoaded, {
            loaded: entries >= lessons.length,
            size: lessons.length
        }))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null);
};



var $lgFxF = parcelRequire("lgFxF");




var $lgFxF = parcelRequire("lgFxF");




var $lgFxF = parcelRequire("lgFxF");
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $427e2f753dd5e414$var$createChainedFunction() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.filter(function(f) {
        return f != null;
    }).reduce(function(acc, f) {
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            // @ts-ignore
            acc.apply(this, args); // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $427e2f753dd5e414$export$2e2bcd8739ae039 = $427e2f753dd5e414$var$createChainedFunction;


function $71ac44a388adb4f2$var$isTrivialHref(href) {
    return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */ var $71ac44a388adb4f2$var$SafeAnchor = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'a' : _ref$as, disabled = _ref.disabled, onKeyDown = _ref.onKeyDown, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "as",
        "disabled",
        "onKeyDown"
    ]);
    var handleClick = function handleClick(event) {
        var href = props.href, onClick = props.onClick;
        if (disabled || $71ac44a388adb4f2$var$isTrivialHref(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        if (onClick) onClick(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if ($71ac44a388adb4f2$var$isTrivialHref(props.href)) {
        props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
        // otherwise, the cursor incorrectly styled (except with role='button')
        props.href = props.href || '#';
    }
    if (disabled) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        ref: ref
    }, props, {
        onClick: handleClick,
        onKeyDown: (0, $427e2f753dd5e414$export$2e2bcd8739ae039)(handleKeyDown, onKeyDown)
    }));
});
$71ac44a388adb4f2$var$SafeAnchor.displayName = 'SafeAnchor';
var $71ac44a388adb4f2$export$2e2bcd8739ae039 = $71ac44a388adb4f2$var$SafeAnchor;


var $a1a8d87165bcf2e4$var$defaultProps = {
    variant: 'primary',
    active: false,
    disabled: false
};
var $a1a8d87165bcf2e4$var$Button = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, size = _ref.size, active = _ref.active, className = _ref.className, block = _ref.block, type = _ref.type, as = _ref.as, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "variant",
        "size",
        "active",
        "className",
        "block",
        "type",
        "as"
    ]);
    var prefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'btn');
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, prefix, active && 'active', prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);
    if (props.href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $71ac44a388adb4f2$export$2e2bcd8739ae039), (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        as: as,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(classes, props.disabled && 'disabled')
    }));
    if (ref) props.ref = ref;
    if (type) props.type = type;
    else if (!as) props.type = 'button';
    var Component = as || 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Component, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        className: classes
    }));
});
$a1a8d87165bcf2e4$var$Button.displayName = 'Button';
$a1a8d87165bcf2e4$var$Button.defaultProps = $a1a8d87165bcf2e4$var$defaultProps;
var $a1a8d87165bcf2e4$export$2e2bcd8739ae039 = $a1a8d87165bcf2e4$var$Button;





/* eslint-disable no-return-assign */ var $98c6a17ecec5a001$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $2fed9eb541717948$export$63fefd044b2bc624 = false;
var $2fed9eb541717948$export$a614c6b395900f69 = false;
try {
    var $2fed9eb541717948$var$options = {
        get passive () {
            return $2fed9eb541717948$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $2fed9eb541717948$export$a614c6b395900f69 = $2fed9eb541717948$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $98c6a17ecec5a001$export$2e2bcd8739ae039) {
        window.addEventListener('test', $2fed9eb541717948$var$options, $2fed9eb541717948$var$options);
        window.removeEventListener('test', $2fed9eb541717948$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 */ function $2fed9eb541717948$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$2fed9eb541717948$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$2fed9eb541717948$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $2fed9eb541717948$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $2fed9eb541717948$export$2e2bcd8739ae039 = $2fed9eb541717948$var$addEventListener;



function $245e3aba68bafc87$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $ab5c98d33580c25b$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $ab5c98d33580c25b$export$2e2bcd8739ae039 = $ab5c98d33580c25b$var$removeEventListener;



var $1eb8c68eae2b8f71$var$size;
function $1eb8c68eae2b8f71$export$2e2bcd8739ae039(recalc) {
    if (!$1eb8c68eae2b8f71$var$size && $1eb8c68eae2b8f71$var$size !== 0 || recalc) {
        if (0, $98c6a17ecec5a001$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $1eb8c68eae2b8f71$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $1eb8c68eae2b8f71$var$size;
}



var $lgFxF = parcelRequire("lgFxF");
function $085de9ed7fc34525$export$2e2bcd8739ae039() {
    return (0, $lgFxF.useState)(null);
}



var $lgFxF = parcelRequire("lgFxF");

var $lgFxF = parcelRequire("lgFxF");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded befor being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $839e84594fdf596e$var$useCommittedRef(value) {
    var ref = (0, $lgFxF.useRef)(value);
    (0, $lgFxF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $839e84594fdf596e$export$2e2bcd8739ae039 = $839e84594fdf596e$var$useCommittedRef;


function $3a4d8a077de3c6b2$export$2e2bcd8739ae039(fn) {
    var ref = (0, $839e84594fdf596e$export$2e2bcd8739ae039)(fn);
    return (0, $lgFxF.useCallback)(function() {
        return ref.current && ref.current.apply(ref, arguments);
    }, [
        ref
    ]);
}



var $lgFxF = parcelRequire("lgFxF");
function $02e5417bdbf4aafb$export$2e2bcd8739ae039(value) {
    var valueRef = (0, $lgFxF.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $lgFxF = parcelRequire("lgFxF");
function $0acac124d330e537$export$2e2bcd8739ae039(fn) {
    var onUnmount = (0, $02e5417bdbf4aafb$export$2e2bcd8739ae039)(fn);
    (0, $lgFxF.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}



function $75ddb78e4e12018a$export$2e2bcd8739ae039(node) {
    var doc = (0, $245e3aba68bafc87$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $288fff06df6fc0b8$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $75ddb78e4e12018a$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $871224c79918cc48$var$rUpper = /([A-Z])/g;
function $871224c79918cc48$export$2e2bcd8739ae039(string) {
    return string.replace($871224c79918cc48$var$rUpper, '-$1').toLowerCase();
}


var $a1c2286dae29374f$var$msPattern = /^ms-/;
function $a1c2286dae29374f$export$2e2bcd8739ae039(string) {
    return (0, $871224c79918cc48$export$2e2bcd8739ae039)(string).replace($a1c2286dae29374f$var$msPattern, '-ms-');
}


var $f81108e42537d80f$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $f81108e42537d80f$export$2e2bcd8739ae039(value) {
    return !!(value && $f81108e42537d80f$var$supportedTransforms.test(value));
}


function $67cec994e97c3399$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $a1c2286dae29374f$export$2e2bcd8739ae039)(property)) || (0, $288fff06df6fc0b8$export$2e2bcd8739ae039)(node).getPropertyValue((0, $a1c2286dae29374f$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $a1c2286dae29374f$export$2e2bcd8739ae039)(key));
        else if ((0, $f81108e42537d80f$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $a1c2286dae29374f$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $67cec994e97c3399$export$2e2bcd8739ae039 = $67cec994e97c3399$var$style;




function $498d97a5e79b828c$var$listen(node, eventName, handler, options) {
    (0, $2fed9eb541717948$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $ab5c98d33580c25b$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $498d97a5e79b828c$export$2e2bcd8739ae039 = $498d97a5e79b828c$var$listen;


function $0ff7e6bfb51d7969$var$parseDuration(node) {
    var str = (0, $67cec994e97c3399$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $0ff7e6bfb51d7969$var$triggerTransitionEnd(element) {
    var evt = document.createEvent('HTMLEvents');
    evt.initEvent('transitionend', true, true);
    element.dispatchEvent(evt);
}
function $0ff7e6bfb51d7969$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) $0ff7e6bfb51d7969$var$triggerTransitionEnd(element);
    }, duration + padding);
    var remove = (0, $498d97a5e79b828c$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $0ff7e6bfb51d7969$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $0ff7e6bfb51d7969$var$parseDuration(element) || 0;
    var removeEmulate = $0ff7e6bfb51d7969$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $498d97a5e79b828c$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}



var $lgFxF = parcelRequire("lgFxF");



function $126485d5fe33ed4c$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $245e3aba68bafc87$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ // HTML DOM and SVG DOM may have different support levels,
// so we need to check on context instead of a document root element.
function $cb8289be878c082c$export$2e2bcd8739ae039(context, node) {
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}






var $lgFxF = parcelRequire("lgFxF");

var $aBztI = parcelRequire("aBztI");

var $lgFxF = parcelRequire("lgFxF");
function $635aa8bd4d4a54da$export$2e2bcd8739ae039() {
    var mounted = (0, $lgFxF.useRef)(true);
    var isMounted = (0, $lgFxF.useRef)(function() {
        return mounted.current;
    });
    (0, $lgFxF.useEffect)(function() {
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}




var $lgFxF = parcelRequire("lgFxF");
function $f75c919b524117e1$export$2e2bcd8739ae039(value) {
    var ref = (0, $lgFxF.useRef)(null);
    (0, $lgFxF.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}



function $9774ad89ffd36f6d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $9b73a87c6c50b605$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $9774ad89ffd36f6d$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $8ec7d9408a0ae9dd$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $8ec7d9408a0ae9dd$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $8ec7d9408a0ae9dd$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $8ec7d9408a0ae9dd$var$replaceClassName(element.className && element.className.baseVal || '', className));
}




function $650a29ebdab03acf$export$2e2bcd8739ae039(element) {
    return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}


function $ba32b33a40c5d114$export$2e2bcd8739ae039(node) {
    if ('window' in node && node.window === node) return node;
    if ((0, $650a29ebdab03acf$export$2e2bcd8739ae039)(node)) return node.defaultView || false;
    return false;
}



function $6a184ab71f76e9a5$var$isBody(node) {
    return node && node.tagName.toLowerCase() === 'body';
}
function $6a184ab71f76e9a5$var$bodyIsOverflowing(node) {
    var doc = (0, $ba32b33a40c5d114$export$2e2bcd8739ae039)(node) ? (0, $245e3aba68bafc87$export$2e2bcd8739ae039)() : (0, $245e3aba68bafc87$export$2e2bcd8739ae039)(node);
    var win = (0, $ba32b33a40c5d114$export$2e2bcd8739ae039)(node) || doc.defaultView;
    return doc.body.clientWidth < win.innerWidth;
}
function $6a184ab71f76e9a5$export$2e2bcd8739ae039(container) {
    var win = (0, $ba32b33a40c5d114$export$2e2bcd8739ae039)(container);
    return win || $6a184ab71f76e9a5$var$isBody(container) ? $6a184ab71f76e9a5$var$bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}


var $28b4ead59181115b$var$BLACKLIST = [
    'template',
    'script',
    'style'
];
var $28b4ead59181115b$var$isHidable = function isHidable(_ref) {
    var nodeType = _ref.nodeType, tagName = _ref.tagName;
    return nodeType === 1 && $28b4ead59181115b$var$BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};
var $28b4ead59181115b$var$siblings = function siblings(container, exclude, cb) {
    [].forEach.call(container.children, function(node) {
        if (exclude.indexOf(node) === -1 && $28b4ead59181115b$var$isHidable(node)) cb(node);
    });
};
function $28b4ead59181115b$export$e1bd0c6150f13d96(hide, node) {
    if (!node) return;
    if (hide) node.setAttribute('aria-hidden', 'true');
    else node.removeAttribute('aria-hidden');
}
function $28b4ead59181115b$export$18dbef20832f547a(container, _ref2) {
    var dialog = _ref2.dialog, backdrop = _ref2.backdrop;
    $28b4ead59181115b$var$siblings(container, [
        dialog,
        backdrop
    ], function(node) {
        return $28b4ead59181115b$export$e1bd0c6150f13d96(true, node);
    });
}
function $28b4ead59181115b$export$9b9b63d3e0115d40(container, _ref3) {
    var dialog = _ref3.dialog, backdrop = _ref3.backdrop;
    $28b4ead59181115b$var$siblings(container, [
        dialog,
        backdrop
    ], function(node) {
        return $28b4ead59181115b$export$e1bd0c6150f13d96(false, node);
    });
}


function $32c4c4cf02996377$var$findIndexOf(arr, cb) {
    var idx = -1;
    arr.some(function(d, i) {
        if (cb(d, i)) {
            idx = i;
            return true;
        }
        return false;
    });
    return idx;
}
/**
 * Proper state management for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */ var $32c4c4cf02996377$var$ModalManager = /*#__PURE__*/ function() {
    function ModalManager(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$hideSiblingNodes = _ref.hideSiblingNodes, hideSiblingNodes = _ref$hideSiblingNodes === void 0 ? true : _ref$hideSiblingNodes, _ref$handleContainerO = _ref.handleContainerOverflow, handleContainerOverflow = _ref$handleContainerO === void 0 ? true : _ref$handleContainerO;
        this.hideSiblingNodes = void 0;
        this.handleContainerOverflow = void 0;
        this.modals = void 0;
        this.containers = void 0;
        this.data = void 0;
        this.scrollbarSize = void 0;
        this.hideSiblingNodes = hideSiblingNodes;
        this.handleContainerOverflow = handleContainerOverflow;
        this.modals = [];
        this.containers = [];
        this.data = [];
        this.scrollbarSize = (0, $1eb8c68eae2b8f71$export$2e2bcd8739ae039)();
    }
    var _proto = ModalManager.prototype;
    _proto.isContainerOverflowing = function isContainerOverflowing(modal) {
        var data = this.data[this.containerIndexFromModal(modal)];
        return data && data.overflowing;
    };
    _proto.containerIndexFromModal = function containerIndexFromModal(modal) {
        return $32c4c4cf02996377$var$findIndexOf(this.data, function(d) {
            return d.modals.indexOf(modal) !== -1;
        });
    };
    _proto.setContainerStyle = function setContainerStyle(containerState, container) {
        var style = {
            overflow: 'hidden'
        }; // we are only interested in the actual `style` here
        // because we will override it
        containerState.style = {
            overflow: container.style.overflow,
            paddingRight: container.style.paddingRight
        };
        if (containerState.overflowing) // use computed style, here to get the real padding
        // to add our scrollbar width
        style.paddingRight = parseInt((0, $67cec994e97c3399$export$2e2bcd8739ae039)(container, 'paddingRight') || '0', 10) + this.scrollbarSize + "px";
        (0, $67cec994e97c3399$export$2e2bcd8739ae039)(container, style);
    };
    _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
        Object.assign(container.style, containerState.style);
    };
    _proto.add = function add(modal, container, className) {
        var modalIdx = this.modals.indexOf(modal);
        var containerIdx = this.containers.indexOf(container);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        if (this.hideSiblingNodes) (0, $28b4ead59181115b$export$18dbef20832f547a)(container, modal);
        if (containerIdx !== -1) {
            this.data[containerIdx].modals.push(modal);
            return modalIdx;
        }
        var data = {
            modals: [
                modal
            ],
            // right now only the first modal of a container will have its classes applied
            classes: className ? className.split(/\s+/) : [],
            overflowing: (0, $6a184ab71f76e9a5$export$2e2bcd8739ae039)(container)
        };
        if (this.handleContainerOverflow) this.setContainerStyle(data, container);
        data.classes.forEach((0, $9b73a87c6c50b605$export$2e2bcd8739ae039).bind(null, container));
        this.containers.push(container);
        this.data.push(data);
        return modalIdx;
    };
    _proto.remove = function remove(modal) {
        var modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        var containerIdx = this.containerIndexFromModal(modal);
        var data = this.data[containerIdx];
        var container = this.containers[containerIdx];
        data.modals.splice(data.modals.indexOf(modal), 1);
        this.modals.splice(modalIdx, 1); // if that was the last modal in a container,
        // clean up the container
        if (data.modals.length === 0) {
            data.classes.forEach((0, $8ec7d9408a0ae9dd$export$2e2bcd8739ae039).bind(null, container));
            if (this.handleContainerOverflow) this.removeContainerStyle(data, container);
            if (this.hideSiblingNodes) (0, $28b4ead59181115b$export$9b9b63d3e0115d40)(container, modal);
            this.containers.splice(containerIdx, 1);
            this.data.splice(containerIdx, 1);
        } else if (this.hideSiblingNodes) {
            // otherwise make sure the next top modal is visible to a SR
            var _data$modals = data.modals[data.modals.length - 1], backdrop = _data$modals.backdrop, dialog = _data$modals.dialog;
            (0, $28b4ead59181115b$export$e1bd0c6150f13d96)(false, dialog);
            (0, $28b4ead59181115b$export$e1bd0c6150f13d96)(false, backdrop);
        }
    };
    _proto.isTopModal = function isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    };
    return ModalManager;
}();
var $32c4c4cf02996377$export$2e2bcd8739ae039 = $32c4c4cf02996377$var$ModalManager;




var $lgFxF = parcelRequire("lgFxF");
var $01467ec95b79e9ba$export$c91fd81e6d65f84a = function resolveContainerRef(ref) {
    var _ref;
    if (typeof document === 'undefined') return null;
    if (ref == null) return (0, $245e3aba68bafc87$export$2e2bcd8739ae039)().body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if ((_ref = ref) == null ? void 0 : _ref.nodeType) return ref || null;
    return null;
};
function $01467ec95b79e9ba$export$2e2bcd8739ae039(ref, onResolved) {
    var _useState = (0, $lgFxF.useState)(function() {
        return $01467ec95b79e9ba$export$c91fd81e6d65f84a(ref);
    }), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $01467ec95b79e9ba$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $lgFxF.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $lgFxF.useEffect)(function() {
        var nextRef = $01467ec95b79e9ba$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}


var $bfff20e23f02ddf4$var$manager;
function $bfff20e23f02ddf4$var$getManager() {
    if (!$bfff20e23f02ddf4$var$manager) $bfff20e23f02ddf4$var$manager = new (0, $32c4c4cf02996377$export$2e2bcd8739ae039)();
    return $bfff20e23f02ddf4$var$manager;
}
function $bfff20e23f02ddf4$var$useModalManager(provided) {
    var modalManager = provided || $bfff20e23f02ddf4$var$getManager();
    var modal = (0, $lgFxF.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: function add(container, className) {
            return modalManager.add(modal.current, container, className);
        },
        remove: function remove() {
            return modalManager.remove(modal.current);
        },
        isTopModal: function isTopModal() {
            return modalManager.isTopModal(modal.current);
        },
        setDialogRef: (0, $lgFxF.useCallback)(function(ref) {
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $lgFxF.useCallback)(function(ref) {
            modal.current.backdrop = ref;
        }, [])
    });
}
var $bfff20e23f02ddf4$var$Modal = /*#__PURE__*/ (0, $lgFxF.forwardRef)(function(_ref, ref) {
    var _ref$show = _ref.show, show = _ref$show === void 0 ? false : _ref$show, _ref$role = _ref.role, role = _ref$role === void 0 ? 'dialog' : _ref$role, className = _ref.className, style = _ref.style, children = _ref.children, _ref$backdrop = _ref.backdrop, backdrop = _ref$backdrop === void 0 ? true : _ref$backdrop, _ref$keyboard = _ref.keyboard, keyboard = _ref$keyboard === void 0 ? true : _ref$keyboard, onBackdropClick = _ref.onBackdropClick, onEscapeKeyDown = _ref.onEscapeKeyDown, transition = _ref.transition, backdropTransition = _ref.backdropTransition, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$enforceFocus = _ref.enforceFocus, enforceFocus = _ref$enforceFocus === void 0 ? true : _ref$enforceFocus, _ref$restoreFocus = _ref.restoreFocus, restoreFocus = _ref$restoreFocus === void 0 ? true : _ref$restoreFocus, restoreFocusOptions = _ref.restoreFocusOptions, renderDialog = _ref.renderDialog, _ref$renderBackdrop = _ref.renderBackdrop, renderBackdrop = _ref$renderBackdrop === void 0 ? function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", props);
    } : _ref$renderBackdrop, providedManager = _ref.manager, containerRef = _ref.container, containerClassName = _ref.containerClassName, onShow = _ref.onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? function() {} : _ref$onHide, onExit = _ref.onExit, onExited = _ref.onExited, onExiting = _ref.onExiting, onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered, rest = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "show",
        "role",
        "className",
        "style",
        "children",
        "backdrop",
        "keyboard",
        "onBackdropClick",
        "onEscapeKeyDown",
        "transition",
        "backdropTransition",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "renderDialog",
        "renderBackdrop",
        "manager",
        "container",
        "containerClassName",
        "onShow",
        "onHide",
        "onExit",
        "onExited",
        "onExiting",
        "onEnter",
        "onEntering",
        "onEntered"
    ]);
    var container = (0, $01467ec95b79e9ba$export$2e2bcd8739ae039)(containerRef);
    var modal = $bfff20e23f02ddf4$var$useModalManager(providedManager);
    var isMounted = (0, $635aa8bd4d4a54da$export$2e2bcd8739ae039)();
    var prevShow = (0, $f75c919b524117e1$export$2e2bcd8739ae039)(show);
    var _useState = (0, $lgFxF.useState)(!show), exited = _useState[0], setExited = _useState[1];
    var lastFocusRef = (0, $lgFxF.useRef)(null);
    (0, $lgFxF.useImperativeHandle)(ref, function() {
        return modal;
    }, [
        modal
    ]);
    if ((0, $98c6a17ecec5a001$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $126485d5fe33ed4c$export$2e2bcd8739ae039)();
    if (!transition && !show && !exited) setExited(true);
    else if (show && exited) setExited(false);
    var handleShow = (0, $3a4d8a077de3c6b2$export$2e2bcd8739ae039)(function() {
        modal.add(container, containerClassName);
        removeKeydownListenerRef.current = (0, $498d97a5e79b828c$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $498d97a5e79b828c$export$2e2bcd8739ae039)(document, 'focus', // and so steals focus from it
        function() {
            return setTimeout(handleEnforceFocus);
        }, true);
        if (onShow) onShow();
         // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var currentActiveElement = (0, $126485d5fe33ed4c$export$2e2bcd8739ae039)(document);
            if (modal.dialog && currentActiveElement && !(0, $cb8289be878c082c$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    var handleHide = (0, $3a4d8a077de3c6b2$export$2e2bcd8739ae039)(function() {
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    }); // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $lgFxF.useEffect)(function() {
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]); // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $lgFxF.useEffect)(function() {
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $0acac124d330e537$export$2e2bcd8739ae039)(function() {
        handleHide();
    }); // --------------------------------
    var handleEnforceFocus = (0, $3a4d8a077de3c6b2$export$2e2bcd8739ae039)(function() {
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        var currentActiveElement = (0, $126485d5fe33ed4c$export$2e2bcd8739ae039)();
        if (modal.dialog && currentActiveElement && !(0, $cb8289be878c082c$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    var handleBackdropClick = (0, $3a4d8a077de3c6b2$export$2e2bcd8739ae039)(function(e) {
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    var handleDocumentKeyDown = (0, $3a4d8a077de3c6b2$export$2e2bcd8739ae039)(function(e) {
        if (keyboard && e.keyCode === 27 && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    var removeFocusListenerRef = (0, $lgFxF.useRef)();
    var removeKeydownListenerRef = (0, $lgFxF.useRef)();
    var handleHidden = function handleHidden() {
        setExited(true);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        onExited == null || onExited.apply(void 0, args);
    };
    var Transition = transition;
    if (!container || !(show || Transition && !exited)) return null;
    var dialogProps = (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    var dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", dialogProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).cloneElement(children, {
        role: 'document'
    }));
    if (Transition) dialog = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Transition, {
        appear: true,
        unmountOnExit: true,
        "in": !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    }, dialog);
    var backdropElement = null;
    if (backdrop) {
        var BackdropTransition = backdropTransition;
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        if (BackdropTransition) backdropElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(BackdropTransition, {
            appear: true,
            "in": !!show
        }, backdropElement);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aBztI))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, backdropElement, dialog), container));
});
var $bfff20e23f02ddf4$var$propTypes = {
    /**
   * Set the visibility of the Modal
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).bool,
    /**
   * A DOM element, a `ref` to an element, or function that returns either. The Modal is appended to it's `container` element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).any,
    /**
   * A callback fired when the Modal is opening.
   */ onShow: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */ onHide: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * Include a backdrop component.
   */ backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).oneOf([
            'static'
        ])
    ]),
    /**
   * A function that returns the dialog component. Useful for custom
   * rendering. **Note:** the component should make sure to apply the provided ref.
   *
   * ```js static
   * renderDialog={props => <MyDialog {...props} />}
   * ```
   */ renderDialog: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */ renderBackdrop: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   *
   * If preventDefault() is called on the keyboard event, closing the modal will be cancelled.
   */ onEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * A callback fired when the backdrop, if specified, is clicked.
   */ onBackdropClick: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */ containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).string,
    /**
   * Close the modal when escape key is pressed
   */ keyboard: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).bool,
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */ transition: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).elementType,
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */ backdropTransition: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).elementType,
    /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).bool,
    /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */ enforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).bool,
    /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */ restoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).bool,
    /**
   * Options passed to focus function when `restoreFocus` is set to `true`
   *
   * @link  https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Parameters
   */ restoreFocusOptions: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).shape({
        preventScroll: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).bool
    }),
    /**
   * Callback fired before the Modal transitions in
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * Callback fired as the Modal begins to transition in
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * Callback fired after the Modal finishes transitioning in
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * Callback fired right before the Modal transitions out
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * Callback fired as the Modal begins to transition out
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * Callback fired after the Modal finishes transitioning out
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func,
    /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */ manager: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).instanceOf((0, $32c4c4cf02996377$export$2e2bcd8739ae039))
};
$bfff20e23f02ddf4$var$Modal.displayName = 'Modal';
$bfff20e23f02ddf4$var$Modal.propTypes = $bfff20e23f02ddf4$var$propTypes;
var $bfff20e23f02ddf4$export$2e2bcd8739ae039 = Object.assign($bfff20e23f02ddf4$var$Modal, {
    Manager: (0, $32c4c4cf02996377$export$2e2bcd8739ae039)
});





var $4b8dbd241e792bd8$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $4b8dbd241e792bd8$export$2e2bcd8739ae039(element, selector) {
    return $4b8dbd241e792bd8$var$toArray(element.querySelectorAll(selector));
}




var $76b9f8b52965985d$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
var $76b9f8b52965985d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_ModalManager) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(BootstrapModalManager, _ModalManager);
    function BootstrapModalManager() {
        return _ModalManager.apply(this, arguments) || this;
    }
    var _proto = BootstrapModalManager.prototype;
    _proto.adjustAndStore = function adjustAndStore(prop, element, adjust) {
        var _css;
        var actual = element.style[prop]; // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $67cec994e97c3399$export$2e2bcd8739ae039)(element, (_css = {}, _css[prop] = parseFloat((0, $67cec994e97c3399$export$2e2bcd8739ae039)(element, prop)) + adjust + "px", _css));
    };
    _proto.restore = function restore(prop, element) {
        var value = element.dataset[prop];
        if (value !== undefined) {
            var _css2;
            delete element.dataset[prop];
            (0, $67cec994e97c3399$export$2e2bcd8739ae039)(element, (_css2 = {}, _css2[prop] = value, _css2));
        }
    };
    _proto.setContainerStyle = function setContainerStyle(containerState, container) {
        var _this = this;
        _ModalManager.prototype.setContainerStyle.call(this, containerState, container);
        if (!containerState.overflowing) return;
        var size = (0, $1eb8c68eae2b8f71$export$2e2bcd8739ae039)();
        (0, $4b8dbd241e792bd8$export$2e2bcd8739ae039)(container, $76b9f8b52965985d$var$Selector.FIXED_CONTENT).forEach(function(el) {
            return _this.adjustAndStore('paddingRight', el, size);
        });
        (0, $4b8dbd241e792bd8$export$2e2bcd8739ae039)(container, $76b9f8b52965985d$var$Selector.STICKY_CONTENT).forEach(function(el) {
            return _this.adjustAndStore('marginRight', el, -size);
        });
        (0, $4b8dbd241e792bd8$export$2e2bcd8739ae039)(container, $76b9f8b52965985d$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
            return _this.adjustAndStore('marginRight', el, size);
        });
    };
    _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
        var _this2 = this;
        _ModalManager.prototype.removeContainerStyle.call(this, containerState, container);
        (0, $4b8dbd241e792bd8$export$2e2bcd8739ae039)(container, $76b9f8b52965985d$var$Selector.FIXED_CONTENT).forEach(function(el) {
            return _this2.restore('paddingRight', el);
        });
        (0, $4b8dbd241e792bd8$export$2e2bcd8739ae039)(container, $76b9f8b52965985d$var$Selector.STICKY_CONTENT).forEach(function(el) {
            return _this2.restore('marginRight', el);
        });
        (0, $4b8dbd241e792bd8$export$2e2bcd8739ae039)(container, $76b9f8b52965985d$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
            return _this2.restore('marginRight', el);
        });
    };
    return BootstrapModalManager;
}((0, $32c4c4cf02996377$export$2e2bcd8739ae039));







var $lgFxF = parcelRequire("lgFxF");




var $lgFxF = parcelRequire("lgFxF");

var $aBztI = parcelRequire("aBztI");
var $4fa2ff96f4b3ee40$export$2e2bcd8739ae039 = {
    disabled: false
};




var $lgFxF = parcelRequire("lgFxF");
var $21ad0f5648c1ebff$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createContext(null);


var $f29916a471284fd2$export$bb38bb9a1161268 = 'unmounted';
var $f29916a471284fd2$export$84cbff306f539230 = 'exited';
var $f29916a471284fd2$export$df38205c966be359 = 'entering';
var $f29916a471284fd2$export$78e9e6e3e014d60a = 'entered';
var $f29916a471284fd2$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $f29916a471284fd2$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $fbf48de18e303cae$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $f29916a471284fd2$export$84cbff306f539230;
                _this.appearStatus = $f29916a471284fd2$export$df38205c966be359;
            } else initialStatus = $f29916a471284fd2$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $f29916a471284fd2$export$bb38bb9a1161268;
        else initialStatus = $f29916a471284fd2$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $f29916a471284fd2$export$bb38bb9a1161268) return {
            status: $f29916a471284fd2$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $f29916a471284fd2$export$df38205c966be359 && status !== $f29916a471284fd2$export$78e9e6e3e014d60a) nextStatus = $f29916a471284fd2$export$df38205c966be359;
            } else if (status === $f29916a471284fd2$export$df38205c966be359 || status === $f29916a471284fd2$export$78e9e6e3e014d60a) nextStatus = $f29916a471284fd2$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $f29916a471284fd2$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $f29916a471284fd2$export$84cbff306f539230) this.setState({
            status: $f29916a471284fd2$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($aBztI))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $4fa2ff96f4b3ee40$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $f29916a471284fd2$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $f29916a471284fd2$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $f29916a471284fd2$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($aBztI))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $4fa2ff96f4b3ee40$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $f29916a471284fd2$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $f29916a471284fd2$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $f29916a471284fd2$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($aBztI))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $f29916a471284fd2$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $21ad0f5648c1ebff$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Component);
$f29916a471284fd2$var$Transition.contextType = (0, $21ad0f5648c1ebff$export$2e2bcd8739ae039);
$f29916a471284fd2$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $f29916a471284fd2$var$noop() {}
$f29916a471284fd2$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $f29916a471284fd2$var$noop,
    onEntering: $f29916a471284fd2$var$noop,
    onEntered: $f29916a471284fd2$var$noop,
    onExit: $f29916a471284fd2$var$noop,
    onExiting: $f29916a471284fd2$var$noop,
    onExited: $f29916a471284fd2$var$noop
};
$f29916a471284fd2$var$Transition.UNMOUNTED = $f29916a471284fd2$export$bb38bb9a1161268;
$f29916a471284fd2$var$Transition.EXITED = $f29916a471284fd2$export$84cbff306f539230;
$f29916a471284fd2$var$Transition.ENTERING = $f29916a471284fd2$export$df38205c966be359;
$f29916a471284fd2$var$Transition.ENTERED = $f29916a471284fd2$export$78e9e6e3e014d60a;
$f29916a471284fd2$var$Transition.EXITING = $f29916a471284fd2$export$4aacc83d4d59139f;
var $f29916a471284fd2$export$2e2bcd8739ae039 = $f29916a471284fd2$var$Transition;


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $6bc6a43820f0d10b$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}


var $1c31fb221d4f2c60$var$_fadeStyles;
var $1c31fb221d4f2c60$var$defaultProps = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false
};
var $1c31fb221d4f2c60$var$fadeStyles = ($1c31fb221d4f2c60$var$_fadeStyles = {}, $1c31fb221d4f2c60$var$_fadeStyles[0, $f29916a471284fd2$export$df38205c966be359] = 'show', $1c31fb221d4f2c60$var$_fadeStyles[0, $f29916a471284fd2$export$78e9e6e3e014d60a] = 'show', $1c31fb221d4f2c60$var$_fadeStyles);
var $1c31fb221d4f2c60$var$Fade = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var className = _ref.className, children = _ref.children, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "className",
        "children"
    ]);
    var handleEnter = (0, $lgFxF.useCallback)(function(node) {
        (0, $6bc6a43820f0d10b$export$2e2bcd8739ae039)(node);
        if (props.onEnter) props.onEnter(node);
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $f29916a471284fd2$export$2e2bcd8739ae039), (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        ref: ref,
        addEndListener: (0, $0ff7e6bfb51d7969$export$2e2bcd8739ae039)
    }, props, {
        onEnter: handleEnter
    }), function(status, innerProps) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).cloneElement(children, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, innerProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))('fade', className, children.props.className, $1c31fb221d4f2c60$var$fadeStyles[status])
        }));
    });
});
$1c31fb221d4f2c60$var$Fade.defaultProps = $1c31fb221d4f2c60$var$defaultProps;
$1c31fb221d4f2c60$var$Fade.displayName = 'Fade';
var $1c31fb221d4f2c60$export$2e2bcd8739ae039 = $1c31fb221d4f2c60$var$Fade;



var $fd40f486998554f1$export$2e2bcd8739ae039 = (0, $24bed91c55d410a8$export$2e2bcd8739ae039)('modal-body');



var $lgFxF = parcelRequire("lgFxF");
var $a7f77f924723b111$var$ModalContext = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide: function onHide() {}
});
var $a7f77f924723b111$export$2e2bcd8739ae039 = $a7f77f924723b111$var$ModalContext;






var $lgFxF = parcelRequire("lgFxF");

var $e9ab71ef0101f720$var$ModalDialog = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, centered = _ref.centered, size = _ref.size, children = _ref.children, scrollable = _ref.scrollable, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "className",
        "centered",
        "size",
        "children",
        "scrollable"
    ]);
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'modal');
    var dialogClass = bsPrefix + "-dialog";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(dialogClass, className, size && bsPrefix + "-" + size, centered && dialogClass + "-centered", scrollable && dialogClass + "-scrollable")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: bsPrefix + "-content"
    }, children));
});
$e9ab71ef0101f720$var$ModalDialog.displayName = 'ModalDialog';
var $e9ab71ef0101f720$export$2e2bcd8739ae039 = $e9ab71ef0101f720$var$ModalDialog;



var $d961584b8a86cfc7$export$2e2bcd8739ae039 = (0, $24bed91c55d410a8$export$2e2bcd8739ae039)('modal-footer');






var $lgFxF = parcelRequire("lgFxF");






var $lgFxF = parcelRequire("lgFxF");

var $d01d20b135b415b7$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($09247dea77919ddb$exports))).func
};
var $d01d20b135b415b7$var$defaultProps = {
    label: 'Close'
};
var $d01d20b135b415b7$var$CloseButton = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var label = _ref.label, onClick = _ref.onClick, className = _ref.className, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "label",
        "onClick",
        "className"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("button", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))('close', className),
        onClick: onClick
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        "aria-hidden": "true"
    }, "\xD7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "sr-only"
    }, label));
});
$d01d20b135b415b7$var$CloseButton.displayName = 'CloseButton';
$d01d20b135b415b7$var$CloseButton.propTypes = $d01d20b135b415b7$var$propTypes;
$d01d20b135b415b7$var$CloseButton.defaultProps = $d01d20b135b415b7$var$defaultProps;
var $d01d20b135b415b7$export$2e2bcd8739ae039 = $d01d20b135b415b7$var$CloseButton;



var $4cb3248f21c5e614$var$defaultProps = {
    closeLabel: 'Close',
    closeButton: false
};
var $4cb3248f21c5e614$var$ModalHeader = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, closeLabel = _ref.closeLabel, closeButton = _ref.closeButton, onHide = _ref.onHide, className = _ref.className, children = _ref.children, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "closeLabel",
        "closeButton",
        "onHide",
        "className",
        "children"
    ]);
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    var context = (0, $lgFxF.useContext)((0, $a7f77f924723b111$export$2e2bcd8739ae039));
    var handleClick = (0, $3a4d8a077de3c6b2$export$2e2bcd8739ae039)(function() {
        if (context) context.onHide();
        if (onHide) onHide();
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix)
    }), children, closeButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $d01d20b135b415b7$export$2e2bcd8739ae039), {
        label: closeLabel,
        onClick: handleClick
    }));
});
$4cb3248f21c5e614$var$ModalHeader.displayName = 'ModalHeader';
$4cb3248f21c5e614$var$ModalHeader.defaultProps = $4cb3248f21c5e614$var$defaultProps;
var $4cb3248f21c5e614$export$2e2bcd8739ae039 = $4cb3248f21c5e614$var$ModalHeader;





var $lgFxF = parcelRequire("lgFxF");

var $9eca7b7728c1f12b$export$2e2bcd8739ae039 = function(className) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(p, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, p, {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(p.className, className)
        }));
    });
};


var $ab6d657007d6cea9$var$DivStyledAsH4 = (0, $9eca7b7728c1f12b$export$2e2bcd8739ae039)('h4');
var $ab6d657007d6cea9$export$2e2bcd8739ae039 = (0, $24bed91c55d410a8$export$2e2bcd8739ae039)('modal-title', {
    Component: $ab6d657007d6cea9$var$DivStyledAsH4
});



var $2839459eb12fe5fa$var$manager;
var $2839459eb12fe5fa$var$defaultProps = {
    show: false,
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    enforceFocus: true,
    restoreFocus: true,
    animation: true,
    dialogAs: (0, $e9ab71ef0101f720$export$2e2bcd8739ae039)
};
/* eslint-disable no-use-before-define, react/no-multi-comp */ function $2839459eb12fe5fa$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $1c31fb221d4f2c60$export$2e2bcd8739ae039), props);
}
function $2839459eb12fe5fa$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $1c31fb221d4f2c60$export$2e2bcd8739ae039), props);
}
/* eslint-enable no-use-before-define */ var $2839459eb12fe5fa$var$Modal = (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, style = _ref.style, dialogClassName = _ref.dialogClassName, children = _ref.children, Dialog = _ref.dialogAs, ariaLabelledby = _ref['aria-labelledby'], show = _ref.show, animation = _ref.animation, backdrop = _ref.backdrop, keyboard = _ref.keyboard, onEscapeKeyDown = _ref.onEscapeKeyDown, onShow = _ref.onShow, onHide = _ref.onHide, container = _ref.container, autoFocus = _ref.autoFocus, enforceFocus = _ref.enforceFocus, restoreFocus = _ref.restoreFocus, restoreFocusOptions = _ref.restoreFocusOptions, onEntered = _ref.onEntered, onExit = _ref.onExit, onExiting = _ref.onExiting, onEnter = _ref.onEnter, onEntering = _ref.onEntering, onExited = _ref.onExited, backdropClassName = _ref.backdropClassName, propsManager = _ref.manager, props = (0, $f708a45bab77cec9$export$2e2bcd8739ae039)(_ref, [
        "bsPrefix",
        "className",
        "style",
        "dialogClassName",
        "children",
        "dialogAs",
        "aria-labelledby",
        "show",
        "animation",
        "backdrop",
        "keyboard",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager"
    ]);
    var _useState = (0, $lgFxF.useState)({}), modalStyle = _useState[0], setStyle = _useState[1];
    var _useState2 = (0, $lgFxF.useState)(false), animateStaticModal = _useState2[0], setAnimateStaticModal = _useState2[1];
    var waitingForMouseUpRef = (0, $lgFxF.useRef)(false);
    var ignoreBackdropClickRef = (0, $lgFxF.useRef)(false);
    var removeStaticModalAnimationRef = (0, $lgFxF.useRef)(null); // TODO: what's this type
    var _useCallbackRef = (0, $085de9ed7fc34525$export$2e2bcd8739ae039)(), modal = _useCallbackRef[0], setModalRef = _useCallbackRef[1];
    var handleHide = (0, $3a4d8a077de3c6b2$export$2e2bcd8739ae039)(onHide);
    bsPrefix = (0, $c3e34bc7febff4e7$export$7f387860ebffb32c)(bsPrefix, 'modal');
    (0, $lgFxF.useImperativeHandle)(ref, function() {
        return {
            get _modal () {
                return modal;
            }
        };
    }, [
        modal
    ]);
    var modalContext = (0, $lgFxF.useMemo)(function() {
        return {
            onHide: handleHide
        };
    }, [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (!$2839459eb12fe5fa$var$manager) $2839459eb12fe5fa$var$manager = new (0, $76b9f8b52965985d$export$2e2bcd8739ae039)();
        return $2839459eb12fe5fa$var$manager;
    }
    function updateDialogStyle(node) {
        if (!(0, $98c6a17ecec5a001$export$2e2bcd8739ae039)) return;
        var containerIsOverflowing = getModalManager().isContainerOverflowing(modal);
        var modalIsOverflowing = node.scrollHeight > (0, $245e3aba68bafc87$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $1eb8c68eae2b8f71$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $1eb8c68eae2b8f71$export$2e2bcd8739ae039)() : undefined
        });
    }
    var handleWindowResize = (0, $3a4d8a077de3c6b2$export$2e2bcd8739ae039)(function() {
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $0acac124d330e537$export$2e2bcd8739ae039)(function() {
        (0, $ab5c98d33580c25b$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        if (removeStaticModalAnimationRef.current) removeStaticModalAnimationRef.current();
    }); // We prevent the modal from closing during a drag by detecting where the
    // the click originates from. If it starts in the modal and then ends outside
    // don't close.
    var handleDialogMouseDown = function handleDialogMouseDown() {
        waitingForMouseUpRef.current = true;
    };
    var handleMouseUp = function handleMouseUp(e) {
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    var handleStaticModalAnimation = function handleStaticModalAnimation() {
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $0ff7e6bfb51d7969$export$2e2bcd8739ae039)(modal.dialog, function() {
            setAnimateStaticModal(false);
        });
    };
    var handleStaticBackdropClick = function handleStaticBackdropClick(e) {
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    var handleClick = function handleClick(e) {
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide();
    };
    var handleEscapeKeyDown = function handleEscapeKeyDown(e) {
        if (!keyboard && backdrop === 'static') {
            // Call preventDefault to stop modal from closing in react-overlays,
            // then play our animation.
            e.preventDefault();
            handleStaticModalAnimation();
        } else if (keyboard && onEscapeKeyDown) onEscapeKeyDown(e);
    };
    var handleEnter = function handleEnter(node) {
        if (node) {
            node.style.display = 'block';
            updateDialogStyle(node);
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (onEnter) onEnter.apply(void 0, [
            node
        ].concat(args));
    };
    var handleExit = function handleExit(node) {
        if (removeStaticModalAnimationRef.current) removeStaticModalAnimationRef.current();
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (onExit) onExit.apply(void 0, [
            node
        ].concat(args));
    };
    var handleEntering = function handleEntering(node) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        if (onEntering) onEntering.apply(void 0, [
            node
        ].concat(args)); // FIXME: This should work even when animation is disabled.
        (0, $2fed9eb541717948$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    var handleExited = function handleExited(node) {
        if (node) node.style.display = ''; // RHL removes it sometimes
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        if (onExited) onExited.apply(void 0, args); // FIXME: This should work even when animation is disabled.
        (0, $ab5c98d33580c25b$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    var renderBackdrop = (0, $lgFxF.useCallback)(function(backdropProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, backdropProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(bsPrefix + "-backdrop", backdropClassName, !animation && 'show')
        }));
    }, [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    var baseModalStyle = (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, style, {}, modalStyle); // Sets `display` always block when `animation` is false
    if (!animation) baseModalStyle.display = 'block';
    var renderDialog = function renderDialog(dialogProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({
            role: "dialog"
        }, dialogProps, {
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e600bd6cf307b673$exports)))(className, bsPrefix, animateStaticModal && bsPrefix + "-static"),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "aria-labelledby": ariaLabelledby
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement(Dialog, (0, $807f637a155dfb5a$export$2e2bcd8739ae039)({}, props, {
            role: "document",
            onMouseDown: handleDialogMouseDown,
            className: dialogClassName
        }), children));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $a7f77f924723b111$export$2e2bcd8739ae039).Provider, {
        value: modalContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $bfff20e23f02ddf4$export$2e2bcd8739ae039), {
        show: show,
        ref: setModalRef,
        backdrop: backdrop,
        container: container,
        keyboard: true // Always set true - see handleEscapeKeyDown
        ,
        autoFocus: autoFocus,
        enforceFocus: enforceFocus,
        restoreFocus: restoreFocus,
        restoreFocusOptions: restoreFocusOptions,
        onEscapeKeyDown: handleEscapeKeyDown,
        onShow: onShow,
        onHide: onHide,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: onEntered,
        onExit: handleExit,
        onExiting: onExiting,
        onExited: handleExited,
        manager: getModalManager(),
        containerClassName: bsPrefix + "-open",
        transition: animation ? $2839459eb12fe5fa$var$DialogTransition : undefined,
        backdropTransition: animation ? $2839459eb12fe5fa$var$BackdropTransition : undefined,
        renderBackdrop: renderBackdrop,
        renderDialog: renderDialog
    }));
});
$2839459eb12fe5fa$var$Modal.displayName = 'Modal';
$2839459eb12fe5fa$var$Modal.defaultProps = $2839459eb12fe5fa$var$defaultProps;
$2839459eb12fe5fa$var$Modal.Body = (0, $fd40f486998554f1$export$2e2bcd8739ae039);
$2839459eb12fe5fa$var$Modal.Header = (0, $4cb3248f21c5e614$export$2e2bcd8739ae039);
$2839459eb12fe5fa$var$Modal.Title = (0, $ab6d657007d6cea9$export$2e2bcd8739ae039);
$2839459eb12fe5fa$var$Modal.Footer = (0, $d961584b8a86cfc7$export$2e2bcd8739ae039);
$2839459eb12fe5fa$var$Modal.Dialog = (0, $e9ab71ef0101f720$export$2e2bcd8739ae039);
$2839459eb12fe5fa$var$Modal.TRANSITION_DURATION = 300;
$2839459eb12fe5fa$var$Modal.BACKDROP_TRANSITION_DURATION = 150;
var $2839459eb12fe5fa$export$2e2bcd8739ae039 = $2839459eb12fe5fa$var$Modal;


function $5a66e6f268a4f18c$export$2e2bcd8739ae039({ show: show, nextStep: nextStep }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $2839459eb12fe5fa$export$2e2bcd8739ae039), {
        show: show
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $2839459eb12fe5fa$export$2e2bcd8739ae039).Header, {
        closeButton: true,
        onHide: ()=>nextStep(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $2839459eb12fe5fa$export$2e2bcd8739ae039).Title, null, "jAccount \u6388\u6743")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $2839459eb12fe5fa$export$2e2bcd8739ae039).Body, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", null, "Course+ \u9700\u8981\u4ECE\u60A8\u7684 jAccount \u8BFB\u53D6\u8BFE\u7A0B\u4FE1\u606F\u3002"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "text-muted"
    }, "Course+ \u7684\u670D\u52A1\u5668\u4E0D\u4F1A\u5B58\u50A8\u60A8\u7684\u8BFE\u7A0B\u4FE1\u606F\u3002\u5F53\u60A8\u4F7F\u7528\u65B0\u8BBE\u5907\u6253\u5F00 Course+ \u65F6\uFF0C\u60A8\u9700\u8981\u91CD\u65B0\u4ECE\u6559\u5B66\u4FE1\u606F\u670D\u52A1\u7F51\u540C\u6B65\u6570\u636E\u3002")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $2839459eb12fe5fa$export$2e2bcd8739ae039).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $a1a8d87165bcf2e4$export$2e2bcd8739ae039), {
        variant: "outline-secondary",
        onClick: ()=>nextStep(false)
    }, "\u5173\u95ED"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $a1a8d87165bcf2e4$export$2e2bcd8739ae039), {
        variant: "outline-primary",
        onClick: ()=>nextStep(true)
    }, "\u7EE7\u7EED")));
}


/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by Niazye and ChiyoYuki from ECNU-minus on 2025-12-02
 * Changes:
 * - feat: hide classtable page
 *
 * Modified by 霧雨バニラ from BetterECNU on 2026-05-23
 * Changes:
 * - feat: 添加全局搜索导航链接，独立页面通过 SWR 获取默认学期，支持 hideToggle 属性隐藏侧栏切换按钮
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ 
var $lgFxF = parcelRequire("lgFxF");



function $75e7b952843d8d3c$var$CoursePlusSvg() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("svg", {
        width: "1.25rem",
        height: "1.25rem",
        viewBox: "0 0 16 16",
        className: "mr-1 align-middle bi bi-calendar-plus",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("linearGradient", {
        id: "gradient",
        gradientTransform: "rotate(45)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("stop", {
        offset: "0%",
        stopColor: "#24C6DC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("stop", {
        offset: "100%",
        stopColor: "#514A9D"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("path", {
        fillRule: "evenodd",
        fill: "url(#gradient)",
        d: "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.5 8.5a.5.5 0 0 0-1 0V10H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V11H10a.5.5 0 0 0 0-1H8.5V8.5z"
    }));
}
var $75e7b952843d8d3c$export$2e2bcd8739ae039 = ({ onToggleClick: onToggleClick, hideToggle: hideToggle })=>{
    const { pathname: pathname } = (0, $8d84d1394a502c2f$export$45d76561a5302f2b)();
    const params = (0, $8d84d1394a502c2f$export$99eaa27ddbbb95ef)();
    const isStandalone = pathname === '/search' || pathname === '/course';
    const semesterFromPath = pathname.match(/^\/([^/]+)/)?.[1];
    const { data: indexData } = (0, $2b7bb7b14013a5cb$export$2e2bcd8739ae039)(isStandalone ? '/course-plus-data/lessonData_index.json' : null, (0, $3f025cdb4fe7d1c8$export$2e2bcd8739ae039));
    const defaultSemester = indexData && indexData.length > 0 ? `${indexData[indexData.length - 1].year}_${indexData[indexData.length - 1].semester}` : null;
    const semester = isStandalone ? defaultSemester || null : params.semester || semesterFromPath;
    const links = [
        {
            path: '/browse',
            text: "\u641C\u7D22",
            match: '/:semester/browse'
        },
        {
            path: '/plan',
            text: "\u6392\u8BFE",
            match: '/:semester/plan'
        }
    ];
    const match_links = links.map((link)=>({
            path: link.path,
            text: link.text,
            match: (0, $8d84d1394a502c2f$export$81336c211d5ff295)(pathname, {
                path: link.match
            })
        }));
    const linksComponent = match_links.map((link)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("li", {
            key: link.path,
            className: `nav-item${link.match ? ' active' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $225277145a49d7b0$export$a6c7ac8248d6e38a), {
            to: `/${semester}${link.path}`,
            className: "nav-link"
        }, link.text)));
    // Global search link - independent of semester
    const globalSearchMatch = (0, $8d84d1394a502c2f$export$81336c211d5ff295)(pathname, {
        path: '/search'
    }) || (0, $8d84d1394a502c2f$export$81336c211d5ff295)(pathname, {
        path: '/course'
    });
    const globalSearchLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("li", {
        key: "/search",
        className: `nav-item${globalSearchMatch ? ' active' : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $225277145a49d7b0$export$a6c7ac8248d6e38a), {
        to: "/search",
        className: "nav-link"
    }, "\u5168\u5C40\u641C\u7D22"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("nav", {
        className: "mb-3 navbar navbar-light navbar-expand-md course-navbar"
    }, !hideToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("button", {
        className: "navbar-toggler d-md-none",
        type: "button",
        onClick: onToggleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "navbar-toggler-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mx-2 navbar-text d-md-none",
        style: {
            color: '#ffc107',
            backgroundColor: '#f2f2f2',
            padding: '0.1rem 0.35rem',
            borderRadius: '0.25rem'
        }
    }, "\u4E3A\u4FDD\u8BC1\u6700\u4F73\u4F53\u9A8C\uFF0C\u5EFA\u8BAE\u4F7F\u7528PC\u7AEF\u8BBF\u95EE"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "mb-0 navbar-brand"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($75e7b952843d8d3c$var$CoursePlusSvg, null), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "align-middle"
    }, "Course+")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "navbar-collapse show"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("ul", {
        className: "ml-auto navbar-nav"
    }, semester ? linksComponent : null, globalSearchLink)));
};


/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by Niazye and ChiyoYuki from ECNU-minus on 2025-12-02
 * Changes:
 * - feat: add select all button on plan page
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ 



var $lgFxF = parcelRequire("lgFxF");




var $643b5aca7889b60f$export$2e2bcd8739ae039 = ({ state: state, setState: setState, starLesson: starLesson, removeStarLesson: removeStarLesson, batchRemoveStarLessons: batchRemoveStarLessons, colorMapping: colorMapping })=>{
    const { semester: semester } = (0, $8d84d1394a502c2f$export$99eaa27ddbbb95ef)();
    const { data: lessons } = (0, $3ba76e806416b3fb$export$991d5b48f7801974)(semester);
    const handleCheckChange = (e)=>{
        const checked = e.target.checked;
        const value = e.target.value;
        const set = new Set(state);
        if (checked) set.add(value);
        else set.delete(value);
        setState(set);
    };
    if (lessons) {
        const starLessonObj = (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))(lessons.filter((lesson)=>starLesson.has(lesson.jxbmc)), 'kch');
        const selectedLessonObj = (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))(lessons.filter((lesson)=>state.has(lesson.jxbmc)), 'kch');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Row, {
            className: "mb-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u661F\u6807\u8BFE\u7A0B (", (0, (/*@__PURE__*/$parcel$interopDefault($fdeac4566d39d3d5$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($905bd22ff9c4e6ec$exports)))(selectedLessonObj, 'jxbmc').map((l)=>parseFloat(l.xf))), ' ', "/", ' ', (0, (/*@__PURE__*/$parcel$interopDefault($fdeac4566d39d3d5$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($905bd22ff9c4e6ec$exports)))(starLessonObj, 'jxbmc').map((l)=>parseFloat(l.xf))), ' ', "\u5B66\u5206)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "col-12"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($905bd22ff9c4e6ec$exports)))(starLessonObj, 'jxbmc').map((lesson)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Check, {
                type: "checkbox",
                key: lesson.jxbmc,
                id: lesson.jxbmc,
                custom: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Check.Input, {
                type: "checkbox",
                checked: state.has(lesson.jxbmc),
                onChange: handleCheckChange,
                value: lesson.jxbmc
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Check.Label, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "course-square",
                style: {
                    backgroundColor: colorMapping[lesson.jxbmc]
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "ml-1 d-inline-block"
            }, lesson.kch), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "ml-2 d-inline-block"
            }, lesson.kcmc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
                className: "ml-2 d-inline-block"
            }, lesson.jszc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
                className: "ml-2 small",
                onClick: ()=>removeStarLesson(lesson.jxbmc)
            }, "\u79FB\u9664")))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("button", {
            type: "button",
            className: "btn btn-sm btn-outline-primary",
            onClick: ()=>{
                const next = new Set(state);
                starLessonObj.forEach((l)=>next.add(l.jxbmc));
                setState(next);
            }
        }, "\u5168\u90E8\u9009\u4E2D"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("button", {
            type: "button",
            className: "btn btn-sm btn-outline-primary ml-2",
            onClick: ()=>{
                const next = new Set(state);
                lessons.forEach((l)=>next.delete(l.jxbmc));
                setState(next);
            }
        }, "\u53D6\u6D88\u5168\u9009"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("button", {
            type: "button",
            className: "btn btn-sm btn-outline-danger ml-2",
            onClick: ()=>{
                if (window.confirm("\u786E\u5B9A\u8981\u79FB\u9664\u6240\u6709\u661F\u6807\u8BFE\u7A0B\u5417\uFF1F")) {
                    batchRemoveStarLessons(starLessonObj.map((l)=>l.jxbmc));
                    setState(new Set());
                }
            }
        }, "\u5168\u90E8\u79FB\u9664"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("hr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $859bf2cdd8712ecd$export$2e2bcd8739ae039), {
            semester: semester,
            selectedLessonObj: selectedLessonObj
        }));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null);
};


/*
 * Copyright 2026 BetterECNU
 */ 



var $lgFxF = parcelRequire("lgFxF");





function $19208b28a21f082b$var$semesterLabel(year, term) {
    let season = term;
    if (term === 'Autumn' || term === 'Fall') season = "\u79CB";
    else if (term === 'Spring') season = "\u6625";
    else if (term === 'Summer') season = "\u590F";
    else if (term === 'Winter') season = "\u51AC";
    return `${year} ${season}`;
}
function $19208b28a21f082b$export$2e2bcd8739ae039() {
    const [keyword, setKeyword] = (0, $lgFxF.useState)(()=>{
        try {
            return window.localStorage.getItem('searchKeyword') || '';
        } catch  {
            return '';
        }
    });
    const [searchedKeyword, setSearchedKeyword] = (0, $lgFxF.useState)('');
    const handleKeywordChange = (e)=>{
        const value = e.target.value;
        setKeyword(value);
        try {
            window.localStorage.setItem('searchKeyword', value);
        } catch  {}
    };
    const [searched, setSearched] = (0, $lgFxF.useState)(false);
    const { data: allLessons, loading: loading, error: error, fetchAll: fetchAll } = (0, $3ba76e806416b3fb$export$e05f7f3137a2fed8)();
    const { data: lessonConversion } = (0, $3ba76e806416b3fb$export$e2ee6cfef5cb8639)();
    const history = (0, $8d84d1394a502c2f$export$3420e1dc2c4a518c)();
    const debounceRef = (0, $lgFxF.useRef)(null);
    (0, $lgFxF.useEffect)(()=>{
        if (debounceRef.current) clearTimeout(debounceRef.current);
        if (!keyword.trim()) {
            setSearched(false);
            setSearchedKeyword('');
            return;
        }
        debounceRef.current = setTimeout(()=>{
            setSearchedKeyword(keyword);
            setSearched(true);
            fetchAll();
        }, 300);
        return ()=>{
            if (debounceRef.current) clearTimeout(debounceRef.current);
        };
    }, [
        keyword,
        fetchAll
    ]);
    const filteredLessons = (()=>{
        if (!allLessons || !searchedKeyword.trim()) return null;
        const kw = searchedKeyword.trim().toLowerCase();
        return allLessons.filter((lesson)=>{
            if (lesson.kcmc.toLowerCase().includes(kw)) return true;
            if (lesson.kch.toLowerCase().includes(kw)) return true;
            if (lessonConversion) {
                if (lessonConversion.to_new[lesson.kch]) {
                    if (lessonConversion.to_new[lesson.kch].toLowerCase().includes(kw)) return true;
                }
                if (lessonConversion.to_old[lesson.kch]) {
                    if (lessonConversion.to_old[lesson.kch].toLowerCase().includes(kw)) return true;
                }
            }
            return false;
        });
    })();
    const groupedCourses = (()=>{
        if (!filteredLessons) return null;
        const grouped = (0, (/*@__PURE__*/$parcel$interopDefault($30f3b24994a55528$exports)))(filteredLessons, 'kch');
        return (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))(Object.entries(grouped).map(([kch, lessons])=>{
            const semesters = (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($905bd22ff9c4e6ec$exports)))(lessons.map((l)=>({
                    year: l._year,
                    term: l._term
                })), (s)=>s.year + s.term), [
                'year',
                'term'
            ]);
            return {
                kch: kch,
                kcmc: lessons[0].kcmc,
                semesters: semesters
            };
        }), 'kch');
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-flex flex-column p-3 h-100 search-page",
        style: {
            width: '100%',
            maxWidth: 'none',
            minWidth: 0,
            margin: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "search-page-header",
        style: {
            width: '100%',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("h5", {
        className: "mb-3"
    }, "\u5168\u5C40\u641C\u7D22"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "mb-3 text-muted small"
    }, "\u641C\u7D22\u6240\u6709\u5B66\u671F\u6570\u636E\uFF0C\u67E5\u627E\u8BFE\u7A0B\u7684\u5F00\u8BFE\u8BB0\u5F55"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Group, {
        className: "mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Control, {
        placeholder: "\u8F93\u5165\u8BFE\u7A0B\u540D\u79F0\u6216\u8BFE\u7A0B\u4EE3\u7801\u2026\u2026",
        name: "keyword",
        value: keyword,
        onChange: handleKeywordChange
    })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "alert alert-danger small"
    }, "\u52A0\u8F7D\u6570\u636E\u5931\u8D25\uFF1A", error.message), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-flex align-items-center my-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $16e0ea112d292bc9$export$2e2bcd8739ae039), {
        animation: "border",
        size: "sm",
        role: "status",
        className: "mr-2 text-primary"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "text-muted small"
    }, "\u6B63\u5728\u52A0\u8F7D\u6240\u6709\u5B66\u671F\u6570\u636E\u2026\u2026"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "search-page-list",
        style: {
            width: '100%',
            minWidth: 0,
            flex: '1 1 0'
        }
    }, !loading && searched && groupedCourses && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "mb-3 text-muted small"
    }, "\u5171\u627E\u5230 ", groupedCourses.length, " \u95E8\u8BFE\u7A0B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "search-results",
        style: {
            width: '100%',
            minWidth: 0
        }
    }, groupedCourses.map((course)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            key: course.kch,
            className: "w-100 search-result-item card",
            style: {
                cursor: 'pointer'
            },
            onClick: ()=>history.push(`/course?id=${course.kch}`)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "px-3 py-2 card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "d-flex align-items-start justify-content-between search-result-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "search-result-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "font-weight-bold text-primary search-result-code"
        }, course.kch), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "ml-2 search-result-name"
        }, course.kcmc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
            className: "ml-2 text-muted text-nowrap small"
        }, course.semesters.length, " \u4E2A\u5B66\u671F")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
            className: "mt-1"
        }, course.semesters.map((sem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $6635d28ab45464ba$export$2e2bcd8739ae039), {
                key: sem.year + sem.term,
                variant: "light",
                className: "mr-1 mb-1 semester-badge"
            }, $19208b28a21f082b$var$semesterLabel(sem.year, sem.term))))))))), !loading && searched && groupedCourses && groupedCourses.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "my-5 text-muted text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", null, "\u672A\u627E\u5230\u5339\u914D\u7684\u8BFE\u7A0B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "small"
    }, "\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u5173\u952E\u8BCD")), !searched && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "my-5 text-muted text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "mb-2"
    }, "\u8F93\u5165\u8BFE\u7A0B\u540D\u79F0\u6216\u4EE3\u7801\u5F00\u59CB\u641C\u7D22"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "small"
    }, "\u652F\u6301\u6309\u8BFE\u7A0B\u540D\u79F0\u6216\u8BFE\u7A0B\u4EE3\u7801\u641C\u7D22\u6240\u6709\u5B66\u671F\u6570\u636E"))));
}


/*
 * Copyright 2025 SJTU-Geek
 * Copyright 2020-2025 SJTU-Plus
 *
 * ----------------------------------------------------------------
 * Modified by Niazye and ChiyoYuki from ECNU-minus on 2025-12-02
 * Changes:
 * - fix: semester name's localization
 *
 * Modified by 霧雨バニラ from BetterECNU on 2026-05-23
 * Changes:
 * - fix: 导航路径校验，限制 path 仅允许 'browse'、'plan'、'classtable'，防止无效路由
 *
 * Copyright 2025 ECNU-minus
 * ----------------------------------------------------------------
 */ 

var $lgFxF = parcelRequire("lgFxF");


var $4ee724c1fea40df7$export$2e2bcd8739ae039 = (0, $8d84d1394a502c2f$export$369b6b2b30582e8e)(({ history: history })=>{
    const [lessonList, setLessonList] = (0, $lgFxF.useState)([]);
    const location = (0, $8d84d1394a502c2f$export$45d76561a5302f2b)();
    const { semester: semesterParam } = (0, $8d84d1394a502c2f$export$99eaa27ddbbb95ef)();
    const semesterFromPath = location.pathname.match(/^\/([^/]+)/)?.[1];
    const currentSemester = semesterParam || semesterFromPath || '';
    (0, $lgFxF.useEffect)(()=>{
        const getLessonIndex = async ()=>{
            const response = (await (0, (/*@__PURE__*/$parcel$interopDefault($ce12fe3b4e8bd060$exports))).get('/course-plus-data/lessonData_index.json')).data;
            setLessonList(response);
            // 如果当前 URL 没有学期,默认跳转到最新学期的 browse
            if (!currentSemester && response.length > 0) {
                const lastIndex = response[response.length - 1];
                history.replace(`/${lastIndex.year}_${lastIndex.semester}/browse`);
            }
        };
        getLessonIndex().then();
    }, [
        history,
        currentSemester
    ]);
    const onPathChange = (event)=>{
        let nextPath = location.pathname.split('/')[2] || 'browse';
        if (nextPath !== 'browse' && nextPath !== 'plan' && nextPath !== 'classtable') nextPath = 'browse';
        history.push(`/${event.target.value}/${nextPath}`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "form-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Group, {
        className: "col mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Label, null, "\u5B66\u5E74\u5B66\u671F"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $61ce1779e2da682b$export$2e2bcd8739ae039).Control, {
        as: "select",
        onChange: onPathChange,
        value: currentSemester
    }, lessonList.map((option)=>{
        let semesterChinese = '';
        if (option.semester === 'Autumn' || option.semester === 'Fall') semesterChinese = "\u79CB";
        else if (option.semester === 'Spring') semesterChinese = "\u6625";
        else if (option.semester === 'Summer') semesterChinese = "\u590F";
        else if (option.semester === 'Winter') semesterChinese = "\u51AC";
        else semesterChinese = option.semester;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("option", {
            value: `${option.year}_${option.semester}`,
            key: `${option.year}_${option.semester}`
        }, option.year, " \u5B66\u5E74, ", semesterChinese, " \u5B66\u671F (\u66F4\u65B0\u4E8E", ' ', option.updated_at, ")");
    }).reverse())));
});



var $lgFxF = parcelRequire("lgFxF");

function $cbeaa25349c08a1c$export$2e2bcd8739ae039() {
    const { semester: semester } = (0, $8d84d1394a502c2f$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $225277145a49d7b0$export$a6c7ac8248d6e38a), {
        to: `/${semester}/classtable`,
        className: "row text-reset jumbotron jumbotron-fluid d-block d-md-none px-1 py-3 text-center my-0 course-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "h4"
    }, "\u663E\u793A\u672C\u5B66\u671F\u8BFE\u8868")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "text-muted small text-center d-md-none"
    }, "\u8BF7\u4F7F\u7528 PC \u8BBF\u95EE\u4EE5\u4F7F\u7528\u5B8C\u6574\u529F\u80FD\u3002"));
}



var $lgFxF = parcelRequire("lgFxF");

function $901d07280e47c809$export$2e2bcd8739ae039({ syncFromISJTU: syncFromISJTU, dataLoading: dataLoading }) {
    const { semester: semester } = (0, $8d84d1394a502c2f$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
        className: "row text-reset jumbotron jumbotron-fluid d-block d-md-none px-1 py-3 text-center my-0 course-button",
        onClick: ()=>syncFromISJTU(semester)
    }, dataLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "spinner-border mr-1 align-middle"
    }) : '', ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("span", {
        className: "h4 align-middle"
    }, "\u540C\u6B65\u6570\u636E"));
}



function $8a03a9e98c48c944$var$colorize(starLesson) {
    const colorScale = (0, (/*@__PURE__*/$parcel$interopDefault($8dabe6189ccff055$exports))).scale('Spectral').gamma(0.5);
    const starLessonArray = [
        ...starLesson
    ];
    const result = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($fd4b61c353ee6397$exports)))((0, $aHLOA.groupBy)(starLessonArray, (lesson)=>lesson.split('-').slice(0, 3).join('-')), (v)=>{
        const colors = colorScale.colors(v.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($96e2fee1941156ba$exports)))(v).forEach((val, idx)=>result[val] = colors[idx]);
    });
    return result;
}
function $8a03a9e98c48c944$var$AppLayout({ isMenuOpen: isMenuOpen, setMenuOpen: setMenuOpen, filterFormState: filterFormState, setFilterFormState: setFilterFormState, starLesson: starLesson, setStarLesson: setStarLesson, removeStarLesson: removeStarLesson, batchRemoveStarLessons: batchRemoveStarLessons, selectedLesson: selectedLesson, setSelectedLesson: setSelectedLesson, sjtuLesson: sjtuLesson, sjtuLessonLoading: sjtuLessonLoading, syncFromISJTU: syncFromISJTU, loginDialog: loginDialog, handleLogin: handleLogin, starColorMapping: starColorMapping, sjtuColorMapping: sjtuColorMapping }) {
    const { pathname: pathname } = (0, $8d84d1394a502c2f$export$45d76561a5302f2b)();
    const hideSidebar = pathname === '/search' || pathname === '/course';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $75e7b952843d8d3c$export$2e2bcd8739ae039), {
        onToggleClick: ()=>setMenuOpen(!isMenuOpen),
        hideToggle: hideSidebar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $5a66e6f268a4f18c$export$2e2bcd8739ae039), {
        show: loginDialog,
        nextStep: handleLogin
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "flex-grow-1 h-100 row",
        style: {
            minHeight: 0
        }
    }, !hideSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: `col-md-3 sidebar-container ${isMenuOpen ? 'open' : ''} h-100 d-flex flex-column`,
        style: {
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "sidebar-overlay d-md-none",
        onClick: ()=>setMenuOpen(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "h-100 sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $4ee724c1fea40df7$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("hr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$b5d5cf8927ab7262), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), {
        path: "/:semester/browse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $cc5d3b75ff45f90a$export$2e2bcd8739ae039), {
        state: filterFormState,
        setState: setFilterFormState
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), {
        path: "/:semester/plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $643b5aca7889b60f$export$2e2bcd8739ae039), {
        starLesson: starLesson,
        removeStarLesson: removeStarLesson,
        batchRemoveStarLessons: batchRemoveStarLessons,
        state: selectedLesson,
        setState: setSelectedLesson,
        colorMapping: starColorMapping
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), {
        path: "/:semester/classtable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $1ff0334130c5ec5d$export$2e2bcd8739ae039), {
        sjtuLesson: sjtuLesson,
        starLesson: starLesson,
        setStarLesson: setStarLesson,
        dataLoading: sjtuLessonLoading,
        syncFromISJTU: syncFromISJTU,
        colorMapping: sjtuColorMapping
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $cc5d3b75ff45f90a$export$2e2bcd8739ae039), {
        state: filterFormState,
        setState: setFilterFormState
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "my-3 text-muted small"
    }, "\u514D\u8D23\u58F0\u660E\uFF1A\u672C\u7F51\u7AD9\u8BFE\u7A0B\u76F8\u5173\u6570\u636E\u6765\u81EA", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
        href: "https://byyt.ecnu.edu.cn/home/#/home",
        target: "_blank",
        rel: "noreferrer"
    }, "\u534E\u4E1C\u5E08\u8303\u5927\u5B66\u6559\u80B2\u6559\u5B66\u7BA1\u7406\u5E73\u53F0"), "\uFF0C\u6570\u636E\u66F4\u65B0\u5B58\u5728\u4E00\u5B9A\u5EF6\u8FDF\u6027\u3002\u4E14\u672C\u7F51\u7AD9\u4EC5\u4F9B\u5B66\u4E60\u548C\u4EA4\u6D41\u4F7F\u7528\uFF0C\u5177\u4F53\u60C5\u51B5\u4EE5\u672C\u79D1\u751F\u9662\u5B89\u6392\u4E3A\u51C6\u3002"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-flex align-items-center col d-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("p", {
        className: "my-1 text-muted small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
        href: "https://github.com/ECNU-minus/course-plus"
    }, "\u672C\u9879\u76EE"), ' ', "\u7531", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
        href: "https://github.com/ECNU-minus",
        target: "_blank",
        rel: "noreferrer"
    }, "ECNU-Minus"), ' ', "\u7EF4\u62A4\u3002\u5982\u60A8\u6709\u4EFB\u4F55\u9700\u8981\u6216\u95EE\u9898\u53CD\u9988\uFF0C\u8BF7\u52A0\u5165", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("a", {
        href: "https://qm.qq.com/q/HBbLlBtnuq",
        target: "_blank",
        rel: "noreferrer"
    }, "\u6211\u4EEC\u7684\u7528\u6237\u7FA4")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "justify-content-end row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-flex align-items-center my-2 p-0 col-auto d-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $3a8ee79cdacea239$export$2e2bcd8739ae039), {
        href: "https://github.com/ECNU-minus/course-plus",
        "data-show-count": true,
        "data-size": "large"
    }, "Star"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: `${hideSidebar ? 'col-12' : 'col-md-9'} main-content h-100 d-flex flex-column`,
        style: {
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$b5d5cf8927ab7262), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), {
        path: "/search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $19208b28a21f082b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), {
        path: "/course"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $b204f98b29da225f$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), {
        path: "/:semester/classtable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $65585991b08f7242$export$2e2bcd8739ae039), {
        selectedLesson: selectedLesson,
        colorMapping: starColorMapping
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), {
        path: "/:semester/plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $65585991b08f7242$export$2e2bcd8739ae039), {
        selectedLesson: selectedLesson,
        colorMapping: starColorMapping
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), {
        path: "/:semester/browse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $fe20ce721ac6c732$export$2e2bcd8739ae039), {
        filterData: filterFormState,
        state: starLesson,
        setState: setStarLesson
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8d84d1394a502c2f$export$e7b0ac011bb776c6), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $fe20ce721ac6c732$export$2e2bcd8739ae039), {
        filterData: filterFormState,
        state: starLesson,
        setState: setStarLesson
    }))))));
}
function $8a03a9e98c48c944$var$App() {
    const [isMenuOpen, setMenuOpen] = (0, $lgFxF.useState)(false);
    const [filterFormState, setFilterFormState] = (0, $lgFxF.useReducer)((state, newState)=>({
            ...state,
            ...newState
        }), {
        checkedNj: new Set(),
        checkedLx: new Set(),
        checkedYx: new Set(),
        checkedTy: new Set(),
        scheduleKey: '',
        lecturerKey: '',
        placeKey: '',
        keywordType: 'kcmc',
        keyword: '',
        composition: '',
        notes: ''
    });
    const [starLesson, setStarLesson] = (0, $3ba76e806416b3fb$export$30c60c3c30f10235)('starLesson', new Set([]));
    const [selectedLesson, setSelectedLesson] = (0, $3ba76e806416b3fb$export$30c60c3c30f10235)('selectedLesson', new Set([]));
    const [sjtuLesson, setSjtuLesson] = (0, $3ba76e806416b3fb$export$30c60c3c30f10235)('sjtuLesson', new Set([]));
    const [sjtuLessonLoading, setSjtuLessonLoading] = (0, $lgFxF.useState)(false);
    const [loginDialog, setLoginDialog] = (0, $lgFxF.useState)(false);
    const removeStarLesson = (0, $lgFxF.useCallback)((value)=>{
        const set = new Set(starLesson);
        set.delete(value);
        setStarLesson(set);
        const set2 = new Set(selectedLesson);
        set2.delete(value);
        setSelectedLesson(set2);
    }, [
        starLesson,
        selectedLesson,
        setStarLesson,
        setSelectedLesson
    ]);
    const batchRemoveStarLessons = (0, $lgFxF.useCallback)((values)=>{
        const set = new Set(starLesson);
        const set2 = new Set(selectedLesson);
        values.forEach((v)=>{
            set.delete(v);
            set2.delete(v);
        });
        setStarLesson(set);
        setSelectedLesson(set2);
    }, [
        starLesson,
        selectedLesson,
        setStarLesson,
        setSelectedLesson
    ]);
    const syncFromISJTU = (0, $lgFxF.useCallback)((semester)=>{
        setSjtuLessonLoading(true);
        (0, (/*@__PURE__*/$parcel$interopDefault($ce12fe3b4e8bd060$exports))).get(`/api/course/lesson?term=${semester.replace('_', '-')}`).then((resp)=>{
            if (resp?.data?.error === 'success') {
                setSjtuLesson(new Set(resp.data.entities.map((x)=>x.code)));
                setSjtuLessonLoading(false);
            } else {
                setSjtuLessonLoading(false);
                setLoginDialog(true);
            }
        }).catch((e)=>{
            setLoginDialog(true);
            setSjtuLessonLoading(false);
        });
    }, [
        setSjtuLesson,
        setSjtuLessonLoading,
        setLoginDialog
    ]);
    const handleLogin = (0, $lgFxF.useCallback)((result)=>{
        if (result) window.location.href = '/login?app=course_plus';
        setLoginDialog(false);
    }, []);
    const starColorMapping = (0, $lgFxF.useMemo)(()=>$8a03a9e98c48c944$var$colorize(starLesson), [
        starLesson
    ]);
    const sjtuColorMapping = (0, $lgFxF.useMemo)(()=>$8a03a9e98c48c944$var$colorize(sjtuLesson), [
        sjtuLesson
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $225277145a49d7b0$export$7221d69dcfc8e36b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement("div", {
        className: "d-flex flex-column container-fluid vh-100",
        style: {
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement($8a03a9e98c48c944$var$AppLayout, {
        isMenuOpen: isMenuOpen,
        setMenuOpen: setMenuOpen,
        filterFormState: filterFormState,
        setFilterFormState: setFilterFormState,
        starLesson: starLesson,
        setStarLesson: setStarLesson,
        removeStarLesson: removeStarLesson,
        batchRemoveStarLessons: batchRemoveStarLessons,
        selectedLesson: selectedLesson,
        setSelectedLesson: setSelectedLesson,
        sjtuLesson: sjtuLesson,
        sjtuLessonLoading: sjtuLessonLoading,
        syncFromISJTU: syncFromISJTU,
        loginDialog: loginDialog,
        handleLogin: handleLogin,
        starColorMapping: starColorMapping,
        sjtuColorMapping: sjtuColorMapping
    })));
}
var $8a03a9e98c48c944$export$2e2bcd8739ae039 = $8a03a9e98c48c944$var$App;


(0, (/*@__PURE__*/$parcel$interopDefault($aBztI))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).StrictMode, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lgFxF))).createElement((0, $8a03a9e98c48c944$export$2e2bcd8739ae039), null)), document.getElementById('root'));


//# sourceMappingURL=course-plus.b849fc49.js.map
